
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("7qvmT", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_NUM_VISIBLE_REPLIES", () => $8067e644a2744f7c$export$36062d4a94e50365);
$parcel$export(module.exports, "ViewReplyOptions", () => $8067e644a2744f7c$export$8a64eadc3c5e2e9a);
$parcel$export(module.exports, "getDefaultNumVisibleReplies", () => $8067e644a2744f7c$export$8648ea63d9b37934);
$parcel$export(module.exports, "handleCommentThreadSelection", () => $8067e644a2744f7c$export$cda46aad7dff898a);
$parcel$export(module.exports, "handlePanelSelectionAndScroll", () => $8067e644a2744f7c$export$e80247d0f3d89e0);
$parcel$export(module.exports, "onSaveReply", () => $8067e644a2744f7c$export$56ed0d504fa641dd);
$parcel$export(module.exports, "handleCommentThreadMouseEnter", () => $8067e644a2744f7c$export$24cbf19a725de615);
$parcel$export(module.exports, "handleCommentThreadMouseLeave", () => $8067e644a2744f7c$export$8ce16d4c9a8b2b8a);
$parcel$export(module.exports, "getCommentThreadsToBatch", () => $8067e644a2744f7c$export$1f10dc4c6b2440d5);
$parcel$export(module.exports, "legacyUpdateVisibleReplies", () => $8067e644a2744f7c$export$6c920326840ef051);
$parcel$export(module.exports, "updateVisibleReplies", () => $8067e644a2744f7c$export$564e359a57aeb34a);
$parcel$export(module.exports, "getCommentReplies", () => $8067e644a2744f7c$export$e9719a1dca3c9c9);
$parcel$export(module.exports, "getCurrentReplyView", () => $8067e644a2744f7c$export$7e952b61948d5915);
$parcel$export(module.exports, "getNumOfHiddenReplies", () => $8067e644a2744f7c$export$94e4f6e86c2cc22f);
$parcel$export(module.exports, "getAdfForQuickReplyMention", () => $8067e644a2744f7c$export$f72e9aa74d51c544);

var $gwFzn = parcelRequire("gwFzn");

var $21K7m = parcelRequire("21K7m");

var $caRYB = parcelRequire("caRYB");
var $bAT9l = parcelRequire("bAT9l");
var $2FFuS = parcelRequire("2FFuS");
var $aoDcQ = parcelRequire("aoDcQ");

var $irVI7 = parcelRequire("irVI7");
var $aJPUt = parcelRequire("aJPUt");

var $aHcFH = parcelRequire("aHcFH");
var $i49vP = parcelRequire("i49vP");

var $g0DaR = parcelRequire("g0DaR");
var $8dA1U = parcelRequire("8dA1U");

var $9wGTI = parcelRequire("9wGTI");

var $cD1qu = parcelRequire("cD1qu");

var $87CZC = parcelRequire("87CZC");

var $8i27m = parcelRequire("8i27m");

var $3mVfX = parcelRequire("3mVfX");

var $vFbJD = parcelRequire("vFbJD");
const $8067e644a2744f7c$export$36062d4a94e50365 = 2;
const $8067e644a2744f7c$export$d7989e622f70691f = 5;
var $8067e644a2744f7c$export$8a64eadc3c5e2e9a = /*#__PURE__*/ function(ViewReplyOptions) {
    ViewReplyOptions["ALL"] = "ALL";
    ViewReplyOptions["DEFAULT"] = "DEFAULT";
    ViewReplyOptions["HIDDEN"] = "HIDDEN";
    ViewReplyOptions["LIMITED"] = "LIMITED";
    return ViewReplyOptions;
}({});
const $8067e644a2744f7c$var$shouldTriggerCommentScroll = (event, id)=>{
    if (!id) return false;
    const target = event.target;
    const isContainer = target === event.currentTarget;
    const isCommentBody = Boolean(target.closest(`[data-testid="comment-thread-${id}-parent"]`));
    const isCommentReplyBody = Boolean(target.closest(`[data-testid="comment-thread-${id}-reply-list"]`));
    const replyToggler = Boolean(target.closest('[data-testid="comments-panel-replies-toggler-container"]'));
    // Don't trigger if clicking on specific interactive elements
    const isInteractiveElement = Boolean(target.closest('button, a, input, textarea, [role="button"]'));
    const isEmojiElement = Boolean(target.closest('[data-testid="emoji-add-icon"], [data-emoji-short-name]'));
    return (isContainer || isCommentBody || isCommentReplyBody || replyToggler) && !isInteractiveElement && !isEmojiElement;
};
const $8067e644a2744f7c$export$8648ea63d9b37934 = (numberOfReplies, isStandaloneComment = false)=>{
    if (isStandaloneComment && numberOfReplies <= $8067e644a2744f7c$export$d7989e622f70691f) return $8067e644a2744f7c$export$d7989e622f70691f;
    return $8067e644a2744f7c$export$36062d4a94e50365;
};
const $8067e644a2744f7c$export$cda46aad7dff898a = ({ parentComment: parentComment, pageMode: pageMode, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, scrollCommentsPanelToThread: scrollCommentsPanelToThread, eventEmitter: eventEmitter, event: event })=>{
    const threadKey = parentComment.type === (0, $8i27m.CommentType).INLINE ? parentComment.location.inlineMarkerRef : parentComment.id;
    const isResolved = !parentComment.isOpen;
    $8067e644a2744f7c$export$e80247d0f3d89e0({
        threadKey: threadKey,
        isResolved: isResolved,
        pageMode: pageMode,
        setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey,
        eventEmitter: eventEmitter,
        commentType: parentComment.type,
        scrollCommentsPanelToThread: scrollCommentsPanelToThread,
        shouldScrollCommentsPanel: true,
        event: event,
        id: parentComment.id
    });
};
const $8067e644a2744f7c$export$e80247d0f3d89e0 = ({ threadKey: threadKey, isResolved: isResolved, pageMode: pageMode, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, eventEmitter: eventEmitter, commentType: commentType, scrollCommentsPanelToThread: scrollCommentsPanelToThread, shouldScrollCommentsPanel: shouldScrollCommentsPanel = false, event: event, id: id, hasKeyPressed: hasKeyPressed })=>{
    // We only scroll the document for non-resolved inline comments or page comments
    if (threadKey && !isResolved) {
        if (event && !$8067e644a2744f7c$var$shouldTriggerCommentScroll(event, id)) setCurrentlySelectedThreadKey(threadKey);
        else setCurrentlySelectedThreadKey(threadKey, commentType);
        if (commentType === (0, $8i27m.CommentType).INLINE) {
            const commentElement = document.getElementById(threadKey);
            if (commentElement) {
                if (pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE) {
                    event && $8067e644a2744f7c$var$shouldTriggerCommentScroll(event, id) && (0, $i49vP.scrollToElementInEditor)({
                        targetElement: commentElement,
                        viewingRoomOffset: -300
                    });
                    eventEmitter?.emit('setselectedannotation', threadKey);
                } else {
                    eventEmitter?.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, {
                        annotationId: threadKey
                    });
                    event && $8067e644a2744f7c$var$shouldTriggerCommentScroll(event, id) && (0, $aHcFH.scrollCommentIntoView)({
                        commentElement: commentElement,
                        isFabricPage: true,
                        useInstantScroll: false,
                        commentThreadAnnotationId: threadKey,
                        isCommentsPanel: true,
                        scrollCommentsPanelToThread: scrollCommentsPanelToThread,
                        shouldScrollCommentsPanel: shouldScrollCommentsPanel
                    });
                }
            }
        }
        // Page comment case
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        commentType === (0, $8i27m.CommentType).GENERAL && (0, $9wGTI.fg)('confluence-frontend-comments-panel-design-update') && !(0, $9wGTI.fg)('confluence-frontend-redesigned-footer-comment')) {
            const commentElementId = (0, $9wGTI.fg)('confluence-frontend-redesigned-footer-comment') ? `footer-comment-thread-${threadKey}-container` : `comment-${threadKey}`;
            const commentElement = document.getElementById(commentElementId);
            if (commentElement) {
                if (pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE) {
                    eventEmitter?.emit('setselectedannotation', null);
                    (0, $i49vP.scrollToElementInEditor)({
                        targetElement: commentElement,
                        viewingRoomOffset: -300
                    });
                } else {
                    eventEmitter?.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
                    (0, $aHcFH.scrollCommentIntoView)({
                        commentElement: commentElement,
                        isFabricPage: true,
                        useInstantScroll: false,
                        commentThreadAnnotationId: threadKey,
                        isCommentsPanel: true,
                        isAbove: true,
                        scrollCommentsPanelToThread: scrollCommentsPanelToThread,
                        shouldScrollCommentsPanel: shouldScrollCommentsPanel
                    });
                }
            }
        }
        // Handle case where a comment is never clicked but is still selected via KB shortcuts
        if (shouldScrollCommentsPanel && scrollCommentsPanelToThread && (0, $9wGTI.fg)('comments_panel_updated_scrolling_behavior')) scrollCommentsPanelToThread({
            annotationId: threadKey,
            commentType: commentType,
            hasKeyPressed: hasKeyPressed
        });
    }
};
const $8067e644a2744f7c$export$56ed0d504fa641dd = async ({ pageId: pageId, parentCommentId: parentCommentId, cloudId: cloudId, adf: adf, onSuccess: onSuccess, pageMode: pageMode, editCommentQueryId: editCommentQueryId, setCommentForEdit: setCommentForEdit, createAnalyticsEvent: createAnalyticsEvent, pageType: pageType, experienceTracker: experienceTracker, createInlineReplyFn: createInlineReplyFn, createGeneralReplyFn: createGeneralReplyFn, selectedAnnotation: selectedAnnotation, addReplyToCommentThread: addReplyToCommentThread, threadKey: threadKey, updateReadCommentsListState: updateReadCommentsListState, commentType: commentType, searchSessionId: searchSessionId, isReactionsEnabled: isReactionsEnabled, analyticsSource: analyticsSource })=>{
    const isInlineComment = commentType === (0, $8i27m.CommentType).INLINE;
    const isEditor = pageMode === (0, $cD1qu.PageMode).EDIT;
    let startExperienceName = (0, $irVI7.REPLY_TO_INLINE_COMMENT_PUBLISH_EXPERIENCE);
    if (!isInlineComment) {
        if ((0, $9wGTI.fg)('confluence_frontend_separate_add_page_comment')) startExperienceName = (0, $irVI7.REPLY_TO_PAGE_COMMENT_PUBLISH_EXPERIENCE);
        else startExperienceName = (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE);
    }
    experienceTracker.start({
        name: startExperienceName,
        timeout: (0, $9wGTI.fg)('confluence_frontend_disable_page_comment_timeout') ? (0, $aJPUt.ExperienceTimeout).EDITOR_PUBLISH : undefined
    });
    const createReplyFn = isInlineComment ? createInlineReplyFn({
        variables: {
            input: {
                containerId: pageId,
                parentCommentId: parentCommentId,
                commentBody: {
                    value: JSON.stringify(adf),
                    representationFormat: (0, $vFbJD.ContentRepresentation).ATLAS_DOC_FORMAT
                },
                createdFrom: (0, $g0DaR.getCommentCreationLocation)(isEditor, pageMode === (0, $cD1qu.PageMode).LIVE)
            },
            pageId: pageId
        },
        update: (0, $g0DaR.updateApolloCacheCallback)('create', {
            pageId: pageId,
            contentStatus: [
                'CURRENT',
                'DRAFT'
            ],
            annotationId: threadKey
        }, parentCommentId)
    }) : createGeneralReplyFn({
        variables: {
            pageId: pageId,
            cloudId: cloudId,
            input: {
                commentBody: {
                    value: JSON.stringify(adf),
                    representationFormat: (0, $vFbJD.ContentRepresentation).ATLAS_DOC_FORMAT
                },
                commentSource: (0, $vFbJD.Platform).WEB,
                containerId: pageId,
                parentCommentId: parentCommentId
            }
        },
        update: (0, $87CZC.updateApolloCacheReplyCallback)('create', {
            pageId: pageId,
            contentStatus: [
                'CURRENT',
                'DRAFT'
            ]
        }, parentCommentId, isReactionsEnabled)
    });
    return createReplyFn.then(({ data: data })=>{
        const replyResult = isInlineComment ? data.replyInlineComment : data.createFooterComment;
        const reply = {
            isUnread: false,
            type: isInlineComment ? (0, $8i27m.CommentType).INLINE : (0, $8i27m.CommentType).GENERAL,
            ...replyResult
        };
        updateReadCommentsListState((prev)=>new Set([
                ...prev,
                reply.id
            ]));
        addReplyToCommentThread(threadKey, reply, commentType);
        if (isInlineComment) (0, $g0DaR.handleCreateReplySuccess)({
            onSuccess: onSuccess,
            editCommentQueryId: editCommentQueryId,
            setCommentForEdit: setCommentForEdit,
            data: data,
            createAnalyticsEvent: createAnalyticsEvent,
            pageId: pageId,
            pageType: pageType,
            analyticsSource: analyticsSource,
            commentId: parentCommentId,
            pageMode: pageMode,
            selectedAnnotation: selectedAnnotation,
            getInlineNodeTypes: undefined,
            experienceTracker: experienceTracker,
            isEditor: isEditor
        });
        else (0, $87CZC.handleCreateReplySuccess)({
            onSuccess: onSuccess,
            editCommentQueryId: editCommentQueryId,
            setCommentForEdit: setCommentForEdit,
            data: data,
            createAnalyticsEvent: createAnalyticsEvent,
            pageId: pageId,
            pageType: pageType,
            analyticsSource: analyticsSource,
            commentId: parentCommentId,
            pageMode: pageMode,
            experienceTracker: experienceTracker,
            searchSessionId: searchSessionId
        });
    }).catch((error)=>{
        let failExperienceName = (0, $irVI7.REPLY_TO_INLINE_COMMENT_PUBLISH_EXPERIENCE);
        if (!isInlineComment) {
            if ((0, $9wGTI.fg)('confluence_frontend_separate_add_page_comment')) failExperienceName = (0, $irVI7.REPLY_TO_PAGE_COMMENT_PUBLISH_EXPERIENCE);
            else failExperienceName = (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE);
        }
        return (0, $8dA1U.handleMutationFailure)({
            experienceTracker: experienceTracker,
            experienceName: failExperienceName,
            error: error,
            commentId: parentCommentId,
            shouldReturnError: true
        });
    });
};
const $8067e644a2744f7c$export$24cbf19a725de615 = ({ id: id, threadKey: threadKey, setIsThreadHovered: setIsThreadHovered, setHoveredCommentId: setHoveredCommentId, pageMode: pageMode, eventEmitter: eventEmitter })=>{
    if (threadKey) {
        setIsThreadHovered(true);
        id && setHoveredCommentId(id);
        if ((0, $9wGTI.fg)('confluence_frontend_comments_panel_v2')) {
            if (pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE) eventEmitter?.emit('sethoveredannotation', threadKey);
            else eventEmitter?.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, {
                annotationId: threadKey
            });
        }
    }
};
const $8067e644a2744f7c$export$8ce16d4c9a8b2b8a = ({ threadKey: threadKey, setIsThreadHovered: setIsThreadHovered, setHoveredCommentId: setHoveredCommentId, pageMode: pageMode, eventEmitter: eventEmitter })=>{
    if (threadKey) {
        setIsThreadHovered(false);
        setHoveredCommentId(undefined);
        if (pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE) eventEmitter?.emit('removehoveredannotation', threadKey);
        else eventEmitter?.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, {
            annotationId: threadKey
        });
    }
};
const $8067e644a2744f7c$export$1f10dc4c6b2440d5 = (comments, passThroughProps, CommentThreadComponent, transitionIndexWithinBatch)=>comments.map((parentComment, index, array)=>{
        const isLastComment = index === array.length - 1;
        const shouldRenderCommentTypeSeparator = index === transitionIndexWithinBatch;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(CommentThreadComponent, {
            key: parentComment.id,
            parentComment: parentComment,
            shouldRenderCommentThreadSeperator: !isLastComment,
            shouldRenderCommentTypeSeparator: shouldRenderCommentTypeSeparator,
            ...passThroughProps
        });
    });
const $8067e644a2744f7c$export$d69a37e7380b7ce5 = (reply, hiddenReplies)=>{
    return hiddenReplies.some((hiddenReply)=>hiddenReply.id === reply.id && hiddenReply.isUnread);
};
const $8067e644a2744f7c$export$6c920326840ef051 = ({ allReplies: allReplies, commentType: commentType, isParentCommentOpen: isParentCommentOpen, currentReplyView: currentReplyView, latestReplies: latestReplies, latestReplyIds: latestReplyIds, parentCommentId: parentCommentId, setVisibleReplies: setVisibleReplies, shouldShowLatestReplies: shouldShowLatestReplies, numOfHiddenReplies: numOfHiddenReplies })=>{
    if (currentReplyView === "ALL") {
        if (commentType !== (0, $8i27m.CommentType).GENERAL) setVisibleReplies(allReplies);
        else {
            const topLevelReplies = allReplies.filter((reply)=>reply.parentId === parentCommentId);
            setVisibleReplies(topLevelReplies);
        }
        numOfHiddenReplies.current = 0;
    } else {
        numOfHiddenReplies.current = allReplies.length;
        if (!isParentCommentOpen) // If the parent comment is resolved, we hide all replies on the thread's initial load
        setVisibleReplies([]);
        else if (shouldShowLatestReplies && latestReplies && latestReplyIds && latestReplyIds.size > 0) {
            /*
			 * If the parent comment is open, we show the latest replies on the thread's initial load only.
			 * When replies are expaneded and collapsed, all replies are hidden.
			 */ setVisibleReplies(latestReplies);
            numOfHiddenReplies.current -= latestReplyIds.size;
        }
    }
};
const $8067e644a2744f7c$export$564e359a57aeb34a = ({ currentReplyView: currentReplyView, setVisibleReplies: setVisibleReplies, allReplies: allReplies, isParentCommentOpen: isParentCommentOpen, latestReplies: latestReplies, parentCommentId: parentCommentId, currentView: currentView, allowNestedReplies: allowNestedReplies = false })=>{
    if (!isParentCommentOpen && currentView !== (0, $3mVfX.ViewValues).RESOLVED) {
        setVisibleReplies([]);
        return;
    }
    switch(currentReplyView){
        case "ALL":
            if (allowNestedReplies) setVisibleReplies(allReplies);
            else {
                const topLevelReplies = $8067e644a2744f7c$export$e9719a1dca3c9c9(allReplies, parentCommentId);
                // Make all direct replies to the parent comment visible, excluding any nested replies.
                setVisibleReplies(topLevelReplies);
            }
            break;
        case "HIDDEN":
            setVisibleReplies([]);
            break;
        case "LIMITED":
            setVisibleReplies(latestReplies);
            break;
    }
};
const $8067e644a2744f7c$export$e9719a1dca3c9c9 = (replies, parentCommentId)=>replies.filter(({ parentId: parentId })=>parentId === parentCommentId);
const $8067e644a2744f7c$export$7e952b61948d5915 = (numberOfReplies, isParentCommentOpen, isStandaloneComment = false)=>{
    if (!(0, $9wGTI.fg)('confluence_frontend_cp_visible_replies_refactor')) return "DEFAULT";
    if (!isParentCommentOpen) return "HIDDEN";
    if (numberOfReplies <= $8067e644a2744f7c$export$8648ea63d9b37934(numberOfReplies, isStandaloneComment)) return "ALL";
    return "LIMITED";
};
const $8067e644a2744f7c$export$94e4f6e86c2cc22f = ({ replies: replies, latestReplyIds: latestReplyIds, currentReplyView: currentReplyView })=>{
    switch(currentReplyView){
        case "HIDDEN":
            return replies.length;
        case "LIMITED":
            return replies.length - latestReplyIds.size;
        default:
            return 0;
    }
};
const $8067e644a2744f7c$export$f72e9aa74d51c544 = (replyToCommentUser)=>{
    if (!replyToCommentUser || !replyToCommentUser.displayName || !replyToCommentUser.accountId) return undefined;
    return (0, $caRYB.doc)((0, $2FFuS.paragraph)((0, $bAT9l.mention)({
        id: replyToCommentUser.accountId,
        text: `@${replyToCommentUser.displayName}`
    }), (0, $aoDcQ.text)(' ')));
};

});
parcelRegister("bAT9l", function(module, exports) {

$parcel$export(module.exports, "mention", () => $6b7e17532fed1b16$export$db83999c14438df4);
const $6b7e17532fed1b16$export$db83999c14438df4 = (attrs)=>({
        type: 'mention',
        attrs: {
            accessLevel: '',
            ...attrs
        }
    });

});

parcelRegister("g0DaR", function(module, exports) {

$parcel$export(module.exports, "updateApolloCacheCallback", () => $31423c43076595b5$export$483f44f07b46ed25);
$parcel$export(module.exports, "updateApolloCacheCallbackForGA", () => $31423c43076595b5$export$ad43a67c7ab9a6d6);
$parcel$export(module.exports, "getCommentCreationLocation", () => $31423c43076595b5$export$1859da3357bd460e);
$parcel$export(module.exports, "handleCreateReplySuccess", () => $31423c43076595b5$export$c94bffbead878776);
$parcel$export(module.exports, "insertReopenedCommentAnnotation", () => $31423c43076595b5$export$ca43168d5a4c3bfd);
$parcel$export(module.exports, "inlineCommentExists", () => $31423c43076595b5$export$cad0f7f0aeb719e7);
$parcel$export(module.exports, "updateReactionsCacheCallbackForGA", () => $31423c43076595b5$export$a5988be2401625e8);

var $1C8XP = parcelRequire("1C8XP");
var $afGoD = parcelRequire("afGoD");
var $3B9cR = parcelRequire("3B9cR");

var $eg9xl = parcelRequire("eg9xl");

var $irVI7 = parcelRequire("irVI7");

var $kmHPt = parcelRequire("kmHPt");

var $7W8i8 = parcelRequire("7W8i8");

var $dEBDF = parcelRequire("dEBDF");

var $9wGTI = parcelRequire("9wGTI");

var $en1dX = parcelRequire("en1dX");

var $asNlu = parcelRequire("asNlu");
const $31423c43076595b5$var$logger = (0, $7W8i8.getLogger)('inline-comments-common');
const $31423c43076595b5$var$removeReplyFromCache = (parentComment, replyId)=>{
    if (parentComment) {
        // Remove the returned commentId from the cache and reset it
        const idxToRemove = parentComment.replies.findIndex((reply)=>reply?.id === replyId);
        if (idxToRemove !== -1) parentComment.replies.splice(idxToRemove, 1);
    }
};
const $31423c43076595b5$var$addReplyToCache = (parentComment, newData, isCommentsPanel)=>{
    if (parentComment) {
        const mutationResult = newData.replyInlineComment;
        // Add the new reply entry to the cache and reset it
        if (isCommentsPanel) parentComment.replies.push(mutationResult);
        else parentComment.replies.push(mutationResult);
    }
};
const $31423c43076595b5$export$483f44f07b46ed25 = (actionType, queryVariables, parentCommentId, commentId)=>(cache, result)=>{
        // If the mutation fails, don't do anything
        if (!result || !result.data) return;
        if ((0, $9wGTI.fg)('confluence_frontend_comments_panel_v2')) try {
            const commentsPanelVariables = {
                pageId: queryVariables.pageId,
                contentStatus: queryVariables.contentStatus
            };
            const commentsPanelResponse = cache.readQuery({
                query: (0, $eg9xl.ActiveCommentsQuery),
                variables: commentsPanelVariables
            });
            if (commentsPanelResponse) {
                const commentsPanelData = {
                    ...commentsPanelResponse
                };
                const commentsPanelParentComment = commentsPanelData?.comments?.nodes?.find((comment)=>comment?.id === parentCommentId);
                if (commentsPanelParentComment) {
                    if (actionType === 'delete') $31423c43076595b5$var$removeReplyFromCache(commentsPanelParentComment, commentId);
                    else $31423c43076595b5$var$addReplyToCache(commentsPanelParentComment, result.data, true);
                }
                // Update the comments panel query
                cache.writeQuery({
                    query: (0, $eg9xl.ActiveCommentsQuery),
                    variables: commentsPanelVariables,
                    data: commentsPanelData
                });
            }
        } catch (err) {
            $31423c43076595b5$var$logger.error`An Error occurred when updating comments panel cache for ${actionType} reply - ${err}`;
        }
        try {
            const inlineQueryVariables = {
                ...queryVariables
            };
            const inlineCommentResponse = cache.readQuery({
                query: (0, $3B9cR.InlineCommentQuery),
                variables: inlineQueryVariables
            });
            if (inlineCommentResponse) {
                const inlineCommentData = {
                    ...inlineCommentResponse
                };
                const inlineCommentsParentComment = inlineCommentData?.comments?.nodes?.find((comment)=>comment?.id === parentCommentId);
                if (inlineCommentsParentComment) {
                    if (actionType === 'delete') $31423c43076595b5$var$removeReplyFromCache(inlineCommentsParentComment, commentId);
                    else $31423c43076595b5$var$addReplyToCache(inlineCommentsParentComment, result.data);
                }
                // Update the inline comments
                cache.writeQuery({
                    query: (0, $3B9cR.InlineCommentQuery),
                    variables: inlineQueryVariables,
                    data: inlineCommentData
                });
            }
        } catch (err) {
            $31423c43076595b5$var$logger.error`An Error occurred when updating inline comments cache for ${actionType} reply - ${err}`;
        }
    };
const $31423c43076595b5$export$ad43a67c7ab9a6d6 = (actionType, queryVariables, parentCommentId, commentId)=>(cache, result)=>{
        // If the mutation fails, don't do anything
        if (!result || !result.data) return;
        try {
            const standaloneCommentVariables = {
                pageId: queryVariables.pageId,
                contentStatus: queryVariables.contentStatus,
                inlineMarkerRefList: [
                    queryVariables.annotationId
                ]
            };
            const standaloneCommentResponse = cache.readQuery({
                query: (0, $1C8XP.ActiveInlineCommentsQuery),
                variables: standaloneCommentVariables
            });
            if (standaloneCommentResponse) {
                const standaloneCommentData = {
                    ...standaloneCommentResponse
                };
                const standaloneParentComment = standaloneCommentData?.comments?.nodes?.find((comment)=>comment?.id === parentCommentId);
                if (standaloneParentComment) {
                    if (actionType === 'delete') $31423c43076595b5$var$removeReplyFromCache(standaloneParentComment, commentId);
                    else $31423c43076595b5$var$addReplyToCache(standaloneParentComment, result.data, true);
                }
                // Update the comments panel query
                cache.writeQuery({
                    query: (0, $1C8XP.ActiveInlineCommentsQuery),
                    variables: standaloneCommentVariables,
                    data: standaloneCommentData
                });
            }
        } catch (err) {
            $31423c43076595b5$var$logger.error`An Error occurred when updating comments panel cache for ${actionType} reply - ${err}`;
        }
    };
const $31423c43076595b5$export$1859da3357bd460e = (isEditor, isLivePage)=>{
    if (isLivePage) return (0, $afGoD.CommentCreationLocation).LIVE;
    if (isEditor) return (0, $afGoD.CommentCreationLocation).EDITOR;
    return (0, $afGoD.CommentCreationLocation).RENDERER;
};
const $31423c43076595b5$export$c94bffbead878776 = ({ onSuccess: onSuccess, editCommentQueryId: editCommentQueryId, setCommentForEdit: setCommentForEdit, data: data, createAnalyticsEvent: createAnalyticsEvent, pageId: pageId, pageType: pageType, analyticsSource: analyticsSource, commentId: commentId, pageMode: pageMode, selectedAnnotation: selectedAnnotation, getInlineNodeTypes: getInlineNodeTypes, experienceTracker: experienceTracker, isEditor: isEditor })=>{
    onSuccess();
    if (editCommentQueryId) setCommentForEdit('');
    const replyCommentInfo = data?.replyInlineComment;
    const markerRef = replyCommentInfo?.location?.inlineMarkerRef;
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: 'created',
            actionSubject: 'comment',
            actionSubjectId: replyCommentInfo?.id,
            objectType: pageType,
            objectId: pageId,
            source: analyticsSource,
            attributes: {
                source: analyticsSource,
                commentType: (0, $en1dX.CommentType).INLINE,
                parentCommentId: commentId ?? null,
                isReply: true,
                pageMode: pageMode,
                framework: (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER,
                navdexPointType: (0, $dEBDF.END),
                inlineNodeTypes: selectedAnnotation && getInlineNodeTypes ? getInlineNodeTypes(selectedAnnotation.id) : undefined,
                targetNodeType: (0, $asNlu.getTargetNodeType)(markerRef, isEditor)
            }
        }
    }).fire();
    experienceTracker.updateAttributes({
        name: (0, $irVI7.REPLY_TO_INLINE_COMMENT_EXPERIENCE),
        attributes: {
            replyCommentId: replyCommentInfo?.id
        }
    });
    experienceTracker.succeed({
        name: (0, $irVI7.REPLY_TO_INLINE_COMMENT_PUBLISH_EXPERIENCE),
        attributes: {
            replyCommentId: replyCommentInfo?.id
        }
    });
};
const $31423c43076595b5$export$ca43168d5a4c3bfd = (allAnnotations, commentMarkerRef, previousOrderedActiveAnnotations, setOrderedActiveAnnotationIdList)=>{
    const indexInAnnotations = allAnnotations.indexOf(commentMarkerRef);
    if (indexInAnnotations === -1) throw new Error('Marker ref is not present in the annotations list');
    const insertIndex = previousOrderedActiveAnnotations.findIndex((annotation)=>allAnnotations.indexOf(annotation) > indexInAnnotations);
    const finalInsertIndex = insertIndex === -1 ? previousOrderedActiveAnnotations.length : insertIndex;
    const updatedOrderedActiveAnnotations = [
        ...previousOrderedActiveAnnotations.slice(0, finalInsertIndex),
        commentMarkerRef,
        ...previousOrderedActiveAnnotations.slice(finalInsertIndex)
    ];
    setOrderedActiveAnnotationIdList(updatedOrderedActiveAnnotations);
};
const $31423c43076595b5$export$cad0f7f0aeb719e7 = (inlineMarkerRef)=>{
    const tiny = `.inline-comment-marker[data-ref="${inlineMarkerRef}"]`;
    const fabricEditorAnnotation = `[id="${inlineMarkerRef}"][data-mark-annotation-type="inlineComment"]`;
    return Boolean(document.querySelector(`${tiny}, ${fabricEditorAnnotation}`));
};
const $31423c43076595b5$export$a5988be2401625e8 = (emojiId, actionType, objectId, pageId, selectedAnnotation, isArchived, cache)=>{
    const queryVariables = {
        pageId: pageId,
        inlineMarkerRefList: [
            selectedAnnotation.id
        ],
        contentStatus: [
            isArchived ? 'ARCHIVED' : 'DRAFT',
            'CURRENT'
        ]
    };
    try {
        const response = cache?.readQuery({
            query: (0, $1C8XP.ActiveInlineCommentsQuery),
            variables: queryVariables
        });
        if (!response?.comments?.nodes?.[0]) return;
        const comment = response.comments.nodes[0];
        let cacheReactionsSummary;
        let reply;
        // If the comment matches the comment ID, use it's reactionsSummary
        if (comment.id === objectId) cacheReactionsSummary = {
            ...comment.reactionsSummary
        };
        else {
            // Otherwise, find the reply that matches
            reply = comment.replies.find((r)=>r?.id === objectId);
            if (reply) cacheReactionsSummary = {
                ...reply.reactionsSummary
            };
        }
        if (!cacheReactionsSummary) return;
        const reactionsAri = cacheReactionsSummary.ari || '';
        const reactionsContainerAri = cacheReactionsSummary.containerAri || '';
        let reactionsCount = cacheReactionsSummary.reactionsCount || 0;
        const updatedReactionsSummary = {
            ...cacheReactionsSummary
        };
        const updatedReactionsNodes = [
            ...cacheReactionsSummary.reactionsSummaryForEmoji || []
        ];
        if (actionType === 'add') {
            const reaction = updatedReactionsNodes.find((item)=>item?.emojiId === emojiId);
            // If reaction exists, update its attributes
            if (reaction && !reaction.reacted) {
                reaction.count++;
                reaction.reacted = true;
            } else {
                // Otherwise, create a new reaction
                const newReaction = {
                    emojiId: emojiId,
                    count: 1,
                    reacted: true,
                    id: `${reactionsContainerAri}|${reactionsAri}|${emojiId}`,
                    __typename: 'ReactionsSummaryForEmoji'
                };
                updatedReactionsNodes.push(newReaction);
            }
            ++reactionsCount;
        } else if (actionType === 'delete') {
            const reactionIdx = updatedReactionsNodes.findIndex((item)=>item?.emojiId === emojiId);
            // If reaction exists, update its attributes
            if (reactionIdx !== -1) {
                const reaction = updatedReactionsNodes[reactionIdx];
                // If we have more than one reaction, remove our user from it and decrement the count
                if (reaction && reaction.count > 1) {
                    reaction.count--;
                    reaction.reacted = false;
                } else // Otherwise, remove the reaction entirely
                updatedReactionsNodes.splice(reactionIdx, 1);
                --reactionsCount;
            }
        }
        updatedReactionsSummary.reactionsSummaryForEmoji = updatedReactionsNodes;
        updatedReactionsSummary.reactionsCount = reactionsCount ?? 0;
        // Create a deep copy of the comment to ensure Apollo detects the change
        const updatedComment = {
            ...comment,
            replies: comment.replies.map((r)=>{
                if (r?.id === objectId) return {
                    ...r,
                    reactionsSummary: updatedReactionsSummary
                };
                return r;
            })
        };
        // Update the comment's reactionsSummary if it's the target comment
        if (comment.id === objectId) // @ts-ignore reactionsCount will always be defined, so the type comparison is wrong
        updatedComment.reactionsSummary = updatedReactionsSummary;
        const newData = {
            comments: {
                nodes: [
                    updatedComment
                ],
                __typename: 'PaginatedCommentList'
            }
        };
        cache?.writeQuery({
            query: (0, $1C8XP.ActiveInlineCommentsQuery),
            variables: queryVariables,
            data: newData
        });
    } catch (err) {
        $31423c43076595b5$var$logger.error`An error occurred when updating reactions cache for ${actionType} - ${err}`;
    }
};

});
parcelRegister("1C8XP", function(module, exports) {

$parcel$export(module.exports, "ActiveInlineCommentsQuery", () => $087454af48047e63$export$c9407390b0cf740d);

var $d2LG0 = parcelRequire("d2LG0");

var $hpsMA = parcelRequire("hpsMA");
const $087454af48047e63$export$c9407390b0cf740d = (0, $d2LG0.default)`query ActiveInlineCommentsQuery($inlineMarkerRefList:[String!]!$pageId:ID!$contentStatus:[GraphQLContentStatus]){comments(inlineMarkerRefList:$inlineMarkerRefList pageId:$pageId contentStatus:$contentStatus){nodes{...inlineCommentFragment location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{isDangling resolvedTime resolvedFriendlyDate resolvedUser resolved}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}createdAt{value}createdAtNonLocalized replies{...inlineCommentFragment createdAt{value}createdAtNonLocalized reactionsSummary(pageId:$pageId contentType:"page" childType:"comment"){ari containerAri reactionsCount reactionsSummaryForEmoji{id emojiId count reacted}}}reactionsSummary(pageId:$pageId contentType:"page" childType:"comment"){ari containerAri reactionsCount reactionsSummaryForEmoji{id emojiId count reacted}}}}}${(0, $hpsMA.inlineCommentFragment)}`;

});

parcelRegister("3B9cR", function(module, exports) {

$parcel$export(module.exports, "InlineCommentQuery", () => $7d2c123586cab1f2$export$5fa1043645dd2c26);

var $d2LG0 = parcelRequire("d2LG0");
const $7d2c123586cab1f2$export$5fa1043645dd2c26 = (0, $d2LG0.default)`query InlineCommentQuery($annotationId:String$pageId:ID!$contentStatus:[GraphQLContentStatus]){comments(inlineMarkerRef:$annotationId pageId:$pageId contentStatus:$contentStatus){nodes{replies{id parentId body(representation:ATLAS_DOC_FORMAT){value}createdAt{value}createdAtNonLocalized links{webui editui}author{displayName permissionType profilePicture{path}...on KnownUser{accountId}...on User{accountId}}location{type}version{by{displayName}when number}permissions{isEditable isRemovable isResolvable}reactionsSummary(pageId:$pageId contentType:"page" childType:"comment"){reactionsCount ari containerAri reactionsSummaryForEmoji{emojiId count reacted id}}}version{by{displayName}when number}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{resolved resolvedTime resolvedUser}}}id body(representation:ATLAS_DOC_FORMAT){value}createdAt{value}createdAtNonLocalized links{webui editui}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}...on User{accountId}}permissions{isEditable isRemovable isResolvable}reactionsSummary(pageId:$pageId contentType:"page" childType:"comment"){reactionsCount ari containerAri reactionsSummaryForEmoji{emojiId count reacted id}}}}}`;

});

parcelRegister("asNlu", function(module, exports) {

$parcel$export(module.exports, "getTargetNodeType", () => $bbb444f37a1f1f7f$export$2f9714b3e1fdd309);

var $ag6aQ = parcelRequire("ag6aQ");
const $bbb444f37a1f1f7f$export$2f9714b3e1fdd309 = (annotationId, isEditor)=>{
    if (!annotationId) return 'unknown';
    const elementWithAnnotationWrapper = document.querySelector(`[id="${annotationId}"]`);
    if (!elementWithAnnotationWrapper) return 'unknown';
    const captionNode = elementWithAnnotationWrapper.closest('[data-media-caption]');
    if (captionNode) return 'caption';
    if (isEditor) {
        const mediaNode = elementWithAnnotationWrapper.querySelector(`.${(0, $ag6aQ.ClassNames).MEDIA_CONTAINER}`);
        if (mediaNode) return 'media';
        // If no node is detected, return "text" as the default node type for now
        return 'text';
    } else {
        const targetNode = elementWithAnnotationWrapper.querySelector('[data-node-type]');
        if (targetNode) return targetNode.dataset.nodeType;
        // If no node is detected, return "text" as the default node type for now
        return 'text';
    }
};

});


parcelRegister("8dA1U", function(module, exports) {

$parcel$export(module.exports, "handleResolveSuccess", () => $ec302ec1fafac461$export$4c0ea2f40582e756);
$parcel$export(module.exports, "handleDeleteSuccess", () => $ec302ec1fafac461$export$6df9d2fc03993824);
$parcel$export(module.exports, "handleMutationFailure", () => $ec302ec1fafac461$export$f2f4dc3fd9171ad8);

var $21K7m = parcelRequire("21K7m");

var $cdbMf = parcelRequire("cdbMf");

var $7Sm4c = parcelRequire("7Sm4c");

var $dixVY = parcelRequire("dixVY");

var $cD1qu = parcelRequire("cD1qu");

var $dEBDF = parcelRequire("dEBDF");

var $9wGTI = parcelRequire("9wGTI");

var $isdzP = parcelRequire("isdzP");

var $kmHPt = parcelRequire("kmHPt");

var $asNlu = parcelRequire("asNlu");
const $ec302ec1fafac461$export$4c0ea2f40582e756 = ({ commentId: commentId, parentCommentMarkerRef: parentCommentMarkerRef, pageId: pageId, pageMode: pageMode, eventEmitter: eventEmitter, source: source, commentType: commentType, removeUnresolvedInlineComment: removeUnresolvedInlineComment, createAnalyticsEvent: createAnalyticsEvent, getInlineNodeTypes: getInlineNodeTypes, setEditorViewProps: setEditorViewProps })=>{
    // Update the unresolved inline comments count
    removeUnresolvedInlineComment && removeUnresolvedInlineComment(parentCommentMarkerRef);
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: 'resolved',
            actionSubject: 'comment',
            actionSubjectId: commentId,
            objectType: 'page',
            objectId: pageId,
            source: source,
            attributes: {
                source: source,
                commentType: commentType,
                pageMode: pageMode,
                framework: (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER,
                navdexPointType: (0, $dEBDF.END),
                inlineNodeTypes: parentCommentMarkerRef && getInlineNodeTypes ? getInlineNodeTypes(parentCommentMarkerRef) : undefined,
                targetNodeType: (0, $asNlu.getTargetNodeType)(parentCommentMarkerRef, pageMode !== (0, $cD1qu.PageMode).VIEW)
            }
        }
    }).fire();
    // Emit the event to mark the annotation as resolved
    if (pageMode === (0, $cD1qu.PageMode).VIEW) eventEmitter?.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_STATE, {
        [parentCommentMarkerRef]: {
            id: parentCommentMarkerRef,
            annotationType: (0, $cdbMf.AnnotationTypes).INLINE_COMMENT,
            state: (0, $cdbMf.AnnotationMarkStates).RESOLVED
        }
    });
    else {
        eventEmitter?.emit('resolve', parentCommentMarkerRef);
        setEditorViewProps && setEditorViewProps(null);
    }
};
const $ec302ec1fafac461$export$6df9d2fc03993824 = ({ commentId: commentId, annotationId: annotationId, pageId: pageId, pageMode: pageMode, isReply: isReply, source: source, inlineNodeTypes: inlineNodeTypes, removeUnresolvedInlineComment: removeUnresolvedInlineComment, createAnalyticsEvent: createAnalyticsEvent, onSuccess: onSuccess })=>{
    if (!annotationId) throw new Error('No annotationId for delete');
    // Update the unresolved inline comments count
    removeUnresolvedInlineComment(annotationId);
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: 'deleted',
            actionSubject: 'comment',
            actionSubjectId: commentId,
            objectType: 'page',
            objectId: pageId,
            source: source,
            attributes: {
                commentType: 'inline',
                mode: pageMode,
                framework: (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER,
                inlineNodeTypes: inlineNodeTypes,
                isReply: isReply,
                targetNodeType: (0, $asNlu.getTargetNodeType)(annotationId, pageMode !== (0, $cD1qu.PageMode).VIEW)
            }
        }
    }).fire();
    // Call the function passed in to do success specific things for each iteration
    onSuccess(annotationId);
};
const $ec302ec1fafac461$export$f2f4dc3fd9171ad8 = ({ experienceTracker: experienceTracker, experienceName: experienceName, error: error, commentId: commentId, shouldReturnError: shouldReturnError = false, shouldAbortForExpectedError: shouldAbortForExpectedError = false, compoundExperienceName: compoundExperienceName })=>{
    // get a truncated graphql error message
    const { message: message } = (0, $isdzP.parseError)(error);
    const translatedError = (0, $isdzP.getTranslatedError)(message, commentId);
    if ((0, $isdzP.isUnexpectedError)(translatedError)) {
        experienceTracker.stopOnError({
            name: experienceName,
            error: error
        });
        /*
		 * stopOnError will fail the experience unless it's a session or network error, then it will be aborted.
		 * If the experience is failed and is a sub-experience, the compound experience will be failed automatically.
		 * If the experience is aborted and is a sub-experience, we need to abort the compound experience.
		 */ if (compoundExperienceName && (0, $9wGTI.fg)('confluence_frontend_improve_handle_mutation_fail')) {
            const experienceState = experienceTracker.getExperienceState(experienceName);
            if (experienceState?.stopState === (0, $dixVY.ExperienceStopStates).TASK_ABORT) experienceTracker.stopOnError({
                name: compoundExperienceName,
                error: error
            });
        }
    } else {
        // we currently display a generic message to the user whenever an error occurs
        // These errors will not be reported to splunk/signalfx through experience tracking as they are expected
        (0, $7Sm4c.markErrorAsHandled)(error);
        if (shouldAbortForExpectedError && (0, $9wGTI.fg)('confluence_frontend_improve_handle_mutation_fail')) {
            // Ensure reason is always a string
            const reason = typeof translatedError.defaultMessage === 'string' ? translatedError.defaultMessage : message;
            experienceTracker.abort({
                name: experienceName,
                reason: reason
            });
            // If a compound experience is also running, we need to abort it
            if (compoundExperienceName) experienceTracker.abort({
                name: compoundExperienceName,
                reason: reason
            });
        }
    }
    if (shouldReturnError) // CommentEditor expects a translated error message otherwise it fails
    // TODO: CommentEditor should likely just receive the translated message
    // rather than expect the object needed for FormattedMessage
    return Promise.reject({
        error: translatedError
    });
};

});
parcelRegister("dixVY", function(module, exports) {

$parcel$export(module.exports, "ExperienceStopStates", () => $8237d31e7e86c8c4$export$ae89b6b0e7b50e02);
const $8237d31e7e86c8c4$export$ae89b6b0e7b50e02 = {
    TASK_FAIL: 'taskFail',
    TASK_SUCCESS: 'taskSuccess',
    TASK_ABORT: 'taskAbort'
};

});

parcelRegister("isdzP", function(module, exports) {

$parcel$export(module.exports, "parseError", () => $e5083fb3da68bf8e$export$e80a9284539c1797);
$parcel$export(module.exports, "getTranslatedError", () => $e5083fb3da68bf8e$export$a67f8c1198066537);
$parcel$export(module.exports, "isHighlightError", () => $e5083fb3da68bf8e$export$336db91bab9fb3ba);
$parcel$export(module.exports, "isUnexpectedError", () => $e5083fb3da68bf8e$export$68de2e41a5e9d0c3);
$parcel$export(module.exports, "isAnnotationError", () => $e5083fb3da68bf8e$export$fb2e61e668e6b1d2);
$parcel$export(module.exports, "isOutOfDateError", () => $e5083fb3da68bf8e$export$81795bac145b8560);
$parcel$export(module.exports, "isAlreadyDeletedError", () => $e5083fb3da68bf8e$export$b2e3f629cad072ef);

var $fJlJm = parcelRequire("fJlJm");

var $hL41C = parcelRequire("hL41C");

var $9CnRS = parcelRequire("9CnRS");
const $e5083fb3da68bf8e$export$e80a9284539c1797 = (error)=>{
    const { message: message } = error;
    let errorMessage = '';
    const parsedError = {
        message: errorMessage,
        isAuthorized: false
    };
    /* If this is a GraphQL error we need to extract the data out of it
   * GraphQL errors that are returned from mutations always have the same format:
   * GraphQL error: <GUID>: <EXCEPTION>: <REASON>
   * The GUID correlates to the microsId so it unfortunately doesn't do much for us
   * With this in mind, we want to extract the REASON as the message for translation
   */ if (message.indexOf('GraphQL error:') !== -1) {
        const reasonStartIdx = message.lastIndexOf(':') + 1;
        errorMessage = message.substr(reasonStartIdx, message.length - reasonStartIdx).trim();
        // Extract the traceId for highlight errors
        parsedError.errorId = (0, $fJlJm.getLogSafeErrorAttributes)(error).traceId;
    } else errorMessage = message;
    parsedError.message = errorMessage;
    // If we have an ApolloError, extract the status code and the authorization status
    const { graphQLErrors: graphQLErrors } = error;
    if (graphQLErrors && graphQLErrors.length) {
        parsedError.statusCode = graphQLErrors?.[0]?.extensions?.statusCode;
        parsedError.isAuthorized = graphQLErrors?.[0]?.extensions?.data?.authorized || false;
    }
    return parsedError;
};
const $e5083fb3da68bf8e$export$a67f8c1198066537 = (message, id = '')=>{
    let i18nError;
    // COMMENTS-4199 - This is our own handling of the error thrown by the editor/renderer that we wrap
    //				   in our own message, so to preserve the original error we just check for our message
    if (message.includes('Unable to apply annotation to document')) {
        if (message.includes('Failed to create annotation')) i18nError = (0, $9CnRS.i18n).unableToApplyDanglingCommentAnnotation;
        else i18nError = (0, $9CnRS.i18n).unableToApplyAnnotation;
    } else switch(message){
        case (0, $hL41C.InlineCommentError).INVALID_SELECTION:
        case (0, $hL41C.InlineCommentError).FAILED_TO_INSERT_MARK:
            i18nError = (0, $9CnRS.i18n).invalidHighlight;
            break;
        case (0, $hL41C.InlineCommentError).STALE_SELECTION:
            i18nError = (0, $9CnRS.i18n).staleContent;
            break;
        case (0, $hL41C.InlineCommentError).NO_ANONYMOUS_ACCESS:
            i18nError = (0, $9CnRS.i18n).actionNotPermitted;
            break;
        case (0, $hL41C.InlineCommentError).NO_COMMENTS_FOUND_FOR_GIVEN_MARKER_REF:
            i18nError = (0, $9CnRS.i18n).noCommentsFoundForGivenMarkerRef;
            break;
        case (0, $hL41C.InlineCommentError).NO_VIEW_PERMS:
            i18nError = (0, $9CnRS.i18n).viewNotPermitted;
            break;
        case (0, $hL41C.InlineCommentError).NO_UPDATE_PERMS.replace('%d', id ? id : ''):
            i18nError = (0, $9CnRS.i18n).editNotPermitted;
            break;
        case (0, $hL41C.InlineCommentError).NO_DELETE_PERMS:
            i18nError = (0, $9CnRS.i18n).deleteNotPermitted;
            break;
        case (0, $hL41C.InlineCommentError).NO_DELETE_WITH_CHILDREN:
            i18nError = (0, $9CnRS.i18n).deleteWithRepliesNotAllowed;
            break;
        case (0, $hL41C.InlineCommentError).NO_CREATE_PERMS:
            i18nError = (0, $9CnRS.i18n).createNotPermitted;
            break;
        case (0, $hL41C.InlineCommentError).UPDATE_COMMENT_NOT_FOUND.replace('%d', id ? id : ''):
        case (0, $hL41C.InlineCommentError).COMMENT_ALREADY_DELETED.replace('%d', id ? id : ''):
        case (0, $hL41C.InlineCommentError).CANNOT_RESOLVE_DELETED_COMMENT.replace('%d', id ? id : ''):
            i18nError = (0, $9CnRS.i18n).commentAlreadyDeleted;
            break;
        case (0, $hL41C.InlineCommentError).CANNOT_REPLY_TO_DELETED_PARENT:
            i18nError = (0, $9CnRS.i18n).replyNotAllowedParentDeleted;
            break;
        case (0, $hL41C.InlineCommentError).INVALID_ARGUMENT_MATCHES:
            i18nError = (0, $9CnRS.i18n).contentHasBeenRemoved;
            break;
        case (0, $hL41C.InlineCommentError).CANNOT_REPLY_TO_RESOLVED_COMMENT:
            i18nError = (0, $9CnRS.i18n).cannotReplyToResolvedComment;
            break;
        case (0, $hL41C.InlineCommentError).CANNOT_UPDATE_RESOLVED_COMMENT:
            i18nError = (0, $9CnRS.i18n).cannotUpdateResolvedComment;
            break;
        case (0, $hL41C.InlineCommentError).CONTENT_OUT_OF_DATE:
            i18nError = (0, $9CnRS.i18n).contentOutOfDate;
            break;
        case (0, $hL41C.InlineCommentError).INVALID_ARGUMENT_CREATED_FROM:
        case (0, $hL41C.InlineCommentError).CREATE_COMMENT_NOT_FOUND.replace('%d', id ? id : ''):
        case (0, $hL41C.InlineCommentError).PARENT_NOT_FOUND.replace('%d', id ? id : ''):
        case (0, $hL41C.InlineCommentError).INCOMPATIBLE_PARENT_TYPE:
        case (0, $hL41C.InlineCommentError).DELETE_ERROR:
        default:
            i18nError = (0, $9CnRS.i18n).unexpectedError;
            break;
    }
    return i18nError;
};
const $e5083fb3da68bf8e$export$336db91bab9fb3ba = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).invalidHighlight.id;
const $e5083fb3da68bf8e$export$68de2e41a5e9d0c3 = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).unexpectedError.id;
const $e5083fb3da68bf8e$export$fb2e61e668e6b1d2 = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).unableToApplyAnnotation.id || translatedMessage.id === (0, $9CnRS.i18n).unableToApplyDanglingCommentAnnotation.id;
const $e5083fb3da68bf8e$export$81795bac145b8560 = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).contentOutOfDate.id || translatedMessage.id === (0, $9CnRS.i18n).staleContent.id;
const $e5083fb3da68bf8e$export$b2e3f629cad072ef = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).commentAlreadyDeleted.id;

});
parcelRegister("hL41C", function(module, exports) {

$parcel$export(module.exports, "InlineCommentError", () => $4bdefc881ecc3bb8$export$317614131ad59950);
var $4bdefc881ecc3bb8$export$317614131ad59950 = /*#__PURE__*/ function(InlineCommentError) {
    InlineCommentError["INVALID_SELECTION"] = "Invalid text selection. Cannot create inline comments on macros (mentions, images, emojis, etc.)";
    InlineCommentError["FAILED_TO_INSERT_MARK"] = "Failed to insert highlight, invalid originalSelection, numMatches, or matchIndex";
    InlineCommentError["INVALID_ARGUMENT_CREATED_FROM"] = "Invalid createdFrom, please specify if created from editor or renderer";
    InlineCommentError["STALE_SELECTION"] = "Selection was made against a stale version of the content";
    InlineCommentError["NO_ANONYMOUS_ACCESS"] = "Anonymous access is not permitted";
    InlineCommentError["NO_COMMENTS_FOUND_FOR_GIVEN_MARKER_REF"] = "No comments found for the given markerRef";
    InlineCommentError["NO_VIEW_PERMS"] = "User doesn't have VIEW permission for this comment";
    // Create Reply
    InlineCommentError["CREATE_COMMENT_NOT_FOUND"] = "Content with id %d for comment container is not found. Please provide correct container id.";
    InlineCommentError["PARENT_NOT_FOUND"] = "Parent comment with id %d is not found. Please provide correct parent comment id.";
    InlineCommentError["INCOMPATIBLE_PARENT_TYPE"] = "Incompatible parent type. Please provide comment id.";
    InlineCommentError["CANNOT_REPLY_TO_DELETED_PARENT"] = "Cannot add reply to a deleted comment";
    InlineCommentError["CANNOT_REPLY_TO_RESOLVED_COMMENT"] = "Inline comment in RESOLVED status cannot be replied";
    // Delete
    // This is the error message for a NotFoundException only
    InlineCommentError["DELETE_ERROR"] = "Exception occurred while deleting comment with id";
    InlineCommentError["NO_DELETE_PERMS"] = "Parent page view is restricted";
    InlineCommentError["NO_DELETE_WITH_CHILDREN"] = "Inline comment with child cannot be deleted.";
    InlineCommentError["COMMENT_ALREADY_DELETED"] = "Exception occurred while deleting comment with id %d";
    // Edit
    InlineCommentError["NO_UPDATE_PERMS"] = "Could not update Content of type  = class com.atlassian.confluence.pages.Comment with id %d";
    InlineCommentError["UPDATE_COMMENT_NOT_FOUND"] = "Could not find Comment for update with id CommentId{id=%d}";
    InlineCommentError["CANNOT_UPDATE_RESOLVED_COMMENT"] = "Inline comment in RESOLVED status cannot be updated";
    // Create
    InlineCommentError["NO_CREATE_PERMS"] = "Could not create content with type comment";
    InlineCommentError["INVALID_ARGUMENT_MATCHES"] = "Invalid arguments provided for matchIndex and/or numMatches";
    InlineCommentError["CONTENT_OUT_OF_DATE"] = "Published Version out of date. Please provide correct published version.";
    InlineCommentError["UNABLE_TO_APPLY_ANNOTATION"] = "Unable to apply annotation to document";
    // Resolve
    InlineCommentError["CANNOT_RESOLVE_DELETED_COMMENT"] = "%d must be existing and be an inline comment";
    return InlineCommentError;
}({});

});



parcelRegister("87CZC", function(module, exports) {

$parcel$export(module.exports, "updateApolloCacheParentCallback", () => $80b47fa0b569ef69$export$a02bedef5e94d20c);
$parcel$export(module.exports, "updateApolloCacheReplyCallback", () => $80b47fa0b569ef69$export$bab18f310e4f95e8);
$parcel$export(module.exports, "updateFooterApolloCacheOnEdit", () => $80b47fa0b569ef69$export$aee61debd6ae89df);
$parcel$export(module.exports, "handleCreateReplySuccess", () => $80b47fa0b569ef69$export$c94bffbead878776);

var $lRn1m = parcelRequire("lRn1m");

var $7W8i8 = parcelRequire("7W8i8");

var $eg9xl = parcelRequire("eg9xl");

var $cD1qu = parcelRequire("cD1qu");

var $irVI7 = parcelRequire("irVI7");

var $dEBDF = parcelRequire("dEBDF");

var $9wGTI = parcelRequire("9wGTI");

var $en1dX = parcelRequire("en1dX");

var $2i3To = parcelRequire("2i3To");

var $ftXPY = parcelRequire("ftXPY");
const $80b47fa0b569ef69$var$logger = (0, $7W8i8.getLogger)('page-comments-queries');
const $80b47fa0b569ef69$export$a02bedef5e94d20c = (actionType, queryVariables, isReactionsEnabled, commentId)=>(cache, result)=>{
        // If the mutation fails, don't do anything
        if (!result || !result.data) return;
        const { pageId: pageId, contentStatus: contentStatus } = queryVariables;
        try {
            // Update the comments panel data
            const commentsPanelCacheResponse = cache.readQuery({
                query: (0, $eg9xl.ActiveCommentsQuery),
                variables: {
                    pageId: pageId,
                    contentStatus: contentStatus
                }
            });
            if (commentsPanelCacheResponse) {
                const cacheDataClone = {
                    ...commentsPanelCacheResponse
                };
                const panelNodes = cacheDataClone?.comments?.nodes || [];
                if (actionType === 'delete') {
                    // Remove the returned commentId from the cache and reset it
                    const idxToRemove = panelNodes.findIndex((comment)=>comment?.id === commentId);
                    if (idxToRemove !== -1) panelNodes.splice(idxToRemove, 1);
                } else {
                    const mutationResult = {
                        ...result.data.createFooterComment,
                        replies: []
                    };
                    // Add the new reply entry to the cache and reset it
                    panelNodes.push(mutationResult);
                }
                cache.writeQuery({
                    query: (0, $eg9xl.ActiveCommentsQuery),
                    variables: {
                        pageId: pageId,
                        contentStatus: contentStatus
                    },
                    data: cacheDataClone
                });
            }
            const commentsSectionQuery = isReactionsEnabled ? (0, $ftXPY.CommentsSectionQuery) : (0, $ftXPY.CommentsSectionWithoutReactionsQuery);
            // Update the comments section data
            const commentsSectionCacheResponse = cache.readQuery({
                query: commentsSectionQuery,
                variables: {
                    contentId: pageId,
                    offset: '',
                    first: (0, $2i3To.DEFAULT_LIMIT)
                }
            });
            if (commentsSectionCacheResponse) {
                // grab the parent comment for the comments panel
                const commentSectionCacheDataClone = {
                    ...commentsSectionCacheResponse
                };
                const commentEdges = commentSectionCacheDataClone?.comments?.edges || [];
                if (actionType === 'delete') {
                    // Find the last index of the top level comment to delete
                    const indexToDelete = commentEdges?.findIndex((edge)=>edge?.node?.id === commentId);
                    if (indexToDelete !== -1) commentEdges.splice(indexToDelete, 1);
                } else if ((0, $9wGTI.fg)('confluence_frontend_comments_synced_comment_create')) {
                    const mutationResult = {
                        ...result.data.createFooterComment
                    };
                    // As far as I can tell, this is always called w/o reactions enabled
                    // This maps the mutation result we get to the cache object that's expected by the comments section query
                    const cacheCommentObject = {
                        id: mutationResult.id,
                        ancestors: [],
                        author: {
                            ...mutationResult.author,
                            type: 'known'
                        },
                        body: mutationResult.body,
                        contentStatus: mutationResult.contentStatus,
                        links: {
                            webui: mutationResult.links.webui,
                            // @ts-ignore
                            __typename: mutationResult.links.__typename
                        },
                        location: mutationResult.location,
                        parentId: mutationResult.parentId,
                        permissions: mutationResult.permissions,
                        version: {
                            ...mutationResult.version,
                            friendlyWhen: 'Just now',
                            by: {
                                type: 'user',
                                displayName: '',
                                accountId: '',
                                __typename: 'User'
                            },
                            __typename: 'Version'
                        },
                        __typename: 'Comment'
                    };
                    // The cache will throw an error if we don't do this ¯\_(ツ)_/¯
                    const cacheContentDeepCopy = JSON.parse(JSON.stringify(cacheCommentObject));
                    const newEdge = {
                        cursor: (commentEdges.length - 1).toString(),
                        node: cacheContentDeepCopy,
                        __typename: 'CommentEdge'
                    };
                    const insertAfterIndex = commentEdges.length - 1;
                    // Put the new reply in the array
                    commentEdges.splice(insertAfterIndex + 1, 0, newEdge);
                } else {
                    const mutationResult = {
                        ...result.data.createFooterComment,
                        ancestors: []
                    };
                    // We always add the new comment to the end of the list until we sort (deal with that later)
                    const insertAfterIndex = commentEdges.length - 1;
                    // Put the new reply in the array
                    commentEdges.splice(insertAfterIndex + 1, 0, {
                        cursor: (insertAfterIndex + 1).toString(),
                        node: mutationResult,
                        __typename: 'CommentEdge'
                    });
                }
                cache.writeQuery({
                    query: commentsSectionQuery,
                    variables: {
                        contentId: pageId,
                        offset: '',
                        first: (0, $2i3To.DEFAULT_LIMIT)
                    },
                    data: {
                        ...commentSectionCacheDataClone,
                        comments: {
                            ...commentSectionCacheDataClone.comments,
                            totalCount: commentEdges.length,
                            pageInfo: {
                                ...commentSectionCacheDataClone.comments?.pageInfo,
                                endCursor: actionType === 'delete' ? '' : (commentEdges.length - 1).toString(),
                                hasNextPage: false
                            },
                            edges: commentEdges
                        }
                    }
                });
            }
        } catch (err) {
            $80b47fa0b569ef69$var$logger.error`An Error occurred when updating cache for ${actionType} - ${err}`;
        }
    };
const $80b47fa0b569ef69$export$bab18f310e4f95e8 = (actionType, queryVariables, parentCommentId, isReactionsEnabled, commentId)=>(cache, result)=>{
        // If the mutation fails, don't do anything
        if (!result || !result.data) return;
        const { pageId: pageId, contentStatus: contentStatus } = queryVariables;
        try {
            // Update the comments panel data
            const commentsPanelCacheResponse = cache.readQuery({
                query: (0, $eg9xl.ActiveCommentsQuery),
                variables: {
                    pageId: pageId,
                    contentStatus: contentStatus
                }
            });
            if (commentsPanelCacheResponse) {
                // grab the parent comment for the comments panel
                const commentsPanelCacheData = Object.assign({}, commentsPanelCacheResponse);
                const commentsPanelParentComment = commentsPanelCacheData?.comments?.nodes?.find((comment)=>comment?.id === parentCommentId);
                if (commentsPanelParentComment) {
                    if (actionType === 'delete') {
                        // Remove the returned commentId from the cache and reset it
                        const idxToRemove = commentsPanelParentComment.replies.findIndex((reply)=>reply?.id === commentId);
                        if (idxToRemove !== -1) commentsPanelParentComment.replies.splice(idxToRemove, 1);
                    } else {
                        const mutationResult = result.data.createFooterComment;
                        // Add the new reply entry to the cache and reset it
                        commentsPanelParentComment.replies.push(mutationResult);
                    }
                    cache.writeQuery({
                        query: (0, $eg9xl.ActiveCommentsQuery),
                        variables: {
                            pageId: pageId,
                            contentStatus: contentStatus
                        },
                        data: commentsPanelCacheData
                    });
                }
            }
        } catch (err) {
            $80b47fa0b569ef69$var$logger.error`An Error occurred when updating comments panel cache for ${actionType} reply - ${err}`;
        }
        try {
            const commentsSectionQuery = isReactionsEnabled ? (0, $ftXPY.CommentsSectionQuery) : (0, $ftXPY.CommentsSectionWithoutReactionsQuery);
            // Update the comments section data
            const commentsSectionCacheResponse = cache.readQuery({
                query: commentsSectionQuery,
                variables: {
                    contentId: pageId,
                    offset: '',
                    first: (0, $2i3To.DEFAULT_LIMIT)
                }
            });
            if (commentsSectionCacheResponse) {
                // grab the parent comment for the comments panel
                const commentsSectionCacheData = {
                    ...commentsSectionCacheResponse
                };
                const commentEdges = commentsSectionCacheData?.comments?.edges || [];
                const parentCommentIdx = commentEdges?.findIndex((commentEdge)=>commentEdge?.node?.id === parentCommentId);
                if (parentCommentIdx !== -1) {
                    if (actionType === 'delete') {
                        // Find the last index of the comment to delete
                        const indexToDelete = commentEdges?.findIndex((edge)=>edge?.node?.id === commentId);
                        if (indexToDelete !== -1) commentEdges.splice(indexToDelete, 1);
                    } else if ((0, $9wGTI.fg)('confluence_frontend_comments_synced_comment_create')) {
                        const mutationResult = {
                            ...result.data.createFooterComment
                        };
                        // As far as I can tell, this is always called w/o reactions enabled
                        // This maps the mutation result we get to the cache object that's expected by the comments section query
                        const cacheCommentObject = {
                            id: mutationResult.id,
                            ancestors: [
                                {
                                    id: mutationResult.parentId,
                                    __typename: 'Comment'
                                }
                            ],
                            author: {
                                ...mutationResult.author,
                                type: 'known'
                            },
                            body: mutationResult.body,
                            contentStatus: mutationResult.contentStatus,
                            links: {
                                webui: mutationResult.links.webui,
                                // @ts-ignore
                                __typename: mutationResult.links.__typename
                            },
                            location: mutationResult.location,
                            parentId: mutationResult.parentId,
                            permissions: mutationResult.permissions,
                            version: {
                                ...mutationResult.version,
                                friendlyWhen: 'Just now',
                                by: {
                                    type: 'user',
                                    displayName: '',
                                    accountId: '',
                                    __typename: 'User'
                                },
                                __typename: 'Version'
                            },
                            __typename: 'Comment'
                        };
                        // The cache will throw an error if we don't do this ¯\_(ツ)_/¯
                        const cacheContentDeepCopy = JSON.parse(JSON.stringify(cacheCommentObject));
                        const newEdge = {
                            cursor: (commentEdges.length - 1).toString(),
                            node: cacheContentDeepCopy,
                            __typename: 'CommentEdge'
                        };
                        // Find the last index of the thread to insert the reply
                        const threadLastCommentIdx = commentEdges?.findLastIndex((edge)=>edge?.node?.parentId === parentCommentId);
                        // If we can't find it, the parent has no replies
                        const insertAfterIndex = threadLastCommentIdx !== -1 ? threadLastCommentIdx : parentCommentIdx;
                        // Put the new reply in the array
                        commentEdges.splice(insertAfterIndex + 1, 0, newEdge);
                    } else {
                        const mutationResult = {
                            ...result.data.createFooterComment,
                            ancestors: [
                                {
                                    id: parentCommentId
                                }
                            ]
                        };
                        // Find the last index of the thread to insert the reply
                        const threadLastCommentIdx = commentEdges?.findLastIndex((edge)=>edge?.node?.parentId === parentCommentId);
                        // If we can't find it, the parent has no replies
                        const insertAfterIndex = threadLastCommentIdx !== -1 ? threadLastCommentIdx : parentCommentIdx;
                        // Put the new reply in the array
                        commentEdges.splice(insertAfterIndex + 1, 0, {
                            cursor: (insertAfterIndex + 1).toString(),
                            node: mutationResult,
                            __typename: 'CommentEdge'
                        });
                    }
                    cache.writeQuery({
                        query: commentsSectionQuery,
                        variables: {
                            contentId: pageId,
                            offset: '',
                            first: (0, $2i3To.DEFAULT_LIMIT)
                        },
                        data: {
                            ...commentsSectionCacheData,
                            comments: {
                                ...commentsSectionCacheData.comments,
                                totalCount: commentEdges.length,
                                pageInfo: {
                                    ...commentsSectionCacheData.comments?.pageInfo,
                                    endCursor: actionType === 'delete' ? '' : (commentEdges.length - 1).toString(),
                                    hasNextPage: false
                                },
                                edges: commentEdges
                            }
                        }
                    });
                }
            }
        } catch (err) {
            $80b47fa0b569ef69$var$logger.error`An Error occurred when updating general comments cache for ${actionType} reply - ${err}`;
        }
    };
const $80b47fa0b569ef69$export$aee61debd6ae89df = (commentId, newBody, pageId, isReactionsEnabled, cache, sessionDisplayName)=>{
    const commentsSectionQuery = isReactionsEnabled ? (0, $ftXPY.CommentsSectionQuery) : (0, $ftXPY.CommentsSectionWithoutReactionsQuery);
    try {
        // Update the comments section data
        const commentsSectionCacheData = cache.readQuery({
            query: commentsSectionQuery,
            variables: {
                contentId: pageId,
                offset: '',
                first: (0, $2i3To.DEFAULT_LIMIT)
            }
        });
        if (commentsSectionCacheData) {
            // grab the parent comment for the comments panel
            const commentEdges = commentsSectionCacheData?.comments?.edges || [];
            const commentIdx = commentEdges?.findIndex((commentEdge)=>commentEdge?.node?.id === commentId);
            if (commentIdx !== undefined && commentIdx !== null && commentIdx !== -1 && commentEdges[commentIdx]?.node?.body && commentEdges[commentIdx]?.node?.version?.number) {
                // Find the index to update. TS will throw an error even though we've already checked the index is valid
                // @ts-ignore
                commentEdges[commentIdx].node.body.value = newBody; // Update the body we keep in the footer cache
                // @ts-ignore
                commentEdges[commentIdx].node.version.number += 1; // This is required for the propagated footer version to also be editable
                // @ts-ignore
                (0, (/*@__PURE__*/$parcel$interopDefault($lRn1m)))(commentEdges[commentIdx].node, 'version.by.displayName', sessionDisplayName); // Update the display name to the user who edited the comment
                // @ts-ignore
                (0, (/*@__PURE__*/$parcel$interopDefault($lRn1m)))(commentEdges[commentIdx].node, 'version.when', new Date().toISOString()); // Update the version date to the date of the edit
            }
            cache.writeQuery({
                query: commentsSectionQuery,
                variables: {
                    contentId: pageId,
                    offset: '',
                    first: (0, $2i3To.DEFAULT_LIMIT)
                },
                data: {
                    ...commentsSectionCacheData,
                    comments: {
                        ...commentsSectionCacheData.comments,
                        totalCount: commentEdges.length,
                        pageInfo: {
                            ...commentsSectionCacheData.comments?.pageInfo,
                            endCursor: Math.random().toString(),
                            hasNextPage: false
                        },
                        edges: commentEdges
                    }
                }
            });
        }
    } catch (err) {
        $80b47fa0b569ef69$var$logger.error`An Error occurred when updating cache for edit footer reply - ${err}`;
    }
};
const $80b47fa0b569ef69$export$c94bffbead878776 = ({ onSuccess: onSuccess, editCommentQueryId: editCommentQueryId, setCommentForEdit: setCommentForEdit, data: data, createAnalyticsEvent: createAnalyticsEvent, pageId: pageId, pageType: pageType, analyticsSource: analyticsSource, commentId: commentId, pageMode: pageMode, experienceTracker: experienceTracker, searchSessionId: searchSessionId })=>{
    onSuccess();
    if (editCommentQueryId) setCommentForEdit && setCommentForEdit('');
    const replyCommentInfo = data?.createFooterComment;
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: 'created',
            actionSubject: 'comment',
            actionSubjectId: replyCommentInfo?.id,
            objectType: pageType,
            objectId: pageId,
            source: analyticsSource,
            attributes: {
                commentType: (0, $en1dX.CommentType).GENERAL,
                source: analyticsSource,
                pageType: pageType,
                isReply: true,
                pageMode: pageMode,
                isLivePage: pageMode === (0, $cD1qu.PageMode).LIVE,
                editor: 'v2',
                searchSessionId: searchSessionId,
                navdexPointType: (0, $dEBDF.END),
                parentCommentId: commentId ?? null
            }
        }
    }).fire();
    experienceTracker.succeed({
        name: (0, $9wGTI.fg)('confluence_frontend_separate_add_page_comment') ? (0, $irVI7.REPLY_TO_PAGE_COMMENT_PUBLISH_EXPERIENCE) : (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE)
    });
};

});

parcelRegister("vFbJD", function(module, exports) {

$parcel$export(module.exports, "ContentRepresentation", () => $fa7a458b6cf5b633$export$f4016897b165b6d5);
$parcel$export(module.exports, "Platform", () => $fa7a458b6cf5b633$export$2dffd0b5373a4389);
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $fa7a458b6cf5b633$export$f4016897b165b6d5 = /*#__PURE__*/ function(ContentRepresentation) {
    ContentRepresentation["ATLAS_DOC_FORMAT"] = "ATLAS_DOC_FORMAT";
    ContentRepresentation["EDITOR"] = "EDITOR";
    ContentRepresentation["EDITOR2"] = "EDITOR2";
    ContentRepresentation["EXPORT_VIEW"] = "EXPORT_VIEW";
    ContentRepresentation["PLAIN"] = "PLAIN";
    ContentRepresentation["RAW"] = "RAW";
    ContentRepresentation["STORAGE"] = "STORAGE";
    ContentRepresentation["STYLED_VIEW"] = "STYLED_VIEW";
    ContentRepresentation["VIEW"] = "VIEW";
    ContentRepresentation["WIKI"] = "WIKI";
    return ContentRepresentation;
}({});
var $fa7a458b6cf5b633$export$2dffd0b5373a4389 = /*#__PURE__*/ function(Platform) {
    Platform["ANDROID"] = "ANDROID";
    Platform["IOS"] = "IOS";
    Platform["WEB"] = "WEB";
    return Platform;
}({});
var $fa7a458b6cf5b633$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});

});


parcelRegister("cAdj8", function(module, exports) {

$parcel$export(module.exports, "usePageInfo", () => $a1394411ec7881e4$export$7b2dac1793a2824);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $7Sm4c = parcelRequire("7Sm4c");

var $ep3mz = parcelRequire("ep3mz");

var $dIouf = parcelRequire("dIouf");

var $flE5X = parcelRequire("flE5X");
const $a1394411ec7881e4$var$usePageInfoPageInfoQuery = (0, $d2LG0.default)`query usePageInfoPageInfoQuery($pageId:ID){content(id:$pageId status:["current" "archived" "draft"]){nodes{id type space{id}operations{operation targetType}version{number}}}}`;
const $a1394411ec7881e4$export$e1b9843c9a40eb2 = {
    id: '',
    type: '',
    space: {
        id: ''
    },
    operations: [],
    version: {
        number: -1
    }
};
const $a1394411ec7881e4$export$7b2dac1793a2824 = ({ fetchPolicy: fetchPolicy = 'cache-and-network', onCompleted: onCompleted, onError: onError } = {})=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $j1Ss3.useQuery)($a1394411ec7881e4$var$usePageInfoPageInfoQuery, {
        variables: {
            pageId: contentId
        },
        fetchPolicy: fetchPolicy,
        onCompleted: onCompleted
    });
    return (0, $gwFzn.useMemo)(()=>{
        // Handle error case first
        if (error) {
            if ((0, $dIouf.isUnauthorizedError)(error) || error instanceof (0, $flE5X.NoNetworkError)) (0, $7Sm4c.markErrorAsHandled)(error);
            onError?.(error);
            return {
                pageInfo: null,
                loading: false,
                error: error,
                refetch: null
            };
        }
        // If we have data, use it even during loading
        if (data) {
            const pageInfoNode = data.content?.nodes?.[0] ?? null;
            if (pageInfoNode) return {
                pageInfo: pageInfoNode,
                loading: loading,
                error: undefined,
                refetch: refetch
            };
            return {
                pageInfo: {
                    ...$a1394411ec7881e4$export$e1b9843c9a40eb2
                },
                loading: loading,
                error: undefined,
                refetch: refetch
            };
        }
        // Only return null pageInfo if we have no data at all
        return {
            pageInfo: null,
            loading: loading,
            error: undefined,
            refetch: null
        };
    }, [
        data,
        loading,
        error,
        onError,
        refetch
    ]);
};

});

parcelRegister("5fMeR", function(module, exports) {

$parcel$export(module.exports, "useShowCommentsPanel", () => $3b7f940e5fdc8097$export$833f9a16214bbf3d);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");

var $21K7m = parcelRequire("21K7m");

var $9wGTI = parcelRequire("9wGTI");

var $jvYFk = parcelRequire("jvYFk");
var $aWwYt = parcelRequire("aWwYt");

var $gfqXk = parcelRequire("gfqXk");
var $gczDe = parcelRequire("gczDe");

var $cD1qu = parcelRequire("cD1qu");

var $aSsfA = parcelRequire("aSsfA");

var $htsj6 = parcelRequire("htsj6");

var $cZa7r = parcelRequire("cZa7r");

var $3mVfX = parcelRequire("3mVfX");

var $ep3mz = parcelRequire("ep3mz");

var $dANtQ = parcelRequire("dANtQ");

var $gEtAQ = parcelRequire("gEtAQ");

var $1kHsc = parcelRequire("1kHsc");
var $irVI7 = parcelRequire("irVI7");

var $cMvMc = parcelRequire("cMvMc");

var $8aF6s = parcelRequire("8aF6s");

var $bSvtO = parcelRequire("bSvtO");

var $g9dNl = parcelRequire("g9dNl");

var $gFN6K = parcelRequire("gFN6K");

var $ioFqb = parcelRequire("ioFqb");

var $5hqV2 = parcelRequire("5hqV2");

var $9buj5 = parcelRequire("9buj5");
const $3b7f940e5fdc8097$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    commentsPanelHeaderLabel: {
        id: "comments-panel.panel.header.label",
        defaultMessage: "Comments"
    }
});
const $3b7f940e5fdc8097$export$833f9a16214bbf3d = ()=>{
    const isSpaceOverviewPage = (0, $gEtAQ.isSpaceOverview)();
    const { handleMarkCommentsAsRead: handleMarkCommentsAsRead } = (0, $9buj5.useUnreadPanelComments)();
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    const [shouldClearUnreads, setShouldClearUnreads] = (0, $gwFzn.useState)(false);
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const { showObjectSidebar: showObjectSidebar, hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { setViewProps: setViewProps, setEditorViewProps: setEditorViewProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const { setCurrentView: setCurrentView, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey } = (0, $3mVfX.useCommentsPanelActions)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId ?? '', true);
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const eventEmitter = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $gczDe.getRendererAnnotationEventEmitter)() : (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    // a ref is needed here because of a closure issue with canClosePanel
    const hasContentChangedRef = (0, $gwFzn.useRef)(hasContentChanged);
    (0, $gwFzn.useEffect)(()=>{
        hasContentChangedRef.current = hasContentChanged;
    }, [
        hasContentChanged
    ]);
    // Required to invoke handleMarkCommentsAsRead and if any commentsMarkedAsRead
    // then we will call the MarkCommentsReadMutation Mutation
    (0, $gwFzn.useEffect)(()=>{
        if (shouldClearUnreads) handleMarkCommentsAsRead();
        return ()=>{
            setShouldClearUnreads(false);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        shouldClearUnreads,
        setShouldClearUnreads
    ]);
    const onPanelClose = ()=>{
        setCurrentView(undefined);
        setShouldClearUnreads(true);
        // Unselect active annotations on the page
        if (pageMode === (0, $cD1qu.PageMode).VIEW) {
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
            setViewProps(null);
        } else {
            eventEmitter.emit('setselectedannotation', '');
            setEditorViewProps(null);
        }
        // clear selected comment thread in the comments panel
        setCurrentlySelectedThreadKey('');
    };
    const canClosePanel = (0, $gwFzn.useCallback)(async ()=>{
        if (hasContentChangedRef.current) return new Promise((resolve)=>{
            showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    resetContentChanged && resetContentChanged();
                    resolve(true);
                },
                onCancel: ()=>{
                    resolve(false);
                }
            });
        });
        else return true;
    }, [
        resetContentChanged,
        showModal
    ]);
    const showCommentsPanel = ({ openWithView: openWithView } = {})=>{
        experienceTracker.start({
            name: (0, $irVI7.SIDEBAR_COMMENTS_PANEL_LOAD_EXPERIENCE)
        });
        showObjectSidebar({
            id: (0, $jvYFk.PanelName).CommentsPanel,
            headerComponentElements: {
                HeaderIcon: (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? (0, $ioFqb.CommentsPanelHeaderIcon) : undefined,
                headerLabel: $3b7f940e5fdc8097$export$a7357cdd1f0b0168.commentsPanelHeaderLabel,
                HeaderRightAlignedElement: (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? (0, $g9dNl.CommentsPanelFilterMenu) : undefined
            },
            BodyComponent: ()=>(0, $5hqV2.CommentsPanelWrapper)({
                    openWithView: openWithView
                }),
            FooterComponent: canAddComments && contentStatus !== (0, $cD1qu.ContentStatus).DRAFT && !isSpaceOverviewPage && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? (0, $gFN6K.CommentsPanelFooter) : undefined,
            closeOptions: {
                canClosePanel: canClosePanel,
                onPanelClose: onPanelClose
            }
        }, 'push');
    };
    // NOTE: Exposing the hide function for now while we have the CommentButton
    return {
        isCommentsPanelShown: isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel,
        showCommentsPanel: showCommentsPanel,
        hideCommentsPanel: hideObjectSidebar
    };
};

});
parcelRegister("htsj6", function(module, exports) {

$parcel$export(module.exports, "useContentStatus", () => $feac3235d890b171$export$50af12b79850199d);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $j1Ss3 = parcelRequire("j1Ss3");

var $ep3mz = parcelRequire("ep3mz");
const $feac3235d890b171$var$useContentStatusContentStatusQuery = (0, $d2LG0.default)`query useContentStatusContentStatusQuery($contentId:ID!){content(id:$contentId status:["current" "draft" "archived"]){nodes{id status type}}}`;
const $feac3235d890b171$export$50af12b79850199d = ({ skip: skip = false } = {})=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { loading: loading, error: error, data: data, refetch: refetch } = (0, $j1Ss3.useQuery)($feac3235d890b171$var$useContentStatusContentStatusQuery, {
        skip: skip || !contentId,
        variables: {
            contentId: contentId ?? ''
        }
    });
    const contentNode = data?.content?.nodes?.[0];
    return {
        contentStatus: contentNode?.status,
        loading: loading,
        error: error,
        refetch: refetch,
        type: contentNode?.type
    };
};

});

parcelRegister("g9dNl", function(module, exports) {

$parcel$export(module.exports, "CommentsPanelFilterMenu", () => $36472532be9af4aa$export$88cb326cef2ff4a6);
/* CommentsPanelFilterMenu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $bUlM5 = parcelRequire("bUlM5");
var $ecnYn = parcelRequire("ecnYn");

var $52EPl = parcelRequire("52EPl");
var $dAYOx = parcelRequire("dAYOx");
var $3pU8m = parcelRequire("3pU8m");
var $fKL7x = parcelRequire("fKL7x");
var $ahaN7 = parcelRequire("ahaN7");

var $1qfLF = parcelRequire("1qfLF");

var $4AkKf = parcelRequire("4AkKf");

var $cMvMc = parcelRequire("cMvMc");

var $8aF6s = parcelRequire("8aF6s");

var $9wGTI = parcelRequire("9wGTI");

var $bSvtO = parcelRequire("bSvtO");

var $3mVfX = parcelRequire("3mVfX");

var $en1dX = parcelRequire("en1dX");

var $ep3mz = parcelRequire("ep3mz");

var $etPef = parcelRequire("etPef");

var $fcFHX = parcelRequire("fcFHX");

var $kt7bZ = parcelRequire("kt7bZ");
const $36472532be9af4aa$var$i18n = (0, $2nPZH.defineMessages)({
    filterAndSortLabel: {
        id: "comments-panel.filter.and.sort.label",
        defaultMessage: "Filter and sort"
    },
    filterTitle: {
        id: "comments-panel.filter.title",
        defaultMessage: "Filter"
    },
    showTitle: {
        id: "comments-panel.show.title",
        defaultMessage: "Show"
    },
    inlineCommentsLabel: {
        id: "comments-panel.inline-comments.label",
        defaultMessage: "Inline comments"
    },
    generalCommentsLabel: {
        id: "comments-panel.general-comments.label",
        defaultMessage: "General comments"
    }
});
const $36472532be9af4aa$var$dropdownItemStyles = null;
const $36472532be9af4aa$var$dropDownMenuStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    paddingBottom: 'space.050',
    paddingLeft: 'space.300',
    paddingTop: 'space.050',
    gap: 'space.100'
});
const $36472532be9af4aa$export$88cb326cef2ff4a6 = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const [{ currentView: currentView, showInlineComments: showInlineComments, showGeneralComments: showGeneralComments, currentSort: currentSort }, { setCurrentView: setCurrentView, setShowInlineComments: setShowInlineComments, setShowGeneralComments: setShowGeneralComments }] = (0, $3mVfX.useCommentsPanel)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const updateView = (view)=>{
        const handleClick = ()=>{
            // Do nothing if the same view is clicked
            if (currentView !== view) setCurrentView && setCurrentView(view);
        };
        if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                resetContentChanged();
                handleClick();
            }
        });
        else handleClick();
    };
    const toggleShow = (type)=>{
        if (type === 'inline') setShowInlineComments && setShowInlineComments(!showInlineComments);
        else if (type === 'general') setShowGeneralComments && setShowGeneralComments(!showGeneralComments);
    };
    const isDefaultFilterState = currentSort === (0, $3mVfX.SortValues).PAGE_ORDER && showInlineComments && showGeneralComments && currentView === 'OPEN';
    const currentFilterIcon = isDefaultFilterState ? (0, (/*@__PURE__*/$parcel$interopDefault($4AkKf))) : $36472532be9af4aa$var$CustomSelectedFilterIcon;
    const icon = (0, $9wGTI.fg)('confluence_frontend_comments_filter_selected_state') ? currentFilterIcon : (0, (/*@__PURE__*/$parcel$interopDefault($4AkKf)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        role: "tablist",
        xcss: $36472532be9af4aa$var$dropDownMenuStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $52EPl.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
                testId: "comments-panel-filter-button",
                ref: triggerRef,
                appearance: "subtle",
                isTooltipDisabled: false,
                icon: icon,
                label: formatMessage($36472532be9af4aa$var$i18n.filterAndSortLabel),
                analyticsContext: {
                    attributes: {
                        name: 'filterButton',
                        source: (0, $en1dX.AnalyticsSource).COMMENTS_PANEL
                    }
                },
                ...props
            }),
        testId: "filter-selector-dropdown",
        placement: "bottom-end",
        spacing: "compact",
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ahaN7.default), {
        id: "filter",
        title: formatMessage($36472532be9af4aa$var$i18n.filterTitle)
    }, (0, $etPef.viewOptions).map((view)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
            key: view.name,
            onClick: ()=>updateView(view.name),
            "data-testId": `menu-item-${view.name}-filter`,
            isSelected: view.name === currentView,
            className: (0, $35pXk.default)([
                "_19bvpxbi"
            ])
        }, formatMessage(view.label)))), contentType === 'whiteboard' && (0, $9wGTI.fg)('cc-whiteboards-consolidating-comments') ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fcFHX.CommentSortOptions), null), [
        'whiteboard',
        'database'
    ].includes(contentType ?? 'page') && (0, $9wGTI.fg)('cc-whiteboards-consolidating-comments') ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fKL7x.default), {
        id: "show",
        title: formatMessage($36472532be9af4aa$var$i18n.showTitle),
        hasSeparator: true
    }, !(0, $9wGTI.fg)('confluence-frontend-comments-panel-design-update') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3pU8m.default), {
        onClick: ()=>toggleShow('inline'),
        id: "toggle-inline-comments",
        "data-testId": "toggle-inline-comments",
        isSelected: showInlineComments
    }, formatMessage($36472532be9af4aa$var$i18n.inlineCommentsLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3pU8m.default), {
        onClick: ()=>toggleShow('general'),
        id: "toggle-general-comments",
        "data-testId": "toggle-general-comments",
        isSelected: showGeneralComments
    }, formatMessage($36472532be9af4aa$var$i18n.generalCommentsLabel))), (0, $9wGTI.fg)('confluence_frontend_cp_bulk_actions') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kt7bZ.CommentBulkActions), null)));
};
function $36472532be9af4aa$var$CustomSelectedFilterIcon(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4AkKf))), {
        ...props,
        color: "var(--ds-icon-selected, #0C66E4)"
    });
}

});
parcelRegister("etPef", function(module, exports) {

$parcel$export(module.exports, "viewOptions", () => $30fe94d49cdd6066$export$10d60cedcb640ed2);
$parcel$export(module.exports, "CommentsPanel", () => $30fe94d49cdd6066$export$1d838cb8a90b7988);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");

var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $67Foi = parcelRequire("67Foi");

var $8SCD6 = parcelRequire("8SCD6");

var $dIouf = parcelRequire("dIouf");

var $7aRa9 = parcelRequire("7aRa9");

var $ep3mz = parcelRequire("ep3mz");

var $9wGTI = parcelRequire("9wGTI");

var $3mVfX = parcelRequire("3mVfX");

var $1eaCJ = parcelRequire("1eaCJ");
var $irVI7 = parcelRequire("irVI7");

var $9qP2u = parcelRequire("9qP2u");

var $2BRez = parcelRequire("2BRez");

var $kTzmM = parcelRequire("kTzmM");
const $30fe94d49cdd6066$var$i18n = (0, $2nPZH.defineMessages)({
    unread: {
        id: "comments-panel.unread.view.label",
        defaultMessage: "Unread"
    },
    open: {
        id: "comments-panel.open.view.label",
        defaultMessage: "Open"
    },
    resolved: {
        id: "comments-panel.resolved.view.label",
        defaultMessage: "Resolved"
    }
});
const $30fe94d49cdd6066$export$10d60cedcb640ed2 = [
    {
        label: $30fe94d49cdd6066$var$i18n.open,
        name: (0, $3mVfX.ViewValues).OPEN
    },
    {
        label: $30fe94d49cdd6066$var$i18n.unread,
        name: (0, $3mVfX.ViewValues).UNREAD
    },
    {
        label: $30fe94d49cdd6066$var$i18n.resolved,
        name: (0, $3mVfX.ViewValues).RESOLVED
    }
];
const $30fe94d49cdd6066$var$commentsPanelViews = {
    [(0, $3mVfX.ViewValues).OPEN]: (0, $9qP2u.OpenView),
    [(0, $3mVfX.ViewValues).UNREAD]: (0, $2BRez.UnreadView),
    [(0, $3mVfX.ViewValues).RESOLVED]: (0, $kTzmM.ResolvedView)
};
const $30fe94d49cdd6066$var$commentPanelContainerStyles = (0, $ecnYn.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    height: '100%'
});
const $30fe94d49cdd6066$var$CommentsPanelComponent = (0, $7aRa9.withFlags)(({ currentView: currentView, flags: flags })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const pageContainsBodiedMacrosRef = (0, $gwFzn.useRef)(false);
    const { currentView: userSelectedView } = (0, $3mVfX.useCommentsPanelState)();
    const viewToShow = userSelectedView || currentView;
    // We need to check that there are page properties macros or excerpt macros on the page
    // so we can hide the delete option which causes weird issues in the document
    (0, $gwFzn.useEffect)(()=>{
        const bodiedMacroElem = document.querySelector('.ak-renderer-extension');
        pageContainsBodiedMacrosRef.current = Boolean(bodiedMacroElem);
    }, []);
    const CommentView = $30fe94d49cdd6066$var$commentsPanelViews[viewToShow];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        xcss: $30fe94d49cdd6066$var$commentPanelContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8SCD6.ReactionsProvider), {
        contentId: contentId ?? ''
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(CommentView, {
        flags: flags,
        showDeleteOption: (0, $9wGTI.fg)('confluence_frontend_nested_renderer_delete') || !pageContainsBodiedMacrosRef.current
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $67Foi.ScreenEvent), {
        name: "commentsPanelScreen",
        id: "commentsPanelScreen",
        attributes: {
            currentView: currentView
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.SIDEBAR_COMMENTS_PANEL_LOAD_EXPERIENCE)
    }));
});
const $30fe94d49cdd6066$export$1d838cb8a90b7988 = (0, $dIouf.withErrorBoundary)({
    attribution: (0, $dIouf.Attribution).COMMENTS
})($30fe94d49cdd6066$var$CommentsPanelComponent);

});
parcelRegister("9qP2u", function(module, exports) {

$parcel$export(module.exports, "OpenView", () => $19281168b6d94c9a$export$829d7948ccc32354);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $dkkKv = parcelRequire("dkkKv");
var $7Oxky = parcelRequire("7Oxky");
var $8i27m = parcelRequire("8i27m");

var $ep3mz = parcelRequire("ep3mz");

var $9wGTI = parcelRequire("9wGTI");

var $i6UMJ = parcelRequire("i6UMJ");
var $3mVfX = parcelRequire("3mVfX");

var $245o4 = parcelRequire("245o4");

var $3Jri8 = parcelRequire("3Jri8");

var $50DH4 = parcelRequire("50DH4");

var $gDWRj = parcelRequire("gDWRj");

var $3hbXQ = parcelRequire("3hbXQ");

var $fVvcP = parcelRequire("fVvcP");
const $19281168b6d94c9a$var$i18n = (0, $2nPZH.defineMessages)({
    emptyCommentsHeaderText: {
        id: "comments-panel.empty.open.comments.header.text",
        defaultMessage: "Be the first to comment"
    },
    emptyCommentsBodyText: {
        id: "comments-panel.empty.open.comments.body.text",
        defaultMessage: "Highlight some text and select {highlighted} or add a comment at the bottom of this panel."
    }
});
const $19281168b6d94c9a$export$829d7948ccc32354 = ({ showDeleteOption: showDeleteOption, flags: flags })=>{
    const [{ orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, commentsDataMap: commentsDataMap, removedThreadsMap: removedThreadsMap }, { clearRemovedComments: clearRemovedComments, setCommentsDataMap: setCommentsDataMap }] = (0, $8i27m.useCommentsData)();
    const [{ initialDataLoadedForViewMap: initialDataLoadedForViewMap, showInlineComments: showInlineComments, showGeneralComments: showGeneralComments }, { setInitialDataLoadedForView: setInitialDataLoadedForView }] = (0, $3mVfX.useCommentsPanel)();
    const isInitialCommentDataLoaded = initialDataLoadedForViewMap[(0, $3mVfX.ViewValues).OPEN];
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const annotationsToLoad = (0, $i6UMJ.getAnnotationsToLoad)(orderedActiveAnnotationIdList);
    const commentsQueryHook = (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? (0, $dkkKv.useActiveCommentsQuery) : (0, $7Oxky.useActiveInlineCommentsQuery);
    const commentsQueryHookVariables = (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? {
        pageId: contentId || ''
    } : {
        pageId: contentId || '',
        markerRefList: annotationsToLoad,
        // skip entirely if no unresolved comments on the page
        skip: annotationsToLoad.length === 0
    };
    const { loading: loading, error: error, refetch: refetch } = commentsQueryHook(commentsQueryHookVariables);
    const { annotationsSet: annotationsSet } = (0, $fVvcP.useDanglingOperations)({
        orderedActiveAnnotationIdList: orderedActiveAnnotationIdList,
        commentsDataMap: commentsDataMap,
        setCommentsDataMap: setCommentsDataMap
    });
    (0, $gwFzn.useEffect)(()=>{
        // When this view unmounts, we want to clear out the "resolved"/"deleted" comments
        return ()=>{
            clearRemovedComments();
        };
    }, [
        clearRemovedComments
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!loading) setInitialDataLoadedForView({
            viewToSetLoaded: (0, $3mVfX.ViewValues).OPEN
        });
    }, [
        loading,
        setInitialDataLoadedForView
    ]);
    const commentThreads = (0, $gwFzn.useMemo)(()=>{
        if (!isInitialCommentDataLoaded && loading || orderedActiveAnnotationIdList.length === 0 && Object.keys(removedThreadsMap).length === 0) return [];
        return (0, $i6UMJ.getCommentThreads)({
            commentsDataMap: commentsDataMap,
            showInlineComments: showInlineComments,
            showGeneralComments: showGeneralComments,
            location: (0, $i6UMJ.LocationValue).PANEL,
            orderedActiveAnnotationIdList: orderedActiveAnnotationIdList,
            removedThreadsMap: removedThreadsMap,
            annotationsSet: annotationsSet
        });
    }, [
        commentsDataMap,
        isInitialCommentDataLoaded,
        loading,
        orderedActiveAnnotationIdList,
        removedThreadsMap,
        showInlineComments,
        showGeneralComments,
        annotationsSet
    ]);
    if (!isInitialCommentDataLoaded) {
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $245o4.Loading), null);
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3Jri8.ErrorPanel), {
            error: error,
            onRetryClick: async ()=>{
                await refetch();
            }
        });
    }
    if (commentThreads.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $50DH4.EmptyStateComponent), {
        SVG: (0, $3hbXQ.EmptyOpenViewSVG),
        emptyCommentsHeaderText: formatMessage($19281168b6d94c9a$var$i18n.emptyCommentsHeaderText),
        emptyCommentsBodyText: formatMessage($19281168b6d94c9a$var$i18n.emptyCommentsBodyText, {
            highlighted: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("b", null, "Comment")
        }),
        isOpenView: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gDWRj.CommentsPanelList), {
        commentThreads: commentThreads,
        supportedTopLevelActions: showDeleteOption ? [
            'edit',
            'resolve',
            'delete'
        ] : [
            'edit',
            'resolve'
        ],
        flags: flags
    });
};

});
parcelRegister("245o4", function(module, exports) {

$parcel$export(module.exports, "Loading", () => $086faa13d49cc321$export$669f6ea7d267feaf);
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $gwFzn = parcelRequire("gwFzn");

var $9hlns = parcelRequire("9hlns");

var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");
const $086faa13d49cc321$var$loadingBoxStyles = (0, $ecnYn.xcss)({
    justifyContent: 'center',
    flexGrow: 1
});
const $086faa13d49cc321$export$669f6ea7d267feaf = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        alignInline: "center",
        space: "space.1000",
        xcss: $086faa13d49cc321$var$loadingBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9hlns.default), {
        testId: "loading-spinner",
        interactionName: "load",
        label: "Loading",
        size: "large"
    }));
};

});

parcelRegister("3Jri8", function(module, exports) {

$parcel$export(module.exports, "ErrorPanel", () => $e631d8ab417bac36$export$9f3dc18e1adf5d8f);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $1GzhS = parcelRequire("1GzhS");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $ccHMk = parcelRequire("ccHMk");

var $dIouf = parcelRequire("dIouf");

var $en1dX = parcelRequire("en1dX");

var $6DSYw = parcelRequire("6DSYw");
const $e631d8ab417bac36$var$errorPanelStyles = (0, $ecnYn.xcss)({
    alignItems: 'center',
    gap: 'space.200',
    paddingTop: 'space.500'
});
const $e631d8ab417bac36$var$retryButtonStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.negative.050'
});
const $e631d8ab417bac36$var$i18n = (0, $2nPZH.defineMessages)({
    commentsPanelErrorMessage: {
        id: "comments-panel.error.panel.message",
        defaultMessage: "Something went wrong."
    },
    commentsPanelErrorRetryButtonLabel: {
        id: "comments-panel.error.panel.retry.button.label",
        defaultMessage: "Retry now"
    }
});
const $e631d8ab417bac36$export$9f3dc18e1adf5d8f = (props)=>{
    const { onRetryClick: onRetryClick, error: error } = props;
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        xcss: $e631d8ab417bac36$var$errorPanelStyles,
        testId: "comments-panel-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6DSYw.ErrorSvg), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        align: "center",
        size: "medium",
        color: "color.text.subtle"
    }, formatMessage($e631d8ab417bac36$var$i18n.commentsPanelErrorMessage)), onRetryClick && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        xcss: $e631d8ab417bac36$var$retryButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        onClick: onRetryClick,
        testId: "comments-panel-error-retry",
        analyticsContext: {
            attributes: {
                name: 'errorRetryButton',
                source: (0, $en1dX.AnalyticsSource).COMMENTS_PANEL
            }
        }
    }, formatMessage($e631d8ab417bac36$var$i18n.commentsPanelErrorRetryButtonLabel)))));
};

});
parcelRegister("6DSYw", function(module, exports) {

$parcel$export(module.exports, "ErrorSvg", () => $48c9fafca30cd8b2$export$bb92a7e2c63b6630);

var $gwFzn = parcelRequire("gwFzn");
const $48c9fafca30cd8b2$export$bb92a7e2c63b6630 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "165",
        height: "209",
        viewBox: "0 0 165 209",
        fill: "none",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            padding: '41px 56px 27px 56px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M0.397461 207.91L0.488116 208.08H164.502L164.603 207.91L82.5003 57.2695L0.397461 207.91Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M82.7822 111.21V166.22",
        stroke: "white",
        strokeWidth: "7.33",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M86.6603 183.36C86.7106 183.1 86.7308 182.82 86.7308 182.53C86.7308 182.24 86.7106 181.95 86.6603 181.69C86.3782 180.12 85.2803 179.16 83.7392 178.91C83.4773 178.87 83.2053 178.85 82.9132 178.85C82.6211 178.85 82.329 178.87 82.057 178.92C80.5159 179.17 79.4281 180.14 79.1359 181.7C79.0856 181.96 79.0654 182.24 79.0654 182.54C79.0654 182.84 79.0856 183.11 79.1359 183.37C79.418 184.93 80.5159 185.89 82.057 186.15C82.329 186.2 82.6211 186.22 82.9132 186.22C83.2053 186.22 83.4773 186.2 83.7392 186.16C85.2803 185.91 86.3782 184.94 86.6603 183.38V183.36Z",
        stroke: "white",
        strokeWidth: "7.33",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M111.248 53.5401L111.379 52.7501C111.379 52.7501 112.356 51.8901 112.144 51.1401L113.393 49.6901C113.393 49.6901 113.705 48.9401 113.524 48.5401C113.413 48.2901 113.242 48.0601 113.051 47.9001C112.658 47.5801 112.154 47.5701 111.882 48.3001C111.852 48.3001 111.812 48.3001 111.771 48.2801C111.63 49.1501 110.663 49.4401 110.271 50.1701C110.402 50.2401 110.482 50.3301 110.402 50.3101L110.25 50.2001C110.25 50.8601 109.565 50.8101 109.807 51.5801C109.807 51.5801 109.636 51.3901 109.636 51.4001C108.78 52.8901 107.269 54.6801 106.483 56.3801H106.513L106.534 56.4101C106.785 56.3701 107.47 55.8401 107.47 55.8401C107.873 56.8501 106.705 56.9201 106.372 57.4801L106.181 57.3401C106.342 57.1101 106.393 56.8401 106.372 56.7001C105.526 57.3601 104.338 59.0301 104.106 60.0501C104.267 60.1301 104.106 59.6601 104.64 59.9201C104.509 60.1301 104.438 60.3901 104.297 60.5801C103.975 60.3701 104.167 60.3301 104.116 60.2701C103.542 60.3801 98.5459 67.0301 101.004 66.2901L101.145 66.4401C101.507 66.0601 101.799 65.7501 102.414 65.5201C102.434 65.4401 102.464 65.4501 102.303 65.3401C102.293 65.3101 102.263 65.2501 102.182 65.2101C101.779 64.9501 102.031 64.9201 102.061 64.8501C103.26 65.7601 103.109 63.5601 103.29 63.4001C103.915 63.7601 103.572 63.0401 103.895 63.0901C103.915 63.1101 104.005 63.2501 104.025 63.2801C104.479 63.4301 104.569 61.0101 104.972 61.9901C107.581 60.8001 108.538 56.1301 111.097 54.6701L111.016 54.6401C111.016 54.6401 111.056 54.5601 111.147 54.6101C111.056 54.2301 111.258 53.5501 111.258 53.5501L111.248 53.5401ZM107.178 58.0801C107.178 58.0801 107.208 58.1001 107.219 58.1101C107.158 58.0701 107.007 58.3801 106.987 58.3801L106.785 58.2501C106.594 57.7101 108.377 57.9601 107.38 58.1901C107.41 58.2401 107.249 58.1301 107.178 58.0901V58.0801ZM105.476 60.5601C105.426 60.6001 105.375 60.6401 105.315 60.6901C105.123 59.6301 106.483 59.2701 106.675 58.3701C107.39 59.2001 106.534 59.4701 106.282 59.7401C106.282 60.1801 105.788 60.3801 105.476 60.5701V60.5601ZM102.535 64.6301L102.635 64.7001V64.7201C102.635 64.7201 102.565 64.6801 102.555 64.6601C102.535 64.6401 102.525 64.6201 102.535 64.6201V64.6301ZM110.553 53.5701C110.684 53.7301 110.472 53.8401 110.23 53.5101C110.301 53.5101 110.21 53.3201 110.553 53.5701ZM104.751 61.1301C105.073 61.3501 104.982 61.6301 104.529 61.3301C104.579 61.2401 104.66 61.1901 104.751 61.1301ZM111.409 51.5701C111.107 51.2701 111.479 51.5501 111.711 51.6801C111.651 51.6601 111.59 51.7101 111.439 51.5901L111.409 51.5701ZM111.943 50.3301C111.781 50.2001 111.721 50.0701 111.731 50.0301C111.912 50.0301 112.114 50.4001 111.943 50.3301ZM113.151 48.4801C112.96 48.3501 112.93 48.2601 113.121 48.3801C113.262 48.4801 113.333 48.6101 113.111 48.4701C113.111 48.4701 113.141 48.4901 113.151 48.4901V48.4801ZM103.31 61.7601C102.787 61.3101 103.391 61.4101 103.31 61.1901C103.864 61.6001 103.31 61.5201 103.341 61.6801C103.32 61.7101 103.31 61.7401 103.3 61.7601H103.31ZM108.286 54.6601C107.783 54.3201 108.347 54.3501 108.286 54.2001L108.488 54.3301C108.457 54.4901 108.538 54.6401 108.296 54.6601H108.286ZM104.64 59.4301C104.469 59.2501 104.71 59.3001 104.741 59.2501C105.023 59.4401 104.942 59.6701 104.64 59.4301ZM106.07 57.4701C106.383 57.6701 106.171 57.6601 106.181 57.7101C106.131 57.6501 105.959 57.4801 105.98 57.4601C106 57.4501 106.03 57.4601 106.07 57.4601V57.4701ZM108.427 54.8801C108.377 54.9801 108.296 55.0801 108.226 55.1701L108.034 55.0301C108.105 54.9301 108.175 54.8401 108.236 54.7501L108.427 54.8901V54.8801ZM107.48 55.6101L107.279 55.4801C107.188 55.2201 107.702 55.5401 107.48 55.6101ZM109.022 53.5001C109.022 53.5001 108.971 53.5201 108.961 53.5301C108.85 53.7401 108.316 52.9801 109.022 53.5001ZM109.515 52.3501C109.515 52.3501 109.455 52.2501 109.475 52.2301C109.596 52.1101 109.968 52.5801 109.515 52.3501Z",
        fill: "#333437"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M57.2177 24.7598L56.5428 24.3398C56.5428 24.3398 56.1299 23.1198 55.3543 23.0198L54.5082 21.3298C54.5082 21.3298 53.9441 20.7598 53.5009 20.7598C53.2289 20.7598 52.9469 20.8298 52.7253 20.9498C52.2821 21.1898 52.0706 21.6398 52.6346 22.1698C52.6145 22.1898 52.6044 22.2398 52.5742 22.2598C53.3196 22.7298 53.2088 23.7198 53.7225 24.3598C53.8434 24.2698 53.9542 24.2298 53.9038 24.2898L53.7426 24.3798C54.347 24.6298 54.0347 25.2398 54.8406 25.3098L54.5988 25.3898C55.6363 26.7498 56.6939 28.8098 57.953 30.1798L57.9732 30.1598H57.9933C58.0538 29.9098 57.8322 29.0798 57.8322 29.0798C58.92 29.1098 58.5272 30.1898 58.92 30.7198L58.7186 30.8398C58.5675 30.5998 58.3358 30.4498 58.2048 30.4198C58.4869 31.4398 59.5546 33.1698 60.4007 33.7798C60.5417 33.6598 60.0381 33.6298 60.4914 33.2398C60.6324 33.4398 60.8439 33.5998 60.9648 33.7998C60.6424 34.0098 60.6827 33.8198 60.6022 33.8398C60.4712 34.4098 64.6514 41.5198 64.9334 38.9898L65.1248 38.9198C64.9133 38.4498 64.742 38.0598 64.7723 37.4098C64.7018 37.3598 64.732 37.3398 64.5607 37.4398C64.5204 37.4398 64.46 37.4398 64.3895 37.4998C63.9866 37.7698 64.0571 37.5298 64.0067 37.4698C65.3162 36.7298 63.2311 36.0198 63.1506 35.7898C63.7247 35.3598 62.9189 35.3998 63.1002 35.1198C63.1304 35.1198 63.2916 35.0798 63.3218 35.0698C63.634 34.7198 61.4483 33.6998 62.5059 33.7098C62.4354 30.8798 58.497 28.1998 58.1646 25.3098L58.1041 25.3698C58.1041 25.3698 58.0437 25.3098 58.1243 25.2398C57.7415 25.1798 57.1875 24.7298 57.1875 24.7298L57.2177 24.7598ZM59.8064 30.2198C59.8064 30.2198 59.8366 30.1998 59.8467 30.1998C59.7863 30.2398 60.0079 30.4998 59.9978 30.5198L59.7963 30.6498C59.2222 30.6198 60.159 29.0798 59.9776 30.0898C60.0381 30.0798 59.8769 30.1898 59.8064 30.2398V30.2198ZM61.4281 32.7198C61.4382 32.7798 61.4583 32.8398 61.4785 32.9098C60.4208 32.6698 60.6324 31.2998 59.8668 30.7798C60.9144 30.4498 60.8238 31.3298 60.9748 31.6698C61.3778 31.8498 61.3778 32.3698 61.418 32.7298L61.4281 32.7198ZM64.0269 36.9798L64.1377 36.9098V36.9298C64.1377 36.9298 64.0873 36.9698 64.0772 36.9698C64.0571 36.9798 64.0269 36.9798 64.037 36.9698L64.0269 36.9798ZM56.976 25.4098C57.1674 25.3498 57.1976 25.5898 56.7947 25.6798C56.8249 25.6098 56.6134 25.6198 56.976 25.4098ZM61.6699 33.6098C62.0023 33.3998 62.2239 33.5898 61.7706 33.8898C61.7102 33.8098 61.69 33.7098 61.6699 33.6098ZM55.4651 23.8598C55.0722 24.0198 55.4751 23.7898 55.6766 23.6298C55.6363 23.6798 55.6564 23.7498 55.4852 23.8398L55.455 23.8598H55.4651ZM54.5283 22.8898C54.347 22.9798 54.1959 22.9898 54.1657 22.9698C54.2463 22.8098 54.6592 22.7598 54.5283 22.8898ZM53.2994 21.0798C53.108 21.1998 53.0073 21.1998 53.1987 21.0598C53.3498 20.9698 53.4908 20.9498 53.2692 21.0998C53.2692 21.0998 53.2894 21.0798 53.2994 21.0698V21.0798ZM61.6799 35.1598C61.0554 35.4698 61.3878 34.9498 61.1562 34.9298C61.7504 34.5898 61.4583 35.0698 61.6195 35.0898C61.6396 35.1198 61.6598 35.1398 61.6799 35.1598ZM57.0868 27.8898C56.5731 28.2198 56.8249 27.7198 56.6536 27.7098L56.8551 27.5798C56.986 27.6698 57.1674 27.6498 57.0767 27.8798L57.0868 27.8898ZM60.0582 33.0598C59.8266 33.1398 59.9676 32.9398 59.9374 32.8998C60.2295 32.7198 60.4007 32.8798 60.0582 33.0598ZM58.8092 30.9898C59.1215 30.7798 59.0308 30.9798 59.0812 30.9898C59.0006 31.0098 58.7891 31.0998 58.7689 31.0698C58.7689 31.0498 58.7991 31.0198 58.8092 30.9898ZM57.3487 27.8498C57.4192 27.9398 57.4796 28.0398 57.53 28.1498L57.3285 28.2798C57.2681 28.1798 57.2076 28.0798 57.1472 27.9798L57.3487 27.8498ZM57.6508 28.9998L57.4494 29.1298C57.1674 29.1198 57.671 28.7698 57.6508 28.9998ZM56.3112 26.7798C56.3112 26.7798 56.3112 26.8298 56.3112 26.8498C56.4623 27.0298 55.5456 27.2298 56.3112 26.7798ZM55.4348 25.8798C55.4348 25.8798 55.314 25.8898 55.314 25.8698C55.2435 25.7198 55.8378 25.5598 55.4348 25.8798Z",
        fill: "#333437"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M51.6874 55.9506L50.8614 55.9106C50.8614 55.9106 49.8239 55.0506 49.0987 55.3506L47.4266 54.2906C47.4266 54.2906 46.6107 54.0806 46.2279 54.2906C45.9862 54.4306 45.7747 54.6206 45.6538 54.8406C45.3919 55.2706 45.4524 55.7706 46.2481 55.9506C46.2481 55.9806 46.2582 56.0206 46.2481 56.0606C47.1647 56.1006 47.6079 57.0206 48.4137 57.3206C48.4641 57.1806 48.5447 57.0906 48.5346 57.1706L48.444 57.3306C49.1188 57.2506 49.1793 57.9406 49.9246 57.6006L49.7635 57.7906C51.4154 58.4606 53.4904 59.7406 55.3538 60.3106V60.2806L55.374 60.2606C55.2934 60.0206 54.6387 59.4006 54.6387 59.4006C55.6157 58.8806 55.8575 60.0306 56.4921 60.2906L56.3813 60.5006C56.1194 60.3706 55.8373 60.3506 55.6963 60.3906C56.5021 61.1406 58.3958 62.1206 59.4837 62.2306C59.5441 62.0606 59.0808 62.2706 59.2721 61.7206C59.5139 61.8306 59.7858 61.8606 59.9974 61.9806C59.8261 62.3206 59.7556 62.1406 59.7053 62.1906C59.9067 62.7506 67.4915 66.8906 66.3533 64.5406L66.4842 64.3906C66.041 64.0806 65.6784 63.8306 65.346 63.2406C65.2654 63.2406 65.2755 63.2006 65.1848 63.3706C65.1546 63.3906 65.0942 63.4206 65.064 63.5006C64.8625 63.9306 64.792 63.6906 64.7114 63.6706C65.4568 62.3706 63.2307 62.7906 63.0293 62.6306C63.3012 61.9706 62.6163 62.4006 62.6163 62.0706C62.6364 62.0506 62.7674 61.9406 62.7875 61.9206C62.8681 61.4606 60.3801 61.6606 61.3169 61.1306C59.6952 58.6806 54.7595 58.3106 52.8759 55.9506L52.8558 56.0406C52.8558 56.0406 52.7652 56.0106 52.7954 55.9206C52.4227 56.0606 51.6874 55.9406 51.6874 55.9406V55.9506ZM56.9756 59.4406C56.9756 59.4406 56.9957 59.4106 56.9957 59.4006C56.9655 59.4706 57.2979 59.5806 57.308 59.6006L57.1971 59.8106C56.6734 60.0606 56.6532 58.2606 57.0461 59.2306C57.0964 59.1906 57.0058 59.3706 56.9756 59.4406ZM59.7758 60.8206C59.7758 60.8206 59.8664 60.9106 59.9269 60.9606C58.8692 61.2806 58.2951 59.9706 57.3382 59.9006C58.0835 59.0906 58.4865 59.9006 58.7987 60.1206C59.252 60.0706 59.534 60.5306 59.7758 60.8206ZM64.3992 63.2506L64.4596 63.1406H64.4898C64.4898 63.1406 64.4495 63.2206 64.4394 63.2306C64.4193 63.2506 64.4092 63.2606 64.4092 63.2506H64.3992ZM51.8284 56.6406C51.9694 56.4906 52.1205 56.6906 51.8284 56.9606C51.8284 56.8906 51.637 57.0006 51.8284 56.6406ZM60.4708 61.4706C60.642 61.1206 60.9442 61.1806 60.7025 61.6606C60.6118 61.6206 60.5312 61.5506 60.4708 61.4706ZM49.6527 56.0406C49.4009 56.3806 49.6225 55.9706 49.7131 55.7306C49.7131 55.7906 49.7635 55.8406 49.6628 56.0106V56.0406H49.6527ZM48.2929 55.6606C48.1821 55.8306 48.0612 55.9106 48.0209 55.9106C48.0007 55.7306 48.3332 55.4806 48.2929 55.6606ZM46.2179 54.6906C46.1172 54.8906 46.0265 54.9406 46.1171 54.7306C46.1977 54.5806 46.3186 54.4906 46.2078 54.7306C46.2078 54.7306 46.2179 54.7006 46.2179 54.6906ZM61.337 62.8206C60.9644 63.4006 60.9644 62.7806 60.7528 62.8806C61.0852 62.2906 61.0953 62.8506 61.2464 62.7906C61.2766 62.8106 61.3068 62.8206 61.337 62.8206ZM53.299 58.7506C53.0371 59.2906 52.9767 58.7306 52.8256 58.8106L52.9364 58.6006C53.0976 58.6006 53.2486 58.5106 53.299 58.7506ZM58.7584 61.7906C58.5973 61.9806 58.6174 61.7306 58.557 61.7106C58.7081 61.4006 58.9599 61.4606 58.7584 61.7906ZM56.5122 60.6106C56.6633 60.2706 56.6935 60.4906 56.7439 60.4706C56.6834 60.5306 56.5424 60.7106 56.5223 60.7006C56.5021 60.6906 56.5223 60.6506 56.5223 60.6106H56.5122ZM53.5005 58.5906C53.6113 58.6306 53.7221 58.6906 53.8228 58.7606L53.712 58.9706C53.6012 58.9106 53.4904 58.8606 53.3897 58.8006L53.5005 58.5906ZM54.3969 59.4406L54.2962 59.6506C54.0444 59.7806 54.2962 59.2206 54.3969 59.4406ZM51.9996 58.1706C51.9996 58.1706 52.0298 58.2206 52.0399 58.2206C52.2716 58.3006 51.5766 58.9306 51.9996 58.1706ZM50.7405 57.8206C50.7405 57.8206 50.6398 57.8906 50.6197 57.8706C50.4786 57.7706 50.9017 57.3406 50.7405 57.8206Z",
        fill: "#333437"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M100.813 19.8202L99.7856 17.4302C99.7856 17.4302 98.8689 13.0502 97.8113 11.4902L96.1795 4.97016C96.1795 4.97016 95.2528 2.32016 94.6686 1.61016C94.306 1.17016 93.9535 0.910156 93.6916 0.910156C93.1678 0.910156 93.0167 1.93016 93.9333 4.48016C93.9132 4.52016 93.9132 4.63016 93.8729 4.66016C95.0111 7.31016 95.1521 10.1302 96.0284 12.9102C96.1594 12.8302 96.3004 12.9002 96.25 13.0002L96.0687 13.0202C96.9551 14.7902 96.7134 16.1102 97.8113 17.6502L97.5192 17.5202C98.0228 19.1702 98.5567 21.0002 99.0905 22.9102C99.433 24.1302 99.7956 25.4102 100.148 26.6802C99.3021 26.5502 98.456 26.4302 97.63 26.3002C96.0989 26.0802 94.6082 25.8702 93.1879 25.7102L93.2181 25.7402L93.198 25.7602C93.7721 26.0402 96.6328 26.7702 96.6328 26.7702C94.3161 27.3002 91.9893 25.9802 89.6625 25.6502L89.7128 25.4202C90.71 25.5902 91.6166 25.6302 91.9893 25.5802C90.6295 25.2302 88.7257 24.8402 86.7515 24.4802C85.7643 24.3002 84.757 24.1302 83.7901 23.9802C82.9037 23.8402 82.0475 23.7102 81.2115 23.5802C80.3855 23.4602 79.5797 23.3402 78.8242 23.2402C79.3077 24.5402 79.7005 25.6302 80.0531 26.5802C80.2243 27.0302 80.3855 27.4502 80.5366 27.8302C80.6373 28.0402 80.7179 28.2402 80.8085 28.4302C80.8791 28.3502 80.738 28.1102 80.6272 27.8002C80.456 27.3002 80.3049 26.7302 80.5668 26.5902L80.9093 27.5202L81.1712 28.1902C81.3323 28.6002 81.4935 29.0002 81.6244 29.3902C81.2618 29.5102 81.2316 29.0102 81.1309 28.9502C81.2014 30.4502 90.3676 58.4402 89.6222 51.2702L89.8639 51.3802C89.3502 49.6302 88.9372 48.1902 88.6854 46.2802C88.5645 46.0402 88.5948 46.0002 88.4034 46.0602C88.353 46.0002 88.2624 45.9102 88.1918 45.9602C87.7486 46.1402 87.7386 45.5202 87.6379 45.2802C89.1588 45.1002 85.8651 39.6802 85.6535 38.8802C86.278 38.5002 85.1499 37.3402 85.2808 36.7802C85.3211 36.8102 85.5427 36.9602 85.5729 36.9802C85.8651 36.4102 82.2792 29.9102 83.8001 31.6002C83.639 30.5602 83.3872 29.4502 83.085 28.2702C82.6418 26.6902 82.7526 26.8402 82.672 26.4902C82.8936 26.5502 83.0749 26.5902 83.2562 26.6202C84.1023 26.7502 84.9686 26.8902 85.8449 27.0302C87.6479 27.2902 89.4812 27.5602 91.3245 27.8302C93.1577 28.1102 94.9909 28.3802 96.7738 28.6502C97.6602 28.8002 98.5366 28.9502 99.3927 29.0902C100.883 29.3602 102.334 29.6202 103.754 29.8702C103.563 29.1202 103.382 28.3902 103.2 27.6702C103.019 26.9402 102.848 26.2302 102.687 25.5302C102.525 24.7102 102.384 23.9302 102.284 23.1702L102.223 23.2602C102.223 23.1802 102.122 22.9702 102.213 22.8902C101.679 22.0802 100.813 19.8102 100.813 19.8102V19.8202ZM89.3603 26.6102C89.3603 26.6102 89.3401 26.6402 89.3502 26.6602C89.3502 26.5902 88.1616 26.4402 88.1213 26.4102L88.1717 26.1802C89.4509 25.9202 91.9691 27.9602 89.4409 26.8502C89.3401 26.8902 89.3704 26.7002 89.3704 26.6202L89.3603 26.6102ZM81.8057 26.9002C81.836 27.0702 81.8763 27.2402 81.9367 27.4702C81.4733 26.8402 81.0402 25.8002 80.7078 24.8202C83.1857 25.2202 85.4218 25.9602 87.5976 26.0702C87.0033 26.5102 86.1068 26.4902 85.2103 26.3302C84.334 26.1702 83.2965 25.8502 82.954 25.7602C82.5511 25.8102 82.1784 25.7502 81.6446 25.6002C81.7151 25.9802 81.7352 26.4102 81.8158 26.9002H81.8057ZM87.3961 43.7002L87.517 43.6702L87.5472 43.7602C87.5472 43.7602 87.4767 43.7702 87.4565 43.7602C87.4263 43.7602 87.3961 43.7302 87.3961 43.7002ZM100.672 21.3902C100.914 21.5302 101.025 22.3002 100.511 21.9102C100.541 21.7702 100.259 21.4502 100.672 21.3902ZM82.5108 29.8502C82.8835 29.7202 83.2864 30.6602 82.7727 30.8302C82.6519 30.5102 82.5813 30.1702 82.5108 29.8502ZM98.2041 14.2402C97.7307 14.1002 98.2041 14.0402 98.4257 13.8902C98.3855 13.9702 98.4257 14.2102 98.2344 14.2102L98.2041 14.2402ZM96.663 9.75016C96.4515 9.74016 96.25 9.52016 96.2097 9.40016C96.2702 9.04016 96.804 9.56016 96.663 9.75016ZM94.4772 2.26015C94.2556 2.31015 94.1247 2.15016 94.3362 2.04016C94.5075 2.01016 94.6988 2.19016 94.447 2.30016C94.447 2.30016 94.4772 2.28015 94.4772 2.26015ZM83.2361 34.5502C82.4907 34.5102 82.7224 33.4602 82.39 33.0502C83.0749 32.9402 82.8835 33.9402 83.1253 34.2602C83.1656 34.3902 83.2059 34.4802 83.2461 34.5502H83.2361ZM100.813 27.4602C100.511 27.1102 100.541 27.0802 100.672 27.1202C100.672 27.0602 100.763 26.9902 100.652 26.8702L100.954 27.0502C101.055 27.2402 101.196 27.4702 101.246 27.6302C101.155 27.6202 101.014 27.5702 100.833 27.4702H100.823L100.813 27.4602ZM79.489 24.2602C79.2372 23.9502 79.1667 23.7002 79.1365 23.5102C79.3782 23.5802 79.62 23.6602 79.771 23.6802C79.9524 23.8502 79.8416 23.9302 79.6401 23.9302C79.8113 24.3002 79.8315 24.5802 79.4789 24.2502L79.489 24.2602ZM89.179 25.3102C89.1588 25.6802 88.766 25.4302 88.6451 25.4502C88.7459 25.3902 88.9372 25.1902 89.038 25.2102C89.1085 25.2302 89.1185 25.2702 89.1891 25.3102H89.179ZM100.803 27.7002C100.541 27.6702 100.229 27.6102 99.9467 27.5502V27.3102C100.168 27.3502 100.39 27.3902 100.612 27.4302L100.803 27.7002ZM97.3379 26.7602L97.3782 26.5302C97.9926 26.4002 97.9624 27.0102 97.358 26.7702H97.348L97.3379 26.7602ZM100.188 24.4602C100.188 24.5202 100.199 24.6202 100.219 24.6702C100.471 25.4602 99.3121 24.5802 100.188 24.4602ZM98.7581 20.3202C98.6977 20.2502 98.6071 20.1602 98.5869 20.0702C98.456 19.5002 99.1913 19.9702 98.7581 20.3202Z",
        fill: "#333437"
    }));
};

});


parcelRegister("50DH4", function(module, exports) {

$parcel$export(module.exports, "EmptyStateComponent", () => $eb66b647970de8bb$export$f672ce11dad283e1);
/* EmptyStateComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $7hXDW = parcelRequire("7hXDW");

var $6f0Oj = parcelRequire("6f0Oj");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $ccHMk = parcelRequire("ccHMk");

var $en1dX = parcelRequire("en1dX");

var $3mVfX = parcelRequire("3mVfX");
const $eb66b647970de8bb$var$emptyStyles = (0, $ecnYn.xcss)({
    alignItems: 'center',
    gap: 'space.200'
});
const $eb66b647970de8bb$var$textStyle = (0, $ecnYn.xcss)({
    width: '305px',
    textAlign: 'center'
});
const $eb66b647970de8bb$var$buttonStyle = null;
const $eb66b647970de8bb$var$i18n = (0, $2nPZH.defineMessages)({
    openViewCommentButton: {
        id: "comments-panel.empty.unread.comments.view.open.comments",
        defaultMessage: "View open comments"
    }
});
const $eb66b647970de8bb$export$f672ce11dad283e1 = ({ SVG: SVG, emptyCommentsHeaderText: emptyCommentsHeaderText, emptyCommentsBodyText: emptyCommentsBodyText, isOpenView: isOpenView })=>{
    const { setCurrentView: setCurrentView } = (0, $3mVfX.useCommentsPanelActions)();
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        xcss: $eb66b647970de8bb$var$emptyStyles,
        testId: "empty-comments-panel-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(SVG, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7hXDW.default), {
        size: "small"
    }, emptyCommentsHeaderText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $eb66b647970de8bb$var$textStyle
    }, emptyCommentsBodyText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        className: (0, $35pXk.default)([
            "_19pkr5cr"
        ])
    }, !isOpenView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
        onClick: ()=>{
            setCurrentView((0, $3mVfX.ViewValues).OPEN);
        },
        testId: "comments-panel-open-view-comments-button",
        analyticsContext: {
            attributes: {
                name: 'viewOpenCommentsButton',
                source: (0, $en1dX.AnalyticsSource).COMMENTS_PANEL
            }
        }
    }, formatMessage($eb66b647970de8bb$var$i18n.openViewCommentButton))));
};

});

parcelRegister("gDWRj", function(module, exports) {

$parcel$export(module.exports, "CommentsPanelList", () => $d394403fb664fc77$export$6e0851fde8d3cd0e);
/* CommentsPanelList.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $aSsfA = parcelRequire("aSsfA");

var $gfqXk = parcelRequire("gfqXk");
var $gczDe = parcelRequire("gczDe");

var $cD1qu = parcelRequire("cD1qu");

var $9QIM2 = parcelRequire("9QIM2");

var $3cu4A = parcelRequire("3cu4A");

var $i6UMJ = parcelRequire("i6UMJ");
var $3mVfX = parcelRequire("3mVfX");

var $1kHsc = parcelRequire("1kHsc");
var $irVI7 = parcelRequire("irVI7");
var $4EKKB = parcelRequire("4EKKB");

var $9wGTI = parcelRequire("9wGTI");

var $7qvmT = parcelRequire("7qvmT");

var $fyUg9 = parcelRequire("fyUg9");
const $d394403fb664fc77$var$listStyles = null; // this component holds a list of comments
const $d394403fb664fc77$export$6e0851fde8d3cd0e = ({ commentThreads: commentThreads, supportedTopLevelActions: supportedTopLevelActions, flags: flags })=>{
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const pageClass = (0, $9QIM2.usePageClass)();
    const { currentSort: currentSort, currentlySelectedThreadKey: currentlySelectedThreadKey } = (0, $3mVfX.useCommentsPanelState)();
    const { setCurrentlyRenderedThreads: setCurrentlyRenderedThreads } = (0, $3mVfX.useCommentsPanelActions)();
    const eventEmitter = pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE ? (0, $gfqXk.getEditorAnnotationEventEmitter)() : (0, $gczDe.getRendererAnnotationEventEmitter)();
    const sortedCommentThreads = (0, $gwFzn.useMemo)(()=>(0, $i6UMJ.getSortedCommentThreads)(currentSort, commentThreads), [
        commentThreads,
        currentSort
    ]); // Whenever the list that we're rendering here changes, we want to update the list that the keyboard shortcuts are listening to
    (0, $gwFzn.useEffect)(()=>{
        setCurrentlyRenderedThreads(sortedCommentThreads.map((thread)=>({
                ...thread.location,
                id: thread.id
            })));
        return ()=>{
            // When this component is unmounted, we want to clear the list that the keyboard shortcuts are listening to
            setCurrentlyRenderedThreads([]);
        };
    }, [
        sortedCommentThreads,
        setCurrentlyRenderedThreads
    ]);
    const actionsToShowUsers = pageMode === (0, $cD1qu.PageMode).EDIT ? supportedTopLevelActions.filter((action)=>action !== 'delete') : supportedTopLevelActions; // Props we want the batch renderer to pass through that aren't comment specific
    const passThroughProps = {
        // When sorting by MOST_RECENT, the comment type separator should never be rendered
        ...currentSort === (0, $3mVfX.SortValues).MOST_RECENT ? {
            shouldRenderCommentTypeSeparator: false
        } : {},
        supportedTopLevelActions: actionsToShowUsers,
        eventEmitter: eventEmitter,
        pageMode: pageMode,
        flags: flags
    };
    const lastSelected = (0, $gwFzn.useRef)(currentlySelectedThreadKey);
    const selectedInlineCommentParentThread = commentThreads.find((thread)=>'inlineMarkerRef' in thread.location && thread.location.inlineMarkerRef === currentlySelectedThreadKey);
    const isActiveInlineComment = selectedInlineCommentParentThread && !selectedInlineCommentParentThread.wasRemovedByAnotherUser && 'inlineResolveProperties' in selectedInlineCommentParentThread.location && selectedInlineCommentParentThread.location.inlineResolveProperties?.resolved === false;
    if ((0, $9wGTI.fg)('confluence_comments_select_comment_experience')) {
        if (lastSelected.current !== currentlySelectedThreadKey) {
            // The selected annotation has changed, so we need to update the last selected
            lastSelected.current = currentlySelectedThreadKey;
            if (currentlySelectedThreadKey && isActiveInlineComment) // If the selected annotation has changed to a new one, we need to start the show comment experience
            (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.start({
                pageClass: pageClass,
                annotationId: currentlySelectedThreadKey,
                entryPoint: 'unknown:CommentsPanelList'
            });
            else // If an non inline comment or non active inline comment is selected,
            // we abort any running show comment experience
            (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.abort({
                abortReason: 'Non inline comment being shown'
            });
        }
    }
    (0, $gwFzn.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_comments_select_comment_experience')) return ()=>{
            // If an inline comment is in the process of being shown as the sidebar closes,
            // we abort any running show comment experience.
            (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.abort({
                abortReason: 'Comment sidebar dismissed'
            });
        };
    }, []);
    (0, $gwFzn.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_comments_select_comment_experience')) {
            if (!isActiveInlineComment) return;
            const initialTaskId = experienceTracker.getExperienceState((0, $irVI7.SELECT_INLINE_COMMENT_SHOW_COMMENT_EXPERIENCE))?.taskId;
            setTimeout(()=>{
                requestAnimationFrame(()=>{
                    const currentTaskId = experienceTracker.getExperienceState((0, $irVI7.SELECT_INLINE_COMMENT_SHOW_COMMENT_EXPERIENCE))?.taskId;
                    if (initialTaskId !== currentTaskId) // The experience has been restarted or has otherwise ended.
                    return;
                    if (currentlySelectedThreadKey !== lastSelected.current) {
                        // The selected annotation has changed, this should have led to an earlier abort
                        // (as an overlapping experience is started)
                        (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.debugPoint('Show comment assumed aborted due to selection change');
                        return;
                    }
                    const selectedSidebarThread = document.querySelector(`[data-selected-comment-thread="${currentlySelectedThreadKey}"]`);
                    if (!selectedSidebarThread) (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.fail(new Error('No selected comment thread found'));
                    else {
                        const isVisible = selectedSidebarThread.checkVisibility();
                        if (!isVisible) (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.fail(new Error('Selected comment thread is not visible'));
                        (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.complete();
                    }
                });
            }, 1000);
        }
    }, [
        currentlySelectedThreadKey,
        isActiveInlineComment,
        experienceTracker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        id: "comments-panel-list-container",
        "data-testid": "comments-panel-list-container",
        className: (0, $35pXk.default)([
            "_18m91wug _1reo15vq _16jlkb7n _1e0c1ule"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3cu4A.CommentBatchList), {
        commentsList: sortedCommentThreads,
        passThroughProps: passThroughProps,
        Component: (0, $fyUg9.CommentThread),
        getElementsToBatch: (0, $7qvmT.getCommentThreadsToBatch)
    }));
};

});
parcelRegister("3cu4A", function(module, exports) {

$parcel$export(module.exports, "BATCH_SIZE", () => $ba24a8cc7b954968$export$3577ba943a5537ec);
$parcel$export(module.exports, "CommentBatchList", () => $ba24a8cc7b954968$export$69f1296a446ecce6);

var $gwFzn = parcelRequire("gwFzn");

var $ep3mz = parcelRequire("ep3mz");

var $8i27m = parcelRequire("8i27m");

var $6eYRP = parcelRequire("6eYRP");
const $ba24a8cc7b954968$export$3577ba943a5537ec = 8;
// Binary search to find the transition point between inline/general comments
const $ba24a8cc7b954968$var$findTransitionIndex = (commentsList)=>{
    if (!commentsList.length) return 0;
    let low = 0;
    let high = commentsList.length - 1;
    // If all comments are of the same type, return 0
    const firstType = commentsList[0].type;
    const lastType = commentsList[high].type;
    if (firstType === lastType) return 0;
    while(low < high){
        const mid = Math.floor((low + high) / 2);
        if (commentsList[mid].type === (0, $8i27m.CommentType).INLINE) low = mid + 1;
        else high = mid;
    }
    return low;
};
const $ba24a8cc7b954968$export$69f1296a446ecce6 = /*#__PURE__*/ (0, $gwFzn.memo)(({ commentsList: commentsList, passThroughProps: passThroughProps, Component: Component, getElementsToBatch: getElementsToBatch })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const batchCount = Math.ceil(commentsList.length / $ba24a8cc7b954968$export$3577ba943a5537ec);
    const batches = (0, $gwFzn.useMemo)(()=>new Array(batchCount).fill(0), [
        batchCount
    ]);
    const [batch, setBatch] = (0, $gwFzn.useState)(0);
    const onBatchRendered = (0, $gwFzn.useCallback)((batchIndex)=>{
        setBatch(batchIndex + 1);
    }, []);
    const globalTransitionIndex = (0, $gwFzn.useMemo)(()=>$ba24a8cc7b954968$var$findTransitionIndex(commentsList), [
        commentsList
    ]);
    const transitionBatchIndex = Math.floor(globalTransitionIndex / $ba24a8cc7b954968$export$3577ba943a5537ec);
    const transitionIndexWithinBatch = globalTransitionIndex % $ba24a8cc7b954968$export$3577ba943a5537ec;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, batches.map((_, index)=>{
        const isTransitionBatch = index === transitionBatchIndex && globalTransitionIndex !== 0;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6eYRP.CommentBatch), {
            key: `${contentId}-batch-${index}`,
            commentsList: commentsList,
            canRenderBatch: index <= batch,
            batchIndex: index,
            passThroughProps: passThroughProps,
            Component: Component,
            getElementsToBatch: getElementsToBatch,
            onBatchRendered: onBatchRendered,
            transitionIndexWithinBatch: isTransitionBatch ? transitionIndexWithinBatch : undefined
        });
    }));
});

});
parcelRegister("6eYRP", function(module, exports) {

$parcel$export(module.exports, "CommentBatch", () => $4d6840eb7d00cd1a$export$a484c9e4bd05c9fe);

var $gwFzn = parcelRequire("gwFzn");

var $bUlM5 = parcelRequire("bUlM5");
var $ecnYn = parcelRequire("ecnYn");

var $9hlns = parcelRequire("9hlns");

var $9wGTI = parcelRequire("9wGTI");

var $3cu4A = parcelRequire("3cu4A");
const $4d6840eb7d00cd1a$var$spinnerContainerStyles = (0, $ecnYn.xcss)({
    margin: 'auto',
    position: 'sticky',
    bottom: '1px'
});
const $4d6840eb7d00cd1a$export$f7f1256703956fe = 100;
const $4d6840eb7d00cd1a$export$a484c9e4bd05c9fe = /*#__PURE__*/ (0, $gwFzn.memo)(({ passThroughProps: passThroughProps, Component: Component, getElementsToBatch: getElementsToBatch, commentsList: commentsList, canRenderBatch: canRenderBatch, batchIndex: batchIndex, onBatchRendered: onBatchRendered, transitionIndexWithinBatch: transitionIndexWithinBatch })=>{
    const [showSpinner, setShowSpinner] = (0, $gwFzn.useState)(false);
    (0, $gwFzn.useLayoutEffect)(()=>{
        if (canRenderBatch) {
            setShowSpinner(true);
            setTimeout(()=>{
                onBatchRendered(batchIndex);
                setShowSpinner(false);
            }, $4d6840eb7d00cd1a$export$f7f1256703956fe);
        }
    }, [
        canRenderBatch,
        batchIndex,
        onBatchRendered
    ]);
    if (!canRenderBatch) return null;
    const batchOffset = batchIndex * (0, $3cu4A.BATCH_SIZE);
    const batchedList = commentsList.slice(batchOffset, batchOffset + (0, $3cu4A.BATCH_SIZE));
    const elements = getElementsToBatch(batchedList, passThroughProps, Component, transitionIndexWithinBatch);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, elements, showSpinner ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        justifyContent: "center",
        alignItems: "center",
        xcss: $4d6840eb7d00cd1a$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9hlns.default), {
        interactionName: (0, $9wGTI.fg)('ufo-manual-experimental-holds-confluence') ? 'comment-batch' : undefined,
        size: "medium"
    })) : null);
});

});


parcelRegister("fyUg9", function(module, exports) {

$parcel$export(module.exports, "CommentThread", () => $ab1935fb02f9af2c$export$534dc0e681c6a2d7);
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ 
var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $cdbMf = parcelRequire("cdbMf");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $8jHAi = parcelRequire("8jHAi");

var $ICFae = parcelRequire("ICFae");

var $8i27m = parcelRequire("8i27m");

var $9wGTI = parcelRequire("9wGTI");

var $liGyh = parcelRequire("liGyh");

var $cAdj8 = parcelRequire("cAdj8");

var $dANtQ = parcelRequire("dANtQ");
var $9QIM2 = parcelRequire("9QIM2");

var $3mVfX = parcelRequire("3mVfX");
var $6KwrO = parcelRequire("6KwrO");

var $4EKKB = parcelRequire("4EKKB");

var $7qvmT = parcelRequire("7qvmT");

var $4Svbr = parcelRequire("4Svbr");

var $9tfnI = parcelRequire("9tfnI");
const $ab1935fb02f9af2c$var$dividerStyle = (0, $ecnYn.xcss)({
    borderBottom: `1px solid ${"var(--ds-border, #091E4224)"}`,
    position: 'relative',
    top: 'space.200'
});
const $ab1935fb02f9af2c$var$commentThreadBoxStyles = (0, $ecnYn.xcss)({
    listStyle: 'none',
    position: 'relative',
    paddingLeft: 'space.200',
    paddingRight: 'space.250',
    paddingTop: 'space.200',
    paddingBottom: 'space.200',
    margin: '0',
    display: 'flex',
    flexDirection: 'column'
});
const $ab1935fb02f9af2c$var$newCommentThreadBoxStyles = (0, $ecnYn.xcss)({
    cursor: 'pointer'
});
const $ab1935fb02f9af2c$var$commentTypeSeperatorStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    gap: 'space.050',
    paddingTop: 'space.300',
    paddingRight: 'space.300',
    paddingBottom: 'space.150',
    paddingLeft: 'space.200',
    borderTop: `1px solid ${"var(--ds-border, #091E4224)"}`
});
const $ab1935fb02f9af2c$var$commentBodyBoxStyles = (0, $ecnYn.xcss)({
    listStyle: 'none',
    position: 'relative',
    marginRight: 'space.100'
});
const $ab1935fb02f9af2c$var$isCurrentSelectedCommentStyles = (0, $ecnYn.xcss)({
    background: "var(--ds-background-selected, #E9F2FF)"
});
const $ab1935fb02f9af2c$var$isCurrentUserSelectedCommentStyles = (0, $ecnYn.xcss)({
    background: "var(--ds-background-input-hovered, #F7F8F9)"
});
const $ab1935fb02f9af2c$var$isThreadHoveredStyles = (0, $ecnYn.xcss)({
    background: "var(--ds-surface-hovered, #F1F2F4)"
});
const $ab1935fb02f9af2c$var$isThreadPressedStyles = (0, $ecnYn.xcss)({
    background: "var(--ds-background-input-hovered, #F7F8F9)"
});
const $ab1935fb02f9af2c$var$i18n = (0, $2nPZH.defineMessages)({
    commentTypeSeperatorText: {
        id: "comments-panel.comment.thread.type-seperator",
        defaultMessage: "General comments"
    }
});
const $ab1935fb02f9af2c$export$534dc0e681c6a2d7 = ({ parentComment: parentComment, supportedTopLevelActions: supportedTopLevelActions, eventEmitter: eventEmitter, pageMode: pageMode, flags: flags, shouldRenderCommentThreadSeperator: shouldRenderCommentThreadSeperator, shouldRenderCommentTypeSeparator: shouldRenderCommentTypeSeparator })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const pageClass = (0, $9QIM2.usePageClass)();
    const [{ currentlySelectedThreadKey: currentlySelectedThreadKey, commentsMarkedAsRead: commentsMarkedAsRead, currentView: currentView }, { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setCommentsInThreadToBeMarkedAsRead: setCommentsInThreadToBeMarkedAsRead }] = (0, $3mVfX.useCommentsPanel)();
    const { pageInfo: pageInfo } = (0, $cAdj8.usePageInfo)({
        fetchPolicy: (0, $9wGTI.fg)('confluence-comment-pageInfo-use-cache-first') ? 'cache-first' : 'cache-and-network'
    });
    const { scrollCommentsPanelToThread: scrollCommentsPanelToThread } = (0, $6KwrO.useCommentsPanelScroll)();
    const threadKey = parentComment.type === (0, $8i27m.CommentType).INLINE ? parentComment.location.inlineMarkerRef ?? '' : parentComment.id;
    const selectedAnnotation = {
        id: threadKey || '',
        type: (0, $cdbMf.AnnotationTypes).INLINE_COMMENT
    };
    // State
    const [isThreadHovered, setIsThreadHovered] = (0, $gwFzn.useState)(false);
    const [isThreadPressed, setIsThreadPressed] = (0, $gwFzn.useState)(false);
    const [hoveredCommentId, setHoveredCommentId] = (0, $gwFzn.useState)(undefined);
    const [isAnnotatedTextPressed, setAnnotatedTextPressed] = (0, $gwFzn.useState)(false);
    // Hook dependent constants
    const isCurrentSelectedComment = currentlySelectedThreadKey === threadKey;
    const { editCommentId: editCommentQueryId } = (0, $liGyh.useInlineCommentQueryParams)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(pageInfo?.id ?? '');
    const { updateUnreadCommentsListState: updateUnreadCommentsListState } = (0, $ICFae.useUnreadCommentsActions)();
    const handleCommentThreadHoverProps = (0, $gwFzn.useMemo)(()=>({
            threadKey: threadKey,
            setIsThreadHovered: setIsThreadHovered,
            setHoveredCommentId: setHoveredCommentId,
            pageMode: pageMode,
            eventEmitter: eventEmitter
        }), [
        threadKey,
        setIsThreadHovered,
        setHoveredCommentId,
        pageMode,
        eventEmitter
    ]);
    const handleMouseEnter = (0, $gwFzn.useCallback)((id)=>{
        (0, $7qvmT.handleCommentThreadMouseEnter)({
            ...handleCommentThreadHoverProps,
            id: id
        });
    }, [
        handleCommentThreadHoverProps
    ]);
    const handleMouseLeave = (0, $gwFzn.useCallback)(()=>{
        (0, $7qvmT.handleCommentThreadMouseLeave)(handleCommentThreadHoverProps);
    }, [
        handleCommentThreadHoverProps
    ]);
    const getBackgroundStyle = ()=>{
        if (isCurrentSelectedComment && !(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2')) return $ab1935fb02f9af2c$var$isCurrentSelectedCommentStyles;
        if (isCurrentSelectedComment && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2')) return $ab1935fb02f9af2c$var$isCurrentUserSelectedCommentStyles;
        if (isThreadHovered && !(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2')) return $ab1935fb02f9af2c$var$isThreadHoveredStyles;
        if (isThreadPressed && !isAnnotatedTextPressed && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2')) return $ab1935fb02f9af2c$var$isThreadPressedStyles;
        return undefined;
    };
    const userActionBackgroundStyles = getBackgroundStyle();
    const unreadParentCommentAlreadyMarkedAsReadRef = (0, $gwFzn.useRef)(false);
    if (isCurrentSelectedComment && !unreadParentCommentAlreadyMarkedAsReadRef.current && parentComment.isUnread) {
        setCommentsInThreadToBeMarkedAsRead({
            threadKey: threadKey,
            commentIds: [
                parentComment.id
            ],
            commentType: parentComment.type
        });
        unreadParentCommentAlreadyMarkedAsReadRef.current = true;
        updateUnreadCommentsListState((prev)=>{
            return prev.filter((unreadComment)=>{
                if (unreadComment.id === parentComment.id) return false;
                return true;
            });
        });
    }
    const isCommentRemovedByAnotherUser = parentComment?.wasRemovedByAnotherUser;
    const isResolvedByAnotherUser = isCommentRemovedByAnotherUser && isCommentRemovedByAnotherUser === (0, $8i27m.CommentActionType).RESOLVE_COMMENT_THREAD;
    // if comment thread is resolved, mark it as read exactly once
    (0, $gwFzn.useEffect)(()=>{
        if (isResolvedByAnotherUser) {
            const unreadCommentIds = [];
            if (parentComment.isUnread) unreadCommentIds.push(parentComment.id);
            const unreadReplies = parentComment.replies.filter((reply)=>reply.isUnread);
            if (unreadReplies.length > 0) unreadCommentIds.push(...unreadReplies.map((reply)=>reply.id));
            if (unreadCommentIds.length > 0) {
                setCommentsInThreadToBeMarkedAsRead({
                    threadKey: threadKey,
                    commentIds: unreadCommentIds,
                    commentType: parentComment.type
                });
                updateUnreadCommentsListState((prev)=>{
                    const unreadCommentIdsSet = new Set(unreadCommentIds);
                    return prev.filter((unreadComment)=>!unreadCommentIdsSet.has(unreadComment.id));
                });
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleCommentTheadMouseDown = ()=>{
        if (parentComment.type === (0, $8i27m.CommentType).GENERAL) return;
        if ((0, $9wGTI.fg)('confluence_comments_select_comment_experience')) {
            const isActiveInlineComment = parentComment.type === (0, $8i27m.CommentType).INLINE && !parentComment.wasRemovedByAnotherUser && 'inlineResolveProperties' in parentComment.location && parentComment.location.inlineResolveProperties?.resolved === false;
            if (isActiveInlineComment) (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                annotationId: parentComment.location.inlineMarkerRef,
                entryPoint: 'sidebar'
            });
        }
        setIsThreadPressed(true);
        !(0, $9wGTI.fg)('confluence-frontend-duplicate-selected-thread') && setCurrentlySelectedThreadKey(threadKey);
    };
    const canAddCommentsToCommentThread = canAddComments && currentView !== (0, $3mVfX.ViewValues).RESOLVED;
    const handleCommentThreadClick = (event)=>{
        (0, $7qvmT.handleCommentThreadSelection)({
            parentComment: parentComment,
            pageMode: pageMode,
            scrollCommentsPanelToThread: scrollCommentsPanelToThread,
            setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey,
            eventEmitter: eventEmitter,
            event: event
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, shouldRenderCommentTypeSeparator && (0, $9wGTI.fg)('confluence-frontend-comments-panel-design-update') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        xcss: $ab1935fb02f9af2c$var$commentTypeSeperatorStyle,
        as: "li",
        testId: "comment-section-separator",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
        testId: "general-comment-page-icon",
        color: "var(--ds-icon-subtlest, #626F86)",
        label: formatMessage($ab1935fb02f9af2c$var$i18n.commentTypeSeperatorText)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        color: "color.text.subtlest",
        weight: "medium"
    }, formatMessage($ab1935fb02f9af2c$var$i18n.commentTypeSeperatorText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        id: `comment-thread-${threadKey}-container`,
        testId: `comment-thread-${threadKey}-container`,
        xcss: [
            $ab1935fb02f9af2c$var$commentThreadBoxStyles,
            userActionBackgroundStyles,
            (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && $ab1935fb02f9af2c$var$newCommentThreadBoxStyles
        ],
        "data-selected-comment-thread": isCurrentSelectedComment && parentComment.location?.inlineMarkerRef ? parentComment.location.inlineMarkerRef : undefined,
        as: "li",
        onClick: handleCommentThreadClick,
        onMouseDown: handleCommentTheadMouseDown,
        onMouseUp: ()=>setIsThreadPressed(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        testId: `comment-thread-${parentComment.id}-parent`,
        xcss: $ab1935fb02f9af2c$var$commentBodyBoxStyles,
        onMouseEnter: ()=>(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? handleMouseEnter(parentComment.id) : undefined,
        onMouseLeave: (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? handleMouseLeave : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9tfnI.Comment), {
        comment: parentComment,
        supportedTopLevelActions: supportedTopLevelActions,
        pageInfo: pageInfo,
        pageMode: pageMode,
        isUnread: !commentsMarkedAsRead[parentComment.type][threadKey]?.has(parentComment.id) && parentComment.isUnread,
        isHovered: hoveredCommentId === parentComment.id,
        threadKey: threadKey,
        flags: flags,
        isAnnotatedTextPressed: isAnnotatedTextPressed,
        setAnnotatedTextPressed: setAnnotatedTextPressed,
        hideBranchingStyle: !parentComment.isOpen && parentComment.replies.length === 0,
        canAddComments: canAddCommentsToCommentThread,
        isThreadHovered: isThreadHovered
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4Svbr.CommentReplies), {
        parentComment: parentComment,
        pageInfo: pageInfo,
        isCurrentSelectedComment: isCurrentSelectedComment,
        hoveredCommentId: hoveredCommentId ?? '',
        selectedAnnotation: selectedAnnotation,
        editCommentQueryId: editCommentQueryId ?? '',
        pageMode: pageMode,
        parentCommentId: parentComment.id,
        handleMouseEnter: handleMouseEnter,
        handleMouseLeave: handleMouseLeave,
        canAddComments: canAddCommentsToCommentThread
    }), shouldRenderCommentThreadSeperator && !(0, $9wGTI.fg)('confluence-frontend-comments-panel') && !(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $ab1935fb02f9af2c$var$dividerStyle,
        testId: `comment-thread-${parentComment.id}-bottom-divider`
    })));
};

});
parcelRegister("4Svbr", function(module, exports) {

$parcel$export(module.exports, "CommentReplies", () => $ff4f83a3b963012b$export$c38311e545a763a);
/* CommentReplies.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $diswb = parcelRequire("diswb");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $7EEGh = parcelRequire("7EEGh");

var $inPa6 = parcelRequire("inPa6");

var $ccHMk = parcelRequire("ccHMk");

var $ICFae = parcelRequire("ICFae");

var $hXzKU = parcelRequire("hXzKU");

var $666Tc = parcelRequire("666Tc");

var $bZhP7 = parcelRequire("bZhP7");

var $fw7xS = parcelRequire("fw7xS");

var $8i27m = parcelRequire("8i27m");

var $8SCD6 = parcelRequire("8SCD6");
var $bSvtO = parcelRequire("bSvtO");

var $irVI7 = parcelRequire("irVI7");
var $1kHsc = parcelRequire("1kHsc");

var $6faGq = parcelRequire("6faGq");

var $9wGTI = parcelRequire("9wGTI");

var $8aF6s = parcelRequire("8aF6s");

var $cMvMc = parcelRequire("cMvMc");

var $1Sjzs = parcelRequire("1Sjzs");

var $bQm3c = parcelRequire("bQm3c");

var $hl1Kw = parcelRequire("hl1Kw");

var $i6UMJ = parcelRequire("i6UMJ");
var $3mVfX = parcelRequire("3mVfX");
var $6KwrO = parcelRequire("6KwrO");

var $en1dX = parcelRequire("en1dX");

var $7qvmT = parcelRequire("7qvmT");

var $7WIld = parcelRequire("7WIld");

var $9tfnI = parcelRequire("9tfnI");

var $6Yerd = parcelRequire("6Yerd");

var $4XQdd = parcelRequire("4XQdd");
const $ff4f83a3b963012b$var$commentThreadRepliesBoxStyles = null;
const $ff4f83a3b963012b$var$commentThreadRepliesBoxStandaloneStyleOverrides = null;
const $ff4f83a3b963012b$var$replyBoxStyles = null;
const $ff4f83a3b963012b$var$oldReplyBoxStyles = null;
const $ff4f83a3b963012b$var$translucentStyle = null;
const $ff4f83a3b963012b$var$replyListStaticStraightBorders = null;
const $ff4f83a3b963012b$var$replyActionButtonStyles = {
    marginLeft: "var(--ds-space-150, 12px)",
    width: '62px',
    height: '24px',
    left: '-12px',
    paddingTop: "var(--ds-space-100, 8px)",
    paddingBottom: "var(--ds-space-100, 8px)"
};
const $ff4f83a3b963012b$var$customizedReplyButtonStyles = null;
const $ff4f83a3b963012b$var$commentEditorCustomStyles = {
    marginLeft: "var(--ds-space-300, 24px)",
    height: '16px',
    marginRight: "var(--ds-space-050, 4px)"
};
const $ff4f83a3b963012b$var$i18n = (0, $2nPZH.defineMessages)({
    replyAction: {
        id: "comments-panel.reply.action",
        defaultMessage: "Reply"
    }
});
const $ff4f83a3b963012b$export$c38311e545a763a = ({ parentComment: parentComment, pageInfo: pageInfo, isCurrentSelectedComment: isCurrentSelectedComment, hoveredCommentId: hoveredCommentId, pageMode: pageMode, editCommentQueryId: editCommentQueryId, selectedAnnotation: selectedAnnotation, parentCommentId: parentCommentId, handleMouseEnter: handleMouseEnter, handleMouseLeave: handleMouseLeave, canAddComments: canAddComments, isStandaloneComment: isStandaloneComment, deleteStandaloneComment: deleteStandaloneComment, replyToComment: replyToComment, updateReactionsCacheFn: updateReactionsCacheFn })=>{
    const [createInlineReplyFn] = (0, $diswb.useMutation)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $bZhP7.CreateInlineReplyMutation));
    const [createGeneralReplyFn] = (0, $diswb.useMutation)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $fw7xS.CreateGeneralReplyMutation));
    const { isReactionsEnabled: isReactionsEnabled } = (0, $gwFzn.useContext)((0, $8SCD6.ReactionsContext));
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { onChange: onChange, resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [{ searchSessionId: searchSessionId }] = (0, $hl1Kw.useSearchSessionId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [, { addReplyToCommentThread: addReplyToCommentThread }] = (0, $8i27m.useCommentsData)();
    const [, { updateReadCommentsListState: updateReadCommentsListState }] = (0, $ICFae.useUnreadComments)();
    const { scrollCommentsPanelToThread: scrollCommentsPanelToThread } = (0, $6KwrO.useCommentsPanelScroll)();
    const [{ commentsMarkedAsRead: commentsMarkedAsRead, replyToCommentId: replyToCommentId, location: location, replyToCommentUser: replyToCommentUser }, { setCommentsInThreadToBeMarkedAsRead: setCommentsInThreadToBeMarkedAsRead, setReplyToCommentId: setReplyToCommentId }] = (0, $3mVfX.useCommentsPanel)();
    const { updateUnreadCommentsListState: updateUnreadCommentsListState } = (0, $ICFae.useUnreadCommentsActions)();
    const allReplies = (0, $gwFzn.useMemo)(()=>{
        return parentComment.replies.filter((r)=>r !== null);
    }, [
        parentComment.replies
    ]);
    const numOfReplies = allReplies.length;
    const unreadReplyIds = (0, $gwFzn.useMemo)(()=>{
        return allReplies.filter((r)=>r.isUnread).map((r)=>r.id);
    }, [
        allReplies
    ]); // Show the latest replies in the thread by default
    const [shouldShowLatestReplies, setShouldShowLatestReplies] = (0, $gwFzn.useState)(true);
    const [visibleReplies, setVisibleReplies] = (0, $gwFzn.useState)([]);
    const [, setCommentForEdit] = (0, $gwFzn.useState)('');
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const pageId = pageInfo?.id ?? '';
    const pageType = pageInfo?.type ?? '';
    const commentType = parentComment.type;
    const isParentCommentOpen = parentComment.isOpen;
    const [currentReplyView, setReplyView] = (0, $gwFzn.useState)(// Determine the reply view by counting the total number of top-level replies to the parent comment.
    // This excludes any nested replies.
    (0, $7qvmT.getCurrentReplyView)((0, $7qvmT.getCommentReplies)(allReplies, parentCommentId).length, isParentCommentOpen, isStandaloneComment)); // User page permissions
    const operations = pageInfo?.operations || []; // The user can upload media only if they have update permissions for the page
    const hasMediaUploadPermissions = operations.some((op)=>op?.operation === 'update' && op?.targetType === pageType);
    const threadKey = commentType === (0, $8i27m.CommentType).INLINE ? (parentComment?.location).inlineMarkerRef || '' : parentCommentId;
    const supportedTopLevelActions = isParentCommentOpen ? [
        'edit',
        'resolve',
        'delete'
    ] : [
        'reopen'
    ]; // reopen won't be rendered for reply, but we are using it to render disabled reaction summary for replies
    const expandReplyEditor = parentCommentId === replyToCommentId && location === (0, $i6UMJ.LocationValue).PANEL;
    const visibleUnreadRepliesNotMarkedAsRead = (0, $gwFzn.useMemo)(()=>{
        return visibleReplies.filter((reply)=>{
            const markedReplies = commentsMarkedAsRead[commentType][threadKey]; // Check if the reply id is not in the markedReplies set
            return (!markedReplies || !markedReplies.has(reply.id)) && reply.isUnread;
        }).map((reply)=>reply.id);
    }, [
        visibleReplies,
        commentsMarkedAsRead,
        threadKey,
        commentType
    ]);
    const numOfHiddenReplies = (0, $gwFzn.useRef)(currentReplyView === (0, $7qvmT.ViewReplyOptions).ALL ? 0 : numOfReplies - visibleReplies.length);
    const topLevelReplyToNestedChildrenMap = (0, $gwFzn.useMemo)(()=>{
        const topLevelReplyIds = new Set(allReplies.filter((reply)=>reply.parentId === parentCommentId).map((reply)=>reply.id)); // We need to get all replies that are nested to any depth under a top level reply.
        // This will help us render the GeneralReplyScroller component for each reply (mainly, we need to show user icons and the blue dot indicator)
        const topLevelReplyToNestedChildrenMapInternal = Array.from(topLevelReplyIds).reduce((acc, replyId)=>{
            acc[replyId] = [];
            return acc;
        }, {});
        const replyIdToReplyMap = allReplies.reduce((acc, reply)=>{
            acc[reply.id] = reply;
            return acc;
        }, {}); // Map all replies to their top level parent. Replies can be nested to any depth, so we need to traverse the tree.
        const filteredReplies = allReplies.filter((reply)=>!topLevelReplyIds.has(reply.id));
        for (const filteredReply of filteredReplies){
            let replyParentId = filteredReply.parentId; // Add a circuit breaker to prevent infinite loops if we get really wonky data
            let circuitBreaker = 0;
            while(replyParentId && circuitBreaker < 100 && !topLevelReplyIds.has(replyParentId)){
                replyParentId = replyIdToReplyMap[replyParentId]?.parentId;
                circuitBreaker++;
            }
            if (replyParentId && replyParentId in topLevelReplyToNestedChildrenMapInternal) // Second condition will always be true, unless we somehow hit circuit breaker above
            topLevelReplyToNestedChildrenMapInternal[replyParentId].push(filteredReply);
        }
        return topLevelReplyToNestedChildrenMapInternal;
    }, [
        allReplies,
        parentCommentId
    ]); // Determine the latest top level replies to show on the thread's initial load
    const latestReplies = (0, $gwFzn.useMemo)(()=>{
        const replies = [];
        const topLevelReplies = allReplies.filter((reply)=>reply.id in topLevelReplyToNestedChildrenMap); // Sort by createdAtNonLocalized value
        topLevelReplies.sort((a, b)=>{
            // Safely handle missing or invalid dates
            const dateA = (0, $6faGq.getValidDate)(a?.createdAtNonLocalized);
            const dateB = (0, $6faGq.getValidDate)(b?.createdAtNonLocalized);
            return dateA.getTime() - dateB.getTime();
        }); // Add the latest replies to the replies array
        for(let i = 0; i < (0, $7qvmT.getDefaultNumVisibleReplies)(numOfReplies, isStandaloneComment); i++)if (topLevelReplies.length > 0) {
            const reply = topLevelReplies.pop();
            if (reply) // Unshift to maintain reply chronological order
            replies.unshift(reply);
        }
        return replies;
    }, [
        allReplies,
        isStandaloneComment,
        numOfReplies,
        topLevelReplyToNestedChildrenMap
    ]); /*
                                                                                          * Determine the latest top level reply IDs and their nested reply IDs.
                                                                                          * This is passed to RepliesToggler to determine the hidden replies.
                                                                                          */ 
    const latestReplyIds = (0, $gwFzn.useMemo)(()=>{
        const latestAndNestedReplyIds = new Set();
        for (const reply of latestReplies){
            latestAndNestedReplyIds.add(reply.id);
            for (const nestedReply of topLevelReplyToNestedChildrenMap[reply.id])latestAndNestedReplyIds.add(nestedReply.id);
        }
        return latestAndNestedReplyIds;
    }, [
        latestReplies,
        topLevelReplyToNestedChildrenMap
    ]); // if selecting the comment thread, we need to mark all visible replies as read as well
    // we'll let setCommentsInThreadToBeMarkedAsRead handle duplicates if any
    (0, $gwFzn.useEffect)(()=>{
        if (isCurrentSelectedComment) {
            setCommentsInThreadToBeMarkedAsRead({
                threadKey: threadKey,
                commentIds: visibleUnreadRepliesNotMarkedAsRead,
                commentType: commentType
            });
            updateUnreadCommentsListState((prev)=>{
                const repliesIds = new Set(visibleUnreadRepliesNotMarkedAsRead);
                return prev.filter((unreadComment)=>{
                    if (repliesIds.has(unreadComment.id)) return false;
                    return true;
                });
            });
        } // eslint-disable-next-line react-hooks/exhaustive-deps -- there might be a better way to handle this without needing a useEFfect
    }, [
        isCurrentSelectedComment
    ]);
    (0, $7WIld.useUpdateVisibleReplies)({
        allReplies: allReplies,
        commentType: commentType,
        isParentCommentOpen: isParentCommentOpen,
        currentReplyView: currentReplyView,
        latestReplies: latestReplies,
        latestReplyIds: latestReplyIds,
        parentCommentId: parentCommentId,
        setVisibleReplies: setVisibleReplies,
        shouldShowLatestReplies: shouldShowLatestReplies,
        numOfHiddenReplies: numOfHiddenReplies
    });
    const handleReplyButtonClick = (event)=>{
        event.stopPropagation();
        if (hasContentChanged) // if the content has changed and the user has clicked reply button to another comment thread, warn the user
        showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                resetContentChanged();
                setReplyToCommentId({
                    parentCommentId: parentCommentId,
                    location: (0, $i6UMJ.LocationValue).PANEL
                });
            }
        });
        else setReplyToCommentId({
            parentCommentId: parentCommentId,
            location: (0, $i6UMJ.LocationValue).PANEL
        });
    };
    const renderReplyButton = ()=>{
        return isParentCommentOpen && canAddComments && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1Sjzs.WithCurvedBranchingStyle), {
            showDefaultStyles: true,
            customStyles: $ff4f83a3b963012b$var$replyActionButtonStyles,
            testId: "comments-panel-reply-comment-action",
            onClick: handleReplyButtonClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
            "data-cy": "comments-panel-reply-comment-action",
            appearance: "subtle",
            isDisabled: !isParentCommentOpen,
            analyticsContext: {
                attributes: {
                    name: 'replyToCommentButton',
                    source: (0, $en1dX.AnalyticsSource).COMMENTS_PANEL
                }
            },
            ...(0, $9wGTI.fg)('cc_comments_track_secondary_comments_actions') ? {
                interactionName: 'start-reply-comment-action'
            } : {},
            className: (0, $35pXk.default)([
                "_1tv3glyw"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $ff4f83a3b963012b$var$i18n.replyAction)));
    };
    const renderCommentEditor = ()=>{
        return expandReplyEditor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $666Tc.NewReplyContainer), {
            mode: "view",
            isCommentsPanel: true,
            "data-testid": "comments-panel-new-reply-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1Sjzs.WithCurvedBranchingStyle), {
            showDefaultStyles: (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2'),
            customStyles: (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? $ff4f83a3b963012b$var$commentEditorCustomStyles : {}
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hXzKU.LazyCommentEditor), {
            pageId: pageId,
            pageType: pageType,
            content: (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment') ? (0, $7qvmT.getAdfForQuickReplyMention)(replyToCommentUser) : undefined,
            appearance: "chromeless",
            EditorComponent: (0, $7EEGh.ChromelessEditor),
            onSaveComment: (adf, onSuccess)=>{
                setReplyView((0, $7qvmT.ViewReplyOptions).ALL);
                setReplyToCommentId();
                resetContentChanged();
                return (0, $7qvmT.onSaveReply)({
                    pageId: pageId,
                    parentCommentId: parentCommentId,
                    cloudId: cloudId,
                    adf: adf,
                    onSuccess: onSuccess,
                    pageMode: pageMode,
                    editCommentQueryId: editCommentQueryId,
                    setCommentForEdit: setCommentForEdit,
                    createAnalyticsEvent: createAnalyticsEvent,
                    pageType: pageType,
                    experienceTracker: experienceTracker,
                    createInlineReplyFn: createInlineReplyFn,
                    createGeneralReplyFn: createGeneralReplyFn,
                    selectedAnnotation: selectedAnnotation,
                    addReplyToCommentThread: addReplyToCommentThread,
                    threadKey: threadKey,
                    updateReadCommentsListState: updateReadCommentsListState,
                    commentType: commentType,
                    searchSessionId: searchSessionId,
                    isReactionsEnabled: isReactionsEnabled,
                    analyticsSource: isStandaloneComment ? (0, $en1dX.AnalyticsSource).STANDALONE : (0, $en1dX.AnalyticsSource).COMMENTS_PANEL
                });
            },
            onContentChange: onChange,
            onEditorReady: ()=>{
                let experienceName = (0, $irVI7.REPLY_TO_INLINE_COMMENT_LOAD_EXPERIENCE);
                if (commentType === (0, $8i27m.CommentType).GENERAL) {
                    if ((0, $9wGTI.fg)('confluence_frontend_separate_add_page_comment')) experienceName = (0, $irVI7.REPLY_TO_PAGE_COMMENT_LOAD_EXPERIENCE);
                    else experienceName = (0, $irVI7.ADD_PAGE_COMMENT_LOAD_EXPERIENCE);
                }
                experienceTracker.succeed({
                    name: experienceName
                });
                scrollCommentsPanelToThread({
                    annotationId: threadKey,
                    scrollToEnd: true
                });
            },
            commentMode: "reply",
            commentType: commentType === (0, $8i27m.CommentType).GENERAL ? 'page' : 'inline',
            spaceId: "",
            showCancelButton: true,
            useNewWarningModal: true,
            hideWatchCheckbox: true,
            expandEditor: expandReplyEditor,
            pageMode: "view",
            hasMediaUploadPermissions: hasMediaUploadPermissions,
            shouldDisplayCommentReplyPrompts: false,
            topLevelCommentId: parentComment.id,
            shouldWarnOnInternalNavigation: true,
            commentThreadLength: numOfReplies + 1,
            onCancelComment: ()=>{
                setReplyToCommentId();
            },
            isCommentsPanel: true,
            wasRemovedByAnotherUser: parentComment.wasRemovedByAnotherUser
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null);
    };
    const renderUpdatedLowerAction = ()=>{
        if (expandReplyEditor && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2')) return renderCommentEditor();
        else if (!isStandaloneComment) return renderReplyButton();
        else return null;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": `comment-thread-${parentComment.id}-replies`,
        className: (0, $35pXk.default)([
            "_1e0c1txw _2lx21bp4 _19bvpxbi _u5f3u2gc",
            parentComment.wasRemovedByAnotherUser && "_tzy41ssb",
            isStandaloneComment && "_u5f3pxbi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", null, numOfReplies > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6Yerd.RepliesToggler), {
        replies: allReplies,
        setVisibleReplies: setVisibleReplies,
        unreadReplyIds: unreadReplyIds,
        setReplyView: setReplyView,
        threadKey: threadKey,
        currentReplyView: currentReplyView,
        numOfHiddenReplies: numOfHiddenReplies,
        commentType: commentType,
        parentCommentId: parentCommentId,
        isParentOpen: isParentCommentOpen,
        canAddComments: canAddComments,
        shouldShowLatestReplies: shouldShowLatestReplies,
        setShouldShowLatestReplies: setShouldShowLatestReplies,
        latestReplyIds: latestReplyIds,
        isStandaloneComment: isStandaloneComment
    }), visibleReplies.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": `comment-thread-${parentComment.id}-reply-list`,
        className: (0, $35pXk.default)([
            !(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && "_1kl7udwz _bozgze3t"
        ])
    }, visibleReplies.map((reply, idx)=>reply && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
            key: reply.id,
            "data-testid": `comment-thread-${parentComment.id}-replies-${reply.id}`,
            onMouseEnter: ()=>handleMouseEnter(reply.id),
            onMouseLeave: handleMouseLeave,
            className: (0, $35pXk.default)([
                (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? "_qtt8glyw _kqswh2mm _ca0qu2gc _n3tdu2gc _19bv1ejb" : "_qtt8glyw _kqswh2mm _ca0qu2gc _n3tdu2gc _19bvpxbi"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9tfnI.Comment), {
            comment: reply,
            supportedTopLevelActions: supportedTopLevelActions,
            pageInfo: pageInfo,
            pageMode: pageMode,
            isUnread: !commentsMarkedAsRead[commentType][threadKey]?.has(reply.id) && reply.isUnread,
            isHovered: hoveredCommentId === reply.id,
            threadKey: threadKey,
            hideBranchingStyle: !canAddComments && idx === visibleReplies.length - 1 || isStandaloneComment && idx === visibleReplies.length - 1,
            adjustForNestedReplies: commentType === (0, $8i27m.CommentType).GENERAL && reply.id in topLevelReplyToNestedChildrenMap && topLevelReplyToNestedChildrenMap[reply.id]?.length > 0 && (0, $9wGTI.fg)('confluence-frontend-comments-panel-design-update'),
            canAddComments: canAddComments,
            isParentCommentOpen: isParentCommentOpen,
            deleteStandaloneComment: deleteStandaloneComment,
            isStandaloneComment: isStandaloneComment,
            replyToComment: replyToComment,
            updateReactionsCacheFn: updateReactionsCacheFn
        }), commentType === (0, $8i27m.CommentType).GENERAL && reply.id in topLevelReplyToNestedChildrenMap && topLevelReplyToNestedChildrenMap[reply.id]?.length > 0 && (0, $9wGTI.fg)('confluence-frontend-comments-panel-design-update') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4XQdd.GeneralReplyScroller), {
            nestedReplies: topLevelReplyToNestedChildrenMap[reply.id],
            unreadReplyIds: unreadReplyIds,
            targetCommentIdForScroll: reply.id
        }))))), renderUpdatedLowerAction()), expandReplyEditor && !(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && renderCommentEditor());
};

});
parcelRegister("666Tc", function(module, exports) {

$parcel$export(module.exports, "ActionsContainer", () => $003eb47e4cfe7fce$export$48377ae1c677702b);
$parcel$export(module.exports, "SidebarContainer", () => $003eb47e4cfe7fce$export$f39f3f768bc98e3d);
$parcel$export(module.exports, "ReplyListContainer", () => $003eb47e4cfe7fce$export$18986330a3dbad03);
$parcel$export(module.exports, "NewReplyContainer", () => $003eb47e4cfe7fce$export$86b1f0d05f7b12cd);
$parcel$export(module.exports, "ResolvedNotificationContainer", () => $003eb47e4cfe7fce$export$5aae1a36fc838370);
$parcel$export(module.exports, "EditorContainer", () => $003eb47e4cfe7fce$export$b38a2fd24b22fb35);
$parcel$export(module.exports, "NavigationContainer", () => $003eb47e4cfe7fce$export$d1b98bde82a43bb3);
$parcel$export(module.exports, "InlineHeaderButton", () => $003eb47e4cfe7fce$export$2616e8e1e1a7c3e5);
$parcel$export(module.exports, "SidebarHeader", () => $003eb47e4cfe7fce$export$e575a964a1fe8b0);
$parcel$export(module.exports, "LoadingSkeletonContainer", () => $003eb47e4cfe7fce$export$b3b0191112eea395);
$parcel$export(module.exports, "TopContainer", () => $003eb47e4cfe7fce$export$f895097fe90363d1);
$parcel$export(module.exports, "CloseButtonContainer", () => $003eb47e4cfe7fce$export$32dd8f1956fe77b1);
$parcel$export(module.exports, "CloseButton", () => $003eb47e4cfe7fce$export$de65de8213222d10);
/* styled-components.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
var $iAWao = parcelRequire("iAWao");

var $4KS7f = parcelRequire("4KS7f");

var $9wGTI = parcelRequire("9wGTI");
const $003eb47e4cfe7fce$var$slideOut = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$48377ae1c677702b = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11c81o8v _1yt4v0yc _1e0c1txw _1n261g80 _4cvr1h6o _1tke1f4h",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$4fbc87ee9c503b41 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1as918uv _j4qy8stv _1wwgnqa1 _v0fytlke",
            __cmplp.className
        ])
    });
});
const $003eb47e4cfe7fce$export$f39f3f768bc98e3d = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSticky: isSticky, isAutoDismissResolve: isAutoDismissResolve, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_16090q4": (0, $iAWao.default)((()=>{
                const { rightOffset: rightOffset = 0 } = __cmplp;
                return `${rightOffset}px`;
            })()),
            "--_162hus6": (0, $iAWao.default)(__cmplp.offset, "px")
        },
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_19itzgxb _2rko1l7b _16qs9g9j _bfhkvuon _1xi21dwo _154i1odf _1e0c1txw _2lx21bp4 _vchhusvi _otyr53f4",
            __cmplp.mode === 'view' ? "_1pbyibnn" : "_1pby1ap8",
            __cmplp.isSticky ? "_kqsw1n9t" : "_kqswstnw",
            (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment') && (0, $9wGTI.fg)('confluence_frontend_comment_sidebar_max_height') ? "_1bsb1kdj" : "_1bsb1178",
            (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment') && (0, $9wGTI.fg)('confluence_frontend_comment_sidebar_max_height') ? "_c71l1us8" : "_c71lglyw",
            Boolean(__cmplp.isAutoDismissResolve) && "",
            Boolean(__cmplp.isAutoDismissResolve) && "_y44vuwz3",
            __cmplp.className
        ])
    });
});
const $003eb47e4cfe7fce$export$18986330a3dbad03 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _2lx21bp4 _bfhkvuon _521wzgxb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$86b1f0d05f7b12cd = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCommentsPanel: isCommentsPanel, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1ms47y0": (0, $iAWao.default)((()=>{
                const basePadding = __cmplp.mode === 'view' ? `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-200, 16px)"}` : `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`;
                return __cmplp.isCommentsPanel ? '0' : basePadding;
            })()),
            "--_u59hks": (0, $iAWao.default)((()=>{
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                return (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment') ? "var(--ds-space-150, 12px)" : "var(--ds-space-100, 8px)";
            })()),
            "--_12xl3ea": (0, $iAWao.default)((0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment') ? "var(--ds-text-subtlest, #626F86)" : "var(--ds-text-disabled, #091E424F)")
        },
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1yt41vmh _n3tdym4m _1k0c1b66 _159vzwfg _1wv1b0m7",
            !(__cmplp.isCommentsPanel || (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment')) && "_x3dozgxb",
            __cmplp.className
        ])
    });
});
const $003eb47e4cfe7fce$export$5aae1a36fc838370 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1yt41jx0 _1e0c1txw _4cvr1h6o _2lx21bp4 _1i7vdcr7 _9a6v14no _kckd15o9 _125x1fxt _31ku1h6o _ekv6dcr7 _dkzuutpp _5lhmtlke _1pzm1h6o",
            __cmplp.className
        ])
    });
}); // View mode styled components
const $003eb47e4cfe7fce$export$b38a2fd24b22fb35 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isReply: isReply, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "",
            !__cmplp.isReply && "_1yt4utpp _n7zlzgxb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$d1b98bde82a43bb3 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldHaveButtonGap: shouldHaveButtonGap, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _1usn19bv _1achz0dk _1scm1gjq",
            __cmplp.shouldHaveButtonGap && "_zulpv77o",
            __cmplp.className
        ])
    });
});
const $003eb47e4cfe7fce$export$6e006bd290301009 = '24px';
const $003eb47e4cfe7fce$export$3421cb2750fe78a7 = '28px';
const $003eb47e4cfe7fce$export$28ae196bde1430fd = '24px'; // Needed to get the correct overall size to match the comment icon next to it
const $003eb47e4cfe7fce$var$inlineHeaderButtonTheme = (isSSRFocusedComment)=>(currentTheme, themeProps)=>{
        const theme = currentTheme(themeProps);
        return {
            ...theme,
            buttonStyles: {
                ...theme.buttonStyles,
                background: 'none',
                borderRadius: '4px',
                height: $003eb47e4cfe7fce$export$6e006bd290301009,
                width: $003eb47e4cfe7fce$export$6e006bd290301009,
                '&:hover': {
                    backgroundColor: `${"var(--ds-surface-hovered, #F1F2F4)"}`
                },
                '&:focus': {
                    boxShadow: `0 0 0 2px ${"var(--ds-border-focused, #388BFF)"}`
                },
                cursor: isSSRFocusedComment ? 'not-allowed' : 'pointer',
                '*': {
                    color: isSSRFocusedComment ? `${"var(--ds-text-subtlest, #626F86)"}` : `inherit`
                }
            }
        };
    };
const $003eb47e4cfe7fce$export$2616e8e1e1a7c3e5 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4KS7f.default), {
        theme: $003eb47e4cfe7fce$var$inlineHeaderButtonTheme(props.isSSRFocusedComment),
        ...props
    });
const $003eb47e4cfe7fce$export$e575a964a1fe8b0 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldShowNavigation: shouldShowNavigation, isReattachHeader: isReattachHeader, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_kqswh2mm _1e0c1txw _19bvutpp _u5f3utpp",
            __cmplp.shouldShowNavigation ? "_1bah1yb4" : "_1bahesu3",
            __cmplp.shouldShowNavigation && "_4t3i10yn _ca0qutpp",
            __cmplp.isReattachHeader && "_4t3i10yn _ca0qpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$b3b0191112eea395 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = $003eb47e4cfe7fce$export$f39f3f768bc98e3d, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1bsb1178 _4t3irvwn",
            __cmplp.showSkeleton ? "_1e0c1ule" : "_1e0cglyw",
            __cmplp.className
        ])
    });
});
const $003eb47e4cfe7fce$export$f895097fe90363d1 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { showNavigation: showNavigation, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw",
            __cmplp.showNavigation ? "_19pkxy5q" : "_19pkze3t",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$32dd8f1956fe77b1 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_kqswstnw _1xi2utpp _1pbykb7n _154iutpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$4b61d9d7155e9162 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_zulp12x7 _kqswstnw _154ipxbi _1ltvpxbi _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $003eb47e4cfe7fce$var$closeButtonTheme = (isUpdatedStandaloneComment)=>(currentTheme, themeProps)=>{
        const theme = currentTheme(themeProps);
        return {
            ...theme,
            buttonStyles: {
                ...theme.buttonStyles,
                height: $003eb47e4cfe7fce$export$6e006bd290301009,
                width: isUpdatedStandaloneComment ? $003eb47e4cfe7fce$export$28ae196bde1430fd : $003eb47e4cfe7fce$export$3421cb2750fe78a7
            }
        };
    };
const $003eb47e4cfe7fce$export$de65de8213222d10 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4KS7f.default), {
        theme: $003eb47e4cfe7fce$var$closeButtonTheme(props.isUpdatedStandaloneComment ?? false),
        ...props
    });

});

parcelRegister("bZhP7", function(module, exports) {

$parcel$export(module.exports, "CreateInlineReplyMutation", () => $00a98ab2c59a4725$export$3ddf6f43bfaf4b85);

var $d2LG0 = parcelRequire("d2LG0");

var $hpsMA = parcelRequire("hpsMA");
const $00a98ab2c59a4725$export$3ddf6f43bfaf4b85 = (0, $d2LG0.default)`mutation CreateInlineReplyMutation($input:ReplyInlineCommentInput!$pageId:ID!){replyInlineComment(input:$input){...inlineCommentFragment createdAt{value}createdAtNonLocalized reactionsSummary(pageId:$pageId contentType:"page" childType:"comment"){ari containerAri reactionsCount reactionsSummaryForEmoji{id emojiId count reacted}}}}${(0, $hpsMA.inlineCommentFragment)}`;

});

parcelRegister("fw7xS", function(module, exports) {

$parcel$export(module.exports, "CreateGeneralReplyMutation", () => $e57d3ec3e007ab69$export$2d1b8e822129af77);

var $d2LG0 = parcelRequire("d2LG0");

var $60Mdo = parcelRequire("60Mdo");
const $e57d3ec3e007ab69$export$2d1b8e822129af77 = (0, $d2LG0.default)`mutation CreateGeneralReplyMutation($pageId:ID!$cloudId:ID!$input:CreateCommentInput!){createFooterComment(cloudId:$cloudId input:$input){...commentFragment}}${(0, $60Mdo.commentFragment)}`;

});
parcelRegister("60Mdo", function(module, exports) {

$parcel$export(module.exports, "commentFragment", () => $bc065e15e326c89d$export$55b7689f58fc33e2);

var $d2LG0 = parcelRequire("d2LG0");
const $bc065e15e326c89d$export$55b7689f58fc33e2 = (0, $d2LG0.default)`fragment commentFragment on Comment{id author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}...on User{accountId}}body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui editui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{isDangling resolvedTime resolvedFriendlyDate resolvedUser resolved}}...on FooterComment{commentResolveProperties{resolvedTime resolvedFriendlyDate resolvedUser resolved}}}parentId permissions{isEditable isRemovable isResolvable}reactionsSummary(pageId:$pageId contentType:"page" childType:"comment"){ari containerAri reactionsCount reactionsSummaryForEmoji{id emojiId count reacted}}version{by{displayName}when number}}`;

});


parcelRegister("1Sjzs", function(module, exports) {

$parcel$export(module.exports, "WithCurvedBranchingStyle", () => $182916127499e17b$export$855243800ee94bad);
/* WithCurvedBranchingStyle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");
const $182916127499e17b$var$replyBranchStyles = null;
const $182916127499e17b$export$855243800ee94bad = ({ showDefaultStyles: showDefaultStyles, children: children, customStyles: customStyles, onClick: onClick, testId: testId, disableLeftProp: disableLeftProp })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...(()=>{
                const { height: height, left: left, ...rest } = customStyles || {};
                return rest;
            })(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...customStyles?.height && {
                '--customHeight': customStyles.height
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...customStyles?.left ? {
                '--customBeforeLeft': customStyles.left
            } : {
                '--customBeforeLeft': disableLeftProp ? '0px' : '-24px'
            }
        },
        onClick: onClick,
        "data-testid": testId,
        className: (0, $35pXk.default)([
            showDefaultStyles && "_kqswh2mm _1n1jqcao _4k1cqcao _1kt9b3bt _1cs8stnw _qnec1gkm _1aukidpf _1mp41skh _kfgt1pfq _fik81v6z"
        ])
    }, children);
};

});

parcelRegister("7WIld", function(module, exports) {

$parcel$export(module.exports, "useUpdateVisibleReplies", () => $45f04e389e3155f6$export$b1d0bdb48de923ea);

var $gwFzn = parcelRequire("gwFzn");

var $9wGTI = parcelRequire("9wGTI");

var $3mVfX = parcelRequire("3mVfX");

var $7qvmT = parcelRequire("7qvmT");
const $45f04e389e3155f6$export$b1d0bdb48de923ea = ({ allReplies: allReplies, commentType: commentType, isParentCommentOpen: isParentCommentOpen, currentReplyView: currentReplyView, latestReplies: latestReplies, latestReplyIds: latestReplyIds, parentCommentId: parentCommentId, setVisibleReplies: setVisibleReplies, shouldShowLatestReplies: shouldShowLatestReplies, numOfHiddenReplies: numOfHiddenReplies, allowNestedReplies: allowNestedReplies = false })=>{
    // As long as the flag is present, we have to provide both
    const { currentView: currentView } = (0, $3mVfX.useCommentsPanelState)();
    (0, $gwFzn.useLayoutEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_cp_visible_replies_refactor')) return;
        (0, $7qvmT.updateVisibleReplies)({
            parentCommentId: parentCommentId,
            currentReplyView: currentReplyView,
            setVisibleReplies: setVisibleReplies,
            allReplies: allReplies,
            isParentCommentOpen: isParentCommentOpen,
            latestReplies: latestReplies,
            currentView: currentView,
            allowNestedReplies: allowNestedReplies
        });
    }, [
        allReplies,
        currentReplyView,
        isParentCommentOpen,
        latestReplies,
        numOfHiddenReplies,
        parentCommentId,
        setVisibleReplies,
        currentView,
        allowNestedReplies
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_cp_visible_replies_refactor')) return;
        (0, $7qvmT.legacyUpdateVisibleReplies)({
            allReplies: allReplies,
            commentType: commentType,
            isParentCommentOpen: isParentCommentOpen,
            currentReplyView: currentReplyView,
            latestReplies: latestReplies,
            latestReplyIds: latestReplyIds,
            parentCommentId: parentCommentId,
            setVisibleReplies: setVisibleReplies,
            shouldShowLatestReplies: shouldShowLatestReplies,
            numOfHiddenReplies: numOfHiddenReplies
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- there might be a better way to handle this without needing a useEffect
    }, [
        allReplies,
        latestReplies,
        latestReplyIds
    ]);
};

});

parcelRegister("9tfnI", function(module, exports) {

$parcel$export(module.exports, "Comment", () => $dbdd2e782e37c476$export$4d299b491347818a);

var $gwFzn = parcelRequire("gwFzn");

var $diswb = parcelRequire("diswb");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $inPa6 = parcelRequire("inPa6");

var $21K7m = parcelRequire("21K7m");

var $cdbMf = parcelRequire("cdbMf");

var $9wGTI = parcelRequire("9wGTI");

var $gfqXk = parcelRequire("gfqXk");
var $gczDe = parcelRequire("gczDe");

var $8i27m = parcelRequire("8i27m");

var $aMfLn = parcelRequire("aMfLn");

var $8SCD6 = parcelRequire("8SCD6");
var $bSvtO = parcelRequire("bSvtO");
var $1YPul = parcelRequire("1YPul");

var $kEmgx = parcelRequire("kEmgx");
var $auGhu = parcelRequire("auGhu");
var $kmHPt = parcelRequire("kmHPt");

var $isdzP = parcelRequire("isdzP");
var $8dA1U = parcelRequire("8dA1U");
var $g0DaR = parcelRequire("g0DaR");

var $ep3mz = parcelRequire("ep3mz");

var $8z9UY = parcelRequire("8z9UY");
var $jkPJy = parcelRequire("jkPJy");
var $6Ebso = parcelRequire("6Ebso");
var $2Ntx6 = parcelRequire("2Ntx6");
var $3s9yq = parcelRequire("3s9yq");
var $5olRs = parcelRequire("5olRs");
var $dhKx6 = parcelRequire("dhKx6");

var $eg9xl = parcelRequire("eg9xl");
var $5odkT = parcelRequire("5odkT");

var $liGyh = parcelRequire("liGyh");

var $aUU0C = parcelRequire("aUU0C");
var $k8e76 = parcelRequire("k8e76");

var $irVI7 = parcelRequire("irVI7");
var $1kHsc = parcelRequire("1kHsc");

var $cD1qu = parcelRequire("cD1qu");

var $8WQTF = parcelRequire("8WQTF");

var $cZa7r = parcelRequire("cZa7r");

var $9CnRS = parcelRequire("9CnRS");

var $2i3To = parcelRequire("2i3To");

var $ftXPY = parcelRequire("ftXPY");

var $h5M1u = parcelRequire("h5M1u");

var $87CZC = parcelRequire("87CZC");

var $bQm3c = parcelRequire("bQm3c");

var $7W8i8 = parcelRequire("7W8i8");

var $i6UMJ = parcelRequire("i6UMJ");
var $3mVfX = parcelRequire("3mVfX");
var $6KwrO = parcelRequire("6KwrO");

var $en1dX = parcelRequire("en1dX");

var $3BI2p = parcelRequire("3BI2p");

var $5fMeR = parcelRequire("5fMeR");
const $dbdd2e782e37c476$var$i18n = (0, $2nPZH.defineMessages)({
    commentReopenedFlagTitle: {
        id: "comments-panel.comment.reopened.flag.title",
        defaultMessage: "Comment reopened"
    },
    commentReopenFailedFlagTitle: {
        id: "comments-panel.comment.reopen.failed.flag.title",
        defaultMessage: "Failed to reopen comment"
    },
    retryCTA: {
        id: "comments-panel.comment.reopen.failed.flag.cta.retry",
        defaultMessage: "Retry now"
    },
    cannotDeleteTitle: {
        id: "comments-panel.could.not.delete.title",
        defaultMessage: "Unable to delete comment"
    }
});
const $dbdd2e782e37c476$var$logger = (0, $7W8i8.getLogger)('page-comments-queries');
const $dbdd2e782e37c476$export$4d299b491347818a = ({ comment: comment, supportedTopLevelActions: supportedTopLevelActions, pageMode: pageMode, pageInfo: pageInfo, isUnread: isUnread = false, isHovered: isHovered, threadKey: threadKey, flags: flags, isAnnotatedTextPressed: isAnnotatedTextPressed, setAnnotatedTextPressed: setAnnotatedTextPressed, adjustForNestedReplies: adjustForNestedReplies = false, hideBranchingStyle: hideBranchingStyle = false, canAddComments: canAddComments = true, isThreadHovered: isThreadHovered, isParentCommentOpen: isParentCommentOpen, isStandaloneComment: isStandaloneComment, deleteStandaloneComment: deleteStandaloneComment, replyToComment: replyToComment, updateReactionsCacheFn: updateReactionsCacheFn })=>{
    const [editCommentId, setCommentForEdit] = (0, $gwFzn.useState)('');
    const { isReactionsEnabled: isReactionsEnabled } = (0, $gwFzn.useContext)((0, $8SCD6.ReactionsContext));
    const { onReopenCommentCallback: onReopenCommentCallback } = (0, $gwFzn.useContext)((0, $3BI2p.WhiteboardResolvedCommentContext));
    const { setEditorViewProps: setEditorViewProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [, { removeUnresolvedInlineComment: removeUnresolvedInlineComment, addUnresolvedInlineComment: addUnresolvedInlineComment }] = (0, $k8e76.useInlineComments)();
    const [{ commentsDataMap: commentsDataMap, orderedActiveAnnotationIdList: orderedActiveAnnotationIdList }, { addNewCommentThreads: addNewCommentThreads, deleteParentComment: deleteParentComment, handleRemovingComments: handleRemovingComments, updateCommentCount: updateCommentCount, setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList }] = (0, $8i27m.useCommentsData)();
    const [{ annotations: annotations }] = (0, $aUU0C.useEditorAnnotations)();
    const { rendererActions: rendererActions } = (0, $8WQTF.useRendererActions)();
    const [{ updateDocumentFn: updateDocumentFn }] = (0, $1YPul.useUpdateDocument)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [{ currentlySelectedThreadKey: currentlySelectedThreadKey }, { setCurrentView: setCurrentView, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setReplyToCommentId: setReplyToCommentId }] = (0, $3mVfX.useCommentsPanel)();
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { focusedCommentId: focusedCommentId } = (0, $liGyh.useInlineCommentQueryParams)();
    const { scrollCommentsPanelToThread: scrollCommentsPanelToThread } = (0, $6KwrO.useCommentsPanelScroll)();
    const { isCommentsPanelShown: isCommentsPanelShown, showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const [resolveInlineCommentFn] = (0, $diswb.useMutation)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $dhKx6.ResolveInlineCommentMutation));
    const [resolveCommentFn] = (0, $diswb.useMutation)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $5odkT.ResolveCommentMutation));
    const resolveCommentMutationFn = (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? resolveCommentFn : resolveInlineCommentFn;
    const [reopenCommentFn] = (0, $diswb.useMutation)((0, $5olRs.ReopenCommentMutation), {
        refetchQueries: // Copied from the existing dialog flow to support standalone experience
        pageMode === (0, $cD1qu.PageMode).VIEW ? [
            {
                query: (0, $3s9yq.InlineCommentsQuery),
                variables: {
                    pageId: contentId
                }
            }
        ] : []
    });
    const [deleteTopLevelRendererInlineCommentFn] = (0, $diswb.useMutation)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $2Ntx6.DeleteInlineCommentMutationWithStep));
    const [deleteInlineCommentFn] = (0, $diswb.useMutation)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $6Ebso.DeleteInlineCommentMutation));
    const [deleteGeneralCommentFn] = (0, $diswb.useMutation)((0, $h5M1u.DeleteGeneralCommentMutation));
    const eventEmitter = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $gczDe.getRendererAnnotationEventEmitter)() : (0, $gfqXk.getEditorAnnotationEventEmitter)();
    // @ts-ignore FIXME: `contentId` can be `undefined` here, and needs proper handling
    const pageId = contentId;
    const userId = comment?.author?.accountId;
    const topCommentUserAvatar = comment?.author?.profilePicture?.path;
    const topCommentDisplayName = comment?.author?.displayName ?? 'Anonymous';
    const commentId = comment?.id;
    const date = comment?.version?.when;
    const createdAtNonLocalized = comment?.createdAtNonLocalized;
    const versionByDisplayName = comment?.version?.by?.displayName;
    const versionDate = comment?.version?.when;
    const permissions = comment?.permissions;
    const content = comment?.body?.value;
    const permissionType = comment?.author?.permissionType ?? undefined;
    const parentCommentId = comment?.parentId;
    const isReply = !!parentCommentId;
    const isEdited = (comment?.version?.number || 0) > 1;
    const numReplies = comment?.replies?.length || 0;
    const commentUrl = pageMode === (0, $cD1qu.PageMode).EDIT ? comment?.links.editui : comment?.links.webui; // view page and live docs uses the webui field
    const inheritedReactionsData = comment?.reactionsSummary;
    const inlineCommentlocation = comment?.location;
    const footerCommentLocation = comment?.location;
    const commentType = inlineCommentlocation?.type === 'INLINE' ? (0, $8i27m.CommentType).INLINE : (0, $8i27m.CommentType).GENERAL;
    const getResolvedProperties = (0, $gwFzn.useCallback)((type)=>{
        const properties = type === (0, $8i27m.CommentType).INLINE ? inlineCommentlocation?.inlineResolveProperties : footerCommentLocation?.commentResolveProperties;
        if (!isReply) return properties || undefined;
        return undefined;
    }, [
        inlineCommentlocation,
        footerCommentLocation,
        isReply
    ]);
    const resolveProperties = getResolvedProperties(commentType);
    const annotatedText = inlineCommentlocation?.inlineText || undefined;
    const isCommentRemovedByAnotherUser = comment?.wasRemovedByAnotherUser;
    const isResolvedByAnotherUser = isCommentRemovedByAnotherUser && isCommentRemovedByAnotherUser === (0, $8i27m.CommentActionType).RESOLVE_COMMENT_THREAD;
    const isDeletedByAnotherUser = isCommentRemovedByAnotherUser && isCommentRemovedByAnotherUser === (0, $8i27m.CommentActionType).DELETE_COMMENT;
    const handleDeleteInlineComment = ()=>{
        // NOTE: The DELETE experience is started in CommentActions.tsx
        const isTopLevelRendererComment = pageMode === (0, $cD1qu.PageMode).VIEW && !isReply;
        let step;
        if (isTopLevelRendererComment) try {
            const deleteResult = rendererActions?.deleteAnnotation(threadKey, 'inlineComment');
            if (deleteResult) step = deleteResult.step;
            else {
                experienceTracker.stopOnError({
                    name: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE),
                    error: new Error(`Unable to remove annotation ${threadKey} from document`)
                });
                return;
            }
        } catch (e) {
            experienceTracker.stopOnError({
                name: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE),
                error: e
            });
            return;
        }
        if (isStandaloneComment) {
            deleteStandaloneComment && parentCommentId && deleteStandaloneComment(parentCommentId, commentId);
            return;
        }
        const deleteMutation = isTopLevelRendererComment ? deleteTopLevelRendererInlineCommentFn : deleteInlineCommentFn;
        const deleteVariables = {
            variables: isTopLevelRendererComment ? {
                input: {
                    commentId: commentId,
                    step: step ? (0, $aMfLn.constructStepForGql)(step) : {}
                }
            } : {
                commentIdToDelete: commentId,
                // There is no VIEW option
                deleteFrom: pageMode === (0, $cD1qu.PageMode).EDIT ? (0, $8z9UY.CommentDeletionLocation).EDITOR : (0, $8z9UY.CommentDeletionLocation).LIVE
            },
            update: isReply ? (0, $g0DaR.updateApolloCacheCallback)('delete', {
                pageId: pageId,
                contentStatus: [
                    'CURRENT',
                    'DRAFT'
                ]
            }, parentCommentId, commentId) : undefined
        };
        deleteMutation({
            ...deleteVariables
        }).then(({ data: data })=>{
            updateCommentCount({
                threadKey: threadKey,
                actionType: (0, $8i27m.CommentActionType).DELETE_COMMENT,
                commentType: commentType
            });
            if (!data || isTopLevelRendererComment && !data.deleteInlineComment || !isTopLevelRendererComment && !data.deleteComment) throw new Error('No data returned from mutation');
            const cleanUpReply = ()=>{
                handleRemovingComments({
                    threadKey: threadKey,
                    commentId: commentId,
                    action: (0, $8i27m.CommentActionType).DELETE_COMMENT,
                    commentType: commentType
                });
                experienceTracker.succeed({
                    name: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE)
                });
            };
            const deleteAnnotationAndCleanUpParent = (annotationId)=>{
                // For a top level comment in renderer, we need to send out the events to tell the
                // renderer to deselect the annotation and remove it from the document
                if (pageMode === (0, $cD1qu.PageMode).VIEW) {
                    const deleteResult = rendererActions?.deleteAnnotation(annotationId, 'inlineComment');
                    if (deleteResult && deleteResult.doc) {
                        // Inform the Renderer to de-select the annotation
                        eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
                        eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
                        updateDocumentFn && updateDocumentFn(deleteResult.doc);
                    }
                // For editor/live pages we need to send the event to delete the mark
                } else eventEmitter.emit('delete', annotationId);
                resetContentChanged();
                deleteParentComment({
                    threadKey: threadKey,
                    commentType: commentType
                });
                if (commentType === (0, $8i27m.CommentType).INLINE) setOrderedActiveAnnotationIdList(orderedActiveAnnotationIdList.map((status)=>status.threadKey).filter((id)=>id !== threadKey));
                experienceTracker.succeed({
                    name: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE)
                });
            };
            (0, $8dA1U.handleDeleteSuccess)({
                commentId: commentId,
                annotationId: threadKey,
                pageId: pageId,
                pageMode: pageMode,
                isReply: isReply,
                source: (0, $en1dX.AnalyticsSource).COMMENTS_PANEL,
                inlineNodeTypes: undefined,
                createAnalyticsEvent: // We need to figure out how to get this data
                createAnalyticsEvent,
                removeUnresolvedInlineComment: removeUnresolvedInlineComment,
                onSuccess: isReply ? cleanUpReply : deleteAnnotationAndCleanUpParent
            });
        }).catch((err)=>{
            if ((0, $9wGTI.fg)('confluence_frontend_show_already_deleted_flag')) {
                const parsedError = (0, $isdzP.parseError)(err);
                const translatedError = (0, $isdzP.getTranslatedError)(parsedError.message, commentId);
                if ((0, $isdzP.isAlreadyDeletedError)(translatedError)) {
                    flags?.showWarningFlag({
                        id: commentId,
                        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $dbdd2e782e37c476$var$i18n.cannotDeleteTitle),
                        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), translatedError)
                    });
                    createAnalyticsEvent({
                        type: 'sendOperationalEvent',
                        data: {
                            action: 'alreadyDeleted',
                            actionSubject: 'comment',
                            actionSubjectId: commentId,
                            objectType: 'page',
                            objectId: pageId,
                            source: (0, $en1dX.AnalyticsSource).COMMENTS_PANEL,
                            attributes: {
                                commentType: 'inline',
                                mode: pageMode,
                                framework: (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER,
                                isReply: isReply
                            }
                        }
                    }).fire();
                }
            }
            (0, $8dA1U.handleMutationFailure)({
                experienceTracker: experienceTracker,
                experienceName: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE),
                error: err,
                commentId: commentId
            });
        });
    };
    const handleDeleteGeneralComment = ()=>{
        let deleteLocation;
        // There is no deleteLocation for View Page
        if (pageMode !== (0, $cD1qu.PageMode).VIEW) deleteLocation = pageMode === (0, $cD1qu.PageMode).EDIT ? (0, $8z9UY.CommentDeletionLocation).EDITOR : (0, $8z9UY.CommentDeletionLocation).LIVE;
        const deleteVariables = {
            variables: {
                commentIdToDelete: commentId,
                deleteFrom: deleteLocation
            },
            update: isReply ? (0, $87CZC.updateApolloCacheReplyCallback)('delete', {
                pageId: pageId,
                contentStatus: [
                    'DRAFT',
                    'CURRENT'
                ]
            }, parentCommentId, isReactionsEnabled, commentId) : (0, $87CZC.updateApolloCacheParentCallback)('delete', {
                pageId: pageId,
                contentStatus: [
                    'DRAFT',
                    'CURRENT'
                ]
            }, isReactionsEnabled, commentId)
        };
        deleteGeneralCommentFn({
            ...deleteVariables
        }).then(({ data: data })=>{
            if (!data || !data.deleteComment) throw new Error('No data returned from mutation');
            resetContentChanged();
            if (isReply) handleRemovingComments({
                threadKey: threadKey,
                commentId: commentId,
                action: (0, $8i27m.CommentActionType).DELETE_COMMENT,
                commentType: commentType
            });
            else deleteParentComment({
                threadKey: threadKey,
                commentType: commentType
            });
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'deleted',
                    actionSubject: 'comment',
                    actionSubjectId: commentId,
                    objectType: 'page',
                    objectId: pageId,
                    source: (0, $en1dX.AnalyticsSource).COMMENTS_PANEL,
                    attributes: {
                        commentType: 'page',
                        mode: pageMode,
                        isReply: isReply
                    }
                }
            }).fire();
            experienceTracker.succeed({
                name: (0, $irVI7.DELETE_PAGE_COMMENT_EXPERIENCE)
            });
        }).catch((err)=>{
            (0, $8dA1U.handleMutationFailure)({
                experienceTracker: experienceTracker,
                experienceName: (0, $irVI7.DELETE_PAGE_COMMENT_EXPERIENCE),
                error: err
            });
        });
    };
    const handleEditComment = ()=>{
        setCommentForEdit(commentId);
    };
    const exitCommentEditor = ()=>{
        setCommentForEdit('');
    };
    const handleReplyToComment = (id)=>{
        setReplyToCommentId({
            parentCommentId: id,
            location: (0, $i6UMJ.LocationValue).PANEL,
            user: (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment') ? {
                displayName: comment?.author?.displayName,
                accountId: comment?.author?.accountId
            } : undefined
        });
    };
    const handleReopenComment = ()=>{
        // NOTE: The reopen experience is started in CommentActions.tsx
        reopenCommentFn({
            variables: {
                commentId: commentId,
                cloudId: cloudId
            }
        }).then(()=>{
            // Update the list of active annotationIds
            addUnresolvedInlineComment(threadKey, pageMode);
            updateCommentCount({
                threadKey: threadKey,
                actionType: (0, $8i27m.CommentActionType).REOPEN_COMMENT_THREAD,
                commentType: commentType
            });
            // Emit the event to editor/renderer to reactivate the annotationId
            if (commentType === (0, $8i27m.CommentType).INLINE) {
                if (pageMode === (0, $cD1qu.PageMode).VIEW) {
                    const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                    emitter.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_STATE, {
                        [threadKey]: {
                            id: threadKey,
                            annotationType: (0, $cdbMf.AnnotationTypes).INLINE_COMMENT,
                            state: (0, $cdbMf.AnnotationMarkStates).ACTIVE
                        }
                    });
                } else {
                    const emitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
                    emitter.emit('unresolve', threadKey);
                }
            }
            // Update the state for panel experience
            const commentsDataMapClone = {
                ...commentsDataMap
            };
            const commentInMap = commentsDataMapClone[commentType][threadKey];
            if (commentInMap) {
                commentInMap.isOpen = true;
                commentInMap.wasRemovedByAnotherUser = false;
                const commentLocation = commentInMap.location;
                if (commentLocation && 'commentResolveProperties' in commentLocation && commentLocation.commentResolveProperties) commentLocation.commentResolveProperties.resolved = false;
                if (commentLocation && 'inlineResolveProperties' in commentLocation && commentLocation.inlineResolveProperties && (0, $9wGTI.fg)('confluence_frontend_dangling_comments')) // make sure this is false too just in case
                commentLocation.inlineResolveProperties.resolved = false;
                addNewCommentThreads(commentsDataMapClone);
            }
            // Show the reopen flag
            flags?.showSuccessCircleFlag({
                id: commentId,
                title: formatMessage($dbdd2e782e37c476$var$i18n.commentReopenedFlagTitle),
                isAutoDismiss: true,
                actions: [
                    {
                        content: formatMessage((0, $9CnRS.i18n).goToCommentCTA),
                        onClick: ()=>{
                            if (!isCommentsPanelShown) showCommentsPanel({
                                openWithView: (0, $3mVfX.ViewValues).OPEN
                            });
                            else setCurrentView((0, $3mVfX.ViewValues).OPEN);
                            if (commentType === (0, $8i27m.CommentType).INLINE) {
                                setCurrentlySelectedThreadKey(threadKey);
                                scrollCommentsPanelToThread({
                                    annotationId: threadKey
                                });
                            }
                            flags.hideFlag(flags.state.flags[0]?.id);
                        }
                    },
                    {
                        content: formatMessage((0, $9CnRS.i18n).undoCTA),
                        onClick: ()=>{
                            handleResolveComment();
                            flags.hideFlag(flags.state.flags[0]?.id);
                        }
                    }
                ]
            });
            if (commentType === (0, $8i27m.CommentType).INLINE) {
                if ((0, $9wGTI.fg)('cc-whiteboards-consolidating-comments')) // add unresolved comment to whiteboard and database
                {
                    if (contentType === 'whiteboard' || contentType === 'database') {
                        const commentLocation = commentInMap.location;
                        onReopenCommentCallback?.({
                            contentId: pageId,
                            referenceId: commentLocation.inlineMarkerRef
                        });
                    }
                }
                const orderedActiveAnnotationIds = orderedActiveAnnotationIdList.map((annotation)=>annotation.threadKey);
                // only insert reopened comment annotation if the comment highlight exists
                if (!resolveProperties?.isDangling) {
                    let annotationsList = annotations;
                    if (pageMode === (0, $cD1qu.PageMode).VIEW) {
                        const annotationMarks = rendererActions?.getAnnotationMarks();
                        annotationsList = annotationMarks?.map((mark)=>mark.attrs.id) ?? [];
                    }
                    if (annotationsList.length > 0) (0, $g0DaR.insertReopenedCommentAnnotation)(annotationsList, threadKey, orderedActiveAnnotationIds, setOrderedActiveAnnotationIdList);
                }
            }
        }).catch(()=>{
            flags?.showErrorFlag({
                id: commentId,
                title: formatMessage($dbdd2e782e37c476$var$i18n.commentReopenFailedFlagTitle),
                isAutoDismiss: true,
                actions: [
                    {
                        content: formatMessage($dbdd2e782e37c476$var$i18n.retryCTA),
                        onClick: ()=>{
                            flags.hideFlag(flags.state.flags[0]?.id);
                            handleReopenComment();
                        }
                    }
                ]
            });
        });
    };
    const handleResolveComment = ()=>{
        const mutationVariables = (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? {
            commentIds: [
                commentId
            ],
            cloudId: cloudId
        } : {
            commentId: commentId,
            resolved: true
        };
        const query = (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? (0, $eg9xl.ActiveCommentsQuery) : (0, $jkPJy.CommentsPanelQuery);
        // NOTE: The RESOLVED experience is started in CommentActions.tsx
        resolveCommentMutationFn({
            variables: mutationVariables,
            update: (cache, { data: data })=>{
                // readQuery can still return null which complicates TS lint errors with optional chaining
                // once we move to v3 of the apollo client we can move to cache.modify
                try {
                    const dataProxy = cache.readQuery({
                        query: query,
                        variables: {
                            pageId: pageId,
                            contentStatus: [
                                'CURRENT',
                                'DRAFT'
                            ]
                        }
                    });
                    const commentsToWrite = Object.assign({}, dataProxy?.comments);
                    let totalCount = commentsToWrite.totalCount || 0;
                    const commentsList = commentsToWrite.nodes?.filter((n)=>n !== null);
                    const idxToRemove = commentsList.findIndex((c)=>c.id === commentId);
                    // Remove the newly resolved comment from the list if we can find it
                    if (idxToRemove !== -1) {
                        commentsList.splice(idxToRemove, 1);
                        totalCount--;
                    }
                    cache.writeQuery({
                        query: query,
                        variables: {
                            pageId: pageId,
                            contentStatus: [
                                'CURRENT',
                                'DRAFT'
                            ]
                        },
                        data: {
                            comments: {
                                nodes: commentsList,
                                totalCount: totalCount
                            }
                        }
                    });
                } catch (err) {
                    $dbdd2e782e37c476$var$logger.error`An error occurred when updating cache for comments panel resolve - ${err}`;
                }
                if (!isReply && comment.type === (0, $8i27m.CommentType).GENERAL && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2')) try {
                    const { confluence_resolveComments: { commentResolutionStates: commentResolutionStates, success: success } } = data;
                    const commentsSectionQuery = isReactionsEnabled ? (0, $ftXPY.CommentsSectionQuery) : (0, $ftXPY.CommentsSectionWithoutReactionsQuery);
                    if (!success || commentResolutionStates.length === 0) return;
                    const { commentId: commentId } = commentResolutionStates[0];
                    const prevData = cache.readQuery({
                        query: commentsSectionQuery,
                        variables: {
                            contentId: contentId,
                            offset: '',
                            first: (0, $2i3To.DEFAULT_LIMIT)
                        }
                    });
                    const edges = prevData?.comments?.edges;
                    // Filter out all comments related to the parent and it's children as they will all be resolved
                    const newEdges = edges?.filter((edge)=>edge?.node?.id !== commentId && !edge?.node?.ancestors.map((a)=>a?.id).includes(commentId)) || [];
                    const newData = {
                        comments: {
                            ...prevData?.comments,
                            totalCount: newEdges.length,
                            pageInfo: {
                                ...prevData?.comments?.pageInfo,
                                endCursor: '',
                                hasNextPage: false //set hasNextPage to always false to avoid performing incremental fetching again which will result in duplicate data
                            },
                            edges: newEdges
                        },
                        content: {
                            ...prevData?.content,
                            nodes: [
                                ...prevData?.content?.nodes || []
                            ]
                        },
                        user: {
                            ...prevData?.user
                        }
                    };
                    cache.writeQuery({
                        query: commentsSectionQuery,
                        variables: {
                            contentId: contentId,
                            offset: '',
                            first: (0, $2i3To.DEFAULT_LIMIT)
                        },
                        data: {
                            ...newData
                        }
                    });
                } catch (err) {
                    $dbdd2e782e37c476$var$logger.error`An error occurred when updating cache for general comments resolve - ${err}`;
                }
            }
        }).then(()=>{
            updateCommentCount({
                threadKey: threadKey,
                actionType: (0, $8i27m.CommentActionType).RESOLVE_COMMENT_THREAD,
                commentType: commentType
            });
            // Update the state for panel experience
            const commentsDataMapClone = {
                ...commentsDataMap
            };
            const commentInMap = commentsDataMapClone[commentType][threadKey];
            if (commentInMap) {
                commentsDataMapClone[commentType][threadKey].isOpen = false;
                const commentLocation = commentsDataMapClone[commentType][threadKey].location;
                if (commentLocation && commentLocation.inlineResolveProperties) commentLocation.inlineResolveProperties.resolved = true;
                addNewCommentThreads(commentsDataMapClone);
            }
            (0, $8dA1U.handleResolveSuccess)({
                commentId: commentId,
                parentCommentMarkerRef: threadKey,
                pageId: pageId,
                pageMode: pageMode,
                commentType: commentType,
                eventEmitter: eventEmitter,
                source: (0, $en1dX.AnalyticsSource).COMMENTS_PANEL,
                removeUnresolvedInlineComment: removeUnresolvedInlineComment,
                createAnalyticsEvent: createAnalyticsEvent,
                setEditorViewProps: setEditorViewProps
            });
            setOrderedActiveAnnotationIdList(orderedActiveAnnotationIdList.map((status)=>status.threadKey).filter((id)=>id !== threadKey));
            // Show the resolved flag
            if ((0, $9wGTI.fg)('confluence_frontend_comments_panel_v2')) flags?.showSuccessCircleFlag({
                id: commentId,
                title: formatMessage((0, $9CnRS.i18n).resolvedFlagText),
                isAutoDismiss: true,
                actions: [
                    {
                        content: formatMessage((0, $9CnRS.i18n).goToCommentCTA),
                        onClick: ()=>{
                            if (!isCommentsPanelShown) showCommentsPanel({
                                openWithView: (0, $3mVfX.ViewValues).RESOLVED
                            });
                            else setCurrentView((0, $3mVfX.ViewValues).RESOLVED);
                            scrollCommentsPanelToThread({
                                annotationId: threadKey
                            });
                            flags.hideFlag(flags.state.flags[0]?.id);
                        }
                    },
                    {
                        content: formatMessage((0, $9CnRS.i18n).undoCTA),
                        onClick: ()=>{
                            if (!isCommentsPanelShown) showCommentsPanel({
                                openWithView: (0, $3mVfX.ViewValues).OPEN
                            });
                            handleReopenComment();
                            flags.hideFlag(flags.state.flags[0]?.id);
                        }
                    }
                ]
            });
            experienceTracker.succeed({
                name: (0, $irVI7.RESOLVE_INLINE_COMMENT_EXPERIENCE)
            });
        }).catch((err)=>{
            (0, $8dA1U.handleMutationFailure)({
                experienceTracker: experienceTracker,
                experienceName: (0, $irVI7.RESOLVE_INLINE_COMMENT_EXPERIENCE),
                error: err
            });
        });
    };
    const handleStandaloneReply = (id)=>{
        replyToComment && replyToComment(id, comment);
    };
    const pageType = pageInfo?.type ?? '';
    // Editor setup
    const spaceId = pageInfo?.space?.id ?? '';
    // User page permissions
    const operations = pageInfo?.operations || [];
    // The user can upload media only if they have update permissions for the page
    const hasMediaUploadPermissions = operations.some((op)=>op?.operation === 'update' && op?.targetType === pageType);
    // We only want to focus resolved comments because the 'active' comments have
    // their own treatment for when one is hovered/selected and could cause weird behavior
    const isCommentFocused = resolveProperties?.resolved && commentId === focusedCommentId;
    const supportedActions = !isReply && isCommentRemovedByAnotherUser ? [
        'reopen'
    ] : supportedTopLevelActions;
    return commentId === editCommentId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $auGhu.EditComment), {
        pageId: pageId,
        pageType: pageType,
        annotationId: threadKey,
        commentId: commentId,
        spaceId: spaceId,
        content: content ?? '',
        isReply: isReply,
        displayCommentInViewMode: exitCommentEditor,
        avatarUrl: topCommentUserAvatar ?? '',
        displayName: topCommentDisplayName,
        mode: pageMode === (0, $cD1qu.PageMode).VIEW ? 'view' : 'edit',
        hasMediaUploadPermissions: hasMediaUploadPermissions,
        isCommentsPanel: isCommentsPanelShown,
        commentType: commentType,
        isStandaloneComment: isStandaloneComment
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kEmgx.CommentBody), {
        mode: "view",
        userId: userId,
        avatarUrl: topCommentUserAvatar,
        displayName: topCommentDisplayName,
        date: date ?? '',
        dateUrl: commentUrl ?? '',
        createdAtNonLocalized: createdAtNonLocalized ?? '',
        versionByDisplayName: versionByDisplayName,
        versionDate: versionDate ?? '',
        pageId: pageId,
        pageType: pageType,
        commentId: commentId ?? '',
        isReply: isReply,
        isEdited: isEdited,
        parentCommentId: parentCommentId,
        permissions: permissions,
        content: content ?? '',
        permissionType: permissionType ?? undefined,
        supportedActions: supportedActions,
        deleteComment: commentType === (0, $8i27m.CommentType).INLINE ? handleDeleteInlineComment : handleDeleteGeneralComment,
        editComment: handleEditComment,
        resolveComment: handleResolveComment,
        numReplies: numReplies,
        isUnread: isUnread,
        isCommentActive: true,
        isCommentsPanel: true,
        isHovered: isHovered,
        isResolvedByAnotherUser: isResolvedByAnotherUser,
        isFocused: isCommentFocused,
        resolveProperties: resolveProperties,
        annotationId: threadKey,
        annotatedText: annotatedText,
        reopenComment: handleReopenComment,
        replyToComment: isStandaloneComment ? handleStandaloneReply : handleReplyToComment,
        inheritedReactionsData: inheritedReactionsData,
        isDeletedByAnotherUser: isDeletedByAnotherUser,
        currentlySelectedThreadKey: currentlySelectedThreadKey,
        setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey,
        isAnnotatedTextPressed: isAnnotatedTextPressed,
        setAnnotatedTextPressed: setAnnotatedTextPressed,
        commentType: commentType,
        adjustForNestedReplies: adjustForNestedReplies,
        hideBranchingStyle: hideBranchingStyle,
        canAddComments: canAddComments,
        isThreadHovered: isThreadHovered,
        isParentCommentOpen: isParentCommentOpen,
        reactionsCacheUpdateFn: updateReactionsCacheFn,
        isStandaloneComment: isStandaloneComment
    });
};

});
parcelRegister("aMfLn", function(module, exports) {

$parcel$export(module.exports, "updateRendererAnnotations", () => $194c389c7ab5ab2c$export$bbbd7ccaedea9691);
$parcel$export(module.exports, "constructStepForGql", () => $194c389c7ab5ab2c$export$2600439b3e609c06);

var $4FvAQ = parcelRequire("4FvAQ");

var $kDIns = parcelRequire("kDIns");
const $194c389c7ab5ab2c$export$bbbd7ccaedea9691 = async ({ rendererActions: rendererActions, contentId: contentId, triggerAnalyticsEvent: triggerAnalyticsEvent, updateUnresolvedInlineComment: updateUnresolvedInlineComment })=>{
    const allAnnotationMarks = rendererActions?.getAnnotationMarks();
    const allAnnotationIds = allAnnotationMarks?.map((mark)=>mark.attrs.id) || [];
    (0, $kDIns.getRendererAnnotationStates)({
        annotations: allAnnotationIds,
        pageId: contentId,
        triggerAnalyticsEvent: triggerAnalyticsEvent,
        validAnnotationsCallback: updateUnresolvedInlineComment,
        isNestedRender: false
    }).catch(()=>{
    //intentional no-op
    });
};
const $194c389c7ab5ab2c$export$2600439b3e609c06 = (step, pos)=>{
    // AddMarkStep has additional properties that aren't allowed in the mutation variables
    const markInfo = {
        mark: {
            attrs: {
                annotationType: 'inlineComment',
                id: step.mark.attrs.id
            },
            type: 'annotation'
        }
    };
    // TODO: remove this logic since pos should be read from step
    if (pos !== undefined) return {
        pos: pos,
        ...markInfo
    };
    if (step instanceof (0, $4FvAQ.AddMarkStep) || step instanceof (0, $4FvAQ.RemoveMarkStep)) {
        const { from: from, to: to } = step;
        return {
            from: from,
            to: to,
            ...markInfo
        };
    }
    return {
        pos: step.pos,
        ...markInfo
    };
};

});
parcelRegister("kDIns", function(module, exports) {

$parcel$export(module.exports, "getEditorResolvedState", () => $655a1f23a26f4e27$export$38c1ce6adefc79a5);
$parcel$export(module.exports, "getRendererAnnotationStates", () => $655a1f23a26f4e27$export$a0fcca613dd8b2c7);

var $csnse = parcelRequire("csnse");

var $atveb = parcelRequire("atveb");

var $cdbMf = parcelRequire("cdbMf");

var $hp2SH = parcelRequire("hp2SH");
var $7Sm4c = parcelRequire("7Sm4c");

var $dIouf = parcelRequire("dIouf");

var $9wGTI = parcelRequire("9wGTI");

var $7W8i8 = parcelRequire("7W8i8");

var $vNBpg = parcelRequire("vNBpg");
const $655a1f23a26f4e27$var$logger = (0, $7W8i8.getLogger)('inline-comments-common:state-resolver');
const $655a1f23a26f4e27$export$8f0e4480674935ab = (0, $csnse.default)((annotations, validAnnotationsCallback, states)=>{
    const rendererAnnotationMap = {};
    const annotationState = [];
    annotations.forEach((id, idx)=>{
        // this will override any repeat ids given by the Renderer
        rendererAnnotationMap[id] = idx;
        annotationState.push({
            annotationType: (0, $cdbMf.AnnotationTypes).INLINE_COMMENT,
            id: id,
            state: (0, $cdbMf.AnnotationMarkStates).RESOLVED
        });
    });
    states?.forEach((state)=>{
        const isResolved = Boolean(state.location?.inlineResolveProperties?.resolved);
        // mark all unresolved annotations to be displayed by the renderer
        if (!isResolved) {
            const annotationId = state.location.inlineMarkerRef;
            if (annotationId) {
                const index = rendererAnnotationMap[annotationId];
                /**
					 * If the BE returns an annotation that the Renderer did not
					 * provide, we could error here. Also account for 0 index.
					 */ if (index || index === 0) annotationState[index].state = (0, $cdbMf.AnnotationMarkStates).ACTIVE;
            }
        }
    });
    const validAnnotations = annotations.filter((annotation)=>{
        const index = rendererAnnotationMap[annotation];
        return annotationState[index].state === (0, $cdbMf.AnnotationMarkStates).ACTIVE;
    });
    // Record the valid annotations to use for navigation and query params
    validAnnotationsCallback(validAnnotations);
    return annotationState;
}, (0, (/*@__PURE__*/$parcel$interopDefault($atveb))));
const $655a1f23a26f4e27$export$228a0d958905d789 = (0, $csnse.default)((annotations, states, updateUnresolvedInlineComment)=>{
    /**
		 * Build a map of annotation states with a default of true for resolved.
		 * This is to accommodate deleted annotations that still exist in the ADF.
		 */ const editorAnnotationMap = {};
    const annotationState = [];
    annotations.forEach((id, idx)=>{
        // this will override any repeat ids given by the Editor
        editorAnnotationMap[id] = idx;
        annotationState.push({
            annotationType: (0, $cdbMf.AnnotationTypes).INLINE_COMMENT,
            id: id,
            state: {
                resolved: true
            }
        });
    });
    states.forEach((state)=>{
        const isResolved = Boolean(state?.location?.inlineResolveProperties?.resolved);
        // mark all unresolved annotations to be displayed by the editor
        if (!isResolved) {
            const annotationId = state?.location?.inlineMarkerRef || '';
            const index = editorAnnotationMap[annotationId];
            /**
				 * If the BE returns an annotation that the Editor did not
				 * provide, we could error here. Also account for 0 index.
				 */ if (index || index === 0) annotationState[index].state.resolved = false;
        }
    });
    //Ordered list of unresolved inline comments
    const unresolvedInlineComments = annotations.filter((annotationId)=>{
        const index = editorAnnotationMap[annotationId];
        if (!annotationState[index].state.resolved) return annotationId;
    });
    updateUnresolvedInlineComment(unresolvedInlineComments);
    return annotationState;
}, (0, (/*@__PURE__*/$parcel$interopDefault($atveb))));
const $655a1f23a26f4e27$export$38c1ce6adefc79a5 = async ({ annotations: annotations, pageId: pageId, triggerAnalyticsEvent: triggerAnalyticsEvent, updateUnresolvedInlineComment: updateUnresolvedInlineComment })=>{
    if (!annotations.length) {
        if ((0, $9wGTI.fg)('use_comments_data_annotation_updater')) updateUnresolvedInlineComment([]);
        return Promise.resolve([]);
    }
    return (0, $hp2SH.getApolloClient)().query({
        query: (0, $vNBpg.AnnotationStateQuery),
        fetchPolicy: 'network-only',
        variables: {
            pageId: pageId,
            contentStatus: [
                'DRAFT',
                'CURRENT'
            ]
        }
    }).then((data)=>{
        return $655a1f23a26f4e27$export$228a0d958905d789(annotations, data.data.comments.nodes, updateUnresolvedInlineComment);
    }).catch((error)=>{
        // COMMENTS-211 - When this code executes sometimes the `triggerAnalyticsEvent` is passed in as a promise
        //                this causes this call to throw an error where `.fire()` is not defined and thus the
        //                code below it which handles the various expected errors thrown to not run and thus
        //                the errors are thrown up the stack as unhandled ui errors causing a lot of noise
        try {
            if (triggerAnalyticsEvent) triggerAnalyticsEvent({
                data: {
                    source: 'editorComponent',
                    action: 'failed',
                    actionSubject: 'annotationState',
                    actionSubjectId: 'inlineComments',
                    attributes: {
                        errorName: error.name,
                        errorMessage: error.message
                    }
                },
                type: 'sendOperationalEvent'
            }).fire();
        } catch (e) {
            $655a1f23a26f4e27$var$logger.error`Error when logging analytics event, ${e}`;
        }
        if ((0, $dIouf.isUnauthorizedError)(error) || // CEMS-1343 - Some specific pages have annotations that have a "null" id because we
        //             still informed the editor on failed creation attempts
        error?.message.includes('java.lang.NullPointerException') || // COMMENTS-211 - If we don't find any inline comments for the given markerRefList
        //               we should mark it handled and return an empty list to be consumed
        error?.message.includes('confluence.api.service.exceptions.NotFoundException')) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return [];
        } else {
            $655a1f23a26f4e27$var$logger.error`Error when retrieving resolved status for marks, ${error}`;
            throw error;
        }
    });
};
let $655a1f23a26f4e27$var$rendererAnnotationsIds;
const $655a1f23a26f4e27$export$a0fcca613dd8b2c7 = async ({ annotations: annotations, pageId: pageId, triggerAnalyticsEvent: triggerAnalyticsEvent, validAnnotationsCallback: validAnnotationsCallback, isNestedRender: isNestedRender })=>{
    // We need to have the page level renderer annotations
    // When the page renders the value of isNestedRender is false as per PageContentRendererFabrics
    // Later, when the macro renders isNestedRender is true
    // so, we will hold the value of annotations for the page renderer when isNestedRender is false
    if (!annotations.length) {
        if ((0, $9wGTI.fg)('use_comments_data_annotation_updater')) validAnnotationsCallback([]);
        return Promise.resolve([]);
    }
    if (!isNestedRender) $655a1f23a26f4e27$var$rendererAnnotationsIds = annotations;
    return (0, $hp2SH.getApolloClient)().query({
        query: (0, $vNBpg.AnnotationStateQuery),
        fetchPolicy: isNestedRender ? 'cache-first' : 'network-only',
        variables: {
            pageId: pageId
        }
    }).then((data)=>{
        // Filter null elements
        const annotationStateNodes = data.data.comments?.nodes?.filter((node)=>node !== null);
        return $655a1f23a26f4e27$export$8f0e4480674935ab($655a1f23a26f4e27$var$rendererAnnotationsIds, validAnnotationsCallback, annotationStateNodes);
    }).catch((error)=>{
        // COMMENTS-1131 - When this code executes sometimes the `triggerAnalyticsEvent` is passed in as a promise
        //                this causes this call to throw an error where `.fire()` is not defined and thus the
        //                code below it which handles the various expected errors thrown to not run and thus
        //                the errors are thrown up the stack as unhandled ui errors causing a lot of noise
        try {
            if (triggerAnalyticsEvent) triggerAnalyticsEvent({
                source: 'rendererComponent',
                action: 'failed',
                actionSubject: 'annotationState',
                actionSubjectId: 'inlineComments',
                attributes: {
                    errorName: error.name,
                    errorMessage: error.message
                }
            }).fire();
        } catch (e) {
            $655a1f23a26f4e27$var$logger.error`Error when logging analytics event, ${e}`;
        }
        if ((0, $dIouf.isUnauthorizedError)(error) || // CEMS-1343 - Some specific pages have annotations that have a "null" id because we
        //             still informed the editor on failed creation attempts
        error?.message.includes('java.lang.NullPointerException') || // COMMENTS-211 - If we don't find any inline comments for the given markerRefList
        //               we should mark it handled and return an empty list to be consumed
        error?.message.includes('confluence.api.service.exceptions.NotFoundException')) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return [];
        } else {
            $655a1f23a26f4e27$var$logger.error`Error when retrieving resolved status for marks, ${error}`;
            throw error;
        }
    });
};

});
parcelRegister("vNBpg", function(module, exports) {

$parcel$export(module.exports, "AnnotationStateQuery", () => $951c06b69b244c75$export$dedc8dce0be2f721);

var $d2LG0 = parcelRequire("d2LG0");
const $951c06b69b244c75$export$dedc8dce0be2f721 = (0, $d2LG0.default)`query AnnotationStateQuery($pageId:ID!$contentStatus:[GraphQLContentStatus]){comments(pageId:$pageId contentStatus:$contentStatus type:UNRESOLVED depth:ROOT){nodes{id location{type ...on InlineComment{inlineMarkerRef inlineResolveProperties{resolved}}}}}}`;

});



parcelRegister("1YPul", function(module, exports) {

$parcel$export(module.exports, "useUpdateDocument", () => $77145f754114b981$export$5e7505d6571fe99d);

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");
const $77145f754114b981$export$d4c72bab9d6cc13a = {
    updateDocumentFn: ()=>{}
};
const $77145f754114b981$export$e324594224ef24da = {
    setUpdateDocumentFn: (newUpdateDocumentFn)=>({ setState: setState })=>{
            setState({
                updateDocumentFn: newUpdateDocumentFn
            });
        }
};
const $77145f754114b981$export$bca0c556b0ff9d9c = (0, $4ZoIm.createStore)({
    initialState: $77145f754114b981$export$d4c72bab9d6cc13a,
    actions: $77145f754114b981$export$e324594224ef24da,
    name: 'UpdateDocumentStore'
});
const $77145f754114b981$export$5e7505d6571fe99d = (0, $iFWZA.createHook)($77145f754114b981$export$bca0c556b0ff9d9c);

});

parcelRegister("kEmgx", function(module, exports) {

$parcel$export(module.exports, "CommentBody", () => $c5a7cd205687b023$export$286a50103f692ed6);
/* CommentBody.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
var $iAWao = parcelRequire("iAWao");

var $csnse = parcelRequire("csnse");

var $dBxQj = parcelRequire("dBxQj");

var $21K7m = parcelRequire("21K7m");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $dcJ7R = parcelRequire("dcJ7R");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $gKvd9 = parcelRequire("gKvd9");

var $gfqXk = parcelRequire("gfqXk");
var $gczDe = parcelRequire("gczDe");

var $1kHsc = parcelRequire("1kHsc");
var $irVI7 = parcelRequire("irVI7");

var $c6FO3 = parcelRequire("c6FO3");

var $i49vP = parcelRequire("i49vP");
var $aHcFH = parcelRequire("aHcFH");

var $9wGTI = parcelRequire("9wGTI");

var $aSsfA = parcelRequire("aSsfA");

var $cD1qu = parcelRequire("cD1qu");

var $8i27m = parcelRequire("8i27m");

var $9CnRS = parcelRequire("9CnRS");

var $k7gEe = parcelRequire("k7gEe");

var $daq5m = parcelRequire("daq5m");

var $jSpUM = parcelRequire("jSpUM");

var $1Sjzs = parcelRequire("1Sjzs");

var $4OVjm = parcelRequire("4OVjm");
const $c5a7cd205687b023$var$fadeOut = null;
const $c5a7cd205687b023$var$unreadIconStyle = null;
const $c5a7cd205687b023$var$unreadStyleInCommentsPanel = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c5a7cd205687b023$var$CommentContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCommentsPanel: isCommentsPanel, isRemoving: isRemoving, isFocused: isFocused, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1qgnt7p": (0, $iAWao.default)((()=>{
                return __cmplp.mode === 'view-all' ? "var(--ds-space-400, 32px)" : __cmplp.isCommentsPanel === true ? 'inherit' : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment') ? `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-200, 16px)"} ${"var(--ds-space-0, 0px)"} ${"var(--ds-space-200, 16px)"}` : `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-200, 16px)"}`;
            })())
        },
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1yt41wsw _12ji1r31 _1qu2glyw _12y31o36 _1kl7idpf _x3doidpf _1e0c1txw _2lx21bp4 _5sag1bs3 _1o51q7pw _tip812c5 _1pglp3kn _1ragidpf _ha8h131l",
            Boolean(__cmplp.isRemoving) ? "_80om13gf" : "_80om1kw7",
            Boolean(__cmplp.isFocused && !__cmplp.isCommentsPanel) && "_11q7fg4m",
            Boolean(__cmplp.isRemoving) && "",
            Boolean(__cmplp.isRemoving) && "_y44vy8h8",
            __cmplp.className
        ])
    });
});
const $c5a7cd205687b023$var$withLeftBorderStyle = null;
const $c5a7cd205687b023$var$commentBodyStyles = null;
const $c5a7cd205687b023$var$commentReplyStyles = null;
const $c5a7cd205687b023$var$commentBodyFooterReplyStyles = null;
const $c5a7cd205687b023$var$commentBodyStandaloneReplyStyles = null;
const $c5a7cd205687b023$var$warningMessageStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    fontStyle: 'italic',
    padding: 'space.150'
});
const $c5a7cd205687b023$var$xcssTranslucentStyle = (0, $ecnYn.xcss)({
    opacity: '50%'
});
const $c5a7cd205687b023$var$cssTranslucentStyle = null;
const $c5a7cd205687b023$var$annotatedTextBodyStyle = (0, $ecnYn.xcss)({
    borderWidth: '1.5px',
    borderStyle: 'solid',
    borderColor: 'color.border',
    borderRadius: 'border.radius.100',
    padding: 'space.200',
    width: '100%',
    backgroundColor: 'elevation.surface',
    marginBottom: 'space.150'
});
const $c5a7cd205687b023$var$annotatedTextBodyHoverStyle = (0, $ecnYn.xcss)({
    cursor: 'pointer'
});
const $c5a7cd205687b023$var$annotatedTextBodyWithPressedStyle = (0, $ecnYn.xcss)({
    background: "var(--ds-surface-pressed, #DCDFE4)"
}); // This snippet is being used in RepliesOpener.tsx
const $c5a7cd205687b023$var$dotStyles = (0, $ecnYn.xcss)({
    height: "var(--ds-space-100, 8px)",
    width: "var(--ds-space-100, 8px)",
    backgroundColor: 'color.background.brand.bold',
    borderRadius: '50%',
    margin: 'space.050'
});
const $c5a7cd205687b023$var$replyBranchStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c5a7cd205687b023$var$RelativeContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_kqswh2mm _4t3it94y",
            __cmplp.className
        ])
    });
});
const $c5a7cd205687b023$var$highlightSvgBoxStyles = (0, $ecnYn.xcss)({
    height: '22px',
    width: '2px'
});
const $c5a7cd205687b023$var$footerCommentAuthorStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.100'
});
const $c5a7cd205687b023$var$parseContent = (0, $csnse.default)((content, experienceTracker)=>{
    if (!content?.length) return null;
    try {
        return JSON.parse(content);
    } catch (error) {
        experienceTracker.stopOnError({
            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
            error: error
        });
        return null;
    }
});
const $c5a7cd205687b023$export$286a50103f692ed6 = ({ pageId: pageId, pageType: pageType, avatarUrl: avatarUrl, commentId: commentId, content: content, date: date, createdAtNonLocalized: createdAtNonLocalized, versionByDisplayName: versionByDisplayName, versionDate: versionDate, displayName: displayName, permissions: permissions, dateUrl: dateUrl, userId: userId, deleteComment: deleteComment, editComment: editComment, resolveComment: resolveComment, isReply: isReply, isEdited: isEdited, parentCommentId: parentCommentId, isFocused: isFocused, shouldScrollIntoView: shouldScrollIntoView, isRemoving: isRemoving, numReplies: numReplies, isFabricPage: isFabricPage, isCommentActive: isCommentActive, isCurrentUserAnonymous: isCurrentUserAnonymous, mode: mode, onRendered: onRendered, onClose: onClose, shouldAutofocus: shouldAutofocus, onAutoFocused: onAutoFocused, permissionType: permissionType, maxHeight: maxHeight, fadeOutHeight: fadeOutHeight, onComplete: onComplete, supportedActions: supportedActions = [
    'edit',
    'delete',
    'resolve'
], isUnread: isUnread = false, unreadCommentRef: unreadCommentRef, isCommentsPanel: isCommentsPanel = false, isHovered: isHovered, isResolvedByAnotherUser: isResolvedByAnotherUser = false, resolveProperties: resolveProperties, annotationId: annotationId, annotatedText: annotatedText, reopenComment: reopenComment, replyToComment: replyToComment, inheritedReactionsData: inheritedReactionsData, reactionsCacheUpdateFn: reactionsCacheUpdateFn, isDeletedByAnotherUser: isDeletedByAnotherUser, currentlySelectedThreadKey: currentlySelectedThreadKey, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, isAnnotatedTextPressed: isAnnotatedTextPressed, setAnnotatedTextPressed: setAnnotatedTextPressed, commentType: commentType = (0, $8i27m.CommentType).INLINE, adjustForNestedReplies: adjustForNestedReplies = false, hideBranchingStyle: hideBranchingStyle = false, canAddComments: canAddComments = true, isThreadHovered: isThreadHovered, isParentCommentOpen: isParentCommentOpen, isStandalonehovered: isStandalonehovered, isFooterComment: isFooterComment = false, adjustForFooterNestedReplies: adjustForFooterNestedReplies = false, isStandaloneComment: isStandaloneComment = false })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [showingCopyLinkButton, setShowingCopyLink] = (0, $gwFzn.useState)(false);
    const [hasFallbackContent, setHasFallbackContent] = (0, $gwFzn.useState)(false);
    const [overflowPortal, setOverflowPortal] = (0, $gwFzn.useState)(undefined);
    const [isAnnotatedTextHovered, setIsAnnotatedTextHovered] = (0, $gwFzn.useState)(false);
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const eventEmitter = pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE ? (0, $gfqXk.getEditorAnnotationEventEmitter)() : (0, $gczDe.getRendererAnnotationEventEmitter)();
    const isSelected = currentlySelectedThreadKey === annotationId && !isStandalonehovered;
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [containerRef, replyBranchHeight] = (0, $4OVjm.useResizeObserver)();
    (0, $gwFzn.useEffect)(()=>{
        /* We only need to scroll for focused replies as parent comments will have scrolled when selected */ if (shouldScrollIntoView && isFocused && containerRef && containerRef.current) (0, $aHcFH.scrollCommentIntoView)({
            commentElement: containerRef.current,
            isFabricPage: isFabricPage
        });
    }, [
        containerRef,
        isFocused,
        shouldScrollIntoView,
        isFabricPage
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (shouldAutofocus) {
            containerRef.current && containerRef.current.focus();
            onAutoFocused && onAutoFocused();
        }
    }, [
        containerRef,
        shouldAutofocus,
        onAutoFocused
    ]);
    const adf = $c5a7cd205687b023$var$parseContent(content, experienceTracker);
    const wrapperLabel = formatMessage((0, $9CnRS.i18n).a11yCommentLabel, {
        username: displayName
    });
    const onCommentContentFallback = (0, $gwFzn.useCallback)(()=>setHasFallbackContent(true), []);
    const handleRef = (portalDiv)=>{
        /* do a check to prevent from re-running setPopupPortal multiple times*/ if (!overflowPortal && portalDiv) setOverflowPortal(portalDiv);
    };
    const handleMouseEventOnWrapper = (eventType)=>()=>{
            setShowingCopyLink(eventType === 'enter');
        };
    const commentRemovedByAnotherUser = isDeletedByAnotherUser || isResolvedByAnotherUser;
    const shouldShowOverflowMenu = supportedActions.length > 0;
    const showRepliesWithCurvedBorders = isCommentsPanel && isReply && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2');
    const getHighlightBackgroundColor = ()=>{
        if (isAnnotatedTextPressed) return "var(--ds-background-accent-yellow-subtle-hovered, #E2B203)";
        if (isSelected) return "var(--ds-background-accent-yellow-subtle, #F5CD47)";
        if (isAnnotatedTextHovered || isThreadHovered && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2')) return "var(--ds-background-accent-yellow-subtlest-hovered, #F8E6A0)";
        return 'inherit';
    };
    const handleMouseUp = ()=>{
        if (annotationId && setCurrentlySelectedThreadKey) {
            !(0, $9wGTI.fg)('confluence-frontend-duplicate-selected-thread') && setCurrentlySelectedThreadKey(annotationId);
            const commentElement = document.getElementById(annotationId);
            if (commentElement && isParentCommentOpen) {
                if (pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE) {
                    (0, $i49vP.scrollToElementInEditor)({
                        targetElement: commentElement,
                        viewingRoomOffset: -300
                    });
                    (0, $i49vP.checkElementExpandInEditor)(commentElement);
                    eventEmitter.emit('setselectedannotation', annotationId);
                } else {
                    eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, {
                        annotationId: annotationId
                    });
                    (0, $aHcFH.scrollCommentIntoView)({
                        commentElement: commentElement,
                        isFabricPage: true,
                        useInstantScroll: false,
                        isAbove: false,
                        commentThreadAnnotationId: annotationId,
                        isCommentsPanel: isCommentsPanel
                    });
                }
            }
            setAnnotatedTextPressed && setAnnotatedTextPressed(false);
        }
    };
    const handleMouseEnter = ()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2')) {
            if (annotationId) {
                if (pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE) eventEmitter.emit('sethoveredannotation', annotationId);
                else eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, {
                    annotationId: annotationId
                });
                setIsAnnotatedTextHovered(true);
            }
        }
    };
    const handleMouseLeave = ()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2')) {
            if (annotationId) {
                if (pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE) eventEmitter.emit('removehoveredannotation', annotationId);
                else eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, {
                    annotationId: annotationId
                });
                setIsAnnotatedTextHovered(false);
            }
        }
    };
    const shouldShowCommentContentContext = annotatedText && isCommentsPanel && !isReply;
    const showContentUnavailableForDanglingComment = resolveProperties?.isDangling && (0, $9wGTI.fg)('confluence_frontend_dangling_comments');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c5a7cd205687b023$var$CommentContainer, {
        ref: containerRef,
        "data-comment-id": commentId,
        "data-testid": commentId,
        isFocused: isFocused,
        isRemoving: isRemoving,
        mode: mode,
        isCommentsPanel: isCommentsPanel,
        "aria-label": wrapperLabel,
        role: "comment",
        tabIndex: -1,
        onMouseEnter: handleMouseEventOnWrapper('enter'),
        onMouseLeave: handleMouseEventOnWrapper('leave'),
        className: (0, $35pXk.default)([
            "_kqswh2mm"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        ref: unreadCommentRef
    }, mode !== 'view' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c5a7cd205687b023$var$RelativeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": "overflow-container",
        ref: handleRef
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div" // We need to adjust the size of the border if we have a nested reply scroller below this
    , {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: !hideBranchingStyle ? {
            '--replyBranchHeight': `${replyBranchHeight + (adjustForNestedReplies ? 53 : 0)}px`
        } : {},
        className: (0, $35pXk.default)([
            isReply && isCommentsPanel && !hideBranchingStyle && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && "_kqswh2mm _1n1jqcao _1kt9b3bt _1cs8stnw _qnec2bgk _1auk7vkz _kfgt1q5s _19wo1ul9 _syaypxbi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1Sjzs.WithCurvedBranchingStyle), {
        showDefaultStyles: showRepliesWithCurvedBorders,
        customStyles: {
            ...isCommentsPanel ? {
                height: '20px'
            } : {},
            ...isFooterComment ? {
                height: '25px'
            } : {},
            // Accounts for additional padding added to the author
            ...adjustForFooterNestedReplies ? {
                left: '-25px'
            } : {} // Accounts for the left border of the parent comment
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: isFooterComment ? $c5a7cd205687b023$var$footerCommentAuthorStyles : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $daq5m.CommentAuthor), {
        commentMode: "view",
        userId: userId,
        date: date,
        createdAtNonLocalized: createdAtNonLocalized,
        versionByDisplayName: versionByDisplayName,
        versionDate: versionDate,
        displayName: displayName,
        avatarUrl: avatarUrl,
        commentDateUrl: dateUrl,
        commentId: isCurrentUserAnonymous ? commentId : null,
        permissionType: permissionType,
        isInactiveComment: Boolean(mode === 'view-all' && !isCommentActive),
        showCopyLink: showingCopyLinkButton,
        resolveProperties: resolveProperties,
        isCommentsPanel: isCommentsPanel,
        isGeneralComments: commentType === (0, $8i27m.CommentType).GENERAL,
        isReply: isReply,
        isEdited: isEdited,
        isFooterComment: isFooterComment,
        isStandaloneComment: isStandaloneComment
    }), isUnread && !isHovered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": `unread-comment-indicator-${commentId}`,
        className: (0, $35pXk.default)([
            "_ca0q1b66",
            isCommentsPanel && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && "_kqswh2mm _154iv77o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $c5a7cd205687b023$var$dotStyles
    })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        className: (0, $35pXk.default)([
            isCommentsPanel && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && "_19pkutpp _18u0pxbi _19bv1ejb _u5f31b66",
            isCommentsPanel && isReply && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && "_18u0ze3t _19bvze3t",
            isCommentsPanel && !isReply && !hideBranchingStyle && (numReplies !== 0 || canAddComments) && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && "_1kl7qcao _n3tdu2gc",
            isFooterComment && isReply && "_19pku2gc",
            isStandaloneComment && isReply && "_19pku2gc"
        ])
    }, shouldShowCommentContentContext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, resolveProperties?.resolved && !(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && annotatedText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        space: "space.150",
        alignBlock: "center",
        xcss: [
            isResolvedByAnotherUser && $c5a7cd205687b023$var$xcssTranslucentStyle
        ],
        testId: "highlight-text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $c5a7cd205687b023$var$highlightSvgBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jSpUM.HighlightLineSVG), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        color: "color.text.subtle",
        size: "medium",
        maxLines: 1
    }, annotatedText)), (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        space: "space.150",
        alignBlock: "center",
        xcss: [
            isResolvedByAnotherUser && $c5a7cd205687b023$var$xcssTranslucentStyle
        ],
        testId: "highlight-text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        "data-testId": "annotated-section-for-inlineComment",
        xcss: [
            $c5a7cd205687b023$var$annotatedTextBodyStyle,
            !isResolvedByAnotherUser && isAnnotatedTextHovered && !isAnnotatedTextPressed && $c5a7cd205687b023$var$annotatedTextBodyHoverStyle,
            !isResolvedByAnotherUser && isAnnotatedTextPressed && $c5a7cd205687b023$var$annotatedTextBodyWithPressedStyle
        ],
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onMouseDown: ()=>{
            if (annotationId) setAnnotatedTextPressed && setAnnotatedTextPressed(true);
        },
        onMouseUp: handleMouseUp
    }, showContentUnavailableForDanglingComment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
        label: "",
        color: "var(--ds-icon-subtlest, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        size: "small",
        maxLines: 3,
        color: "color.text.subtle"
    }, formatMessage((0, $9CnRS.i18n).contentUnavailable))) : annotatedText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        size: "small",
        maxLines: 3
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
        style: {
            background: getHighlightBackgroundColor(),
            borderBottom: isAnnotatedTextPressed || isSelected || isAnnotatedTextHovered || isThreadHovered && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? `2px solid ${"var(--ds-icon-accent-yellow, #B38600)"}` : ''
        }
    }, annotatedText))))), adf && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        className: (0, $35pXk.default)([
            isCommentsPanel && commentRemovedByAnotherUser && "_tzy41ssb"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $c6FO3.CommentRenderer), {
        commentId: commentId,
        adf: adf,
        onContentFallback: onCommentContentFallback,
        isTruncatedContent: mode === 'view-all' && !isCommentActive,
        onRendered: onRendered,
        onComplete: onComplete,
        maxHeight: maxHeight,
        fadeOutHeight: fadeOutHeight,
        isInlineComment: true,
        isCommentsPanel: isCommentsPanel,
        isEdited: isEdited,
        versionByDisplayName: versionByDisplayName,
        versionDate: versionDate,
        commentType: commentType
    })), isDeletedByAnotherUser && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $c5a7cd205687b023$var$warningMessageStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        weight: "bold"
    }, formatMessage((0, $9CnRS.i18n).deletedCommentActionLabel))))), shouldShowOverflowMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $k7gEe.CommentActions), {
        pageId: pageId,
        pageType: pageType,
        commentId: commentId,
        permissions: permissions,
        isReply: isReply,
        parentCommentId: parentCommentId,
        deleteComment: deleteComment,
        editComment: editComment,
        resolveComment: resolveComment,
        restrictEdit: hasFallbackContent,
        restrictDelete: Boolean(numReplies),
        numReplies: numReplies,
        isCommentActive: isCommentActive,
        mode: mode,
        commentDateUrl: dateUrl,
        onClose: onClose,
        overflowMenuPortal: overflowPortal,
        supportedActions: supportedActions,
        isCommentsPanel: isCommentsPanel,
        isHovered: isHovered,
        annotationId: annotationId,
        resolveProperties: resolveProperties,
        reopenComment: reopenComment,
        replyToComment: replyToComment,
        isUnread: isUnread,
        inheritedReactionsData: inheritedReactionsData,
        reactionsCacheUpdateFn: reactionsCacheUpdateFn,
        isResolvedByAnotherUser: isResolvedByAnotherUser,
        commentType: commentType,
        hideBranchingStyle: hideBranchingStyle,
        canAddComments: canAddComments,
        isDeletedByAnotherUser: isDeletedByAnotherUser,
        isSelected: isSelected,
        isParentCommentOpen: isParentCommentOpen,
        isFooterComment: isFooterComment
    })));
};

});
parcelRegister("k7gEe", function(module, exports) {

$parcel$export(module.exports, "CommentActions", () => $21f8bd546279fd06$export$e75a036919cd8d68);
/* CommentActions.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $d2LG0 = parcelRequire("d2LG0");

var $4FhhO = parcelRequire("4FhhO");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $diswb = parcelRequire("diswb");

var $1qfLF = parcelRequire("1qfLF");

var $9VJDA = parcelRequire("9VJDA");

var $cvXh8 = parcelRequire("cvXh8");

var $52EPl = parcelRequire("52EPl");
var $dAYOx = parcelRequire("dAYOx");
var $ahaN7 = parcelRequire("ahaN7");

var $6f0Oj = parcelRequire("6f0Oj");
var $2W0qg = parcelRequire("2W0qg");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $aUEBE = parcelRequire("aUEBE");

var $c6fYi = parcelRequire("c6fYi");

var $1pSma = parcelRequire("1pSma");

var $irVI7 = parcelRequire("irVI7");
var $aJPUt = parcelRequire("aJPUt");
var $1kHsc = parcelRequire("1kHsc");
var $8Ss4E = parcelRequire("8Ss4E");

var $lTdMf = parcelRequire("lTdMf");

var $9wGTI = parcelRequire("9wGTI");

var $cMvMc = parcelRequire("cMvMc");

var $2ttXz = parcelRequire("2ttXz");
var $1NF8X = parcelRequire("1NF8X");

var $8SCD6 = parcelRequire("8SCD6");
var $bSvtO = parcelRequire("bSvtO");

var $3jwuS = parcelRequire("3jwuS");

var $9sGCn = parcelRequire("9sGCn");

var $ep3mz = parcelRequire("ep3mz");

var $8aF6s = parcelRequire("8aF6s");

var $8i27m = parcelRequire("8i27m");

var $aHcFH = parcelRequire("aHcFH");

var $bQm3c = parcelRequire("bQm3c");

var $en1dX = parcelRequire("en1dX");

var $ad6ZE = parcelRequire("ad6ZE");

var $kmHPt = parcelRequire("kmHPt");

var $666Tc = parcelRequire("666Tc");

var $9CnRS = parcelRequire("9CnRS");

var $g0DaR = parcelRequire("g0DaR");
const $21f8bd546279fd06$var$CommentActionsReactionsCommentsQuery = (0, $d2LG0.default)`query CommentActionsReactionsCommentsQuery($contentId:ID!$containerId:ID!){comments(commentId:$contentId contentStatus:[DRAFT CURRENT]){nodes{id reactionsSummary(pageId:$containerId contentType:"page" childType:"comment"){reactionsCount ari containerAri reactionsSummaryForEmoji{emojiId count reacted id}}}}}`;
const $21f8bd546279fd06$var$reactionBelowCommentBodyStyle = (0, $ecnYn.xcss)({
    marginTop: 'space.0'
});
const $21f8bd546279fd06$var$itemStyles = null;
const $21f8bd546279fd06$var$reactionInCommentPanelStyle = (0, $ecnYn.xcss)({
    paddingTop: 'space.050',
    marginLeft: 'space.200',
    paddingLeft: 'space.300',
    paddingBottom: 'space.100'
});
const $21f8bd546279fd06$var$reactionInCommentPanelStyleV2 = (0, $ecnYn.xcss)({
    paddingTop: 'space.050',
    paddingBottom: 'space.100'
});
const $21f8bd546279fd06$var$replyReactionInCommentPanelStyle = (0, $ecnYn.xcss)({
    marginLeft: 'space.0',
    paddingLeft: 'space.0',
    paddingTop: 'space.150',
    paddingBottom: 'space.0'
});
const $21f8bd546279fd06$var$standaloneNewDesign = (0, $ecnYn.xcss)({
    marginLeft: 'space.0'
});
const $21f8bd546279fd06$var$withLeftBorderStyle = (0, $ecnYn.xcss)({
    borderLeft: `1.5px solid ${"var(--ds-background-accent-gray-subtlest-hovered, #DCDFE4)"}`
});
const $21f8bd546279fd06$var$customPaddingStyle = (0, $ecnYn.xcss)({
    paddingLeft: 'space.0'
}); // As footer does not have isDangling
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $21f8bd546279fd06$var$OverflowDisabledDropdownItem = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = (0, $dAYOx.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $21f8bd546279fd06$var$DropdownMenuContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCommentsPanel: isCommentsPanel, enableDropdownForEditMode: enableDropdownForEditMode, showClose: showClose, isUnread: isUnread, isCommentActive: isCommentActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_zs121y44 _l58r1y44 _14hp1tcg _1kmv1tcg _jq8g1tcg _k6rd1tcg _u5wqgktf _zbjigktf _boltgktf _5fdigktf",
            __cmplp.isCommentsPanel ? "_kqswh2mm" : "_kqswstnw",
            __cmplp.isCommentsPanel ? "_154iidpf" : __cmplp.mode === 'view' ? "_154i1fm0" : __cmplp.enableDropdownForEditMode ? "_154iukr8" : __cmplp.showClose ? "_154ir5cr" : "_154i1i6y",
            __cmplp.isCommentsPanel ? "_1xi2n7od" : __cmplp.mode !== 'view' ? __cmplp.enableDropdownForEditMode ? "_1xi21ejb" : __cmplp.showClose ? "_1xi21ejb" : "_1xi21b66" : __cmplp.isCommentsPanel ? !__cmplp.isUnread ? "_1xi2ze3t" : "_1xi21ejb" : "_1xi21jfw",
            !__cmplp.isCommentActive && __cmplp.mode === 'view-all' ? "_3um015vq" : "_3um0ewfl",
            __cmplp.className
        ])
    });
});
const $21f8bd546279fd06$var$clickableItemStyle = (0, $ecnYn.xcss)({
    cursor: 'pointer'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $21f8bd546279fd06$var$ReplyContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_ae4v1h6o _80omtlke",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $21f8bd546279fd06$var$ReactionsContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasReactions: hasReactions, isCommentsPanel: isCommentsPanel, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "",
            __cmplp.hasReactions ? "_1e0c1ule" : "_1e0c116y",
            __cmplp.hasReactions ? "_i0dl1osq" : "_i0dl1wug",
            !__cmplp.isCommentsPanel && !__cmplp.hasReactions ? "_19pk1b66" : "_19pkze3t",
            !__cmplp.isCommentsPanel && !__cmplp.hasReactions ? "_18u01b66" : "_18u0ze3t",
            __cmplp.className
        ])
    });
});
const $21f8bd546279fd06$var$ActionItem = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_2lx2vrvc _1n261q9c _1e0c116y _syaz1gjq _1tke1tcg _4cvr1h6o _xrwlcs5v _144bkb7n _14p1f1ug _ekv61o8v _6wjiesu3 _43ds1e6v _1pzmusic _ep9t1b66 _5lhmtlke _1tzjf4df _8bo21mp2 _nqnu1gjq _d32v1gjq _mn8eglyw _49cdugt7",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $21f8bd546279fd06$var$ActionButton = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11q7glyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _12ji1r31 _1qu21kw7 _12y31o36 _syaz1kw7 _1wyb1kw7 _80omtlke _1as918uv _j4qy8stv _1wwgnqa1 _y2mvugt7 _1bg4yh40",
            __cmplp.className
        ])
    });
});
const $21f8bd546279fd06$var$pressableStyles = (0, $ecnYn.xcss)({
    ':hover': {
        textDecoration: 'underline'
    }
});
const $21f8bd546279fd06$var$rightAlignedActionItemsStyle = (0, $ecnYn.xcss)({
    position: 'absolute',
    right: 'space.0',
    display: 'flex',
    gap: 'space.075',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: 'space.150'
});
const $21f8bd546279fd06$var$rightAlignedActionItemsCommentsPanelStyle = (0, $ecnYn.xcss)({
    top: 'space.0'
});
const $21f8bd546279fd06$var$rightAlignedItemsStandaloneStyle = (0, $ecnYn.xcss)({
    top: 'space.150',
    right: 'space.200'
});
const $21f8bd546279fd06$var$rightAlignedActionItemsFooterCommentStyle = (0, $ecnYn.xcss)({
    top: 'space.100'
});
const $21f8bd546279fd06$var$hoveredBackground = (0, $ecnYn.xcss)({
    background: "var(--ds-background-input, #FFFFFF)"
});
const $21f8bd546279fd06$var$selectedBackground = (0, $ecnYn.xcss)({
    background: "var(--ds-background-input-hovered, #F7F8F9)"
});
const $21f8bd546279fd06$var$resolvedTextStyle = null;
const $21f8bd546279fd06$export$e75a036919cd8d68 = ({ pageId: pageId, pageType: pageType, commentId: commentId, permissions: permissions, isReply: isReply, parentCommentId: parentCommentId, restrictEdit: restrictEdit, restrictDelete: restrictDelete, deleteComment: deleteComment, editComment: editComment, resolveComment: resolveComment, isCommentActive: isCommentActive, mode: mode, onClose: onClose, overflowMenuPortal: overflowMenuPortal, supportedActions: supportedActions = [
    'edit',
    'delete',
    'resolve'
], isCommentsPanel: isCommentsPanel = false, isHovered: isHovered, annotationId: annotationId, resolveProperties: resolveProperties, reopenComment: reopenComment, replyToComment: replyToComment, isUnread: isUnread = false, inheritedReactionsData: inheritedReactionsData, reactionsCacheUpdateFn: reactionsCacheUpdateFn, commentDateUrl: commentDateUrl, isResolvedByAnotherUser: isResolvedByAnotherUser, commentType: commentType, hideBranchingStyle: hideBranchingStyle = false, canAddComments: canAddComments = true, isDeletedByAnotherUser: isDeletedByAnotherUser = false, isSelected: isSelected = false, isParentCommentOpen: isParentCommentOpen, isFooterComment: isFooterComment = false })=>{
    const deletePressTracing = (0, $1pSma.default)('delete-comment-action');
    const editPressTracing = (0, $1pSma.default)('start-edit-comment-action');
    const replyPressTracing = (0, $1pSma.default)('start-reply-comment-action');
    const resolvePressTracing = (0, $1pSma.default)('resolve-comment-action');
    const [isDropdownOpen, setIsDropdownOpen] = (0, $gwFzn.useState)(false);
    const [showCommentActionItems, setShowCommentActionItems] = (0, $gwFzn.useState)(false);
    const [isEditable, setIsEditable] = (0, $gwFzn.useState)(false);
    const [isRemovable, setIsRemovable] = (0, $gwFzn.useState)(false);
    const [isResolvable, setIsResolvable] = (0, $gwFzn.useState)(false);
    const [canBeReopened, setCanBeReopened] = (0, $gwFzn.useState)(false);
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { isReactionsEnabled: isReactionsEnabled } = (0, $gwFzn.useContext)((0, $8SCD6.ReactionsContext));
    const [reactionsCount, setReactionsCount] = (0, $gwFzn.useState)(inheritedReactionsData?.reactionsCount || 0);
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { updateReactionsSummary: updateReactionsSummary } = (0, $8i27m.useCommentsDataActions)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { subType: subType } = (0, $9sGCn.getCachedPageData)(contentId);
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const handleGqlError = (error)=>{
        experienceTracker.stopOnError({
            name: (0, $irVI7.VIEW_REACTIONS_EXPERIENCE),
            error: error
        });
    };
    const { data: reactionsData, loading: reactionsLoading } = (0, $diswb.useQuery)($21f8bd546279fd06$var$CommentActionsReactionsCommentsQuery, {
        variables: {
            contentId: commentId,
            containerId: pageId
        },
        onError: handleGqlError,
        fetchPolicy: 'cache-and-network',
        // If we have the reactions from a higher component, skip the query
        skip: Boolean(inheritedReactionsData)
    });
    (0, $gwFzn.useEffect)(()=>{
        // If we have the reactions from a higher component, use that count
        const count = (inheritedReactionsData === undefined ? reactionsData?.comments?.nodes?.[0]?.reactionsSummary?.reactionsCount : inheritedReactionsData?.reactionsCount) || 0;
        setReactionsCount(count);
    }, [
        reactionsData,
        inheritedReactionsData
    ]);
    (0, $gwFzn.useEffect)(()=>{
        // Actions are decided by the mode we're displaying
        // and the permissions available for the user
        const canEdit = Boolean(permissions?.isEditable && editComment && supportedActions.includes('edit'));
        const canDelete = Boolean(permissions?.isRemovable && deleteComment && supportedActions.includes('delete'));
        const canResolve = Boolean(permissions?.isResolvable && resolveComment && supportedActions.includes('resolve')); // if user doesn't have resolve comment permission then they shouldn't have reopen permission too
        const hasPermissionToReopen = reopenComment && supportedActions.includes('reopen') && permissions?.isResolvable;
        const canReopen = Boolean(hasPermissionToReopen && !isReply); // handle reopening dangling comments
        if (resolveProperties?.resolved && resolveProperties?.isDangling) {
            if (!(0, $9wGTI.fg)('confluence_frontend_dangling_comments')) setCanBeReopened(false);
            else setCanBeReopened(canReopen);
             // handle reopening non-dangling comments
        } else setCanBeReopened(Boolean(canReopen && (resolveProperties?.resolved || isResolvedByAnotherUser) && (annotationId && (0, $g0DaR.inlineCommentExists)(annotationId) || commentType === (0, $8i27m.CommentType).GENERAL)));
        if (mode === 'view' || mode === 'edit') {
            if (!isReply) setIsResolvable(canResolve); // Parent comments are resolvable if allowed
            else setIsResolvable(false); // Replies cannot be resolved
            if (isCommentsPanel || (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment')) {
                const hasPermissions = canEdit || canDelete || canResolve;
                const shouldShowDropdownMenu = !!isHovered && hasPermissions; // Set the state for using the dropdown menu
                setShowCommentActionItems(shouldShowDropdownMenu);
            } else if (!isReply && (canEdit || canDelete || canResolve)) setShowCommentActionItems(true); // Parent comments or replies outside panel can show menu
             // Users can delete the replies they created
            setIsRemovable(canDelete);
            setIsEditable(canEdit);
        } else {
            setIsRemovable(canDelete);
            setIsEditable(canEdit);
            setIsResolvable(canResolve && !isReply);
        }
    }, [
        mode,
        permissions,
        isHovered,
        isReply,
        isCommentsPanel,
        supportedActions,
        deleteComment,
        editComment,
        resolveComment,
        reopenComment,
        resolveProperties?.isDangling,
        annotationId,
        resolveProperties?.resolved,
        isResolvedByAnotherUser,
        commentType
    ]);
    (0, $gwFzn.useEffect)(()=>{
        // If the user is on the comments panel and leaves this comment and the dropdown menu is open,
        // close the dropdown menu so they don't see it when they return
        if (isCommentsPanel && isDropdownOpen && !isHovered) setIsDropdownOpen(false);
    }, [
        isCommentsPanel,
        isDropdownOpen,
        isHovered,
        setIsDropdownOpen
    ]);
    const getInlineCommentModeConstant = ()=>{
        switch(mode){
            case 'view':
                return (0, $ad6ZE.InlineCommentMode).VIEW;
            case 'edit':
                if (isLivePage) return (0, $ad6ZE.InlineCommentMode).LIVE;
                return (0, $ad6ZE.InlineCommentMode).EDIT;
        }
    };
    const handleDelete = ()=>{
        if (commentType === (0, $8i27m.CommentType).INLINE) experienceTracker.start({
            name: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE),
            attributes: {
                mode: getInlineCommentModeConstant(),
                framework: (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER,
                isReply: isReply,
                source: isCommentsPanel ? (0, $en1dX.AnalyticsSource).COMMENTS_PANEL : (0, $en1dX.AnalyticsSource).STANDALONE
            }
        });
        else experienceTracker.start({
            name: (0, $irVI7.DELETE_PAGE_COMMENT_EXPERIENCE),
            attributes: {
                isReply: isReply
            }
        });
        showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                if ((0, $9wGTI.fg)('cc_comments_track_secondary_comments_actions')) deleteCommentWithPressTracing();
                else deleteComment && deleteComment();
            },
            isDelete: true,
            onCancel: ()=>{
                // abort delete experience if dialog is closed
                experienceTracker.abort({
                    name: commentType === (0, $8i27m.CommentType).INLINE ? (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE) : (0, $irVI7.DELETE_PAGE_COMMENT_EXPERIENCE),
                    reason: 'delete dialog closed'
                });
            }
        });
    };
    const deleteCommentWithPressTracing = ()=>{
        if (!!deleteComment) {
            deletePressTracing();
            deleteComment();
        }
    };
    const handleEditComment = ()=>{
        if (commentType === (0, $8i27m.CommentType).INLINE) (0, $8Ss4E.startEditorExperiences)(/* compoundExperience */ {
            name: (0, $irVI7.EDIT_INLINE_COMMENT_EXPERIENCE),
            attributes: {
                mode: getInlineCommentModeConstant(),
                framework: (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER,
                isReply: isReply,
                type: isReply ? 'reply' : 'topLevel'
            }
        }, /* editorLoadExperience */ {
            name: (0, $irVI7.EDIT_INLINE_COMMENT_LOAD_EXPERIENCE)
        }, /* editorPublishExperience */ {
            name: (0, $irVI7.EDIT_INLINE_COMMENT_PUBLISH_EXPERIENCE)
        });
        else if ((0, $9wGTI.fg)('confluence_frontend_separate_add_page_comment')) (0, $8Ss4E.startEditorExperiences)(/* compoundExperience */ {
            name: (0, $irVI7.EDIT_PAGE_COMMENT_EXPERIENCE),
            timeout: (0, $9wGTI.fg)('confluence_frontend_disable_page_comment_timeout') ? undefined : (0, $aJPUt.ExperienceTimeout).EDITOR_PUBLISH,
            attributes: {
                editor: 'FABRIC',
                isSingleExperience: true,
                edition: edition,
                type: isReply ? 'reply' : 'topLevel',
                source: isFooterComment ? 'footer' : 'commentsPanel'
            }
        }, /* editorLoadExperience */ {
            name: (0, $irVI7.EDIT_PAGE_COMMENT_LOAD_EXPERIENCE)
        }, /* editorPublishExperience */ {
            name: (0, $irVI7.EDIT_PAGE_COMMENT_PUBLISH_EXPERIENCE)
        });
        else (0, $8Ss4E.startEditorExperiences)(/* compoundExperience */ {
            name: (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE),
            timeout: (0, $9wGTI.fg)('confluence_frontend_disable_page_comment_timeout') ? undefined : (0, $aJPUt.ExperienceTimeout).EDITOR_PUBLISH,
            attributes: {
                editor: 'FABRIC',
                isSingleExperience: true,
                mode: 'editComment',
                edition: edition,
                source: isFooterComment ? 'footer' : 'commentsPanel'
            }
        }, /* editorLoadExperience */ {
            name: (0, $irVI7.ADD_PAGE_COMMENT_LOAD_EXPERIENCE)
        }, /* editorPublishExperience */ {
            name: (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE)
        });
        editComment && editComment();
    };
    const handleEditCommentWithPressTracing = ()=>{
        editPressTracing();
        handleEditComment();
    };
    const handleReply = ()=>{
        const replyToCommentId = isFooterComment ? commentId : parentCommentId || commentId;
        if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                resetContentChanged();
                if ((0, $9wGTI.fg)('cc_comments_track_secondary_comments_actions')) replyToCommentWithPressTracing(replyToCommentId);
                else replyToComment && replyToComment(replyToCommentId);
            }
        });
        else if ((0, $9wGTI.fg)('cc_comments_track_secondary_comments_actions')) replyToCommentWithPressTracing(replyToCommentId);
        else replyToComment && replyToComment(replyToCommentId);
    };
    const replyToCommentWithPressTracing = (replyToCommentId)=>{
        if (!!replyToComment) {
            replyPressTracing();
            replyToComment(replyToCommentId);
        }
    };
    const handleCopyLink = async ()=>{
        const linkToComment = `${window.location.origin}/wiki${commentDateUrl}`;
        if ((0, $aHcFH.isClipboardApiSupported)()) await (0, $aHcFH.copyToClipboard)(linkToComment);
        else if ((0, $aHcFH.isIEClipboardApiSupported)()) await (0, $aHcFH.copyToClipboardIE)(linkToComment);
    };
    const handleResolveComment = ()=>{
        const doResolve = ()=>{
            experienceTracker.start({
                name: (0, $irVI7.RESOLVE_INLINE_COMMENT_EXPERIENCE),
                id: commentId,
                attributes: {
                    mode: getInlineCommentModeConstant(),
                    framework: (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER
                }
            });
            if ((0, $9wGTI.fg)('cc_comments_track_secondary_comments_actions')) resolveCommentWithPressTracing();
            else resolveComment && resolveComment();
        };
        if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                resetContentChanged();
                doResolve();
            }
        });
        else doResolve();
    };
    const resolveCommentWithPressTracing = ()=>{
        if (!!resolveComment) {
            resolvePressTracing();
            resolveComment();
        }
    };
    const handleReopenComment = ()=>{
        reopenComment && reopenComment();
    };
    const renderEditAction = (isRestricted, isDropdownMenu)=>{
        if (isDropdownMenu) return isRestricted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($21f8bd546279fd06$var$OverflowDisabledDropdownItem, {
            testId: "disabled-edit-comment-dropdown-action"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lTdMf.DisabledCommentAction), {
            action: "edit",
            isReply: isReply,
            isInOverflowMenu: true
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
            testId: "edit-comment-dropdown-action",
            "data-cy": "edit-comment-action",
            onClick: handleEditComment,
            ...(0, $9wGTI.fg)('cc_comments_track_secondary_comments_actions') ? {
                interactionName: 'start-edit-comment-action'
            } : {}
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $9CnRS.i18n).edit));
        return isRestricted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lTdMf.DisabledCommentAction), {
            action: "edit",
            isReply: isReply,
            isInOverflowMenu: true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($21f8bd546279fd06$var$ActionButton, {
            "data-testid": "edit-comment-action",
            "data-cy": "edit-comment-action",
            onClick: (0, $9wGTI.fg)('cc_comments_track_secondary_comments_actions') ? handleEditCommentWithPressTracing : handleEditComment
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $9CnRS.i18n).edit));
    };
    const renderDeleteAction = (isRestricted, isDropdownMenu)=>{
        if (isDropdownMenu) return isRestricted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($21f8bd546279fd06$var$OverflowDisabledDropdownItem, {
            testId: "disabled-delete-comment-dropdown-action"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lTdMf.DisabledCommentAction), {
            action: "delete",
            isReply: isReply,
            isInOverflowMenu: true
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
            testId: "delete-comment-dropdown-action",
            onClick: handleDelete
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $9CnRS.i18n).delete));
        return isRestricted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lTdMf.DisabledCommentAction), {
            action: "delete",
            isReply: isReply
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($21f8bd546279fd06$var$ActionButton, {
            "data-testid": "delete-comment-action",
            onClick: handleDelete
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $9CnRS.i18n).delete));
    };
    const renderReopenComment = ()=>{
        return canBeReopened && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
            className: (0, $35pXk.default)([
                "_zulp12x7 _1e0c1txw _1bah1h6o _4cvr1h6o"
            ])
        }, isResolvedByAnotherUser && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
            className: (0, $35pXk.default)([
                "_11c81vhk _syaz1gjq"
            ])
        }, formatMessage((0, $9CnRS.i18n).resolved)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aUEBE))), {
                    ...iconProps,
                    spacing: "spacious",
                    color: "var(--ds-icon-success, #22A06B)",
                    label: formatMessage((0, $9CnRS.i18n).reopen)
                }),
            label: formatMessage((0, $9CnRS.i18n).reopen),
            isTooltipDisabled: false,
            onClick: handleReopenComment,
            appearance: "subtle",
            testId: "reopen-comment-action",
            analyticsContext: {
                attributes: {
                    name: (0, $en1dX.ActionName).REOPEN_COMMENT,
                    source: isCommentsPanel ? (0, $en1dX.AnalyticsSource).COMMENTS_PANEL : (0, $en1dX.AnalyticsSource).STANDALONE,
                    isDanglingComment: resolveProperties?.isDangling // all dangling comments are inline comments
                }
            }
        }));
    };
    const renderReplyAction = ()=>{
        if (!isCommentsPanel && !(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2')) return;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($21f8bd546279fd06$var$ReplyContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($21f8bd546279fd06$var$ActionButton, {
            "data-testid": "reply-comment-action",
            "data-cy": "reply-comment-action",
            onClick: handleReply
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $9CnRS.i18n).replyPlaceholder)));
    };
    const renderCopyButton = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
            testId: "copy-link-dropdown-action",
            onClick: handleCopyLink
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $9CnRS.i18n).copyLink));
    };
    const renderResolveOption = ()=>{
        if (isCommentsPanel && isReply && (0, $9wGTI.fg)('confluence-frontend-comments-panel')) return;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
            testId: "resolve-comment-dropdown-action",
            onClick: handleResolveComment
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $9CnRS.i18n).resolve));
    };
    const renderDropdownMenu = (editRestricted, deleteRestricted)=>{
        // hide the dropdown if not the comments panel and does not have permissions to edit/delete/resolve
        const hasNoCommmentPermissions = !isEditable && !isRemovable && (isReply || !isResolvable); // For old UI, use the existing logic
        const shouldHideDropdownForStandalone = !isCommentsPanel && hasNoCommmentPermissions;
        const shouldHideDropdownForCommentsPanel = isCommentsPanel && hasNoCommmentPermissions && !(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2');
        if (shouldHideDropdownForStandalone || shouldHideDropdownForCommentsPanel) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null);
        const dropdownMenu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($21f8bd546279fd06$var$DropdownMenuContainer, {
            id: "saketsdiva",
            "data-cy": "comment-overflow-actions-menu",
            "data-testid": "comment-overflow-actions-menu",
            isCommentActive: isCommentActive,
            mode: mode,
            showClose: Boolean(onClose),
            enableDropdownForEditMode: (0, $9wGTI.fg)('confluence-frontend-comments-panel') || mode === 'edit',
            isCommentsPanel: isCommentsPanel || (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment'),
            isUnread: isUnread
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $52EPl.default), {
            testId: "comment-overflow-menu",
            isOpen: isDropdownOpen,
            placement: "bottom-end",
            onOpenChange: ({ isOpen: isOpen, event: event })=>{
                event?.stopPropagation();
                setIsDropdownOpen(isOpen);
            },
            trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
                    ...props,
                    testId: "comment-overflow-menu-trigger",
                    ref: triggerRef,
                    label: formatMessage((0, $9CnRS.i18n).commentActionsMenuLabel),
                    appearance: "subtle",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                    isTooltipDisabled: false,
                    isSelected: isDropdownOpen,
                    analyticsContext: {
                        attributes: {
                            name: 'moreActionsButton',
                            source: isCommentsPanel ? (0, $en1dX.AnalyticsSource).COMMENTS_PANEL : (0, $en1dX.AnalyticsSource).STANDALONE,
                            commentType: commentType
                        }
                    }
                })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ahaN7.default), null, (isCommentsPanel || (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment')) && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && renderCopyButton(), !isCommentsPanel && !(0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment') && isResolvable && renderResolveOption(), isEditable && renderEditAction(editRestricted, showCommentActionItems), isRemovable && renderDeleteAction(deleteRestricted, showCommentActionItems))));
        return overflowMenuPortal && !(0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment') ? /*#__PURE__*/ (0, $4FhhO.createPortal)(dropdownMenu, overflowMenuPortal) : dropdownMenu;
    };
    const reactionsUpdateFn = (0, $gwFzn.useMemo)(()=>{
        if (reactionsCacheUpdateFn) return reactionsCacheUpdateFn;
        return inheritedReactionsData !== undefined && isCommentsPanel ? (emojiId, actionType, objectId, containerId, cache)=>updateReactionsSummary(emojiId, actionType, objectId, commentType, containerId, annotationId, cache) : undefined;
    }, [
        inheritedReactionsData,
        reactionsCacheUpdateFn,
        isCommentsPanel,
        annotationId,
        commentType,
        updateReactionsSummary
    ]);
    const renderReplyButton = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
            testId: "comment-reply-button",
            label: formatMessage((0, $9CnRS.i18n).replyPlaceholder),
            appearance: "subtle",
            spacing: "compact",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($c6fYi))),
            onClick: handleReply,
            isTooltipDisabled: false
        });
    };
    const renderResolveActionButton = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
            testId: "comment-resolve-action-item",
            label: formatMessage((0, $9CnRS.i18n).resolve),
            appearance: "subtle",
            spacing: "compact",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))),
            onClick: handleResolveComment,
            isTooltipDisabled: false,
            analyticsContext: {
                attributes: {
                    name: 'resolveActionsButton',
                    source: isCommentsPanel ? (0, $en1dX.AnalyticsSource).COMMENTS_PANEL : (0, $en1dX.AnalyticsSource).STANDALONE,
                    commentType: commentType
                }
            },
            className: (0, $35pXk.default)([
                "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
            ])
        });
    };
    const renderReactions = ({ onlyRenderPicker: onlyRenderPicker = false, readOnly: readOnly = false } = {})=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($21f8bd546279fd06$var$ReactionsContainer, {
            hasReactions: reactionsCount > 0,
            isCommentsPanel: isCommentsPanel || (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1NF8X.ReactionsLoader), {
            readOnly: readOnly,
            contentId: commentId,
            containerId: pageId,
            containerType: pageType,
            location: mode === 'edit' ? (0, $2ttXz.ReactionLocation).EDITOR_INLINE_COMMENT : (0, $2ttXz.ReactionLocation).INLINE_COMMENT,
            hidePlaceholder: reactionsCount === 0 || inheritedReactionsData !== undefined,
            reactionsData: inheritedReactionsData === undefined ? reactionsData?.comments?.nodes?.[0]?.reactionsSummary : inheritedReactionsData,
            updateCache: reactionsUpdateFn,
            onlyRenderPicker: onlyRenderPicker,
            isSubtle: isCommentsPanel || (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment'),
            showAddReactionText: false,
            customAnalyticsAttributes: {
                source: isCommentsPanel ? (0, $en1dX.AnalyticsSource).COMMENTS_PANEL : (0, $en1dX.AnalyticsSource).STANDALONE,
                isReply: isReply,
                mode: mode
            },
            contentSubType: subType,
            isListItem: (0, $9wGTI.fg)('confluence_frontend_comment_a11y_fixes')
        }));
    };
    const renderV1ReopenComment = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2W0qg.default), {
            testId: "old-reopen-comment-action",
            onClick: handleReopenComment,
            padding: "space.0",
            backgroundColor: "color.background.neutral.subtle",
            xcss: $21f8bd546279fd06$var$pressableStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
            color: "color.text.subtlest",
            size: "small"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $9CnRS.i18n).reopen)));
    };
    const renderActionItemsOnHover = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
            "data-testId": "comment-action-items",
            xcss: [
                $21f8bd546279fd06$var$rightAlignedActionItemsStyle,
                $21f8bd546279fd06$var$clickableItemStyle,
                isHovered && $21f8bd546279fd06$var$hoveredBackground,
                isSelected && $21f8bd546279fd06$var$selectedBackground,
                isFooterComment && $21f8bd546279fd06$var$rightAlignedActionItemsFooterCommentStyle,
                isCommentsPanel && !isFooterComment && $21f8bd546279fd06$var$rightAlignedActionItemsCommentsPanelStyle,
                !isCommentsPanel && !isFooterComment && (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment') && $21f8bd546279fd06$var$rightAlignedItemsStandaloneStyle
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
            className: (0, $35pXk.default)([
                "_zulp12x7 _1e0c1txw _1bah1h6o _4cvr1h6o"
            ])
        }, !resolveProperties?.resolved && !isResolvedByAnotherUser && (!isReply || isFooterComment || isCommentsPanel && (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment')) && // Footer replies can be replied to
        canAddComments && renderReplyButton(), isReactionsEnabled && !reactionsLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", null, renderReactions({
            onlyRenderPicker: true
        })), !isReply && !resolveProperties?.resolved && !isResolvedByAnotherUser && isResolvable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", null, renderResolveActionButton()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", null, renderDropdownMenu(restrictEdit, restrictDelete))));
    const renderStaticActionsItemsForCommentsPanel = ()=>{
        const isResolved = resolveProperties?.resolved || isResolvedByAnotherUser;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, isResolved && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
            xcss: (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && [
                $21f8bd546279fd06$var$rightAlignedActionItemsStyle,
                isCommentsPanel && !isFooterComment && $21f8bd546279fd06$var$rightAlignedActionItemsCommentsPanelStyle,
                isFooterComment && $21f8bd546279fd06$var$rightAlignedActionItemsFooterCommentStyle
            ],
            testId: "static-actions-items"
        }, (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? renderReopenComment() : renderV1ReopenComment()));
    };
    const renderCommentsPanelActionItems = ()=>{
        const shouldRenderReplyAction = !resolveProperties?.resolved && !isResolvedByAnotherUser && !(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2');
        const isReadOnlyForResolved = resolveProperties?.resolved || isReply && !isParentCommentOpen;
        const commonElements = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, shouldRenderReplyAction && renderReplyAction(), isReactionsEnabled && !reactionsLoading && reactionsCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
            xcss: [
                $21f8bd546279fd06$var$reactionBelowCommentBodyStyle,
                (isCommentsPanel || (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment')) && $21f8bd546279fd06$var$reactionInCommentPanelStyle,
                (isCommentsPanel || (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment')) && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && $21f8bd546279fd06$var$reactionInCommentPanelStyleV2,
                (isCommentsPanel || (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment')) && isReply && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && $21f8bd546279fd06$var$replyReactionInCommentPanelStyle,
                (isCommentsPanel || (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment')) && !isReply && (!hideBranchingStyle && canAddComments || isReadOnlyForResolved) && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && $21f8bd546279fd06$var$withLeftBorderStyle,
                !isCommentsPanel && (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment') && $21f8bd546279fd06$var$standaloneNewDesign,
                !isCommentsPanel && !isFooterComment && hideBranchingStyle && (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment') && $21f8bd546279fd06$var$customPaddingStyle
            ]
        }, renderReactions({
            readOnly: isReadOnlyForResolved
        }))); // no hover state for resolved comments
        const shouldRenderHoverState = ()=>{
            if (isReply && !isParentCommentOpen) return false;
            else return isHovered && !resolveProperties?.resolved && !isDeletedByAnotherUser;
        };
        const stateSpecificElements = shouldRenderHoverState() ? renderActionItemsOnHover() : renderStaticActionsItemsForCommentsPanel();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, stateSpecificElements, commonElements);
    };
    const renderStandaloneCommentActions = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $666Tc.ActionsContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($21f8bd546279fd06$var$ActionItem, {
            "aria-hidden": "true"
        }), !isReply && isResolvable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($21f8bd546279fd06$var$ActionItem, {
            mode: mode,
            isReply: isReply
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($21f8bd546279fd06$var$ActionButton, {
            "data-testid": "resolve-comment-action",
            "data-cy": "resolve-comment-action",
            onClick: handleResolveComment
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $9CnRS.i18n).resolve))), !showCommentActionItems && isEditable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($21f8bd546279fd06$var$ActionItem, {
            mode: mode,
            isReply: isReply
        }, renderEditAction(restrictEdit, showCommentActionItems)), !showCommentActionItems && isRemovable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($21f8bd546279fd06$var$ActionItem, {
            mode: mode,
            isReply: isReply
        }, renderDeleteAction(restrictDelete, showCommentActionItems)), isReactionsEnabled && !reactionsLoading && !resolveProperties?.resolved && renderReactions(), !resolveProperties?.resolved || // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        isCommentsPanel && (0, $9wGTI.fg)('confluence-frontend-comments-panel') && renderReplyAction());
    };
    const renderStandaloneCommentActionItems = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, !isReply && renderDropdownMenu(restrictEdit, restrictDelete), renderStandaloneCommentActions());
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, isCommentsPanel || (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment') ? renderCommentsPanelActionItems() : renderStandaloneCommentActionItems());
};

});
parcelRegister("lTdMf", function(module, exports) {

$parcel$export(module.exports, "DisabledCommentAction", () => $46066c9f9a854335$export$fa26121f031ea499);
/* DisabledCommentAction.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $4jR19 = parcelRequire("4jR19");

var $lsxnT = parcelRequire("lsxnT");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $46066c9f9a854335$var$PopupPaddingContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1yt41ppf _bfhkcdhy _syaz15cr",
            __cmplp.className
        ])
    });
});
const $46066c9f9a854335$var$DisabledActionContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isReply: isReply, isInOverflowMenu: isInOverflowMenu, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _80omtlke _uiztglyw",
            __cmplp.isReply ? "_syaz1gjq" : "_syaz131l",
            __cmplp.isInOverflowMenu ? "_1yt4zc28" : "_ca0q1wug _u5f31wug _n3td1wug _19bv1wug",
            __cmplp.className
        ])
    });
});
const $46066c9f9a854335$var$Container = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11c8dcr7 _1bsbuuw1 _uiztglyw _o5724jg8",
            __cmplp.className
        ])
    });
});
const $46066c9f9a854335$var$StyledLink = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _syaz1e6v _1e0c1nu9 _80omtlke _9oik18uv _1bnx8stv _jf4cnqa1",
            __cmplp.className
        ])
    });
});
const $46066c9f9a854335$export$fa26121f031ea499 = ({ action: action, isReply: isReply, isInOverflowMenu: isInOverflowMenu })=>{
    const { Popup: Popup } = (0, $lsxnT.useChoreographerAssets)();
    const [showDialog, setShowDialog] = (0, $gwFzn.useState)(false);
    // make the dialog visible over the dropdown menu portal
    const dropdownMenu = document.querySelector(`[data-testid="comment-overflow-menu--content"]`);
    if (dropdownMenu && dropdownMenu.style) dropdownMenu.style.overflow = 'visible';
    const toggleDialog = (0, $gwFzn.useCallback)((e)=>{
        e.stopPropagation();
        setShowDialog(!showDialog);
    }, [
        showDialog
    ]);
    const triggerReplyEditor = ()=>{
        const textArea = document.querySelector(`[placeholder="Reply"]`);
        if (textArea) {
            textArea.focus();
            setShowDialog(false);
        }
    };
    const DialogContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($46066c9f9a854335$var$Container, {
        "data-testid": "disabled-explanation-dialog"
    }, action === 'edit' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($46066c9f9a854335$var$StyledLink, {
        "data-testid": "disabled-edit-action-link",
        onClick: triggerReplyEditor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        id: "comment.no.edit.action.text",
        defaultMessage: "Add a new comment"
    })), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        id: "comment.no.edit.reason.text",
        defaultMessage: "since this one cannot be edited; it contains content created in a legacy version of Confluence."
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        id: "comment.no.delete.reason.text" // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        ,
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "You can't delete this comment because it has replies."
    }));
    const renderActionText = ()=>{
        if (action === 'edit') return isReply ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
            id: "comment.no.edit.inline.label",
            defaultMessage: "Edit is not available"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
            id: "comment.no.edit.overflow.menu.label",
            defaultMessage: "Edit"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
            id: "comment.no.delete.overflow.menu.label",
            defaultMessage: "Delete"
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Popup, {
        messageType: "transactional",
        messageId: "disabled-comment-action",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($46066c9f9a854335$var$PopupPaddingContainer, null, DialogContent),
        isOpen: showDialog,
        placement: isReply ? 'bottom' : 'bottom-end',
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($46066c9f9a854335$var$DisabledActionContainer, {
                "data-testid": "disabled-action-container",
                onClick: toggleDialog,
                isReply: isReply,
                isInOverflowMenu: isInOverflowMenu,
                ...triggerProps
            }, renderActionText())
    });
};

});


parcelRegister("daq5m", function(module, exports) {

$parcel$export(module.exports, "CommentAuthor", () => $005e7fbdd3b99ea0$export$d05a2f5fbf67a6d7);
/* CommentAuthor.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $d2LG0 = parcelRequire("d2LG0");

var $diswb = parcelRequire("diswb");

var $dBxQj = parcelRequire("dBxQj");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $3gadb = parcelRequire("3gadb");

var $8jHAi = parcelRequire("8jHAi");

var $9Z0wk = parcelRequire("9Z0wk");

var $fs6LW = parcelRequire("fs6LW");
var $jJK3p = parcelRequire("jJK3p");

var $1YXTQ = parcelRequire("1YXTQ");

var $kr1Wj = parcelRequire("kr1Wj");

var $en1dX = parcelRequire("en1dX");

var $6faGq = parcelRequire("6faGq");

var $7tI6B = parcelRequire("7tI6B");

var $9wGTI = parcelRequire("9wGTI");

var $6b5EI = parcelRequire("6b5EI");

var $9CnRS = parcelRequire("9CnRS");
const $005e7fbdd3b99ea0$var$CommentAuthorInlineCommentAuthorQuery = (0, $d2LG0.default)`query CommentAuthorInlineCommentAuthorQuery($commentId:ID!){content(id:$commentId){nodes{id history{createdBy{displayName profilePicture{path}...on KnownUser{accountId}...on User{accountId}}}}}}`;
const $005e7fbdd3b99ea0$var$CommentAuthorUserQuery = (0, $d2LG0.default)`query CommentAuthorUserQuery($id:ID!){user(id:$id){id displayName photos{value}}}`;
const $005e7fbdd3b99ea0$var$AuthorContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { commentMode: commentMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1reowpa7 _18m9wpa7 _1e0c1txw _4cvr1h6o _jva41r81 _uvzw1r81 _wkreagmp _12rjagmp _gcmzvv82 _1vjrvv82 _5xy116l4 _1dtc16l4 _1msj16l4",
            __cmplp.commentMode === 'reply' ? "_18u012gs" : "_18u01kw7",
            __cmplp.commentMode !== 'view' && "_n3tdftgi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $005e7fbdd3b99ea0$var$AvatarWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCommentsPanel: isCommentsPanel, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1hv8",
            __cmplp.isCommentsPanel ? "_u5f312x7" : "_u5f3u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $005e7fbdd3b99ea0$var$Container = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _2lx21bp4 _14yy2smr _hwn1ugt7 _1msj16l4 _5xy116l4 _1dtc16l4 _17rp1o8v _cpznidpf _1s79idpf _amufidpf _x966idpf _387xglyw _14l51gjq _1ptk18uv _19gd1gjq _1gid1gjq _1e6p1gjq",
            __cmplp.className
        ])
    });
});
const $005e7fbdd3b99ea0$var$resolvedPropertiesStyle = (0, $ecnYn.xcss)({
    paddingLeft: 'space.050'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $005e7fbdd3b99ea0$var$ProfileLinkContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = $005e7fbdd3b99ea0$var$Container, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_2lx2vrvc _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $005e7fbdd3b99ea0$var$LozengeWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_19bvu2gc _s7n4jp4b",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $005e7fbdd3b99ea0$var$DateContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isStandaloneComment: isStandaloneComment, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_2lx2vrvc _1n261q9c _1e0c1txw _4cvr1h6o _102e1o8v _1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf _7wy0glyw _1plv18uv _zmp81gjq _1blw1gjq _9b8i1gjq _1kcs1vm4",
            __cmplp.isStandaloneComment && (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment') ? "_2lx21bp4" : "_2lx2n7od",
            __cmplp.isStandaloneComment && (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment') ? "_4cvr1y6m" : "_4cvrn7od",
            __cmplp.isStandaloneComment ? "_1t4p131l" : "_1t4p1gjq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $005e7fbdd3b99ea0$var$EditedContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isStandaloneComment: isStandaloneComment, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11c8dcr7 _syaz131l",
            __cmplp.isStandaloneComment && (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment') ? "_19bvze3t" : "_19bvu2gc",
            __cmplp.isStandaloneComment && (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment') ? "_1wpz1y6m" : "_1wpzn7od",
            __cmplp.className
        ])
    });
});
const $005e7fbdd3b99ea0$export$d05a2f5fbf67a6d7 = ({ commentMode: commentMode, userId: userId, date: date, createdAtNonLocalized: createdAtNonLocalized, versionByDisplayName: versionByDisplayName, versionDate: versionDate, size: size, displayName: displayName, avatarUrl: avatarUrl, commentDateUrl: commentDateUrl, commentId: commentId, permissionType: permissionType, isInactiveComment: isInactiveComment, showCopyLink: showCopyLink = false, resolveProperties: resolveProperties, isCommentsPanel: isCommentsPanel = false, isGeneralComments: isGeneralComments = false, isReply: isReply = false, isEdited: isEdited = false, isFooterComment: isFooterComment = false, isStandaloneComment: isStandaloneComment = false })=>{
    const { data: authorData } = (0, $diswb.useQuery)($005e7fbdd3b99ea0$var$CommentAuthorInlineCommentAuthorQuery, {
        variables: {
            commentId: commentId
        },
        fetchPolicy: 'cache-and-network',
        skip: Boolean(userId || !commentId)
    });
    const { data: userData } = (0, $diswb.useQuery)($005e7fbdd3b99ea0$var$CommentAuthorUserQuery, {
        variables: {
            id: userId
        },
        fetchPolicy: 'cache-and-network',
        // Skip the query if data is provided or the user is anonymous
        skip: Boolean(avatarUrl && displayName || !userId || commentId)
    });
    const author = (authorData?.content?.nodes || [])[0]?.history?.createdBy;
    const userAvatar = author ? author.profilePicture?.path : (userData?.user?.photos || [])[0]?.value;
    const userDisplayName = author ? author.displayName : userData?.user?.displayName;
    const userAccountId = author?.accountId;
    const linkToComment = `${window.location.origin}/wiki${commentDateUrl}`;
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const tooltipText = resolveProperties?.resolved ? formatMessage((0, $9CnRS.i18n).resolvedByTooltipTextCommentsPanel, {
        username: resolveProperties?.resolvedUser
    }) : formatMessage((0, $9CnRS.i18n).reopenedByTooltipTextCommentsPanel, {
        username: resolveProperties?.resolvedUser,
        createdAtNonLocalized: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1YXTQ.TimeAgo), {
            date: (0, $6faGq.getValidDate)(createdAtNonLocalized),
            usePrepositions: true
        })
    });
    const oldStandloneExperienceResolveInfo = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
            content: resolveProperties?.resolvedFriendlyDate
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
            color: "color.text.subtlest",
            size: "small",
            maxLines: 2
        }, formatMessage((0, $9CnRS.i18n).resolvedByInfoText, {
            username: resolveProperties?.resolvedUser,
            friendlyDate: resolveProperties?.resolvedFriendlyDate
        })));
    };
    const newExperienceResolveInfo = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
            position: "top",
            content: tooltipText
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
            color: "color.text.subtlest",
            size: "small",
            maxLines: 2
        }, resolveProperties?.resolved ? formatMessage((0, $9CnRS.i18n).resolvedDateInfoText, {
            friendlyDate: resolveProperties?.resolvedFriendlyDate
        }) : formatMessage((0, $9CnRS.i18n).reopenedDateInfoText, {
            friendlyDate: resolveProperties?.resolvedFriendlyDate
        })));
    };
    const renderResolveInfo = ()=>{
        const standAloneExperience = !isFooterComment && !isCommentsPanel;
        if (standAloneExperience && (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment') || isFooterComment && (0, $9wGTI.fg)('confluence-frontend-redesigned-footer-comment') || isCommentsPanel) return newExperienceResolveInfo();
        return oldStandloneExperienceResolveInfo();
    };
    const renderCopyButton = ()=>{
        const resolvedInfo = renderResolveInfo();
        const renderCopyLinkButton = commentDateUrl && !(0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment') && (isCommentsPanel && !(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') || !isCommentsPanel);
        const versionDisplayName = versionByDisplayName || formatMessage((0, $9CnRS.i18n).anonymous);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($005e7fbdd3b99ea0$var$DateContainer, {
            isStandaloneComment: isStandaloneComment
        }, resolveProperties?.resolved || resolveProperties?.resolvedFriendlyDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, resolvedInfo, isGeneralComments && !isReply && (0, $9wGTI.fg)('confluence-frontend-comments-panel-design-update') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
            xcss: $005e7fbdd3b99ea0$var$resolvedPropertiesStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
            content: formatMessage((0, $9CnRS.i18n).generalCommentTooltip)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
            color: "var(--ds-icon-subtlest, #626F86)",
            testId: "general-comment-page-icon",
            label: formatMessage((0, $9CnRS.i18n).generalCommentTooltip)
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1YXTQ.TimeAgo), {
            date: (0, $6faGq.getValidDate)((0, $9wGTI.fg)('confluence_frontend_cp_sort_new_to_old') ? createdAtNonLocalized : date)
        }), isGeneralComments && !isReply && (0, $9wGTI.fg)('confluence-frontend-comments-panel-design-update') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
            content: formatMessage((0, $9CnRS.i18n).generalCommentTooltip)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
            color: "var(--ds-icon-subtlest, #626F86)",
            testId: "general-comment-page-icon",
            label: formatMessage((0, $9CnRS.i18n).generalCommentTooltip)
        })))), isEdited && (0, $9wGTI.fg)('confluence_frontend_cp_sort_new_to_old') && !(0, $9wGTI.fg)('confluence_frontend_comment_edited_label_v2') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($005e7fbdd3b99ea0$var$EditedContainer, {
            isStandaloneComment: isStandaloneComment
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
            content: formatMessage((0, $9CnRS.i18n).editedBy, {
                username: versionDisplayName,
                at: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1YXTQ.TimeAgo), {
                    date: (0, $6faGq.getValidDate)(versionDate),
                    usePrepositions: true
                })
            }),
            analyticsContext: {
                attributes: {
                    source: isCommentsPanel ? (0, $en1dX.AnalyticsSource).COMMENTS_PANEL : (0, $en1dX.AnalyticsSource).STANDALONE,
                    commentType: isGeneralComments ? (0, $en1dX.CommentType).GENERAL : (0, $en1dX.CommentType).INLINE,
                    name: 'commentEditedBadgeTooltip'
                }
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
            "data-testid": "comment-edited-label"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9Z0wk.default), null, formatMessage((0, $9CnRS.i18n).edited))))), renderCopyLinkButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6b5EI.CopyLinkButton), {
            visible: showCopyLink,
            textToCopy: linkToComment
        }));
    };
    const isDateShown = commentMode === 'view' && date;
    const name = displayName || userDisplayName || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($005e7fbdd3b99ea0$var$AuthorContainer, {
        commentMode: commentMode,
        "data-cy": "comment-author"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($005e7fbdd3b99ea0$var$AvatarWrapper, {
        isCommentsPanel: isCommentsPanel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fs6LW.ProfileAvatar), {
        userId: userId,
        src: avatarUrl || userAvatar,
        trigger: "click",
        size: size,
        name: name
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($005e7fbdd3b99ea0$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($005e7fbdd3b99ea0$var$ProfileLinkContainer, null, isInactiveComment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
        "data-testid": "dummy-profile-link"
    }, displayName || userDisplayName) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jJK3p.ProfileLink), {
        fullName: displayName || userDisplayName,
        userId: userId || userAccountId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            wordBreak: 'break-word',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            color: "var(--ds-text, #172B4D)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            fontWeight: "var(--ds-font-weight-medium, 500)"
        },
        isUnderlinedByDefault: false
    }), permissionType === (0, $7tI6B.SitePermissionType).EXTERNAL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($005e7fbdd3b99ea0$var$LozengeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kr1Wj.ExternalCollaboratorUserLozenge), null)) : null), isDateShown && renderCopyButton()));
};

});
parcelRegister("7tI6B", function(module, exports) {

$parcel$export(module.exports, "SitePermissionType", () => $89d6a09a4f827a20$export$8995abb8169b2cb8);
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $89d6a09a4f827a20$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});

});


parcelRegister("jSpUM", function(module, exports) {

$parcel$export(module.exports, "HighlightLineSVG", () => $2f634d0f466224e4$export$77a2990571eb5aa2);

var $gwFzn = parcelRequire("gwFzn");
const $2f634d0f466224e4$export$77a2990571eb5aa2 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "2",
        height: "22",
        viewBox: "0 0 2 22",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M1 1L1 21",
        stroke: "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)",
        strokeWidth: "2",
        strokeLinecap: "round"
    }));
};

});

parcelRegister("4OVjm", function(module, exports) {

$parcel$export(module.exports, "useResizeObserver", () => $ce87683ee211df83$export$683480f191c0e3ea);

var $gwFzn = parcelRequire("gwFzn");
const $ce87683ee211df83$export$683480f191c0e3ea = ()=>{
    const [height, setHeight] = (0, $gwFzn.useState)(0);
    const ref = (0, $gwFzn.useRef)(null);
    (0, $gwFzn.useLayoutEffect)(()=>{
        const observeTarget = ref.current;
        const resizeObserver = new ResizeObserver((entries)=>{
            entries.forEach((entry)=>{
                setHeight(entry.contentRect.height);
            });
        });
        if (observeTarget) {
            resizeObserver.observe(observeTarget);
            return ()=>{
                resizeObserver.unobserve(observeTarget);
            };
        }
    }, []);
    return [
        ref,
        height
    ];
};

});


parcelRegister("auGhu", function(module, exports) {

$parcel$export(module.exports, "EditComment", () => $2d789a7ecebf6a19$export$55ec0e499a2afded);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $diswb = parcelRequire("diswb");

var $lRn1m = parcelRequire("lRn1m");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $inPa6 = parcelRequire("inPa6");

var $7EEGh = parcelRequire("7EEGh");

var $lesF8 = parcelRequire("lesF8");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $7Sm4c = parcelRequire("7Sm4c");

var $irVI7 = parcelRequire("irVI7");
var $aJPUt = parcelRequire("aJPUt");
var $1kHsc = parcelRequire("1kHsc");

var $hXzKU = parcelRequire("hXzKU");

var $8i27m = parcelRequire("8i27m");

var $8SCD6 = parcelRequire("8SCD6");
var $bSvtO = parcelRequire("bSvtO");

var $bQm3c = parcelRequire("bQm3c");

var $1C8XP = parcelRequire("1C8XP");
var $jkPJy = parcelRequire("jkPJy");
var $3B9cR = parcelRequire("3B9cR");

var $7W8i8 = parcelRequire("7W8i8");

var $dEBDF = parcelRequire("dEBDF");

var $87CZC = parcelRequire("87CZC");

var $9wGTI = parcelRequire("9wGTI");

var $7aRa9 = parcelRequire("7aRa9");

var $aSsfA = parcelRequire("aSsfA");

var $cD1qu = parcelRequire("cD1qu");

var $fTFoe = parcelRequire("fTFoe");

var $1Sjzs = parcelRequire("1Sjzs");

var $isdzP = parcelRequire("isdzP");

var $daq5m = parcelRequire("daq5m");
const $2d789a7ecebf6a19$var$EditCommentUpdateInlineCommentMutation = (0, $d2LG0.default)`mutation EditCommentUpdateInlineCommentMutation($input:UpdateCommentInput!){updateComment(input:$input){id}}`;
const $2d789a7ecebf6a19$var$i18n = (0, $2nPZH.defineMessages)({
    cannotEditTitle: {
        id: "inline-comments-common.could.not.edit.title",
        defaultMessage: "Unable to edit comment"
    }
});
const $2d789a7ecebf6a19$var$logger = (0, $7W8i8.getLogger)('inline-comments-common:edit-comment');
const $2d789a7ecebf6a19$var$editorContainerStyle = (0, $ecnYn.xcss)({
    paddingBlock: 'space.150',
    paddingInline: 'space.200'
});
const $2d789a7ecebf6a19$var$editorContainerForFooterWrapperStyle = (0, $ecnYn.xcss)({
    padding: 'unset',
    paddingTop: 'space.100'
});
const $2d789a7ecebf6a19$var$editorContainerForFooterExtraLeftPaddingWithBorderStyle = (0, $ecnYn.xcss)({
    paddingLeft: 'space.300',
    marginLeft: 'space.200',
    marginTop: 'space.050',
    // If we're doing the border here, we need margin instead of padding so the border is flush with the editor
    borderLeft: `1.5px solid ${"var(--ds-background-accent-gray-subtlest-hovered, #DCDFE4)"}`
});
const $2d789a7ecebf6a19$var$editorBottomPaddingStyle = (0, $ecnYn.xcss)({
    paddingBottom: 'space.100'
});
const $2d789a7ecebf6a19$var$EditCommentComponent = ({ pageId: pageId, pageType: pageType, annotationId: annotationId, commentId: commentId, spaceId: spaceId, content: content, displayCommentInViewMode: displayCommentInViewMode, isReply: isReply, avatarUrl: avatarUrl, displayName: displayName, mode: mode, hasMediaUploadPermissions: hasMediaUploadPermissions, isCommentsPanel: isCommentsPanel, isFooterComment: isFooterComment = false, adjustForFooterReplies: adjustForFooterReplies = false, isLastNestedFooterReply: isLastNestedFooterReply = false, onCancelEdit: onCancelEdit, getInlineNodeTypes: getInlineNodeTypes, commentType: commentType, flags: flags, isStandaloneComment: isStandaloneComment })=>{
    const { userId: userId, displayName: sessionDisplayName } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { onChange: onChange, resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { isReactionsEnabled: isReactionsEnabled } = (0, $gwFzn.useContext)((0, $8SCD6.ReactionsContext));
    const [, { updateCommentBody: updateCommentBody }] = (0, $8i27m.useCommentsData)();
    const commentContainerElementRef = (0, $gwFzn.useRef)(null);
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const [updateCommentFn] = (0, $diswb.useMutation)($2d789a7ecebf6a19$var$EditCommentUpdateInlineCommentMutation);
    const handleOnEditorReady = ()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_separate_add_page_comment')) {
            if (commentType === (0, $8i27m.CommentType).GENERAL) experienceTracker.succeed({
                name: (0, $irVI7.EDIT_PAGE_COMMENT_LOAD_EXPERIENCE)
            });
            else experienceTracker.succeed({
                name: (0, $irVI7.EDIT_INLINE_COMMENT_LOAD_EXPERIENCE)
            });
        } else experienceTracker.succeed({
            name: (0, $irVI7.EDIT_INLINE_COMMENT_LOAD_EXPERIENCE)
        });
    };
    const handleOnCancel = ()=>{
        displayCommentInViewMode();
        resetContentChanged();
        onCancelEdit && onCancelEdit();
    };
    const handleUpdateComment = (adf, onSuccess)=>{
        if ((0, $9wGTI.fg)('confluence_frontend_separate_add_page_comment')) {
            if (commentType === (0, $8i27m.CommentType).GENERAL) experienceTracker.start({
                name: (0, $irVI7.EDIT_PAGE_COMMENT_PUBLISH_EXPERIENCE),
                timeout: (0, $9wGTI.fg)('confluence_frontend_disable_page_comment_timeout') ? (0, $aJPUt.ExperienceTimeout).EDITOR_PUBLISH : undefined,
                attributes: {
                    mode: pageMode
                }
            });
            else experienceTracker.start({
                name: (0, $irVI7.EDIT_INLINE_COMMENT_PUBLISH_EXPERIENCE),
                timeout: (0, $9wGTI.fg)('confluence_frontend_disable_page_comment_timeout') ? (0, $aJPUt.ExperienceTimeout).EDITOR_PUBLISH : undefined,
                attributes: {
                    mode: pageMode
                }
            });
        } else experienceTracker.start({
            name: (0, $irVI7.EDIT_INLINE_COMMENT_PUBLISH_EXPERIENCE),
            timeout: (0, $9wGTI.fg)('confluence_frontend_disable_page_comment_timeout') ? (0, $aJPUt.ExperienceTimeout).EDITOR_PUBLISH : undefined,
            attributes: {
                mode: pageMode
            }
        });
        const adfString = JSON.stringify(adf);
        const variables = {
            input: {
                commentId: commentId,
                commentBody: {
                    value: adfString,
                    representationFormat: (0, $fTFoe.ContentRepresentation).ATLAS_DOC_FORMAT
                }
            }
        };
        const getQuery = ()=>{
            if (isCommentsPanel || isFooterComment) return 0, $jkPJy.CommentsPanelQuery;
            else if (isStandaloneComment && (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment')) return 0, $1C8XP.ActiveInlineCommentsQuery;
            else return 0, $3B9cR.InlineCommentQuery;
        };
        const getQueryVariable = ()=>{
            if (isCommentsPanel || isFooterComment) return {
                pageId: pageId
            };
            else if (isStandaloneComment && (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment')) return {
                inlineMarkerRefList: [
                    annotationId
                ],
                pageId: pageId,
                contentStatus: [
                    'DRAFT',
                    'CURRENT'
                ]
            };
            else return {
                annotationId: annotationId,
                pageId: pageId,
                contentStatus: [
                    'DRAFT',
                    'CURRENT'
                ]
            };
        };
        return updateCommentFn({
            variables: variables,
            update: (cache)=>{
                // readQuery can still return null which complicates TS lint errors with optional chaining
                // once we move to v3 of the apollo client we can move to cache.modify
                try {
                    const dataProxy = cache.readQuery({
                        query: getQuery(),
                        variables: getQueryVariable()
                    });
                    const data = Object.assign({}, dataProxy);
                    let oldComment;
                    // Standalone only has 1 comment so use index 0
                    const idxToUpdate = isCommentsPanel || isFooterComment ? data?.comments?.nodes?.findIndex((n)=>n?.id === commentId) || -1 : 0;
                    if (idxToUpdate === -1) return;
                    // find the comment to update for a reply or the parent comment
                    if (isReply) {
                        // @ts-ignore
                        const replies = data?.comments?.nodes[idxToUpdate].replies ?? [];
                        replies.forEach((reply)=>{
                            // @ts-ignore
                            if (reply?.id === commentId) oldComment = reply;
                        });
                    } else // @ts-ignore
                    oldComment = data?.comments?.nodes[idxToUpdate];
                    if (oldComment) {
                        (0, (/*@__PURE__*/$parcel$interopDefault($lRn1m)))(oldComment, 'body.value', adfString);
                        (0, (/*@__PURE__*/$parcel$interopDefault($lRn1m)))(oldComment, 'version.number', (oldComment.version?.number ?? 0) + 1);
                        (0, (/*@__PURE__*/$parcel$interopDefault($lRn1m)))(oldComment, 'version.when', new Date().toISOString());
                        (0, (/*@__PURE__*/$parcel$interopDefault($lRn1m)))(oldComment, 'version.by.displayName', sessionDisplayName);
                    }
                    cache.writeQuery({
                        query: getQuery(),
                        variables: getQueryVariable(),
                        data: data
                    });
                } catch (error) {
                    $2d789a7ecebf6a19$var$logger.error`An Error occurred when updating cache for edit reply in panel or inline - ${error}`;
                }
                if (commentType === (0, $8i27m.CommentType).GENERAL) (0, $87CZC.updateFooterApolloCacheOnEdit)(commentId, adfString, pageId, isReactionsEnabled, cache, sessionDisplayName);
            }
        }).then(()=>{
            if ((0, $9wGTI.fg)('confluence_frontend_separate_add_page_comment')) {
                if (commentType === (0, $8i27m.CommentType).GENERAL) experienceTracker.succeed({
                    name: (0, $irVI7.EDIT_PAGE_COMMENT_PUBLISH_EXPERIENCE),
                    attributes: {
                        mode: pageMode,
                        type: isReply ? 'reply' : 'topLevel'
                    }
                });
                else experienceTracker.succeed({
                    name: (0, $irVI7.EDIT_INLINE_COMMENT_PUBLISH_EXPERIENCE),
                    attributes: {
                        mode: pageMode,
                        type: isReply ? 'reply' : 'topLevel'
                    }
                });
            } else experienceTracker.succeed({
                name: (0, $irVI7.EDIT_INLINE_COMMENT_PUBLISH_EXPERIENCE),
                attributes: {
                    mode: pageMode,
                    type: isReply ? 'reply' : 'topLevel'
                }
            });
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'updated',
                    actionSubject: 'comment',
                    actionSubjectId: commentId,
                    objectType: pageType,
                    objectId: pageId,
                    source: pageMode === (0, $cD1qu.PageMode).VIEW ? 'viewPageScreen' : 'editPageScreen',
                    attributes: {
                        commentType: commentType,
                        pageType: pageType,
                        navdexPointType: (0, $dEBDF.END),
                        isLivePage: pageMode === (0, $cD1qu.PageMode).LIVE,
                        inlineNodeTypes: getInlineNodeTypes && annotationId ? getInlineNodeTypes(annotationId) : undefined
                    }
                }
            }).fire();
            annotationId && updateCommentBody(commentId, annotationId, adfString, commentType, sessionDisplayName);
            // reset the editor
            onSuccess();
            resetContentChanged();
            displayCommentInViewMode();
        }).catch((error)=>{
            const { message: message } = (0, $isdzP.parseError)(error);
            const translatedError = (0, $isdzP.getTranslatedError)(message, commentId);
            if ((0, $9wGTI.fg)('confluence_frontend_show_already_deleted_flag')) {
                if ((0, $isdzP.isAlreadyDeletedError)(translatedError)) {
                    flags.showWarningFlag({
                        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $2d789a7ecebf6a19$var$i18n.cannotEditTitle),
                        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), translatedError)
                    });
                    experienceTracker.abort({
                        name: (0, $irVI7.EDIT_INLINE_COMMENT_PUBLISH_EXPERIENCE),
                        reason: 'Comment already deleted'
                    });
                }
            }
            if ((0, $isdzP.isUnexpectedError)(translatedError)) experienceTracker.stopOnError({
                name: (0, $irVI7.EDIT_INLINE_COMMENT_PUBLISH_EXPERIENCE),
                error: error
            });
            else // These errors will not be reported to splunk/signalfx through experience tracking as they are expected
            (0, $7Sm4c.markErrorAsHandled)(error);
            return Promise.reject({
                error: translatedError
            });
        });
    };
    let parsedContent = undefined;
    try {
        parsedContent = JSON.parse(content);
    } catch (e) {
        $2d789a7ecebf6a19$var$logger.error`Unable to parse content ADF, ${e}`;
    }
    const showBranchingStyle = isFooterComment && isReply;
    // Create a wrapper for the editor component. If we have a branching style, the wrapper needs to use withBranchingStyle, otherwise just return as normal
    const BranchingStyleWrapper = (0, $gwFzn.useCallback)(({ children: children })=>{
        return showBranchingStyle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1Sjzs.WithCurvedBranchingStyle), {
            showDefaultStyles: true,
            customStyles: {
                // If we don't have children, line up with the author
                // If we do have children, line up with the bottom of the editor toolbar
                height: adjustForFooterReplies ? '25px' : '90px',
                left: isLastNestedFooterReply ? '-24px' : '-25px'
            }
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children);
    }, [
        showBranchingStyle,
        adjustForFooterReplies,
        isLastNestedFooterReply
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(BranchingStyleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: [
            $2d789a7ecebf6a19$var$editorContainerStyle,
            isFooterComment && $2d789a7ecebf6a19$var$editorContainerForFooterWrapperStyle
        ],
        "data-cy": "editor-edit-container",
        ref: commentContainerElementRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $daq5m.CommentAuthor), {
        commentMode: "edit",
        userId: userId,
        displayName: displayName,
        avatarUrl: avatarUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: [
            isFooterComment && $2d789a7ecebf6a19$var$editorBottomPaddingStyle,
            adjustForFooterReplies && $2d789a7ecebf6a19$var$editorContainerForFooterExtraLeftPaddingWithBorderStyle
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hXzKU.LazyCommentEditor), {
        pageId: pageId,
        pageType: pageType,
        spaceId: spaceId,
        appearance: isFooterComment ? 'comment' : 'chromeless',
        EditorComponent: isFooterComment ? (0, $lesF8.CommentEditor) : (0, $7EEGh.ChromelessEditor),
        commentMode: "edit",
        commentType: mode === 'view' ? 'inline' : 'edit-inline',
        onSaveComment: handleUpdateComment,
        content: parsedContent,
        onCancelComment: handleOnCancel,
        onContentChange: onChange,
        showCancelButton: true,
        useNewWarningModal: true,
        onEditorReady: handleOnEditorReady,
        hideWatchCheckbox: true,
        isFooterComment: isFooterComment,
        pageMode: mode,
        hasMediaUploadPermissions: hasMediaUploadPermissions,
        commentContainerElementRef: commentContainerElementRef,
        isStandaloneComment: isStandaloneComment
    }))));
};
const $2d789a7ecebf6a19$export$55ec0e499a2afded = (0, $7aRa9.withFlags)($2d789a7ecebf6a19$var$EditCommentComponent);

});
parcelRegister("jkPJy", function(module, exports) {

$parcel$export(module.exports, "CommentsPanelQuery", () => $eea05c4e9d0eb879$export$9e679b96e845bbef);

var $d2LG0 = parcelRequire("d2LG0");

var $hpsMA = parcelRequire("hpsMA");
const $eea05c4e9d0eb879$export$9e679b96e845bbef = (0, $d2LG0.default)`query CommentsPanelQuery($pageId:ID!){comments(pageId:$pageId type:UNRESOLVED depth:ROOT first:50){nodes{...inlineCommentFragment createdAt{value}createdAtNonLocalized replies{...inlineCommentFragment createdAt{value}createdAtNonLocalized}}totalCount}}${(0, $hpsMA.inlineCommentFragment)}`;

});

parcelRegister("fTFoe", function(module, exports) {

$parcel$export(module.exports, "ContentRepresentation", () => $d6487e78194ebc92$export$f4016897b165b6d5);
/**
 * @generated SignedSource<<32f19d06fa6672a3c37f0c760c31cf28>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/ var $d6487e78194ebc92$export$f4016897b165b6d5 = /*#__PURE__*/ function(ContentRepresentation) {
    ContentRepresentation["ATLAS_DOC_FORMAT"] = "ATLAS_DOC_FORMAT";
    ContentRepresentation["EDITOR"] = "EDITOR";
    ContentRepresentation["EDITOR2"] = "EDITOR2";
    ContentRepresentation["EXPORT_VIEW"] = "EXPORT_VIEW";
    ContentRepresentation["PLAIN"] = "PLAIN";
    ContentRepresentation["RAW"] = "RAW";
    ContentRepresentation["STORAGE"] = "STORAGE";
    ContentRepresentation["STYLED_VIEW"] = "STYLED_VIEW";
    ContentRepresentation["VIEW"] = "VIEW";
    ContentRepresentation["WIKI"] = "WIKI";
    return ContentRepresentation;
}({});

});


parcelRegister("8z9UY", function(module, exports) {

$parcel$export(module.exports, "CommentDeletionLocation", () => $651b67533e11f043$export$26bc7a3bb70e176c);
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $651b67533e11f043$export$26bc7a3bb70e176c = /*#__PURE__*/ function(CommentDeletionLocation) {
    CommentDeletionLocation["EDITOR"] = "EDITOR";
    CommentDeletionLocation["LIVE"] = "LIVE";
    return CommentDeletionLocation;
}({});

});

parcelRegister("6Ebso", function(module, exports) {

$parcel$export(module.exports, "DeleteInlineCommentMutation", () => $9d5f2b2aa1f9b17f$export$549cff8431cdc668);

var $d2LG0 = parcelRequire("d2LG0");
const $9d5f2b2aa1f9b17f$export$549cff8431cdc668 = (0, $d2LG0.default)`mutation DeleteInlineCommentMutation($commentIdToDelete:ID!$deleteFrom:CommentDeletionLocation){deleteComment(commentIdToDelete:$commentIdToDelete deleteFrom:$deleteFrom)}`;

});

parcelRegister("2Ntx6", function(module, exports) {

$parcel$export(module.exports, "DeleteInlineCommentMutationWithStep", () => $76a7717235c05655$export$d6887adb8bc38627);

var $d2LG0 = parcelRequire("d2LG0");
const $76a7717235c05655$export$d6887adb8bc38627 = (0, $d2LG0.default)`mutation DeleteInlineCommentMutationWithStep($input:DeleteInlineCommentInput!){deleteInlineComment(input:$input)}`;

});

parcelRegister("5olRs", function(module, exports) {

$parcel$export(module.exports, "ReopenCommentMutation", () => $c186ae5815726105$export$b4833f22c25c301b);

var $d2LG0 = parcelRequire("d2LG0");
const $c186ae5815726105$export$b4833f22c25c301b = (0, $d2LG0.default)`mutation ReopenCommentMutation($commentId:ID!$cloudId:ID!){confluence_reopenComment(commentId:$commentId cloudId:$cloudId){success commentResolutionStates{commentId status}errors{message extensions{...on ReopenCommentsMutationErrorExtension{errorType statusCode}__typename}}}}`;

});

parcelRegister("dhKx6", function(module, exports) {

$parcel$export(module.exports, "ResolveInlineCommentMutation", () => $219365be6e8283d5$export$26ef11a105bd81d);

var $d2LG0 = parcelRequire("d2LG0");
const $219365be6e8283d5$export$26ef11a105bd81d = (0, $d2LG0.default)`mutation ResolveInlineCommentMutation($commentId:ID!$resolved:Boolean!){resolveInlineComment(commentId:$commentId resolved:$resolved dangling:false){status resolveProperties{resolved resolvedUser isDangling resolvedFriendlyDate resolvedTime}}}`;

});

parcelRegister("8WQTF", function(module, exports) {

$parcel$export(module.exports, "RendererActionsProvider", () => $4677820b18a14e4d$export$a41bfe8d4028fb59);
$parcel$export(module.exports, "useRendererActions", () => $4677820b18a14e4d$export$55249bdd00e8a5d6);
$parcel$export(module.exports, "useRendererActionsDispatch", () => $4677820b18a14e4d$export$6e9863dfedeaae60);

var $gwFzn = parcelRequire("gwFzn");
const $4677820b18a14e4d$export$66feffbad722f9d4 = /*#__PURE__*/ (0, $gwFzn.createContext)({
    rendererActions: null
});
$4677820b18a14e4d$export$66feffbad722f9d4.displayName = 'RendererActionsContext';
const $4677820b18a14e4d$export$c7c5640cf8aff722 = /*#__PURE__*/ (0, $gwFzn.createContext)({
    setRendererActions: ()=>{}
});
$4677820b18a14e4d$export$c7c5640cf8aff722.displayName = 'RendererActionsDispatchContext';
const $4677820b18a14e4d$export$a41bfe8d4028fb59 = ({ children: children })=>{
    const [rendererActions, setRendererActions] = (0, $gwFzn.useState)(null);
    const providerValue = (0, $gwFzn.useMemo)(()=>({
            rendererActions: rendererActions
        }), [
        rendererActions
    ]);
    const dispatchProviderValue = (0, $gwFzn.useMemo)(()=>({
            setRendererActions: setRendererActions
        }), [
        setRendererActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4677820b18a14e4d$export$66feffbad722f9d4.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4677820b18a14e4d$export$c7c5640cf8aff722.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $4677820b18a14e4d$export$55249bdd00e8a5d6 = ()=>{
    return (0, $gwFzn.useContext)($4677820b18a14e4d$export$66feffbad722f9d4);
};
const $4677820b18a14e4d$export$6e9863dfedeaae60 = ()=>{
    return (0, $gwFzn.useContext)($4677820b18a14e4d$export$c7c5640cf8aff722);
};

});

parcelRegister("h5M1u", function(module, exports) {

$parcel$export(module.exports, "DeleteGeneralCommentMutation", () => $7746316426ba5b6a$export$f39bc72029cff350);

var $d2LG0 = parcelRequire("d2LG0");
const $7746316426ba5b6a$export$f39bc72029cff350 = (0, $d2LG0.default)`mutation DeleteGeneralCommentMutation($commentIdToDelete:ID!$deleteFrom:CommentDeletionLocation){deleteComment(commentIdToDelete:$commentIdToDelete deleteFrom:$deleteFrom)}`;

});

parcelRegister("3BI2p", function(module, exports) {

$parcel$export(module.exports, "WhiteboardResolvedCommentContext", () => $564a9c647fe91d8f$export$20640a5300663a9b);
$parcel$export(module.exports, "WhiteboardResolvedCommentProvider", () => $564a9c647fe91d8f$export$c578ecc900dc205);

var $gwFzn = parcelRequire("gwFzn");
const $564a9c647fe91d8f$export$20640a5300663a9b = /*#__PURE__*/ (0, $gwFzn.createContext)({
    onReopenCommentCallback: ()=>{}
});
const $564a9c647fe91d8f$export$c578ecc900dc205 = ({ callback: callback, children: children })=>{
    const contextValue = (0, $gwFzn.useMemo)(()=>({
            onReopenCommentCallback: callback
        }), [
        callback
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($564a9c647fe91d8f$export$20640a5300663a9b.Provider, {
        value: contextValue
    }, children);
};

});


parcelRegister("6Yerd", function(module, exports) {

$parcel$export(module.exports, "RepliesToggler", () => $c266473b218a2e87$export$fa25a7ffef408bc8);
/* RepliesToggler.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $bUlM5 = parcelRequire("bUlM5");
var $2W0qg = parcelRequire("2W0qg");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $6kv9e = parcelRequire("6kv9e");

var $gcvXg = parcelRequire("gcvXg");

var $2Pg7f = parcelRequire("2Pg7f");

var $ccHMk = parcelRequire("ccHMk");

var $8i27m = parcelRequire("8i27m");

var $9wGTI = parcelRequire("9wGTI");

var $1Sjzs = parcelRequire("1Sjzs");

var $3mVfX = parcelRequire("3mVfX");

var $en1dX = parcelRequire("en1dX");

var $7qvmT = parcelRequire("7qvmT");
const $c266473b218a2e87$var$repliesTogglerStyles = {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    height: '24px',
    left: 0
};
const $c266473b218a2e87$var$repliesTogglerBranchingStyle = null;
const $c266473b218a2e87$var$replyBranchUnsetHeight = null;
const $c266473b218a2e87$var$repliesTogglerBranchingStyleWithoutReply = null;
const $c266473b218a2e87$var$replyWrapperWithSpacingStyles = {
    paddingTop: "var(--ds-space-100, 8px)",
    paddingBottom: "var(--ds-space-100, 8px)",
    left: 0
};
const $c266473b218a2e87$var$unreadIndicatorStyle = (0, $ecnYn.xcss)({
    alignItems: 'center',
    gap: 'space.075'
});
const $c266473b218a2e87$var$pressableStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtle',
    backgroundColor: 'color.background.neutral.subtle',
    paddingTop: 'space.050',
    paddingBottom: 'space.050',
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    borderRadius: 'border.radius.100',
    userSelect: 'none',
    fontWeight: "var(--ds-font-weight-medium, 500)",
    ':hover': {
        cursor: 'pointer',
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
}); // This snippet is being used in CommentBody.tsx
const $c266473b218a2e87$var$dotStyles = null;
const $c266473b218a2e87$var$i18n = (0, $2nPZH.defineMessages)({
    commentsPanelHideRepliesText: {
        id: "comments-panel.comment-thread.hide.replies",
        defaultMessage: "Hide replies"
    },
    commentsPanelHideReplyText: {
        id: "comments-panel.comment-thread.hide.reply",
        defaultMessage: "Hide reply"
    },
    commentsPanelShowMoreRepliesText: {
        id: "comments-panel.comment-thread.show.more.replies",
        defaultMessage: "Show {numOfHiddenReplies, plural, one {# more reply} other {# more replies}}"
    },
    commentsPanelShowMoreRepliesTextForStandalone: {
        id: "comments-panel.comment-thread.show.more.replies.for.standalone",
        defaultMessage: "{numOfHiddenReplies, plural, one {# more reply} other {# more replies}}"
    },
    commentsPanelShowReplyText: {
        id: "comments-panel.comment-thread.show.reply",
        defaultMessage: "Show reply"
    }
});
const $c266473b218a2e87$var$withLeftMargin = null;
const $c266473b218a2e87$export$fa25a7ffef408bc8 = ({ replies: replies, setVisibleReplies: setVisibleReplies, unreadReplyIds: unreadReplyIds, setReplyView: setReplyView, threadKey: threadKey, currentReplyView: currentReplyView, numOfHiddenReplies: numOfHiddenReplies, commentType: commentType, parentCommentId: parentCommentId, isParentOpen: isParentOpen, canAddComments: canAddComments, shouldShowLatestReplies: shouldShowLatestReplies, setShouldShowLatestReplies: setShouldShowLatestReplies, latestReplyIds: latestReplyIds, isStandaloneComment: isStandaloneComment = false })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [{ commentsMarkedAsRead: commentsMarkedAsRead }, { setCommentsInThreadToBeMarkedAsRead: setCommentsInThreadToBeMarkedAsRead }] = (0, $3mVfX.useCommentsPanel)(); // for the unread indicator, we only want to render it if there are any hidden unread
    const unreadRepliesNotMarkedAsRead = (0, $gwFzn.useMemo)(()=>{
        return unreadReplyIds.filter((replyId)=>{
            const markedReplies = commentsMarkedAsRead[commentType][threadKey]; // Check if the reply id is not in the markedReplies set
            return !markedReplies || !markedReplies.has(replyId);
        });
    }, [
        unreadReplyIds,
        commentsMarkedAsRead,
        threadKey,
        commentType
    ]); // considers replies marked as read due to hiding/showing replies
    const hasHiddenUnreadReplies = unreadRepliesNotMarkedAsRead.filter((replyId)=>!latestReplyIds.has(replyId)).length > 0;
    const maxProfilePicturesToShow = 3;
    const currentNumOfHiddenReplies = (0, $9wGTI.fg)('confluence_frontend_cp_visible_replies_refactor') ? (0, $7qvmT.getNumOfHiddenReplies)({
        replies: replies,
        latestReplyIds: latestReplyIds,
        currentReplyView: currentReplyView
    }) : numOfHiddenReplies.current;
    const shouldShowHideRepliesToggle = currentNumOfHiddenReplies > 0;
    const shouldShowProfilePictures = currentReplyView !== (0, $7qvmT.ViewReplyOptions).ALL && shouldShowHideRepliesToggle;
    const shouldShowShortenedBranchStyles = !isParentOpen && shouldShowHideRepliesToggle;
    const hiddenReplies = replies.filter((reply)=>!shouldShowLatestReplies || !isParentOpen ? true : !latestReplyIds.has(reply.id)); // filter out duplicate authors when we're showing the profile pictures
    const getProfilePicturesOfHiddenReplies = (repliesToFilter)=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2')) return [];
        const uniqueAccountsMap = new Map(); // Start from the end of the list and move backwards
        for(let i = repliesToFilter.length - 1; i >= 0; i--){
            const reply = repliesToFilter[i];
            const { displayName: displayName, profilePicture: profilePicture } = reply.author; // Determine if the author has an accountId, anonymous users don't have accountId
            let uniqueKey;
            if ('accountId' in reply.author && reply.author.accountId) uniqueKey = reply.author.accountId;
            else // Fallback for anonymous users or if accountId is not present
            uniqueKey = `anonymous-${i}`;
            if (!uniqueAccountsMap.has(uniqueKey)) uniqueAccountsMap.set(uniqueKey, {
                displayName: displayName ?? '',
                profilePicturePath: profilePicture?.path
            });
        }
        return Array.from(uniqueAccountsMap.values());
    };
    const profilePicturesHiddenReplies = (0, $gwFzn.useRef)(shouldShowProfilePictures ? getProfilePicturesOfHiddenReplies(hiddenReplies) : []);
    const showHiddenReplies = (0, $gwFzn.useCallback)((event)=>{
        event.stopPropagation();
        setReplyView((0, $7qvmT.ViewReplyOptions).ALL);
        if (!(0, $9wGTI.fg)('confluence_frontend_cp_visible_replies_refactor')) {
            if (commentType === (0, $8i27m.CommentType).GENERAL && (0, $9wGTI.fg)('confluence-frontend-comments-panel-design-update')) {
                const topLevelReplyIds = new Set(replies.filter((reply)=>reply.parentId === parentCommentId).map((reply)=>reply.id));
                const visibleReplies = replies.filter((reply)=>topLevelReplyIds.has(reply.id));
                setVisibleReplies(visibleReplies);
            } else setVisibleReplies(replies);
            numOfHiddenReplies.current = 0;
        }
        profilePicturesHiddenReplies.current = [];
    }, [
        setReplyView,
        commentType,
        numOfHiddenReplies,
        replies,
        setVisibleReplies,
        parentCommentId
    ]);
    const hideReplies = (0, $gwFzn.useCallback)((event)=>{
        event.stopPropagation();
        if ((0, $9wGTI.fg)('confluence_frontend_cp_visible_replies_refactor')) setReplyView((0, $7qvmT.ViewReplyOptions).HIDDEN);
        else {
            setReplyView((0, $7qvmT.ViewReplyOptions).DEFAULT);
            setVisibleReplies([]);
            setShouldShowLatestReplies(false);
            numOfHiddenReplies.current = replies.length;
        } // all unread replies will be marked as read
        setCommentsInThreadToBeMarkedAsRead({
            threadKey: threadKey,
            commentIds: unreadReplyIds,
            commentType: commentType
        }); // all replies will be considered
        profilePicturesHiddenReplies.current = getProfilePicturesOfHiddenReplies(replies);
    }, [
        threadKey,
        replies,
        setReplyView,
        setVisibleReplies,
        setCommentsInThreadToBeMarkedAsRead,
        unreadReplyIds,
        numOfHiddenReplies,
        commentType,
        setShouldShowLatestReplies
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        className: (0, $35pXk.default)([
            replies.length > 0 && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && (canAddComments || currentNumOfHiddenReplies === 0) && "_kqswh2mm _1n1jqcao _1kt9b3bt _1cs8stnw _qnecidpf _1aukidpf _kfgt1wqb",
            replies.length > 0 && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && shouldShowShortenedBranchStyles && "_kfgtgktf",
            replies.length > 0 && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && currentReplyView === (0, $7qvmT.ViewReplyOptions).HIDDEN && isStandaloneComment && (0, $9wGTI.fg)('confluence-frontend-redesigned-standalone-comment') && "_kfgtn7od"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1Sjzs.WithCurvedBranchingStyle), {
        testId: "comments-panel-replies-toggler-container",
        showDefaultStyles: replies.length > 0 && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2'),
        disableLeftProp: true,
        customStyles: {
            ...$c266473b218a2e87$var$repliesTogglerStyles,
            ...(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? $c266473b218a2e87$var$replyWrapperWithSpacingStyles : {}
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        className: (0, $35pXk.default)([
            "_18u0utpp"
        ])
    }, shouldShowHideRepliesToggle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2W0qg.default), {
        onClick: showHiddenReplies,
        testId: "comments-panel-thread-show-hidden-replies",
        analyticsContext: {
            attributes: {
                name: 'showHiddenReplies',
                source: isStandaloneComment ? (0, $en1dX.AnalyticsSource).STANDALONE : (0, $en1dX.AnalyticsSource).COMMENTS_PANEL,
                commentType: commentType,
                hasHiddenUnreadReplies: hasHiddenUnreadReplies,
                numOfHiddenReplies: currentNumOfHiddenReplies,
                numOfReplies: replies.length
            }
        },
        xcss: $c266473b218a2e87$var$pressableStyles,
        interactionName: "comments-panel-thread-show-hidden-replies"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        gap: isStandaloneComment ? 'space.150' : 'space.050'
    }, shouldShowProfilePictures && profilePicturesHiddenReplies.current.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Pg7f.default), {
        data: profilePicturesHiddenReplies.current.map((profilePicturesInfo)=>({
                name: profilePicturesInfo.displayName,
                src: profilePicturesInfo.profilePicturePath
            })),
        maxCount: maxProfilePicturesToShow,
        appearance: "stack",
        size: "small",
        shouldPopupRenderToParent: true,
        testId: "replies-toggler-profile-pictures"
    }), !(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6kv9e))), {
        spacing: "compact",
        label: "show-more-replies-button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        xcss: $c266473b218a2e87$var$unreadIndicatorStyle
    }, replies.length === 1 ? formatMessage($c266473b218a2e87$var$i18n.commentsPanelShowReplyText) : isStandaloneComment ? formatMessage($c266473b218a2e87$var$i18n.commentsPanelShowMoreRepliesTextForStandalone, {
        numOfHiddenReplies: currentNumOfHiddenReplies
    }) : formatMessage($c266473b218a2e87$var$i18n.commentsPanelShowMoreRepliesText, {
        numOfHiddenReplies: currentNumOfHiddenReplies
    }), hasHiddenUnreadReplies && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
        "data-testid": "comments-panel-unread-comment-replies-indicator",
        className: (0, $35pXk.default)([
            "_2rko1ssb _18s81b66 _4t3iu2gc _1bsbu2gc _bfhkb29m"
        ])
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
        onClick: hideReplies,
        testId: "comments-panel-thread-hide-replies",
        appearance: "subtle",
        analyticsContext: {
            attributes: {
                name: 'hideReplies',
                source: isStandaloneComment ? (0, $en1dX.AnalyticsSource).STANDALONE : (0, $en1dX.AnalyticsSource).COMMENTS_PANEL,
                commentType: commentType,
                numOfReplies: replies.length
            }
        },
        interactionName: "comments-panel-thread-hide-replies"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        gap: "space.050"
    }, !(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gcvXg))), {
        spacing: "compact",
        label: "hide-replies-button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        color: "color.text",
        size: "medium",
        weight: "medium"
    }, replies.length === 1 ? formatMessage($c266473b218a2e87$var$i18n.commentsPanelHideReplyText) : formatMessage($c266473b218a2e87$var$i18n.commentsPanelHideRepliesText)))))));
};

});

parcelRegister("4XQdd", function(module, exports) {

$parcel$export(module.exports, "GeneralReplyScroller", () => $798de2a5d72f0afa$export$a0769df2292690a8);
/* GeneralReplyScroller.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $bUlM5 = parcelRequire("bUlM5");
var $2W0qg = parcelRequire("2W0qg");
var $ecnYn = parcelRequire("ecnYn");

var $2Pg7f = parcelRequire("2Pg7f");

var $1Sjzs = parcelRequire("1Sjzs");

var $fURMF = parcelRequire("fURMF");
const $798de2a5d72f0afa$var$replyScrollerStyles = {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    height: '24px',
    marginTop: "var(--ds-space-150, 12px)",
    left: 0
};
const $798de2a5d72f0afa$var$replyScrollerBranchingStyle = null;
const $798de2a5d72f0afa$var$replyWrapperWithSpacingStyles = {
    paddingTop: "var(--ds-space-100, 8px)"
};
const $798de2a5d72f0afa$var$leftMargin = null;
const $798de2a5d72f0afa$var$unreadIndicatorStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center'
}); // This snippet is being used in CommentBody.tsx
const $798de2a5d72f0afa$var$dotStyles = null;
const $798de2a5d72f0afa$var$pressableStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtle',
    backgroundColor: 'color.background.neutral.subtle',
    paddingTop: 'space.050',
    paddingBottom: 'space.050',
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    borderRadius: 'border.radius.100',
    userSelect: 'none',
    fontWeight: "var(--ds-font-weight-medium, 500)",
    ':hover': {
        cursor: 'pointer',
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $798de2a5d72f0afa$var$i18n = (0, $2nPZH.defineMessages)({
    commentsPanelShowGeneralNestedReplies: {
        id: "comments-panel.comment-thread.go.to.nested.general.reply",
        defaultMessage: "Go to more replies"
    },
    commentsPanelGeneralNestedRepliesHasUnread: {
        id: "comments-panel.comment-thread.general.nested.replies.has.unread",
        defaultMessage: "There are unread replies"
    }
});
const $798de2a5d72f0afa$export$a0769df2292690a8 = ({ nestedReplies: nestedReplies, unreadReplyIds: unreadReplyIds, targetCommentIdForScroll: targetCommentIdForScroll })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const maxProfilePicturesToShow = 3; // If any of the nestedReplies match an ID in unreadReplyIds, render the blue dot indicator
    const unreadReplyIdsSet = new Set(unreadReplyIds);
    const shouldRenderBlueDotIndicator = nestedReplies.some((reply)=>unreadReplyIdsSet.has(reply.id));
    const avatarsToShow = (0, $gwFzn.useMemo)(()=>{
        const uniqueAccountsMap = new Map(); // Start from the end of the list and move backwards
        for(let i = nestedReplies.length - 1; i >= 0; i--){
            const reply = nestedReplies[i];
            const { displayName: displayName, profilePicture: profilePicture } = reply.author; // Determine if the author has an accountId, anonymous users don't have accountId
            let uniqueKey;
            if ('accountId' in reply.author && reply.author.accountId) uniqueKey = reply.author.accountId;
            else // Fallback for anonymous users or if accountId is not present
            uniqueKey = `anonymous-${i}`;
            if (!uniqueAccountsMap.has(uniqueKey)) uniqueAccountsMap.set(uniqueKey, {
                displayName: displayName ?? '',
                profilePicturePath: profilePicture?.path
            });
        }
        const avatars = Array.from(uniqueAccountsMap.values());
        const mappedAvatars = avatars.map((profilePicturesInfo)=>({
                name: profilePicturesInfo.displayName,
                src: profilePicturesInfo.profilePicturePath
            }));
        return mappedAvatars;
    }, [
        nestedReplies
    ]);
    // NOTE: This component replicates a lot of the code in RepliesToggler.tsx
    // However, GeneralReplyScroller is only used for multi nested general comment replies for pages created before the single threading general comments feature was introduced
    // All new pages created after this time will use RepliesScroller instead of GeneralReplyScroller
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        className: (0, $35pXk.default)([
            "_kqswh2mm _18u0pxbi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1Sjzs.WithCurvedBranchingStyle), {
        testId: "comments-panel-reply-scroller-container",
        showDefaultStyles: true,
        customStyles: {
            ...$798de2a5d72f0afa$var$replyScrollerStyles,
            ...$798de2a5d72f0afa$var$replyWrapperWithSpacingStyles
        },
        disableLeftProp: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        className: (0, $35pXk.default)([
            "_18u0utpp"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2W0qg.default), {
        onClick: ()=>{
            const commentElement = document.getElementById(`comment-${targetCommentIdForScroll}`);
            if (commentElement) (0, $fURMF.scrollToElement)(commentElement, -75, 'smooth');
        },
        testId: "comments-panel-thread-show-nested-general-replies",
        xcss: $798de2a5d72f0afa$var$pressableStyles,
        interactionName: "comments-panel-thread-show-nested-general-replies"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        gap: "space.050"
    }, avatarsToShow.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Pg7f.default), {
        data: avatarsToShow,
        maxCount: maxProfilePicturesToShow,
        appearance: "stack",
        size: "small",
        shouldPopupRenderToParent: true,
        testId: "comments-panel-replies-scroller-profile-pictures"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        xcss: $798de2a5d72f0afa$var$unreadIndicatorStyle
    }, formatMessage($798de2a5d72f0afa$var$i18n.commentsPanelShowGeneralNestedReplies), shouldRenderBlueDotIndicator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
        "data-testid": "comments-panel-unread-nested-general-replies-indicator",
        "aria-label": formatMessage($798de2a5d72f0afa$var$i18n.commentsPanelGeneralNestedRepliesHasUnread),
        className: (0, $35pXk.default)([
            "_2rko1ssb _18s81b66 _4t3iu2gc _1bsbu2gc _bfhkb29m"
        ])
    }))))))));
};

});




parcelRegister("3hbXQ", function(module, exports) {

$parcel$export(module.exports, "EmptyOpenViewSVG", () => $3608976ee61a8e71$export$a1f3770750e6029b);

var $gwFzn = parcelRequire("gwFzn");
const $3608976ee61a8e71$export$a1f3770750e6029b = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("svg", {
        width: "127",
        height: "126",
        viewBox: "0 0 127 126",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M106.207 40.3301H20.793V92.3429H106.207V40.3301Z",
        fill: "#DDDEE1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M63.5002 89.1211L51.5462 91.105C51.5462 91.105 52.6963 96.5711 49.9609 101.497C50.3275 101.529 50.694 101.552 51.0697 101.552C57.9379 101.552 63.5002 95.9847 63.5002 89.1211Z",
        fill: "#DDDEE1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M102.148 43.624C102.331 42.5977 102.427 41.5072 102.427 40.3526C102.427 39.1979 102.331 38.0754 102.143 37.0399C101.034 30.859 96.7366 27.047 90.7161 26.0665C89.6898 25.9015 88.613 25.8145 87.4905 25.8145C86.3221 25.8145 85.1996 25.9061 84.132 26.0848C78.1069 27.0928 73.8184 30.8911 72.705 37.0399C72.5171 38.08 72.4209 39.1842 72.4209 40.3526C72.4209 41.5072 72.5171 42.5977 72.7004 43.624C73.8046 49.7636 78.0932 53.5711 84.132 54.5791C85.1996 54.7578 86.3221 54.8494 87.4905 54.8494C88.613 54.8494 89.6898 54.7624 90.7161 54.5974C96.7458 53.6169 101.048 49.8003 102.148 43.624Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M102.148 43.624C102.331 42.5976 102.427 41.5072 102.427 40.3525H72.4209C72.4209 41.5072 72.5171 42.5976 72.7004 43.624C73.8046 49.7636 78.0932 53.5711 84.132 54.5791C85.1996 54.7578 86.3221 54.8494 87.4905 54.8494C88.613 54.8494 89.6898 54.7624 90.7161 54.5974C96.7458 53.6169 101.048 49.8002 102.148 43.624Z",
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M97.1444 42.7668H77.6992V39.5596H97.1444V42.7668Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M85.8184 50.8863V31.4365H89.0256V50.8863H85.8184Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M95.5865 61.3508H31.4136V58.1436H95.5865V61.3508Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M95.5865 70.217H31.4136V67.0098H95.5865V70.217Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M79.3577 79.0784H31.4136V75.8711H79.3577V79.0784Z",
        fill: "white"
    }));
};

});

parcelRegister("fVvcP", function(module, exports) {

$parcel$export(module.exports, "useDanglingOperations", () => $1b76c02cdf5fdb1f$export$46ce0a09006fb8b7);

var $gwFzn = parcelRequire("gwFzn");

var $bQm3c = parcelRequire("bQm3c");

var $9wGTI = parcelRequire("9wGTI");

var $gCV7N = parcelRequire("gCV7N");
const $1b76c02cdf5fdb1f$export$46ce0a09006fb8b7 = ({ orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, commentsDataMap: commentsDataMap, setCommentsDataMap: setCommentsDataMap })=>{
    const processedMarkerRefsForMark = (0, $gwFzn.useRef)(new Set());
    const processedMarkerRefsForUnmark = (0, $gwFzn.useRef)(new Set());
    const annotationsSet = (0, $gwFzn.useMemo)(()=>new Set(orderedActiveAnnotationIdList.map((item)=>item.threadKey)), [
        orderedActiveAnnotationIdList
    ]);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { markCommentAsDangling: markCommentAsDangling, unmarkCommentAsDangling: unmarkCommentAsDangling, commentDanglingRef: commentDanglingRef } = (0, $gCV7N.useDanglingComments)({
        updatedCommentsDataMap: commentsDataMap,
        setCommentsDataMap: setCommentsDataMap
    });
    const handleMarkCommentAsDangling = (0, $gwFzn.useCallback)((commentThreadId, markerRef)=>{
        commentDanglingRef.current = markerRef;
        return markCommentAsDangling({
            variables: {
                input: {
                    id: commentThreadId
                },
                cloudId: cloudId
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        markCommentAsDangling,
        cloudId
    ]);
    const handleUnmarkCommentAsDangling = (0, $gwFzn.useCallback)((commentThreadId, markerRef)=>{
        commentDanglingRef.current = markerRef;
        return unmarkCommentAsDangling({
            variables: {
                input: {
                    id: commentThreadId
                },
                cloudId: cloudId
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        unmarkCommentAsDangling,
        cloudId
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_dangling_comments')) {
            const processDanglingComments = async ()=>{
                for(const threadKey in commentsDataMap.inline){
                    const commentThread = commentsDataMap.inline[threadKey];
                    const isDanglingComment = commentThread?.location?.inlineResolveProperties?.isDangling;
                    if (commentThread?.isOpen) {
                        // if the comment is already dangling, check if it's in the annotations set and unmark it if it is
                        if (isDanglingComment) {
                            const markerRef = commentThread?.location?.inlineMarkerRef;
                            if (markerRef && annotationsSet.has(markerRef) && !processedMarkerRefsForUnmark.current.has(markerRef)) {
                                const result = await handleUnmarkCommentAsDangling(commentThread.id, markerRef);
                                if (result?.data?.confluence_unmarkCommentAsDangling?.success) processedMarkerRefsForUnmark.current.add(markerRef);
                            }
                            continue;
                        }
                        // check for real time dangling comments
                        const markerRef = commentThread?.location?.inlineMarkerRef;
                        // comment is dangling if it has a marker ref and is not in the annotations set
                        // deleted and resolved comments are not in commentsDataMap so we know it's only dangling scenario
                        if (markerRef && !annotationsSet.has(markerRef) && !processedMarkerRefsForMark.current.has(markerRef)) {
                            const result = await handleMarkCommentAsDangling(commentThread.id, markerRef);
                            if (result?.data?.confluence_markCommentAsDangling?.success) processedMarkerRefsForMark.current.add(markerRef);
                        }
                    }
                }
                // reset the sets for the next run
                processedMarkerRefsForMark.current = new Set();
                processedMarkerRefsForUnmark.current = new Set();
            };
            processDanglingComments();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        handleMarkCommentAsDangling,
        handleUnmarkCommentAsDangling,
        annotationsSet
    ]);
    return {
        annotationsSet: annotationsSet
    };
};

});
parcelRegister("gCV7N", function(module, exports) {

$parcel$export(module.exports, "useDanglingComments", () => $6e77aca6583a610f$export$5863d0e03409914a);
/** @graphql cc **/ 
var $diswb = parcelRequire("diswb");

var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");
// eslint-disable-next-line graphql-relay-compat/consistent-graphql-operation-naming -- Read https://go/connie-relay-migration-fyi
const $6e77aca6583a610f$var$MarkDanglingCommentsMutation = (0, $d2LG0.gql)`mutation MarkDanglingCommentsMutation($input:ConfluenceMarkCommentAsDanglingInput!$cloudId:ID!){confluence_markCommentAsDangling(input:$input cloudId:$cloudId){success errors{message}}}`;
// eslint-disable-next-line graphql-relay-compat/consistent-graphql-operation-naming -- Read https://go/connie-relay-migration-fyi
const $6e77aca6583a610f$var$UnmarkDanglingCommentsMutation = (0, $d2LG0.gql)`mutation UnmarkDanglingCommentsMutation($input:ConfluenceUnmarkCommentAsDanglingInput!$cloudId:ID!){confluence_unmarkCommentAsDangling(input:$input cloudId:$cloudId){success errors{message}}}`;
const $6e77aca6583a610f$export$5863d0e03409914a = ({ updatedCommentsDataMap: updatedCommentsDataMap, setCommentsDataMap: setCommentsDataMap })=>{
    const commentDanglingRef = (0, $gwFzn.useRef)(null);
    const [markCommentAsDangling] = (0, $diswb.useMutation)($6e77aca6583a610f$var$MarkDanglingCommentsMutation, {
        onCompleted: (data)=>{
            if (data?.confluence_markCommentAsDangling?.success) {
                // we have to set isDangling for the comment thread in the commentsDataMap
                const threadKey = commentDanglingRef.current;
                if (!threadKey) return;
                setCommentsDataMap({
                    ...updatedCommentsDataMap,
                    inline: {
                        ...updatedCommentsDataMap.inline,
                        [threadKey]: {
                            ...updatedCommentsDataMap.inline[threadKey],
                            location: {
                                ...updatedCommentsDataMap.inline[threadKey].location,
                                inlineResolveProperties: {
                                    ...updatedCommentsDataMap.inline[threadKey].location.inlineResolveProperties,
                                    isDangling: true
                                }
                            }
                        }
                    }
                });
                commentDanglingRef.current = null;
            }
        },
        onError: ()=>{
        // TODO: handle error, for now it's okay if not since BE will eventually handle the dangling comment
        // we could retry this mutation if we want to
        }
    });
    const [unmarkCommentAsDangling] = (0, $diswb.useMutation)($6e77aca6583a610f$var$UnmarkDanglingCommentsMutation, {
        onCompleted: (data)=>{
            if (data?.confluence_unmarkCommentAsDangling?.success) {
                const threadKey = commentDanglingRef.current;
                if (!threadKey) return;
                setCommentsDataMap({
                    ...updatedCommentsDataMap,
                    inline: {
                        ...updatedCommentsDataMap.inline,
                        [threadKey]: {
                            ...updatedCommentsDataMap.inline[threadKey],
                            location: {
                                ...updatedCommentsDataMap.inline[threadKey].location,
                                inlineResolveProperties: {
                                    ...updatedCommentsDataMap.inline[threadKey].location.inlineResolveProperties,
                                    isDangling: false
                                }
                            }
                        }
                    }
                });
                commentDanglingRef.current = null;
            }
        },
        onError: ()=>{
        // TODO: handle error, for now it's okay if not since BE will eventually handle the dangling comment
        // we could retry this mutation if we want to
        }
    });
    return {
        markCommentAsDangling: markCommentAsDangling,
        unmarkCommentAsDangling: unmarkCommentAsDangling,
        commentDanglingRef: commentDanglingRef
    };
};

});



parcelRegister("2BRez", function(module, exports) {

$parcel$export(module.exports, "UnreadView", () => $c141c7c027f4500c$export$fa61d47fb9e8af00);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $ICFae = parcelRequire("ICFae");

var $dkkKv = parcelRequire("dkkKv");
var $7Oxky = parcelRequire("7Oxky");
var $8i27m = parcelRequire("8i27m");

var $ep3mz = parcelRequire("ep3mz");

var $9wGTI = parcelRequire("9wGTI");

var $i6UMJ = parcelRequire("i6UMJ");
var $3mVfX = parcelRequire("3mVfX");

var $245o4 = parcelRequire("245o4");

var $3Jri8 = parcelRequire("3Jri8");

var $gDWRj = parcelRequire("gDWRj");

var $46CY7 = parcelRequire("46CY7");

var $50DH4 = parcelRequire("50DH4");
const $c141c7c027f4500c$var$i18n = (0, $2nPZH.defineMessages)({
    emptyCommentsHeaderText: {
        id: "comments-panel.empty.unread.comments.header.text",
        defaultMessage: "No unread comments"
    },
    emptyCommentsBodyText: {
        id: "comments-panel.empty.unread.comments.body.text",
        defaultMessage: "Comments you haven\u2019t read yet will appear here."
    }
});
const $c141c7c027f4500c$export$fa61d47fb9e8af00 = ({ showDeleteOption: showDeleteOption, flags: flags })=>{
    const [{ unreadCommentsListState: unreadCommentsListState }] = (0, $ICFae.useUnreadComments)();
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [{ orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, commentsDataMap: commentsDataMap, removedThreadsMap: removedThreadsMap }, { clearRemovedComments: clearRemovedComments }] = (0, $8i27m.useCommentsData)();
    const [{ initialDataLoadedForViewMap: initialDataLoadedForViewMap, showInlineComments: showInlineComments, showGeneralComments: showGeneralComments }, { setInitialDataLoadedForView: setInitialDataLoadedForView }] = (0, $3mVfX.useCommentsPanel)();
    const isInitialCommentDataLoaded = initialDataLoadedForViewMap[(0, $3mVfX.ViewValues).UNREAD];
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const unreadAnnotationsToLoad = (0, $gwFzn.useMemo)(()=>{
        const unreadCommentsThreadKeys = new Set([
            ...unreadCommentsListState.map((unreadComment)=>unreadComment.threadKey)
        ]);
        // Filter and map to get the annotation IDs that need to be loaded
        return orderedActiveAnnotationIdList.filter((annotation)=>!annotation.isLoaded && unreadCommentsThreadKeys.has(annotation.threadKey)).map((annotation)=>annotation.threadKey);
    }, [
        unreadCommentsListState,
        orderedActiveAnnotationIdList
    ]);
    const commentsQueryHook = (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? (0, $dkkKv.useActiveCommentsQuery) : (0, $7Oxky.useActiveInlineCommentsQuery);
    const commentsQueryHookVariables = (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? {
        pageId: contentId || ''
    } : {
        pageId: contentId || '',
        markerRefList: unreadAnnotationsToLoad,
        skip: unreadAnnotationsToLoad.length === 0
    };
    const { loading: loading, error: error, refetch: refetch } = commentsQueryHook(commentsQueryHookVariables);
    (0, $gwFzn.useEffect)(()=>{
        // When this view unmounts, we want to clear out the "resolved"/"deleted" comments
        return ()=>{
            clearRemovedComments();
        };
    }, [
        clearRemovedComments
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!loading) setInitialDataLoadedForView({
            viewToSetLoaded: (0, $3mVfX.ViewValues).UNREAD
        });
    }, [
        loading,
        setInitialDataLoadedForView
    ]);
    // TODO needs improvement: getting the unread comment threads here when the unread view is opened means that
    // the user might be seeing unread comments that they previously read suddenly disappear
    // since we're marking comments as read only when the user changes views
    const commentThreads = (0, $gwFzn.useMemo)(()=>{
        if (!isInitialCommentDataLoaded && loading || orderedActiveAnnotationIdList.length === 0 && Object.keys(commentsDataMap.general).length === 0 && Object.keys(removedThreadsMap.inline).length === 0 && Object.keys(removedThreadsMap.general).length === 0 && unreadCommentsListState.length === 0) return [];
        return (0, $i6UMJ.getUnreadCommentThreads)({
            numUnreadComments: unreadCommentsListState?.length,
            commentsDataMap: commentsDataMap,
            orderedActiveAnnotationIdList: orderedActiveAnnotationIdList,
            removedThreadsMap: removedThreadsMap,
            location: (0, $i6UMJ.LocationValue).PANEL,
            showInlineComments: showInlineComments,
            showGeneralComments: showGeneralComments
        });
    }, [
        loading,
        isInitialCommentDataLoaded,
        commentsDataMap,
        orderedActiveAnnotationIdList,
        removedThreadsMap,
        unreadCommentsListState?.length,
        showInlineComments,
        showGeneralComments
    ]);
    if (!isInitialCommentDataLoaded) {
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $245o4.Loading), null);
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3Jri8.ErrorPanel), {
            error: error,
            onRetryClick: async ()=>{
                await refetch();
            }
        });
    }
    if (commentThreads.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $50DH4.EmptyStateComponent), {
        SVG: (0, $46CY7.EmptyUnreadSVG),
        emptyCommentsHeaderText: formatMessage($c141c7c027f4500c$var$i18n.emptyCommentsHeaderText),
        emptyCommentsBodyText: formatMessage($c141c7c027f4500c$var$i18n.emptyCommentsBodyText)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gDWRj.CommentsPanelList), {
        commentThreads: commentThreads,
        supportedTopLevelActions: showDeleteOption ? [
            'edit',
            'resolve',
            'delete'
        ] : [
            'edit',
            'resolve'
        ],
        flags: flags
    });
};

});
parcelRegister("46CY7", function(module, exports) {

$parcel$export(module.exports, "EmptyUnreadSVG", () => $fcf0a5360ebf589e$export$bed089266f1d2f9);

var $gwFzn = parcelRequire("gwFzn");
const $fcf0a5360ebf589e$export$bed089266f1d2f9 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("svg", {
        width: "127",
        height: "126",
        viewBox: "0 0 127 126",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M106.207 40.3291H20.793V92.3419H106.207V40.3291Z",
        fill: "#DDDEE1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M77.209 27.3555C66.0687 27.3555 57.322 36.0127 54 40.3301C56.2146 44.6587 66.0687 53.3048 77.209 53.3048C88.3493 53.3048 98.2033 44.6476 100.418 40.3301C97.1072 36.0015 88.3493 27.3555 77.209 27.3555ZM77.209 30.9347C82.3988 30.9347 86.6044 35.1403 86.6044 40.3301C86.6044 45.52 82.3988 49.7256 77.209 49.7256C72.0191 49.7256 67.8135 45.52 67.8135 40.3301C67.8135 35.1403 72.0191 30.9347 77.209 30.9347Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M63.5002 89.1211L51.5462 91.105C51.5462 91.105 52.6963 96.5711 49.9609 101.497C50.3275 101.529 50.694 101.552 51.0697 101.552C57.9379 101.552 63.5002 95.9847 63.5002 89.1211Z",
        fill: "#DDDEE1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M95.5865 61.3508H31.4136V58.1436H95.5865V61.3508Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M95.5865 70.217H31.4136V67.0098H95.5865V70.217Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M79.3577 79.0784H31.4136V75.8711H79.3577V79.0784Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M100.417 40.3291H86.6044C86.6044 40.3294 86.6044 40.3298 86.6044 40.3301C86.6044 45.52 82.3988 49.7256 77.209 49.7256C72.0191 49.7256 67.8135 45.52 67.8135 40.3301C67.8135 40.3298 67.8135 40.3294 67.8135 40.3291H54.0008C54.0005 40.3294 54.0003 40.3298 54 40.3301C56.2146 44.6587 66.0687 53.3048 77.209 53.3048C88.3493 53.3048 98.2033 44.6476 100.418 40.3301C100.418 40.3298 100.417 40.3294 100.417 40.3291Z",
        fill: "#09326C"
    }));
};

});


parcelRegister("kTzmM", function(module, exports) {

$parcel$export(module.exports, "ResolvedView", () => $386fb4f759883921$export$856bb247960f11e6);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $3ZsvI = parcelRequire("3ZsvI");
var $8i27m = parcelRequire("8i27m");
var $dNVC1 = parcelRequire("dNVC1");

var $ep3mz = parcelRequire("ep3mz");

var $ICFae = parcelRequire("ICFae");

var $aSsfA = parcelRequire("aSsfA");

var $bQm3c = parcelRequire("bQm3c");

var $aUU0C = parcelRequire("aUU0C");

var $9wGTI = parcelRequire("9wGTI");

var $i6UMJ = parcelRequire("i6UMJ");
var $3mVfX = parcelRequire("3mVfX");
var $6KwrO = parcelRequire("6KwrO");

var $gDWRj = parcelRequire("gDWRj");

var $245o4 = parcelRequire("245o4");

var $3Jri8 = parcelRequire("3Jri8");

var $fXPkn = parcelRequire("fXPkn");

var $50DH4 = parcelRequire("50DH4");

var $adDSj = parcelRequire("adDSj");
const $386fb4f759883921$var$ResolvedViewResolvedInlineCommentsQuery = (0, $d2LG0.default)`query ResolvedViewResolvedInlineCommentsQuery($pageId:ID!$contentStatus:[GraphQLContentStatus!]){comments(pageId:$pageId contentStatus:$contentStatus confluenceCommentFilter:{commentState:RESOLVED commentType:INLINE})@allowHigherTimeout{nodes{id body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui editui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{resolved isDangling resolvedFriendlyDate resolvedTime resolvedUser}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}parentId permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}...on User{accountId}}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{isDangling resolvedTime resolvedFriendlyDate resolvedUser resolved}}}createdAt{value}createdAtNonLocalized replies{id body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui editui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{resolved isDangling resolvedFriendlyDate resolvedTime resolvedUser}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}parentId permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}...on User{accountId}}createdAt{value}createdAtNonLocalized}}totalCount}}`;
const $386fb4f759883921$var$i18n = (0, $2nPZH.defineMessages)({
    emptyCommentsHeaderText: {
        id: "comments-panel.resolved.view.empty.header.text",
        defaultMessage: "No resolved comments"
    },
    emptyCommentsBodyText: {
        id: "comments-panel.resolved.view.empty.text",
        defaultMessage: "Got comments that aren\u2019t needed? Resolve them! They\u2019ll display here, so you can reopen and add them back in the future."
    }
});
const $386fb4f759883921$export$856bb247960f11e6 = ({ flags: flags })=>{
    const [loading, setLoading] = (0, $gwFzn.useState)(true);
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [{ commentsDataMap: commentsDataMap }, { addNewCommentThreads: addNewCommentThreads, setCommentsDataMap: setCommentsDataMap, clearRemovedComments: clearRemovedComments }] = (0, $8i27m.useCommentsData)();
    const [{ readCommentsListState: readCommentsListState }] = (0, $ICFae.useUnreadComments)();
    const [{ annotations: annotations }] = (0, $aUU0C.useEditorAnnotations)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { userId: currentUserId } = (0, $bQm3c.useSessionData)();
    const [{ initialDataLoadedForViewMap: initialDataLoadedForViewMap, showInlineComments: showInlineComments, showGeneralComments: showGeneralComments, currentlySelectedThreadKey: currentlySelectedThreadKey }, { setInitialDataLoadedForView: setInitialDataLoadedForView }] = (0, $3mVfX.useCommentsPanel)();
    const isInitialCommentDataLoaded = initialDataLoadedForViewMap[(0, $3mVfX.ViewValues).RESOLVED];
    const { scrollCommentsPanelToThread: scrollCommentsPanelToThread } = (0, $6KwrO.useCommentsPanelScroll)();
    const annotationsInEditorDoc = (0, $gwFzn.useMemo)(()=>{
        return new Set(annotations);
    }, [
        annotations
    ]);
    /* eslint-disable react-hooks/rules-of-hooks */ const { loading: queryLoading, error: error, refetch: refetch } = (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? (0, $dNVC1.useResolvedCommentsQuery)({
        pageId: contentId || ''
    }) : // eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $j1Ss3.useQuery)($386fb4f759883921$var$ResolvedViewResolvedInlineCommentsQuery, {
        variables: {
            pageId: contentId ?? '',
            contentStatus: [
                (0, $adDSj.GraphQLContentStatus).DRAFT,
                (0, $adDSj.GraphQLContentStatus).CURRENT
            ]
        },
        onCompleted: (data)=>{
            const hasAlreadyFetchedInitialData = Object.keys(commentsDataMap).length > 0;
            (0, $3ZsvI.updateCommentsDataState)({
                data: data,
                readCommentsListState: // Just to coerce this type
                readCommentsListState,
                updateData: hasAlreadyFetchedInitialData ? addNewCommentThreads : setCommentsDataMap,
                annotationsInEditorDoc: annotationsInEditorDoc,
                pageMode: pageMode,
                currentUserId: currentUserId ?? '',
                isOpen: false
            });
            setLoading(false);
        },
        onError: ()=>{
            setLoading(false);
        }
    });
    /* eslint-enable react-hooks/rules-of-hooks */ (0, $gwFzn.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2')) {
            if (queryLoading) setLoading(true);
        } else setLoading(queryLoading);
    }, [
        queryLoading,
        setLoading
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!loading && !isInitialCommentDataLoaded) {
            setInitialDataLoadedForView({
                viewToSetLoaded: (0, $3mVfX.ViewValues).RESOLVED
            });
            // handle focused comment
            if (currentlySelectedThreadKey) scrollCommentsPanelToThread({
                annotationId: currentlySelectedThreadKey,
                isCommentThreadResolved: true
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- ignore change in currentlySelectedThreadKey since we only wan to scroll the first time for focused comments
    }, [
        loading,
        setInitialDataLoadedForView
    ]);
    (0, $gwFzn.useEffect)(()=>{
        // When this view unmounts, we want to clear out the "resolved"/"deleted" comments
        return ()=>{
            clearRemovedComments();
        };
    }, [
        clearRemovedComments
    ]);
    const resolvedThreads = (0, $gwFzn.useMemo)(()=>{
        if (!isInitialCommentDataLoaded && loading) return [];
        return (0, $i6UMJ.getResolvedCommentThreads)({
            commentsDataMap: commentsDataMap,
            showInlineComments: showInlineComments,
            showGeneralComments: showGeneralComments,
            location: (0, $i6UMJ.LocationValue).PANEL
        });
    }, [
        loading,
        isInitialCommentDataLoaded,
        commentsDataMap,
        showInlineComments,
        showGeneralComments
    ]);
    if (!isInitialCommentDataLoaded) {
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $245o4.Loading), null);
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3Jri8.ErrorPanel), {
            error: error,
            onRetryClick: async ()=>{
                await refetch();
            }
        });
    }
    if (resolvedThreads.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $50DH4.EmptyStateComponent), {
        SVG: (0, $fXPkn.EmptyResolvedSVG),
        emptyCommentsHeaderText: formatMessage($386fb4f759883921$var$i18n.emptyCommentsHeaderText),
        emptyCommentsBodyText: formatMessage($386fb4f759883921$var$i18n.emptyCommentsBodyText)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gDWRj.CommentsPanelList), {
        commentThreads: resolvedThreads,
        supportedTopLevelActions: [
            'reopen'
        ],
        flags: flags
    });
};

});
parcelRegister("dNVC1", function(module, exports) {

$parcel$export(module.exports, "useResolvedCommentsQuery", () => $7d095cbe42572b58$export$aa2bd4203d25d1e0);

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $7Sm4c = parcelRequire("7Sm4c");

var $ICFae = parcelRequire("ICFae");

var $bQm3c = parcelRequire("bQm3c");

var $aSsfA = parcelRequire("aSsfA");

var $aUU0C = parcelRequire("aUU0C");

var $1khXm = parcelRequire("1khXm");

var $8i27m = parcelRequire("8i27m");

var $3ZsvI = parcelRequire("3ZsvI");
const $7d095cbe42572b58$export$aa2bd4203d25d1e0 = ({ pageId: pageId, skip: skip = false })=>{
    // The query loading was not sticking around long enough or triggering at the right times
    // so I created a loading state that will set after the query is successful/fails
    const [loading, setLoading] = (0, $gwFzn.useState)(true);
    const [{ commentsDataMap: commentsDataMap }, { addNewCommentThreads: addNewCommentThreads, setCommentsDataMap: setCommentsDataMap }] = (0, $8i27m.useCommentsData)();
    const [{ readCommentsListState: readCommentsListState }] = (0, $ICFae.useUnreadComments)();
    const [{ annotations: annotations }] = (0, $aUU0C.useEditorAnnotations)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { userId: currentUserId } = (0, $bQm3c.useSessionData)();
    const annotationsInEditorDoc = (0, $gwFzn.useMemo)(()=>{
        return new Set(annotations);
    }, [
        annotations
    ]);
    // Determine if the query should be skipped
    const skipQuery = !pageId || skip;
    const hasAlreadyFetchedInitialData = Object.keys(commentsDataMap.inline).length > 0 || Object.keys(commentsDataMap.general).length > 0;
    // Execute the query
    const { data: data, loading: queryLoading, error: error, refetch: refetch } = (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $1khXm.ResolvedCommentsQuery), {
        variables: {
            pageId: pageId,
            contentStatus: [
                'DRAFT',
                'CURRENT'
            ]
        },
        // Skip is not respected after the initial call: https://github.com/apollographql/apollo-client/issues/6190#issuecomment-649933628
        fetchPolicy: skipQuery ? 'cache-only' : 'cache-and-network',
        skip: skipQuery,
        onCompleted: (result)=>{
            (0, $3ZsvI.updateCommentsDataState)({
                data: result,
                readCommentsListState: readCommentsListState,
                updateData: hasAlreadyFetchedInitialData ? addNewCommentThreads : setCommentsDataMap,
                annotationsInEditorDoc: annotationsInEditorDoc,
                pageMode: pageMode,
                currentUserId: currentUserId ?? '',
                isOpen: false
            });
            setLoading(false);
        },
        onError: (err)=>{
            // If the error is related to reactionsSummary returning null, just mark it handled
            // or if the error is related to cc-pages not being reachable, just mark it handled
            if (err.message.search(/reactions/i) !== -1 || err.message.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(err);
            setLoading(false);
        }
    });
    (0, $gwFzn.useEffect)(()=>{
        if (queryLoading) setLoading(true);
    }, [
        queryLoading
    ]);
    return {
        loading: !skipQuery ? loading : false,
        data: data,
        error: error,
        refetch: refetch
    };
};

});
parcelRegister("1khXm", function(module, exports) {

$parcel$export(module.exports, "ResolvedCommentsQuery", () => $afbe97c63b5dba65$export$7a04b403e0e4a799);

var $d2LG0 = parcelRequire("d2LG0");

var $h3dNE = parcelRequire("h3dNE");
const $afbe97c63b5dba65$export$7a04b403e0e4a799 = (0, $d2LG0.default)`query ResolvedCommentsQuery($pageId:ID!$contentStatus:[GraphQLContentStatus]){comments(pageId:$pageId contentStatus:$contentStatus depth:ROOT confluenceCommentFilter:{commentState:RESOLVED}singleThreaded:true){nodes{...commentFragment replies{...commentFragment}}}}${(0, $h3dNE.commentFragment)}`;

});


parcelRegister("fXPkn", function(module, exports) {

$parcel$export(module.exports, "EmptyResolvedSVG", () => $5a3e109a86a93bbf$export$8d1628213f9c0f24);

var $gwFzn = parcelRequire("gwFzn");
const $5a3e109a86a93bbf$export$8d1628213f9c0f24 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("svg", {
        width: "127",
        height: "126",
        viewBox: "0 0 127 126",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M101.3 71.7281C101.831 68.7499 102.106 65.593 102.106 62.2391C102.106 58.8852 101.822 55.6413 101.286 52.6265C98.0694 34.6932 85.6068 23.6419 68.1363 20.7966C65.1536 20.3155 62.0288 20.0635 58.7803 20.0635C55.5317 20.0635 52.132 20.3292 49.0347 20.8515C31.5551 23.7702 19.12 34.7986 15.8899 52.6265C15.3446 55.6367 15.0605 58.844 15.0605 62.2391C15.0605 65.6342 15.34 68.7499 15.8715 71.7281C19.0742 89.5376 31.523 100.584 49.0301 103.503C52.1275 104.021 55.3851 104.291 58.7757 104.291C62.1662 104.291 65.1536 104.044 68.1317 103.558C85.6297 100.717 98.0968 89.6384 101.295 71.7281H101.3Z",
        fill: "#DDDEE1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M73.7172 61.9231L107.219 27.0234L119.609 38.4963L70.9452 80.2687L48.0361 59.1603L59.9489 45.4057L73.7126 61.9277L73.7172 61.9231Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "M101.29 52.627C100.337 47.3395 98.5824 42.6386 96.1311 38.5791L73.7214 61.9235L59.9577 45.4014L48.0449 59.156L70.954 80.2645L101.524 54.0244C101.455 53.5525 101.382 53.0851 101.299 52.6224L101.29 52.627Z",
        fill: "#09326C"
    }));
};

});

parcelRegister("adDSj", function(module, exports) {

$parcel$export(module.exports, "GraphQLContentStatus", () => $c679e7452e199689$export$b634e5de755b7d35);
/**
 * @generated SignedSource<<42e9c00c17a44b7c61717c44c1d67079>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/ var $c679e7452e199689$export$b634e5de755b7d35 = /*#__PURE__*/ function(GraphQLContentStatus) {
    GraphQLContentStatus["ARCHIVED"] = "ARCHIVED";
    GraphQLContentStatus["CURRENT"] = "CURRENT";
    GraphQLContentStatus["DELETED"] = "DELETED";
    GraphQLContentStatus["DRAFT"] = "DRAFT";
    return GraphQLContentStatus;
}({});
var $c679e7452e199689$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});

});



parcelRegister("fcFHX", function(module, exports) {

$parcel$export(module.exports, "CommentSortOptions", () => $796234d93c63c82b$export$6a152b8af3a8eac2);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $dAYOx = parcelRequire("dAYOx");
var $ahaN7 = parcelRequire("ahaN7");

var $3mVfX = parcelRequire("3mVfX");

var $9wGTI = parcelRequire("9wGTI");
const $796234d93c63c82b$var$i18n = (0, $2nPZH.defineMessages)({
    sortTitle: {
        id: "comments-panel.sort.title",
        defaultMessage: "Sort"
    },
    pageOrder: {
        id: "comments-panel.page-order.label",
        defaultMessage: "Top \u2192 Bottom"
    },
    mostRecent: {
        id: "comments-panel.most-recent.label",
        defaultMessage: "New \u2192 Old"
    }
});
const $796234d93c63c82b$var$I18N_SORT_BY_MAP = {
    PAGE_ORDER: $796234d93c63c82b$var$i18n.pageOrder,
    MOST_RECENT: $796234d93c63c82b$var$i18n.mostRecent
};
const $796234d93c63c82b$export$6a152b8af3a8eac2 = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [{ currentSort: currentSort }, { setCurrentSort: setCurrentSort }] = (0, $3mVfX.useCommentsPanel)();
    const handleSortChange = (sort)=>{
        // Do nothing if the same sort is clicked
        if (currentSort !== sort && setCurrentSort) setCurrentSort(sort);
    };
    const sortOptions = Object.values((0, $3mVfX.SortValues)).filter((sortBy)=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_cp_sort_new_to_old')) return sortBy !== (0, $3mVfX.SortValues).MOST_RECENT;
        return true;
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ahaN7.default), {
        id: "sort",
        title: formatMessage($796234d93c63c82b$var$i18n.sortTitle),
        hasSeparator: true
    }, sortOptions.map((sortOption)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
            key: sortOption,
            onClick: ()=>handleSortChange(sortOption),
            "data-testId": `menu-item-${sortOption}-sort`,
            isSelected: currentSort === sortOption
        }, formatMessage($796234d93c63c82b$var$I18N_SORT_BY_MAP[sortOption]))));
};

});

parcelRegister("kt7bZ", function(module, exports) {

$parcel$export(module.exports, "CommentBulkActions", () => $8b3b7fc10378a2d1$export$4dfcfd4e5b226b64);

var $gwFzn = parcelRequire("gwFzn");

var $ahaN7 = parcelRequire("ahaN7");

var $htsj6 = parcelRequire("htsj6");

var $ep3mz = parcelRequire("ep3mz");

var $lfBMY = parcelRequire("lfBMY");
var $2wo33 = parcelRequire("2wo33");

var $iAzqG = parcelRequire("iAzqG");

var $24GMi = parcelRequire("24GMi");
const $8b3b7fc10378a2d1$export$4dfcfd4e5b226b64 = ()=>{
    const [contentId = ''] = (0, $ep3mz.usePageContentId)();
    const { contentStatus: contentStatus = '' } = (0, $htsj6.useContentStatus)();
    const [canPerformResolveAllComments] = (0, $2wo33.useCanPerformContentOperation)({
        contentId: contentId,
        contentType: 'comment',
        status: [
            contentStatus
        ],
        operation: (0, $lfBMY.OperationTypes).CREATE
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ahaN7.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iAzqG.CommentBulkReadWithFlags), null), canPerformResolveAllComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $24GMi.CommentBulkResolveWithFlags), null));
};

});
parcelRegister("iAzqG", function(module, exports) {

$parcel$export(module.exports, "CommentBulkReadWithFlags", () => $aa3bded99b482c1a$export$1bf93cfef8e1d8d7);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $dAYOx = parcelRequire("dAYOx");

var $9hlns = parcelRequire("9hlns");

var $8i27m = parcelRequire("8i27m");

var $7aRa9 = parcelRequire("7aRa9");

var $3mVfX = parcelRequire("3mVfX");

var $aSsfA = parcelRequire("aSsfA");

var $cD1qu = parcelRequire("cD1qu");

var $kV6aH = parcelRequire("kV6aH");

var $fy5yb = parcelRequire("fy5yb");

var $aFRph = parcelRequire("aFRph");

var $eQ6M5 = parcelRequire("eQ6M5");
const $aa3bded99b482c1a$var$i18n = (0, $2nPZH.defineMessages)({
    markAllAsRead: {
        id: "comments-panel.comment-bulk-actions.mark-all-as-read",
        defaultMessage: "Mark all as read"
    }
});
const $aa3bded99b482c1a$export$672f2f624abff1a2 = ({ flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const includeDrafts = pageMode !== (0, $cD1qu.PageMode).VIEW;
    const { retryCountRef: retryCountRef, ...commentBulkActionFlags } = (0, $eQ6M5.useCommentBulkOperationsFlags)((0, $eQ6M5.READ), flags);
    const { commentsMarkedAsRead: commentsMarkedAsRead } = (0, $3mVfX.useCommentsPanelState)();
    const commentBulkRead = (0, $kV6aH.useCommentBulkRead)(commentBulkActionFlags);
    const { commentsDataMap: commentsDataMap } = (0, $8i27m.useCommentsDataState)();
    const { isBulkReadInProgress: isBulkReadInProgress } = (0, $aFRph.useCommentBulkOperationsState)();
    const unreadCommentIdCount = (0, $fy5yb.computeUnreadCommentIds)(commentsDataMap, commentsMarkedAsRead, includeDrafts).size;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
        elemBefore: isBulkReadInProgress && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9hlns.default), {
            size: "small"
        }),
        isDisabled: isBulkReadInProgress || unreadCommentIdCount === 0,
        onClick: ()=>{
            retryCountRef.current = 0;
            commentBulkRead();
        }
    }, formatMessage($aa3bded99b482c1a$var$i18n.markAllAsRead));
};
const $aa3bded99b482c1a$export$1bf93cfef8e1d8d7 = (0, $7aRa9.withFlags)($aa3bded99b482c1a$export$672f2f624abff1a2);

});
parcelRegister("kV6aH", function(module, exports) {

$parcel$export(module.exports, "useCommentBulkRead", () => $92e6a097a0ccab1d$export$5465b6e82db69e06);

var $j1Ss3 = parcelRequire("j1Ss3");

var $ep3mz = parcelRequire("ep3mz");

var $h9GHl = parcelRequire("h9GHl");

var $bQm3c = parcelRequire("bQm3c");

var $aFRph = parcelRequire("aFRph");

var $7uNBN = parcelRequire("7uNBN");

var $9H7tX = parcelRequire("9H7tX");
const $92e6a097a0ccab1d$export$5465b6e82db69e06 = (flags)=>{
    const [contentId = ''] = (0, $ep3mz.usePageContentId)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const location = (0, $9H7tX.useLocation)();
    const { setIsBulkReadInProgress: setIsBulkReadInProgress } = (0, $aFRph.useCommentBulkOperationsActions)();
    const syncReadComments = (0, $7uNBN.useSyncReadComments)();
    const handleReadAllComments = ()=>{
        readAllComments({
            variables: {
                contentId: contentId,
                cloudId: cloudId,
                readView: location
            }
        });
        setIsBulkReadInProgress(true);
    };
    const [readAllComments] = (0, $j1Ss3.useMutation)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $h9GHl.MarkAllCommentsAsReadMutation), {
        onCompleted: async ({ confluence_markAllCommentsAsRead: confluence_markAllCommentsAsRead })=>{
            if (confluence_markAllCommentsAsRead?.success) {
                syncReadComments();
                flags.showSuccess();
            } else flags.showFailure(handleReadAllComments);
            setIsBulkReadInProgress(false);
        },
        onError: ()=>{
            flags.showFailure(handleReadAllComments);
            setIsBulkReadInProgress(false);
        }
    });
    return handleReadAllComments;
};

});
parcelRegister("h9GHl", function(module, exports) {

$parcel$export(module.exports, "MarkAllCommentsAsReadMutation", () => $7ff57ab5d1e27476$export$920ba1ec9d2eb1f8);

var $d2LG0 = parcelRequire("d2LG0");
const $7ff57ab5d1e27476$export$920ba1ec9d2eb1f8 = (0, $d2LG0.default)`mutation MarkAllCommentsAsReadMutation($cloudId:ID!$contentId:String!$readView:ConfluenceViewState){confluence_markAllCommentsAsRead(cloudId:$cloudId input:{contentId:$contentId readView:$readView}){success errors{message}}}`;

});

parcelRegister("aFRph", function(module, exports) {

$parcel$export(module.exports, "useCommentBulkOperationsState", () => $c85d08de2dd805d1$export$f5d8cecd79da3b62);
$parcel$export(module.exports, "useCommentBulkOperationsActions", () => $c85d08de2dd805d1$export$6490cb1cd1a2f648);

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");
const $c85d08de2dd805d1$var$Store = (0, $4ZoIm.createStore)({
    initialState: {
        isBulkReadInProgress: false,
        isBulkResolveInProgress: false
    },
    actions: {
        setIsBulkReadInProgress: (isBulkReadInProgress)=>({ setState: setState })=>setState({
                    isBulkReadInProgress: isBulkReadInProgress
                }),
        setIsBulkResolveInProgress: (isBulkResolveInProgress)=>({ setState: setState })=>setState({
                    isBulkResolveInProgress: isBulkResolveInProgress
                })
    }
});
const $c85d08de2dd805d1$export$f5d8cecd79da3b62 = (0, $iFWZA.createStateHook)($c85d08de2dd805d1$var$Store);
const $c85d08de2dd805d1$export$6490cb1cd1a2f648 = (0, $iFWZA.createActionsHook)($c85d08de2dd805d1$var$Store);

});

parcelRegister("7uNBN", function(module, exports) {

$parcel$export(module.exports, "useSyncReadComments", () => $c2f6f02024e4ecfd$export$12dc97316d69bae3);

var $gwFzn = parcelRequire("gwFzn");

var $8i27m = parcelRequire("8i27m");

var $3mVfX = parcelRequire("3mVfX");

var $fy5yb = parcelRequire("fy5yb");
const $c2f6f02024e4ecfd$export$12dc97316d69bae3 = ()=>{
    const { setCommentsToBeMarkedAsRead: setCommentsToBeMarkedAsRead } = (0, $3mVfX.useCommentsPanelActions)();
    const [{ commentsDataMap: commentsDataMap }, { setCommentsDataMap: setCommentsDataMap }] = (0, $8i27m.useCommentsData)();
    return (0, $gwFzn.useCallback)(()=>{
        setCommentsToBeMarkedAsRead((0, $fy5yb.getCommentIdsByTypeAndAnnotationId)(commentsDataMap));
        setCommentsDataMap((0, $fy5yb.createReadCommentsDataMap)(commentsDataMap));
    }, [
        commentsDataMap,
        setCommentsToBeMarkedAsRead,
        setCommentsDataMap
    ]);
};

});
parcelRegister("fy5yb", function(module, exports) {

$parcel$export(module.exports, "getResolvedAnnotationState", () => $747cae967af72a91$export$765c3cc11af57952);
$parcel$export(module.exports, "getCommentIdsByTypeAndAnnotationId", () => $747cae967af72a91$export$4022ebdd60549871);
$parcel$export(module.exports, "createReadCommentsDataMap", () => $747cae967af72a91$export$9dbbea976afc91ec);
$parcel$export(module.exports, "computeUnreadCommentIds", () => $747cae967af72a91$export$80da35dda4637638);
$parcel$export(module.exports, "computeResolvedCommentIds", () => $747cae967af72a91$export$8407ff9f3ad87778);
$parcel$export(module.exports, "updateResolvedComments", () => $747cae967af72a91$export$e25befbc00a116b);

var $cdbMf = parcelRequire("cdbMf");

var $8i27m = parcelRequire("8i27m");
const $747cae967af72a91$var$setCommentProperties = (properties, comments)=>Object.fromEntries(Object.entries(comments).map(([id, comment])=>[
            id,
            {
                ...comment,
                ...properties
            }
        ]));
const $747cae967af72a91$export$765c3cc11af57952 = (unresolvedInlineComments)=>Object.fromEntries(unresolvedInlineComments.map((annotationId)=>[
            annotationId,
            {
                id: annotationId,
                annotationType: (0, $cdbMf.AnnotationTypes).INLINE_COMMENT,
                state: (0, $cdbMf.AnnotationMarkStates).RESOLVED
            }
        ]));
const $747cae967af72a91$var$createCommentsDataMap = (commentsDataMap, propertyUpdate)=>Object.entries(commentsDataMap).reduce((updatedCommentsDataMap, [type, comments])=>({
            ...updatedCommentsDataMap,
            [type]: $747cae967af72a91$var$setCommentProperties(propertyUpdate, comments)
        }), {});
const $747cae967af72a91$var$transformCommentsToIdSets = (dataMap)=>{
    return Object.fromEntries(Object.entries(dataMap).map(([commentId, comment])=>[
            commentId,
            new Set([
                comment.id,
                ...comment.replies ? comment.replies.map(({ id: id })=>id) : []
            ])
        ]));
};
const $747cae967af72a91$export$4022ebdd60549871 = (commentsDataMap)=>({
        inline: $747cae967af72a91$var$transformCommentsToIdSets(commentsDataMap.inline),
        general: $747cae967af72a91$var$transformCommentsToIdSets(commentsDataMap.general)
    });
const $747cae967af72a91$export$9dbbea976afc91ec = (commentsDataMap)=>$747cae967af72a91$var$createCommentsDataMap(commentsDataMap, {
        isUnread: false
    });
const $747cae967af72a91$export$f3aa68d52552526d = (obj)=>Object.values(obj).reduce((combinedSet, nestedObj)=>new Set([
            ...combinedSet,
            ...Object.values(nestedObj).flatMap((set)=>[
                    ...set
                ])
        ]), new Set());
const $747cae967af72a91$var$extractAllComments = (commentsDataMap)=>Object.values(commentsDataMap).flatMap((dataMap)=>Object.values(dataMap));
const $747cae967af72a91$var$excludeDraftComments = (comments)=>comments.filter((comment)=>comment.contentStatus !== 'draft');
const $747cae967af72a91$var$extractUnreadCommentIds = (comments)=>comments.filter((comment)=>comment.isUnread).map((comment)=>comment.id);
const $747cae967af72a91$export$80da35dda4637638 = (commentsDataMap, commentsMarkedAsRead, includeDrafts)=>{
    const allParentComments = includeDrafts ? $747cae967af72a91$var$extractAllComments(commentsDataMap) : $747cae967af72a91$var$excludeDraftComments($747cae967af72a91$var$extractAllComments(commentsDataMap));
    const allCommentReplies = allParentComments.flatMap(({ replies: replies })=>replies);
    const allComments = [
        ...allParentComments,
        ...allCommentReplies
    ];
    const unreadIds = $747cae967af72a91$var$extractUnreadCommentIds(allComments);
    const readIds = $747cae967af72a91$export$f3aa68d52552526d(commentsMarkedAsRead);
    return new Set(unreadIds.filter((id)=>!readIds.has(id)));
};
const $747cae967af72a91$var$extractUnresolvedCommentIds = (comments)=>comments.filter((comment)=>comment.isOpen).map((comment)=>comment.id);
const $747cae967af72a91$export$8407ff9f3ad87778 = (commentsDataMap, includeDrafts)=>{
    const allParentComments = includeDrafts ? $747cae967af72a91$var$extractAllComments(commentsDataMap) : $747cae967af72a91$var$excludeDraftComments($747cae967af72a91$var$extractAllComments(commentsDataMap));
    return $747cae967af72a91$var$extractUnresolvedCommentIds(allParentComments);
};
const $747cae967af72a91$var$COMMENTS_LOCATIONS = {
    INLINE: 'INLINE',
    FOOTER: 'FOOTER'
};
const $747cae967af72a91$export$e25befbc00a116b = (resolvedComments, commentData)=>{
    if (!resolvedComments?.comments?.nodes) return commentData;
    const resolvedCommentNodes = resolvedComments.comments.nodes.filter((node)=>node !== null);
    const updateComments = (comments, locationType, commentType)=>Object.keys(comments).reduce((acc, key)=>{
            const comment = comments[key];
            const resolvedComment = resolvedCommentNodes.find((resolved)=>locationType === $747cae967af72a91$var$COMMENTS_LOCATIONS.INLINE ? resolved.location.inlineMarkerRef === key && resolved.location.type === locationType : resolved.id === key && resolved.location.type === locationType);
            if (resolvedComment && (comment.isOpen || comment.isUnread)) return {
                ...acc,
                [key]: {
                    ...resolvedComment,
                    isOpen: false,
                    isUnread: false,
                    type: commentType
                }
            };
            else return {
                ...acc,
                [key]: comment
            };
        }, {});
    const updatedInlineComments = updateComments(commentData.inline, $747cae967af72a91$var$COMMENTS_LOCATIONS.INLINE, (0, $8i27m.CommentType).INLINE);
    const updatedGeneralComments = updateComments(commentData.general, $747cae967af72a91$var$COMMENTS_LOCATIONS.FOOTER, (0, $8i27m.CommentType).GENERAL);
    return {
        inline: updatedInlineComments,
        general: updatedGeneralComments
    };
};

});


parcelRegister("9H7tX", function(module, exports) {

$parcel$export(module.exports, "useLocation", () => $20b196a5324636fc$export$45d76561a5302f2b);

var $aSsfA = parcelRequire("aSsfA");

var $cD1qu = parcelRequire("cD1qu");
const $20b196a5324636fc$var$EDITOR = 'EDITOR';
const $20b196a5324636fc$var$RENDERER = 'RENDERER';
const $20b196a5324636fc$var$LIVE = 'LIVE';
const $20b196a5324636fc$var$MODE_TO_LOCATION_MAP = {
    [(0, $cD1qu.PageMode).EDIT]: $20b196a5324636fc$var$EDITOR,
    [(0, $cD1qu.PageMode).VIEW]: $20b196a5324636fc$var$RENDERER,
    [(0, $cD1qu.PageMode).LIVE]: $20b196a5324636fc$var$LIVE
};
const $20b196a5324636fc$export$45d76561a5302f2b = ()=>{
    const pageMode = (0, $aSsfA.useGetPageMode)();
    return $20b196a5324636fc$var$MODE_TO_LOCATION_MAP[pageMode];
};

});


parcelRegister("eQ6M5", function(module, exports) {

$parcel$export(module.exports, "READ", () => $96541fda0357adfd$export$bc0caad942f9affc);
$parcel$export(module.exports, "RESOLVE", () => $96541fda0357adfd$export$4732ab3df087d9be);
$parcel$export(module.exports, "useCommentBulkOperationsFlags", () => $96541fda0357adfd$export$590afa14fcd4f863);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");
const $96541fda0357adfd$var$i18n = (0, $2nPZH.defineMessages)({
    allCommentsMarkedAsResolved: {
        id: "comments-panel.comment-bulk-actions.all-comments-marked-as-resolved",
        defaultMessage: "All comments marked as resolved"
    },
    allCommentsMarkedAsRead: {
        id: "comments-panel.comment-bulk-actions.all-comments-marked-as-read",
        defaultMessage: "All comments marked as read"
    },
    commentsFailedToResolve: {
        id: "comments-panel.comment-bulk-actions.comments-failed-to-resolve",
        defaultMessage: "Comments failed to resolve. Please try again."
    },
    failedToMarkAllCommentsAsRead: {
        id: "comments-panel.comment-bulk-actions.failed-to-mark-all-comments-as-read",
        defaultMessage: "Failed to mark all comments as read. Please try again."
    },
    retryNow: {
        id: "comments-panel.comment-bulk-actions.retry-now",
        defaultMessage: "Retry now"
    }
});
const $96541fda0357adfd$var$MAXIMUM_BULK_ACTION_RETRIES = 1;
const $96541fda0357adfd$export$bc0caad942f9affc = 'read';
const $96541fda0357adfd$export$4732ab3df087d9be = 'resolve';
const $96541fda0357adfd$var$getSuccessFlagId = (action)=>`comments-panel.comment-bulk-actions.mark-all-as-${action}-success`;
const $96541fda0357adfd$var$getFailureFlagId = (action)=>`comments-panel.comment-bulk-actions.mark-all-as-${action}-failure`;
const $96541fda0357adfd$var$getSuccessMessage = (action)=>{
    switch(action){
        case $96541fda0357adfd$export$bc0caad942f9affc:
            return $96541fda0357adfd$var$i18n.allCommentsMarkedAsRead;
        case $96541fda0357adfd$export$4732ab3df087d9be:
            return $96541fda0357adfd$var$i18n.allCommentsMarkedAsResolved;
        default:
            throw new Error('Invalid action');
    }
};
const $96541fda0357adfd$var$getFailureMessage = (action)=>{
    switch(action){
        case $96541fda0357adfd$export$bc0caad942f9affc:
            return $96541fda0357adfd$var$i18n.failedToMarkAllCommentsAsRead;
        case $96541fda0357adfd$export$4732ab3df087d9be:
            return $96541fda0357adfd$var$i18n.commentsFailedToResolve;
        default:
            throw new Error('Invalid action');
    }
};
const $96541fda0357adfd$export$590afa14fcd4f863 = (action, flags)=>{
    const retryCountRef = (0, $gwFzn.useRef)(0);
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const showSuccess = ()=>{
        const successFlagId = $96541fda0357adfd$var$getSuccessFlagId(action);
        const title = $96541fda0357adfd$var$getSuccessMessage(action);
        flags.showSuccessCircleFlag({
            id: successFlagId,
            title: formatMessage(title),
            isAutoDismiss: true
        });
    };
    const showFailure = (handleRetry)=>{
        const failureFlagId = $96541fda0357adfd$var$getFailureFlagId(action);
        const title = $96541fda0357adfd$var$getFailureMessage(action);
        const actions = retryCountRef.current < $96541fda0357adfd$var$MAXIMUM_BULK_ACTION_RETRIES ? [
            {
                content: formatMessage($96541fda0357adfd$var$i18n.retryNow),
                onClick: ()=>{
                    handleRetry();
                    flags.hideFlag(failureFlagId);
                    retryCountRef.current += 1;
                }
            }
        ] : [];
        flags.showErrorFlag({
            id: failureFlagId,
            title: formatMessage(title),
            isAutoDismiss: true,
            actions: actions
        });
    };
    return {
        retryCountRef: retryCountRef,
        showSuccess: showSuccess,
        showFailure: showFailure
    };
};

});


parcelRegister("24GMi", function(module, exports) {

$parcel$export(module.exports, "CommentBulkResolveWithFlags", () => $e1eb9abc8745646b$export$301dbba548b15461);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $dAYOx = parcelRequire("dAYOx");

var $9hlns = parcelRequire("9hlns");

var $8i27m = parcelRequire("8i27m");

var $7aRa9 = parcelRequire("7aRa9");

var $cD1qu = parcelRequire("cD1qu");

var $aSsfA = parcelRequire("aSsfA");

var $cgvhN = parcelRequire("cgvhN");

var $fy5yb = parcelRequire("fy5yb");

var $aFRph = parcelRequire("aFRph");

var $eQ6M5 = parcelRequire("eQ6M5");
const $e1eb9abc8745646b$var$i18n = (0, $2nPZH.defineMessages)({
    markAllAsResolved: {
        id: "comments-panel.comment-bulk-actions.mark-all-as-resolved",
        defaultMessage: "Mark all as resolved"
    }
});
const $e1eb9abc8745646b$export$148149ec51767218 = ({ flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { retryCountRef: retryCountRef, ...commentBulkActionFlags } = (0, $eQ6M5.useCommentBulkOperationsFlags)((0, $eQ6M5.RESOLVE), flags);
    const commentBulkResolve = (0, $cgvhN.useCommentBulkResolve)(commentBulkActionFlags);
    const { commentsDataMap: commentsDataMap } = (0, $8i27m.useCommentsDataState)();
    const { isBulkResolveInProgress: isBulkResolveInProgress } = (0, $aFRph.useCommentBulkOperationsState)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const includeDrafts = pageMode !== (0, $cD1qu.PageMode).VIEW;
    const unresolvedCommentCount = (0, $fy5yb.computeResolvedCommentIds)(commentsDataMap, includeDrafts).length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
        elemBefore: isBulkResolveInProgress && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9hlns.default), {
            size: "small"
        }),
        isDisabled: isBulkResolveInProgress || unresolvedCommentCount === 0,
        onClick: ()=>{
            retryCountRef.current = 0;
            commentBulkResolve();
        }
    }, formatMessage($e1eb9abc8745646b$var$i18n.markAllAsResolved));
};
const $e1eb9abc8745646b$export$301dbba548b15461 = (0, $7aRa9.withFlags)($e1eb9abc8745646b$export$148149ec51767218);

});
parcelRegister("cgvhN", function(module, exports) {

$parcel$export(module.exports, "useCommentBulkResolve", () => $53d9485b5e238bee$export$8c69b3dc6db98670);

var $j1Ss3 = parcelRequire("j1Ss3");

var $hp2SH = parcelRequire("hp2SH");

var $bQm3c = parcelRequire("bQm3c");

var $ep3mz = parcelRequire("ep3mz");

var $3YSvE = parcelRequire("3YSvE");
var $1khXm = parcelRequire("1khXm");

var $aFRph = parcelRequire("aFRph");

var $2zf5d = parcelRequire("2zf5d");

var $9H7tX = parcelRequire("9H7tX");
const $53d9485b5e238bee$export$8c69b3dc6db98670 = (flags)=>{
    const [contentId = ''] = (0, $ep3mz.usePageContentId)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const location = (0, $9H7tX.useLocation)();
    const { setIsBulkResolveInProgress: setIsBulkResolveInProgress } = (0, $aFRph.useCommentBulkOperationsActions)();
    const syncResolvedComments = (0, $2zf5d.useSyncResolvedComments)();
    const handleResolveAllComments = ()=>{
        resolveAllComments({
            variables: {
                contentId: contentId,
                cloudId: cloudId,
                resolveView: location
            }
        });
        setIsBulkResolveInProgress(true);
    };
    const [resolveAllComments] = (0, $j1Ss3.useMutation)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $3YSvE.ResolveAllCommentsMutation), {
        onCompleted: async ({ confluence_resolveCommentsByContentId: confluence_resolveCommentsByContentId })=>{
            const client = (0, $hp2SH.getApolloClient)();
            const { data: resolvedCommentsData } = await client.query({
                query: (0, $1khXm.ResolvedCommentsQuery),
                variables: {
                    pageId: contentId,
                    contentStatus: [
                        'DRAFT',
                        'CURRENT'
                    ]
                },
                fetchPolicy: 'network-only'
            });
            syncResolvedComments(resolvedCommentsData);
            if (confluence_resolveCommentsByContentId?.success) flags.showSuccess();
            else flags.showFailure(handleResolveAllComments);
            setIsBulkResolveInProgress(false);
        },
        onError: ()=>{
            flags.showFailure(handleResolveAllComments);
            setIsBulkResolveInProgress(false);
        }
    });
    return handleResolveAllComments;
};

});
parcelRegister("3YSvE", function(module, exports) {

$parcel$export(module.exports, "ResolveAllCommentsMutation", () => $daea546d0e1d0a00$export$ef15137f300e1d3a);

var $d2LG0 = parcelRequire("d2LG0");
const $daea546d0e1d0a00$export$ef15137f300e1d3a = (0, $d2LG0.default)`mutation ResolveAllCommentsMutation($contentId:ID!$cloudId:ID!$resolveView:ConfluenceCommentResolveAllLocation=RENDERER){confluence_resolveCommentsByContentId(contentId:$contentId cloudId:$cloudId resolveView:$resolveView){success errors{message}}}`;

});

parcelRegister("2zf5d", function(module, exports) {

$parcel$export(module.exports, "useSyncResolvedComments", () => $1a0d2284fd234e59$export$29476759abd9487);

var $gwFzn = parcelRequire("gwFzn");

var $21K7m = parcelRequire("21K7m");

var $aSsfA = parcelRequire("aSsfA");

var $cD1qu = parcelRequire("cD1qu");

var $8i27m = parcelRequire("8i27m");

var $k8e76 = parcelRequire("k8e76");

var $gfqXk = parcelRequire("gfqXk");
var $gczDe = parcelRequire("gczDe");

var $fy5yb = parcelRequire("fy5yb");
const $1a0d2284fd234e59$var$RESOLVE = 'resolve';
const $1a0d2284fd234e59$var$useSyncResolvedEditorComments = ()=>{
    const { unresolvedInlineComments: unresolvedInlineComments } = (0, $k8e76.useInlineCommentsState)();
    const editorAnnotationEventEmitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
    return (0, $gwFzn.useCallback)(()=>{
        unresolvedInlineComments.forEach((comment)=>editorAnnotationEventEmitter.emit($1a0d2284fd234e59$var$RESOLVE, comment));
    }, [
        editorAnnotationEventEmitter,
        unresolvedInlineComments
    ]);
};
const $1a0d2284fd234e59$var$useSyncResolvedRendererComments = ()=>{
    const { unresolvedInlineComments: unresolvedInlineComments } = (0, $k8e76.useInlineCommentsState)();
    const rendererAnnotationEventEmitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
    return (0, $gwFzn.useCallback)(()=>{
        const resolvedAnnotationState = (0, $fy5yb.getResolvedAnnotationState)(unresolvedInlineComments);
        rendererAnnotationEventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_STATE, resolvedAnnotationState);
    }, [
        rendererAnnotationEventEmitter,
        unresolvedInlineComments
    ]);
};
const $1a0d2284fd234e59$export$29476759abd9487 = ()=>{
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const [{ commentsDataMap: commentsDataMap }, { setCommentsDataMap: setCommentsDataMap }] = (0, $8i27m.useCommentsData)();
    const syncResolvedEditorComments = $1a0d2284fd234e59$var$useSyncResolvedEditorComments();
    const syncResolvedRendererComments = $1a0d2284fd234e59$var$useSyncResolvedRendererComments();
    return (0, $gwFzn.useCallback)((resolvedComments)=>{
        setCommentsDataMap((0, $fy5yb.updateResolvedComments)(resolvedComments, commentsDataMap));
        if (pageMode === (0, $cD1qu.PageMode).VIEW) syncResolvedRendererComments();
        else syncResolvedEditorComments();
    }, [
        commentsDataMap,
        setCommentsDataMap,
        pageMode,
        syncResolvedRendererComments,
        syncResolvedEditorComments
    ]);
};

});





parcelRegister("gFN6K", function(module, exports) {

$parcel$export(module.exports, "CommentsPanelFooter", () => $05d295f79bec1a8a$export$d22dcc9813559881);
/* CommentsPanelFooter.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $d2LG0 = parcelRequire("d2LG0");

var $diswb = parcelRequire("diswb");

var $6f0Oj = parcelRequire("6f0Oj");

var $inPa6 = parcelRequire("inPa6");

var $4CTa9 = parcelRequire("4CTa9");

var $8SCD6 = parcelRequire("8SCD6");
var $bSvtO = parcelRequire("bSvtO");

var $irVI7 = parcelRequire("irVI7");
var $aJPUt = parcelRequire("aJPUt");
var $1kHsc = parcelRequire("1kHsc");
var $8Ss4E = parcelRequire("8Ss4E");

var $kKAQX = parcelRequire("kKAQX");

var $87CZC = parcelRequire("87CZC");

var $ep3mz = parcelRequire("ep3mz");

var $bQm3c = parcelRequire("bQm3c");

var $hl1Kw = parcelRequire("hl1Kw");

var $8i27m = parcelRequire("8i27m");

var $ICFae = parcelRequire("ICFae");

var $aSsfA = parcelRequire("aSsfA");

var $cD1qu = parcelRequire("cD1qu");

var $dEBDF = parcelRequire("dEBDF");

var $6KwrO = parcelRequire("6KwrO");

var $en1dX = parcelRequire("en1dX");

var $9wGTI = parcelRequire("9wGTI");

var $2oXQ7 = parcelRequire("2oXQ7");
const $05d295f79bec1a8a$var$CommentsPanelFooterCreateGeneralCommentMutation = (0, $d2LG0.default)`mutation CommentsPanelFooterCreateGeneralCommentMutation($pageId:ID!$cloudId:ID!$input:CreateCommentInput!){createFooterComment(cloudId:$cloudId input:$input){id author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}...on User{accountId}}body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui editui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{isDangling resolvedTime resolvedFriendlyDate resolvedUser resolved}}...on FooterComment{commentResolveProperties{resolvedTime resolvedFriendlyDate resolvedUser resolved}}}parentId permissions{isEditable isRemovable isResolvable}reactionsSummary(pageId:$pageId contentType:"page" childType:"comment"){ari containerAri reactionsCount reactionsSummaryForEmoji{id emojiId count reacted}}version{by{displayName}when number}}}`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $05d295f79bec1a8a$var$FooterWrapperContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1tke1ylp _lo5415zi _x94414em",
            __cmplp.className
        ])
    });
});
var $05d295f79bec1a8a$var$CommentMode = /*#__PURE__*/ function(CommentMode) {
    CommentMode["VIEW"] = "view";
    CommentMode["ADD"] = "add";
    return CommentMode;
}($05d295f79bec1a8a$var$CommentMode || {});
const $05d295f79bec1a8a$export$d22dcc9813559881 = ()=>{
    const [commentMode, setCommentMode] = (0, $gwFzn.useState)("view");
    const shouldAutofocusPromptRef = (0, $gwFzn.useRef)(false);
    const [createGeneralCommentFn] = (0, $diswb.useMutation)($05d295f79bec1a8a$var$CommentsPanelFooterCreateGeneralCommentMutation);
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { isReactionsEnabled: isReactionsEnabled } = (0, $gwFzn.useContext)((0, $8SCD6.ReactionsContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { cloudId: cloudId, edition: edition } = (0, $bQm3c.useSessionData)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const [{ searchSessionId: searchSessionId }] = (0, $hl1Kw.useSearchSessionId)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { onChange: onChange, resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { addNewCommentThreads: addNewCommentThreads } = (0, $8i27m.useCommentsDataActions)();
    const { updateReadCommentsListState: updateReadCommentsListState } = (0, $ICFae.useUnreadCommentsActions)();
    const { scrollCommentsPanelToThread: scrollCommentsPanelToThread } = (0, $6KwrO.useCommentsPanelScroll)();
    const handleCommentsPanelSave = (adfObject, onSuccess)=>{
        const pageId = contentId || '';
        const { adf: adf } = adfObject;
        if ((0, $9wGTI.fg)('confluence_frontend_disable_page_comment_timeout')) experienceTracker.start({
            name: (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE),
            timeout: (0, $aJPUt.ExperienceTimeout).EDITOR_PUBLISH
        });
        return createGeneralCommentFn({
            variables: {
                pageId: pageId,
                cloudId: cloudId,
                input: {
                    commentBody: {
                        value: JSON.stringify(adf),
                        representationFormat: (0, $kKAQX.ContentRepresentation).ATLAS_DOC_FORMAT
                    },
                    commentSource: (0, $kKAQX.Platform).WEB,
                    containerId: pageId
                }
            },
            update: (0, $87CZC.updateApolloCacheParentCallback)('create', {
                pageId: pageId,
                contentStatus: [
                    'DRAFT',
                    'CURRENT'
                ]
            }, isReactionsEnabled)
        }).then(({ data: data })=>{
            const commentResult = data.createFooterComment;
            const comment = {
                ...commentResult,
                replies: [],
                // not included in the payload
                isUnread: false,
                isOpen: true,
                type: (0, $8i27m.CommentType).GENERAL
            };
            updateReadCommentsListState((prev)=>new Set([
                    ...prev,
                    comment.id
                ]));
            addNewCommentThreads({
                inline: {},
                general: {
                    [comment.id]: comment
                }
            });
            onSuccess && onSuccess();
            resetContentChanged();
            setCommentMode("view");
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'created',
                    actionSubject: 'comment',
                    actionSubjectId: comment.id,
                    // The newly created comment ID
                    objectType: contentType,
                    objectId: contentId,
                    source: (0, $en1dX.AnalyticsSource).COMMENTS_PANEL,
                    attributes: {
                        commentType: (0, $8i27m.CommentType).GENERAL,
                        source: (0, $en1dX.AnalyticsSource).COMMENTS_PANEL,
                        pageMode: pageMode,
                        isReply: false,
                        pageType: contentType,
                        isLivePage: pageMode === (0, $cD1qu.PageMode).LIVE,
                        editor: 'v2',
                        searchSessionId: searchSessionId,
                        navdexPointType: (0, $dEBDF.END),
                        parentCommentId: null // analytics event schema type expects string or null
                    }
                }
            }).fire();
            experienceTracker.succeed({
                name: (0, $9wGTI.fg)('confluence_frontend_disable_page_comment_timeout') ? (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE) : (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE)
            });
            setTimeout(()=>{
                scrollCommentsPanelToThread({
                    annotationId: comment.id
                });
            }, 1000);
        });
    };
    const handleCancel = ({ isEditorAborted: isEditorAborted })=>{
        const doCancel = ()=>{
            if (isEditorAborted) {
                shouldAutofocusPromptRef.current = true;
                if ((0, $9wGTI.fg)('confluence_frontend_disable_page_comment_timeout')) experienceTracker.abort({
                    name: (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE),
                    reason: 'aborted because comment was cancelled'
                });
            }
            setCommentMode("view");
        };
        if (hasContentChanged) resetContentChanged();
        doCancel();
    };
    const handleOnEditorLoaded = ()=>{
        experienceTracker.succeed({
            name: (0, $irVI7.ADD_PAGE_COMMENT_LOAD_EXPERIENCE)
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($05d295f79bec1a8a$var$FooterWrapperContainer, null, commentMode === "view" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2oXQ7.CommentAddPrompt), {
        onClick: ()=>{
            if ((0, $9wGTI.fg)('confluence_frontend_disable_page_comment_timeout')) (0, $8Ss4E.startEditorExperiences)({
                name: (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE),
                attributes: {
                    editor: 'FABRIC',
                    isSingleExperience: true,
                    edition: edition,
                    source: 'commentsPanel'
                }
            }, {
                name: (0, $irVI7.ADD_PAGE_COMMENT_LOAD_EXPERIENCE)
            }, {
                name: (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE)
            });
            setCommentMode("add");
        },
        autofocusRef: shouldAutofocusPromptRef
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4CTa9.PageCommentEditor), {
        mode: "create",
        saveHandler: handleCommentsPanelSave,
        cancelHandler: handleCancel,
        onEditorLoaded: handleOnEditorLoaded,
        onEditorContentChanged: onChange,
        useNewExperienceAbort: true,
        expandEditor: true,
        isCommentsPanel: true
    })));
};

});
parcelRegister("kKAQX", function(module, exports) {

$parcel$export(module.exports, "ContentRepresentation", () => $485d7166d746f7d6$export$f4016897b165b6d5);
$parcel$export(module.exports, "Platform", () => $485d7166d746f7d6$export$2dffd0b5373a4389);
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $485d7166d746f7d6$export$f4016897b165b6d5 = /*#__PURE__*/ function(ContentRepresentation) {
    ContentRepresentation["ATLAS_DOC_FORMAT"] = "ATLAS_DOC_FORMAT";
    ContentRepresentation["EDITOR"] = "EDITOR";
    ContentRepresentation["EDITOR2"] = "EDITOR2";
    ContentRepresentation["EXPORT_VIEW"] = "EXPORT_VIEW";
    ContentRepresentation["PLAIN"] = "PLAIN";
    ContentRepresentation["RAW"] = "RAW";
    ContentRepresentation["STORAGE"] = "STORAGE";
    ContentRepresentation["STYLED_VIEW"] = "STYLED_VIEW";
    ContentRepresentation["VIEW"] = "VIEW";
    ContentRepresentation["WIKI"] = "WIKI";
    return ContentRepresentation;
}({});
var $485d7166d746f7d6$export$2dffd0b5373a4389 = /*#__PURE__*/ function(Platform) {
    Platform["ANDROID"] = "ANDROID";
    Platform["IOS"] = "IOS";
    Platform["WEB"] = "WEB";
    return Platform;
}({});
var $485d7166d746f7d6$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});

});

parcelRegister("2oXQ7", function(module, exports) {

$parcel$export(module.exports, "CommentAddPrompt", () => $d5041c486de6f643$export$f2f708c5f3dc3a3b);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");
const $d5041c486de6f643$var$commentAddPromptContainerStyle = (0, $ecnYn.xcss)({
    font: 'inherit',
    width: '100%',
    height: '40px',
    color: 'color.text.subtlest',
    display: 'inline-flex',
    verticalAlign: 'top',
    marginLeft: 'space.100',
    flexGrow: 1,
    backgroundColor: 'elevation.surface.overlay',
    borderStyle: 'solid',
    borderColor: 'color.border',
    borderRadius: 'border.radius.100',
    paddingLeft: 'space.100',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        cursor: 'text'
    }
});
const $d5041c486de6f643$var$i18n = (0, $2nPZH.defineMessages)({
    commentPanelFooterPlaceholder: {
        id: "comments-panel.comments.add.prompt-placeholder",
        defaultMessage: "Add text, @mention others, or use / for elements"
    }
});
const $d5041c486de6f643$var$commentAddPromptMessage = (0, $ecnYn.xcss)({
    display: 'inline-flex',
    alignItems: 'center',
    color: 'color.text.subtlest'
});
const $d5041c486de6f643$export$f2f708c5f3dc3a3b = ({ onClick: onClick, autofocusRef: autofocusRef })=>{
    const buttonRef = (0, $gwFzn.useRef)(null);
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    (0, $gwFzn.useEffect)(()=>{
        if (autofocusRef.current) {
            buttonRef.current?.focus();
            autofocusRef.current = false;
        }
    }, [
        autofocusRef
    ]);
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $d5041c486de6f643$var$commentAddPromptContainerStyle,
        onClick: onClick,
        ref: buttonRef,
        "data-testId": "add-comment-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        xcss: $d5041c486de6f643$var$commentAddPromptMessage
    }, formatMessage($d5041c486de6f643$var$i18n.commentPanelFooterPlaceholder))));
};

});


parcelRegister("ioFqb", function(module, exports) {

$parcel$export(module.exports, "CommentsPanelHeaderIcon", () => $a6c34bb5c7bdb592$export$1cf03c47eb0e5d38);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $1yB28 = parcelRequire("1yB28");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
const $a6c34bb5c7bdb592$var$i18n = (0, $2nPZH.defineMessages)({
    commentPanelHeaderIconLabel: {
        id: "comments-panel.comments.panel.header-icon.label",
        defaultMessage: "Comments"
    }
});
const $a6c34bb5c7bdb592$var$commentsPanelHeaderIconStyle = (0, $ecnYn.xcss)({
    paddingTop: 'space.050'
});
const $a6c34bb5c7bdb592$export$1cf03c47eb0e5d38 = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        "data-testId": "comments-panel-header-icon",
        xcss: $a6c34bb5c7bdb592$var$commentsPanelHeaderIconStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
        label: formatMessage($a6c34bb5c7bdb592$var$i18n.commentPanelHeaderIconLabel)
    }));
};

});

parcelRegister("5hqV2", function(module, exports) {

$parcel$export(module.exports, "CommentsPanelWrapper", () => $16bc8cf6f34e1936$export$9dc9759562ccdf5d);

var $gwFzn = parcelRequire("gwFzn");

var $ICFae = parcelRequire("ICFae");

var $9wGTI = parcelRequire("9wGTI");

var $3mVfX = parcelRequire("3mVfX");

var $etPef = parcelRequire("etPef");

var $245o4 = parcelRequire("245o4");
const $16bc8cf6f34e1936$export$9dc9759562ccdf5d = ({ openWithView: openWithView })=>{
    const [showLoader, setShowLoader] = (0, $gwFzn.useState)(!openWithView);
    const [{ unreadCommentsListState: unreadCommentList, isUnreadQueryLoading: isUnreadQueryLoading }] = (0, $ICFae.useUnreadComments)();
    const { setCurrentView: setCurrentView, setShowInlineComments: setShowInlineComments, setShowGeneralComments: setShowGeneralComments } = (0, $3mVfX.useCommentsPanelActions)();
    // As long as we don't have a "default" view to open the panel to show then we should check
    // if the unread call is still in flight to figure out which view to show if there are unread
    // NOTE: In v2 we will always go to 'Open' tab unless the intent is to show the 'Resolved' tab
    (0, $gwFzn.useEffect)(()=>{
        if (!openWithView) setShowLoader(!(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? isUnreadQueryLoading : false);
    }, [
        isUnreadQueryLoading,
        openWithView
    ]);
    const viewToShow = (0, $gwFzn.useRef)((0, $3mVfX.ViewValues).OPEN);
    (0, $gwFzn.useEffect)(()=>{
        // We need to allow the `Resolved` tab to be immediately opened if the user comes from the overflow menu
        if (openWithView) viewToShow.current = openWithView;
        // Only run the unread logic when there is no view provided
        if (!openWithView && !(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2')) {
            if (unreadCommentList.length === 0) // If no unreads then move to Open View
            viewToShow.current = (0, $3mVfX.ViewValues).OPEN;
            else if (unreadCommentList.length > 0) // If there is Unread and current view is undefined or Unread then move it to Unread or retain Unread view
            // otherwise any incoming Unread through pubsub will auto move the user to the Unread Pill while
            // they are on the Open/Resolved pill and going through it.
            // Unread should only get defaulted if there are any unreads on opening the comments panel
            viewToShow.current = (0, $3mVfX.ViewValues).UNREAD;
        }
        setShowInlineComments(true);
        setShowGeneralComments(true);
        setCurrentView(viewToShow.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- we only want to set the view once on comments panel mount
    }, []);
    return showLoader ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $245o4.Loading), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $etPef.CommentsPanel), {
        currentView: viewToShow.current
    });
};

});

parcelRegister("9buj5", function(module, exports) {

$parcel$export(module.exports, "useUnreadPanelComments", () => $02faaefae22f6672$export$b2c07ec1a20446f7);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $diswb = parcelRequire("diswb");

var $8i27m = parcelRequire("8i27m");

var $ICFae = parcelRequire("ICFae");

var $3mVfX = parcelRequire("3mVfX");
const $02faaefae22f6672$var$useUnreadPanelCommentsMarkInlineCommentsReadMutation = (0, $d2LG0.default)`mutation useUnreadPanelCommentsMarkInlineCommentsReadMutation($commentIds:[ID!]!){markCommentsAsRead(input:{commentIds:$commentIds}){success errors}}`;
const $02faaefae22f6672$export$b2c07ec1a20446f7 = ()=>{
    const [{ commentsMarkedAsRead: commentsMarkedAsRead }, { clearCommentsMarkedAsRead: clearCommentsMarkedAsRead }] = (0, $3mVfX.useCommentsPanel)();
    const { updateUnreadStatus: updateUnreadStatus } = (0, $8i27m.useCommentsDataActions)();
    const [{ readCommentsListState: readCommentsListState, unreadCommentsListState: unreadCommentsListState }, { updateReadCommentsListState: updateReadCommentsListState, updateUnreadCommentsListState: updateUnreadCommentsListState }] = (0, $ICFae.useUnreadComments)();
    // TODO: handle error
    const [markInlineCommentsRead] = (0, $diswb.useMutation)($02faaefae22f6672$var$useUnreadPanelCommentsMarkInlineCommentsReadMutation);
    // call the mutation to mark the list of comment IDs as read
    const handleMarkCommentsAsRead = (0, $gwFzn.useCallback)(()=>{
        if (Object.keys(commentsMarkedAsRead.inline).length > 0 || Object.keys(commentsMarkedAsRead.general).length > 0) {
            const inlineCommentIdsToMarkAsRead = Object.values(commentsMarkedAsRead.inline).reduce((acc, set)=>{
                acc.push(...set);
                return acc;
            }, []);
            const generalCommentIdsToMarkAsRead = Object.values(commentsMarkedAsRead.general).reduce((acc, set)=>{
                acc.push(...set);
                return acc;
            }, []);
            const commentIdsToMarkAsRead = [
                ...inlineCommentIdsToMarkAsRead,
                ...generalCommentIdsToMarkAsRead
            ];
            if (!commentIdsToMarkAsRead?.length) return;
            markInlineCommentsRead({
                variables: {
                    commentIds: commentIdsToMarkAsRead
                }
            });
            // update our data store to indicate these comments are now read
            updateUnreadStatus(commentsMarkedAsRead, (0, $8i27m.UnreadAction).READ);
            // reset our list of comments to mark as read
            clearCommentsMarkedAsRead();
            // update existing unread and read data stores
            const commentIdsToMarkAsReadSet = new Set(commentIdsToMarkAsRead);
            const filteredUnreadComments = unreadCommentsListState.filter((unreadComment)=>!commentIdsToMarkAsReadSet.has(unreadComment.id));
            updateUnreadCommentsListState(()=>filteredUnreadComments);
            const newReadCommentsListState = new Set([
                ...readCommentsListState,
                ...commentIdsToMarkAsRead
            ]);
            updateReadCommentsListState(()=>newReadCommentsListState);
        }
    }, [
        markInlineCommentsRead,
        clearCommentsMarkedAsRead,
        commentsMarkedAsRead,
        updateUnreadStatus,
        readCommentsListState,
        unreadCommentsListState,
        updateReadCommentsListState,
        updateUnreadCommentsListState
    ]);
    (0, $gwFzn.useEffect)(()=>{
        const handleBeforeUnload = ()=>{
            // Mark comments as read if the user closes the window
            handleMarkCommentsAsRead();
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return ()=>{
            // Mark comments as read when the component unmounts
            handleMarkCommentsAsRead();
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (0, $gwFzn.useMemo)(()=>({
            handleMarkCommentsAsRead: handleMarkCommentsAsRead
        }), [
        handleMarkCommentsAsRead
    ]);
};

});



//# sourceMappingURL=FullPageEditorComponent.a97ce389.js.map
